require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0d21bcaaf9225eaf120e4006b08f507d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0d21bcaaf9225eaf120e4006b08f507d'] = async function fn_0d21bcaaf9225eaf120e4006b08f507d(listToModify) {
  await (async function(array) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.reverse(array)
  })(listToModify);

}

})
define('./functions/0ea1d65b7a2db5c48adc82f4f78b00c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0ea1d65b7a2db5c48adc82f4f78b00c1'] = async function fn_0ea1d65b7a2db5c48adc82f4f78b00c1(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/15ca0e8cc5e67ed6b62edeb5642db8ca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ca0e8cc5e67ed6b62edeb5642db8ca'] = async function fn_15ca0e8cc5e67ed6b62edeb5642db8ca(listToCompact) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.compact(array)
})(listToCompact))
}

})
define('./functions/15ceddbd38db9429a0f97a454e8b367a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ceddbd38db9429a0f97a454e8b367a'] = async function fn_15ceddbd38db9429a0f97a454e8b367a(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.take(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/16424e16271fba19226ae38e9f473baa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_16424e16271fba19226ae38e9f473baa'] = async function fn_16424e16271fba19226ae38e9f473baa(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.head(array)
})(listToQuery))
}

})
define('./functions/1c281acb3a51cd63d152afb639d9a49f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1c281acb3a51cd63d152afb639d9a49f'] = async function fn_1c281acb3a51cd63d152afb639d9a49f(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.dropRight(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/26d5effe010a024af594e7ea0151369e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_26d5effe010a024af594e7ea0151369e'] = async function fn_26d5effe010a024af594e7ea0151369e(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/27a3d5b5fe9f5c3e7f0c16ee16cd7b55/code.js', () => { 

BackendlessUI.Functions.Custom['fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55'] = async function fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55(propertyNamePathsList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObjectDeep(props, values)
})(propertyNamePathsList, propertyValuesList))
}

})
define('./functions/2a1538e41c7c2966c613c5082d9cc4a6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2a1538e41c7c2966c613c5082d9cc4a6'] = async function fn_2a1538e41c7c2966c613c5082d9cc4a6(listOfGroupedElements, combinerFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzipWith(array, iteratee)
})(listOfGroupedElements, combinerFunction))
}

})
define('./functions/2bab1b7406627074e9c73f97d5958322/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2bab1b7406627074e9c73f97d5958322'] = async function fn_2bab1b7406627074e9c73f97d5958322(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.initial(array)
})(listToQuery))
}

})
define('./functions/33f4c01b8e8eda17aee5c5294b33b8fc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_33f4c01b8e8eda17aee5c5294b33b8fc'] = async function fn_33f4c01b8e8eda17aee5c5294b33b8fc(listsToProcess) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zip(...arrays)
})(listsToProcess))
}

})
define('./functions/37a70893d34d348151130eb779d90624/code.js', () => { 

BackendlessUI.Functions.Custom['fn_37a70893d34d348151130eb779d90624'] = async function fn_37a70893d34d348151130eb779d90624(listsToProcess, combinerFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipWith(...arrays, iteratee)
})(listsToProcess, combinerFunction))
}

})
define('./functions/38c2ffe50d0e5cca36f20903850cc95a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_38c2ffe50d0e5cca36f20903850cc95a'] = async function fn_38c2ffe50d0e5cca36f20903850cc95a(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.last(array)
})(listToQuery))
}

})
define('./functions/3a17163a8ed3566b1d770b133f9e456c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3a17163a8ed3566b1d770b133f9e456c'] = async function fn_3a17163a8ed3566b1d770b133f9e456c(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/3b22bf56ea095bef299e80632005db52/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3b22bf56ea095bef299e80632005db52'] = async function fn_3b22bf56ea095bef299e80632005db52(listToProcess, chunkLength) {
return (await (async function(array, size) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (size == null) {
	  size = 1
	}

	return _.chunk(array, size)
})(listToProcess, chunkLength))
}

})
define('./functions/3da675c9560df4688c120284991f799e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3da675c9560df4688c120284991f799e'] = async function fn_3da675c9560df4688c120284991f799e(listToInspect, valuesToExclude, comparatorFunction) {
return (await (async function(array, values, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceWith(array, values, comparator)
})(listToInspect, valuesToExclude, comparatorFunction))
}

})
define('./functions/4305c6b3c9678eaff3f213c4ef4213e4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4305c6b3c9678eaff3f213c4ef4213e4'] = async function fn_4305c6b3c9678eaff3f213c4ef4213e4(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.tail(array)
})(listToQuery))
}

})
define('./functions/45e840d979f666875cfc9d9849ef3d28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_45e840d979f666875cfc9d9849ef3d28'] = async function fn_45e840d979f666875cfc9d9849ef3d28(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/461d17e665f8b6391823125f6307ab14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_461d17e665f8b6391823125f6307ab14'] = async function fn_461d17e665f8b6391823125f6307ab14(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniq(array)
})(listToInspect))
}

})
define('./functions/486ef78363267883c1df0cc331fd1a59/code.js', () => { 

BackendlessUI.Functions.Custom['fn_486ef78363267883c1df0cc331fd1a59'] = async function fn_486ef78363267883c1df0cc331fd1a59(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.without(array, ...values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/4cf12a1449b890f2c42b8fe2a753bc14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4cf12a1449b890f2c42b8fe2a753bc14'] = async function fn_4cf12a1449b890f2c42b8fe2a753bc14(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/520e5b11f44ee8f88266875f0285766e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_520e5b11f44ee8f88266875f0285766e'] = async function fn_520e5b11f44ee8f88266875f0285766e(propertyNamesList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObject(props, values)
})(propertyNamesList, propertyValuesList))
}

})
define('./functions/52fdb524073bbad39dd107b4c7541e2d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_52fdb524073bbad39dd107b4c7541e2d'] = async function fn_52fdb524073bbad39dd107b4c7541e2d(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/56599adc54c74c9fdbc667193c854a77/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56599adc54c74c9fdbc667193c854a77'] = async function fn_56599adc54c74c9fdbc667193c854a77(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.drop(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/56884591a118bc7af84daa6bfc0ea942/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56884591a118bc7af84daa6bfc0ea942'] = async function fn_56884591a118bc7af84daa6bfc0ea942(listToModify, valuesToRemove, filterFunction) {
  await (async function(array, values, iteratee) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllBy(array, values, iteratee)
  })(listToModify, valuesToRemove, filterFunction);

}

})
define('./functions/568e2a48f77224570a8491fdadaa9b15/code.js', () => { 

BackendlessUI.Functions.Custom['fn_568e2a48f77224570a8491fdadaa9b15'] = async function fn_568e2a48f77224570a8491fdadaa9b15(lower, upper) {
return (await (async function(lower, upper) {
	if (isNaN(lower) || isNaN(upper)) {
	  console.error(`lower and upper must be valid numbers, received: lower=${ arguments[0] }, upper=${ arguments[1] }`)

	  return
	}

	lower = Math.ceil(lower)
	upper = Math.floor(upper)

	return Math.floor(Math.random() * (upper - lower + 1)) + lower
})(lower, upper))
}

})
define('./functions/58ac96052b6cbe4266b47f18e18aecef/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58ac96052b6cbe4266b47f18e18aecef'] = async function fn_58ac96052b6cbe4266b47f18e18aecef(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/58b599fc79a1984718ac68445dc7b9e6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58b599fc79a1984718ac68445dc7b9e6'] = async function fn_58b599fc79a1984718ac68445dc7b9e6(listToFill, valueToFillListWith, startPosition, endPosition) {
  await (async function(array, value, start, end) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	if (start == null) {
  	  start = 0
  	}
  	if (end == null) {
  	  end = array.length
  	}

  	_.fill(array, value, start, end)
  })(listToFill, valueToFillListWith, startPosition, endPosition);

}

})
define('./functions/58db38bddf2dcf8f42d5e5214a01acc1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58db38bddf2dcf8f42d5e5214a01acc1'] = async function fn_58db38bddf2dcf8f42d5e5214a01acc1(listOfGroupedElements) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzip(array)
})(listOfGroupedElements))
}

})
define('./functions/5aa80c3936bd19c8f14dd135542b64be/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5aa80c3936bd19c8f14dd135542b64be'] = async function fn_5aa80c3936bd19c8f14dd135542b64be(listsTonspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorBy(...arrays, iteratee)
})(listsTonspect, filterFunction))
}

})
define('./functions/5cf5dbc753056ca91dc2c9c78a2441d8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5cf5dbc753056ca91dc2c9c78a2441d8'] = async function fn_5cf5dbc753056ca91dc2c9c78a2441d8(noFound) {
    if (noFound > '6') {
    return 'Excellent';
  }
  if (noFound > '4') {
    return 'Good';
  }
  if (noFound > '2') {
    return 'Fair';
  }


  return 'Poor'
}

})
define('./functions/601f96e6c6e413ff585a05b78783325d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_601f96e6c6e413ff585a05b78783325d'] = async function fn_601f96e6c6e413ff585a05b78783325d(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/6194a5e48c17ad88c852e7d77f4da9cd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6194a5e48c17ad88c852e7d77f4da9cd'] = function fn_6194a5e48c17ad88c852e7d77f4da9cd() {
/**
 * Describe this function...
 */
async function holdFunction() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2dfdb9c52b4efa8e21337fa1c51bce3'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2dfdb9c52b4efa8e21337fa1c51bce3'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f83a0d3f34b40bc553cc6c6954b82016'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f83a0d3f34b40bc553cc6c6954b82016'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('11549025fde5007b5b26e1464e47d065'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('11549025fde5007b5b26e1464e47d065'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6bc4e2c656adb34b05596ba434f7958c'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6bc4e2c656adb34b05596ba434f7958c'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e39d1fc8d146751e50aa9626dda3bc23'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e39d1fc8d146751e50aa9626dda3bc23'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e0dec8978035a7896e1da6db59701f9'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e0dec8978035a7896e1da6db59701f9'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8595236642825065e4f69c4e3594c995'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8595236642825065e4f69c4e3594c995'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55e52a2efe332aa5ec83f8c205823e4f'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55e52a2efe332aa5ec83f8c205823e4f'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f6a13c756823f25aa6d79d17f97d47'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f6a13c756823f25aa6d79d17f97d47'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9afd0b7c8a983f675da6e5f34bd826d9'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9afd0b7c8a983f675da6e5f34bd826d9'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('152de17f7bfa69e7d4ea4e1c207350b3'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('152de17f7bfa69e7d4ea4e1c207350b3'))['background'] = '#EBEBEB';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45bb32841b640a788abedeb8474fb58c'))['color'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('45bb32841b640a788abedeb8474fb58c'))['background'] = '#EBEBEB';
}



return null
}

})
define('./functions/74c621ab98a12163bece4cad7be292b9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_74c621ab98a12163bece4cad7be292b9'] = async function fn_74c621ab98a12163bece4cad7be292b9(listToConcatenate, valuesToConcatenate) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.concat(array, ...values)
})(listToConcatenate, valuesToConcatenate))
}

})
define('./functions/7508d2443aea24ba74d73b27671a9829/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7508d2443aea24ba74d73b27671a9829'] = async function fn_7508d2443aea24ba74d73b27671a9829(listToModify, indexesOfElementsToRemove) {
return (await (async function(array, indexes) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.pullAt(array, ...indexes)
})(listToModify, indexesOfElementsToRemove))
}

})
define('./functions/77bed231064ec0e2a7d4ac07f751667a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_77bed231064ec0e2a7d4ac07f751667a'] = async function fn_77bed231064ec0e2a7d4ac07f751667a(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.findIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/79a6f77258336011dee2ccdfcf062c76/code.js', () => { 

BackendlessUI.Functions.Custom['fn_79a6f77258336011dee2ccdfcf062c76'] = async function fn_79a6f77258336011dee2ccdfcf062c76(listToInspect, valuesToExclude, filterFunction) {
return (await (async function(array, values, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceBy(array, values, iteratee)
})(listToInspect, valuesToExclude, filterFunction))
}

})
define('./functions/7bd98f3e8e1d5a6571e78cd4492f75a8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7bd98f3e8e1d5a6571e78cd4492f75a8'] = async function fn_7bd98f3e8e1d5a6571e78cd4492f75a8(listToModify, valuesToRemove, comparatorFunction) {
  await (async function(array, values, comparator) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllWith(array, values, comparator)
  })(listToModify, valuesToRemove, comparatorFunction);

}

})
define('./functions/7e649ea1525e52829e82c43fc4f84e2f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7e649ea1525e52829e82c43fc4f84e2f'] = async function fn_7e649ea1525e52829e82c43fc4f84e2f(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flatten(array)
})(listToFlatten))
}

})
define('./functions/84c352dcf0d18e7fa2ca41bb0fa92c91/code.js', () => { 

BackendlessUI.Functions.Custom['fn_84c352dcf0d18e7fa2ca41bb0fa92c91'] = async function fn_84c352dcf0d18e7fa2ca41bb0fa92c91(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/854e825608123b86707265b1cfb74f87/code.js', () => { 

BackendlessUI.Functions.Custom['fn_854e825608123b86707265b1cfb74f87'] = async function fn_854e825608123b86707265b1cfb74f87(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/8c6afca1481cdc048f1c296a77be1975/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8c6afca1481cdc048f1c296a77be1975'] = async function fn_8c6afca1481cdc048f1c296a77be1975(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flattenDeep(array)
})(listToFlatten))
}

})
define('./functions/8f4b34774e84b8b3681c852e49ed1ac5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8f4b34774e84b8b3681c852e49ed1ac5'] = async function fn_8f4b34774e84b8b3681c852e49ed1ac5(listToSlice, startPosition, endPosition) {
return (await (async function(array, start, end) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (start == null) {
	  start = 0
	}

	if (end == null) {
	  end = array.length
	}

	return _.slice(array, start, end)
})(listToSlice, startPosition, endPosition))
}

})
define('./functions/91a5e30346d69d6434991212a8a5e8b4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_91a5e30346d69d6434991212a8a5e8b4'] = function fn_91a5e30346d69d6434991212a8a5e8b4() {
var error, myTX;



return 
}

})
define('./functions/9458f55be4fb02eee2e72e0b6b1c347c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9458f55be4fb02eee2e72e0b6b1c347c'] = async function fn_9458f55be4fb02eee2e72e0b6b1c347c(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/95a8a1ed4f6da56382e43a6149f25d0c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_95a8a1ed4f6da56382e43a6149f25d0c'] = async function fn_95a8a1ed4f6da56382e43a6149f25d0c(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeRightWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/9743fcc6f0cc18c8ec28a5f4d0d17e34/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9743fcc6f0cc18c8ec28a5f4d0d17e34'] = async function fn_9743fcc6f0cc18c8ec28a5f4d0d17e34(listToModify, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.remove(array, predicate)
})(listToModify, valuePickerFunction))
}

})
define('./functions/99a570aeed997a122be7a512bad9a462/code.js', () => { 

BackendlessUI.Functions.Custom['fn_99a570aeed997a122be7a512bad9a462'] = function fn_99a570aeed997a122be7a512bad9a462(unPackColumn, inputField) {
var listOfObjects, eof, foundField, colour, name2, objectId, length2, iconPosition, roomTextLength, inputField, unPackColumn;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  listOfObjects = [];
  foundField = inputField;
  while (!(iconPosition == 0)) {
    iconPosition = foundField.indexOf('') + 1;
    roomTextLength = foundField.indexOf('©') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 4) - 1), iconPosition + 6))));
    objectId = foundField.slice(((iconPosition + 7) - 1), iconPosition + length2 + 6);
    iconPosition = foundField.indexOf('◊') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 1) - 1), iconPosition + 3))));
    name2 = foundField.slice(((iconPosition + 4) - 1), iconPosition + length2 + 3);
    iconPosition = foundField.indexOf('∑') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 1) - 1), iconPosition + 3))));
    colour = foundField.slice(((iconPosition + 4) - 1), iconPosition + length2 + 3);
    addItemToList(listOfObjects, ({ [`objectId`]: objectId,[`roomName`]: name2,[`colour`]: colour }));
    foundField = foundField.slice(((foundField.indexOf('©') + 1 + 1) - 1), foundField.length);
    eof = foundField.indexOf('') + 1;
    if (eof == 0) {
      break;
    }
  }

return listOfObjects
}

})
define('./functions/9ef225438f774527c9eb1feb6044ce26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9ef225438f774527c9eb1feb6044ce26'] = async function fn_9ef225438f774527c9eb1feb6044ce26(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/a1856c74d27745ecf1c18a8269e6103d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a1856c74d27745ecf1c18a8269e6103d'] = async function fn_a1856c74d27745ecf1c18a8269e6103d(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	    fromIndex = array.length - 1
	}

	return _.findLastIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/a376d7d6007e9dbebe6eea15750b4b61/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a376d7d6007e9dbebe6eea15750b4b61'] = async function fn_a376d7d6007e9dbebe6eea15750b4b61(listToInspect, comparatorFunction) {
return (await (async function(array, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqWith(array, comparator)
})(listToInspect, comparatorFunction))
}

})
define('./functions/a85d11be1bc25c0c58e939cc4e39dbeb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a85d11be1bc25c0c58e939cc4e39dbeb'] = async function fn_a85d11be1bc25c0c58e939cc4e39dbeb(tableName, whereClause, havingClause, relations, properties, excludeProperties, relationsDepth, relationPageSize, sortBy, groupBy, pageSize, pageOffset, distinct, fileReferrencePrefix) {
var result, offset, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  result = [];
  var i_end = Math.floor(pageSize / 101);
  var i_inc = 1;
  if (0 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    offset = i * 100;
    addItemToList(result, (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setHavingClause(havingClause).setProperties(properties).excludeProperties(excludeProperties).setRelated(relations).setRelationsDepth(relationsDepth).setRelationsPageSize(relationPageSize).setSortBy(sortBy).setGroupBy(groupBy).setPageSize((pageSize - offset >= 100 ? 100 : pageSize - offset)).setOffset((pageOffset ? offset + pageOffset : offset)).setDistinct(distinct).setFileReferencePrefix(fileReferrencePrefix))));
  }

return result
}

})
define('./functions/a868a6a4f6678dfcdaf2fbd8ee89f031/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a868a6a4f6678dfcdaf2fbd8ee89f031'] = async function fn_a868a6a4f6678dfcdaf2fbd8ee89f031(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAll(array, values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/ac6a83c67b17a47876aa60415ea8abf3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ac6a83c67b17a47876aa60415ea8abf3'] = async function fn_ac6a83c67b17a47876aa60415ea8abf3(noFound) {
    if (noFound > '14') {
    return 'Excellent';
  }
  if (noFound > '10') {
    return 'Good';
  }
  if (noFound > '6') {
    return 'Fair';
  }


  return 'Poor'
}

})
define('./functions/b10683b89d3a8232328807d905aa7ecc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b10683b89d3a8232328807d905aa7ecc'] = async function fn_b10683b89d3a8232328807d905aa7ecc(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/b55a0b2dad43d733ad63285e237240c8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b55a0b2dad43d733ad63285e237240c8'] = async function fn_b55a0b2dad43d733ad63285e237240c8(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropRightWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b665c075565aa28862ac1e9374ca2b96/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b665c075565aa28862ac1e9374ca2b96'] = async function fn_b665c075565aa28862ac1e9374ca2b96(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b8d6305d8b24558eb58f8fe7c0212833/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b8d6305d8b24558eb58f8fe7c0212833'] = async function fn_b8d6305d8b24558eb58f8fe7c0212833(listToFlatten, maxRecursionDepth) {
return (await (async function(array, depth) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (depth == null) {
	  depth = 1
	}

	return _.flattenDepth(array, depth)
})(listToFlatten, maxRecursionDepth))
}

})
define('./functions/b93bcd5de56aa56928854fbb554683b1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b93bcd5de56aa56928854fbb554683b1'] = async function fn_b93bcd5de56aa56928854fbb554683b1(listToQuery, elementIndex) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 0
	}

	return _.nth(array, n)
})(listToQuery, elementIndex))
}

})
define('./functions/bdb98128566e1fe6234fc799878574b3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_bdb98128566e1fe6234fc799878574b3'] = function fn_bdb98128566e1fe6234fc799878574b3(textToConvert) {
var result, currentCharacter, i;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  result = '';
  var i_end = getValueLength(textToConvert);
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    currentCharacter = textToConvert.charAt((i - 1));
    if (i % 2 == 1) {
      result = String(result) + String(currentCharacter.toUpperCase());
    } else {
      result = String(result) + String(currentCharacter);
    }
  }

return result
}

})
define('./functions/c1083dfc958bfce9f511282469f18202/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c1083dfc958bfce9f511282469f18202'] = async function fn_c1083dfc958bfce9f511282469f18202(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.union(...arrays)
})(listsToInspect))
}

})
define('./functions/c58e08966457701101ab34279f33af6d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c58e08966457701101ab34279f33af6d'] = async function fn_c58e08966457701101ab34279f33af6d(keyValuePairsList) {
return (await (async function(pairs) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.fromPairs(pairs)
})(keyValuePairsList))
}

})
define('./functions/cab97651610a7df89b05dbc568adb257/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cab97651610a7df89b05dbc568adb257'] = async function fn_cab97651610a7df89b05dbc568adb257(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = array.length - 1
	}

	return _.lastIndexOf(array, value, fromIndex);
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./functions/ced9e76a9c5d3ed5ff04eac55a1be327/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ced9e76a9c5d3ed5ff04eac55a1be327'] = async function fn_ced9e76a9c5d3ed5ff04eac55a1be327(noFound) {
    if (noFound > '16') {
    return 'Excellent';
  }
  if (noFound > '10') {
    return 'Good';
  }
  if (noFound > '6') {
    return 'Fair';
  }


  return 'Poor'
}

})
define('./functions/cf0cee815db7c56daa3d4a3f0704a8ac/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cf0cee815db7c56daa3d4a3f0704a8ac'] = async function fn_cf0cee815db7c56daa3d4a3f0704a8ac(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersection(...arrays)
})(listsToInspect))
}

})
define('./functions/d535622b38bb7a25aa31ae757fe6869c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d535622b38bb7a25aa31ae757fe6869c'] = async function fn_d535622b38bb7a25aa31ae757fe6869c(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.takeRight(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/d813cd0b8767bda332b7d73f1ea8155b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d813cd0b8767bda332b7d73f1ea8155b'] = async function fn_d813cd0b8767bda332b7d73f1ea8155b(listToConvert, elementSeparator) {
return (await (async function(array, separator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.join(array, separator)
})(listToConvert, elementSeparator))
}

})
define('./functions/dfe6f4741626a11429b6777d44ba18e7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfe6f4741626a11429b6777d44ba18e7'] = async function fn_dfe6f4741626a11429b6777d44ba18e7(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.difference(array, values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/dfef9391c409b8519db2242d696ca08c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfef9391c409b8519db2242d696ca08c'] = async function fn_dfef9391c409b8519db2242d696ca08c(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniq(array)
})(listToInspect))
}

})
define('./functions/e04783eefccc55279cd3ffc580231f28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e04783eefccc55279cd3ffc580231f28'] = async function fn_e04783eefccc55279cd3ffc580231f28(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/e554f56a70898a83c7e94f22338589cb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e554f56a70898a83c7e94f22338589cb'] = function fn_e554f56a70898a83c7e94f22338589cb() {
  console.log('bttn clicked');
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca2c076f59a69943086ef47d9d52f5be'))['background-color'] = 'white';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0e0d5314d4bc991137bfb00459f92795'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eac6800e1da359d4aaed003bc12b4d64'))['background-color'] = 'white';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5d3a648e1bbae48bdafc995418e8f1b'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cca94c157a210c8b5103d12e2ae48855'))['background-color'] = 'white';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46cba61a852faeb8c37355dd63f650ce'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9ea898f3e1b17d5e1c87c45731b594f'))['background-color'] = 'white';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8820af7d1899ac30817c5c8ffb82783'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('42b9a3af27b5cdb10725ed87a378b04e'))['background-color'] = 'white';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2b0a3ed658c9385f164261fe6e6a725d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dee5e61f81d506c70fc8c7d3aa298853'))['background-color'] = 'white';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('865d8ca9caab7167af0a447c517e93db'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b77544c4fda3953193ef6d4a05eccce4'))['background-color'] = 'white';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f2bb71adb42b0094aa76cadae2fb7d32'))['color'] = '#F15C45';
  console.log('week bttns reset');

}

})
define('./functions/eab6964cdd451a9c2dbbbeb2cbcc36de/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eab6964cdd451a9c2dbbbeb2cbcc36de'] = async function fn_eab6964cdd451a9c2dbbbeb2cbcc36de(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pull(array, ...values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/ec97791f4918eb07b6dff2a5bfec059a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ec97791f4918eb07b6dff2a5bfec059a'] = async function fn_ec97791f4918eb07b6dff2a5bfec059a(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xor(...arrays)
})(listsToInspect))
}

})
define('./functions/eced56f43629affe376eef897d6cf9df/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eced56f43629affe376eef897d6cf9df'] = function fn_eced56f43629affe376eef897d6cf9df(panelTitle, noOfCalls, kitchenTrading, producerTrading, additionalText) {
  if (kitchenTrading == '1') {
    (function (message) { alert(message) })('hello detail is talking about \'restaurants\'');
  }

}

})
define('./functions/f1c97833e26b0995f236b863812bfed2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f1c97833e26b0995f236b863812bfed2'] = async function fn_f1c97833e26b0995f236b863812bfed2(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.indexOf(array, value, fromIndex)
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./pages/0typeOfBusinessRegistration/components/a77404ac25f308a57a08a80d5b048dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    ___arguments.context.appData['softwareProductName'] = 'Fork2Fork.co.uk';
    ___arguments.context.appData['businessStyle'] = 'Producer';
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('producerRegistration2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/0typeOfBusinessRegistration/components/e06277bf56e2a5da93963a77593267f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    ___arguments.context.appData['softwareProductName'] = 'Fork2Fork.co.uk';
    ___arguments.context.appData['businessStyle'] = 'Kitchen';
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('kitchenAbout', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/0typeOfBusinessRegistration/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.appData['noTimes'] = 0;
  ___arguments.context.appData['buildingManagementVisable'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97fc5bd4fdb3e2c72acf7276cf0e24a7', false);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/0typeOfBusinessRegistration/components/af26964abd7ad35b4212770cd5a3c593/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('signin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/0typeOfBusinessRegistration/components/5a17400c754d540c9f7f37368f995b25/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 414) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b1ad8c99b67c2c57c2cd49a3e93777b6'))['width'] = undefined;
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('abc');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/0typeOfBusinessRegistration/components/9b8b47d12b84bff1113bd94e3b1f9d9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    ___arguments.context.appData['businessStyle'] = 'BuildingManagement';
    ___arguments.context.appData['businessType'] = 'BuildingManagement';
    ___arguments.context.appData['tradingStyle'] = 'BuildingManagement';
    ___arguments.context.appData['tradingCode'] = 10;
    ___arguments.context.appData['tradingStyleGroup'] = 30;
    ___arguments.context.appData['softwareProductName'] = 'Fork2Fork.co.uk';
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userRegUniversal', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/0typeOfBusinessRegistration/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/0typeOfBusinessRegistration/components/8bedf9e836487c48b8532ec597e88838/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('invitedSignUp2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inviteNewUser1', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'));
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 500) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0478c02f65289a5530ee8078f883b56b', undefined);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd73805893c65138a3f8df2823982b28', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c98459826e7b81886e8d69eb23e0ea8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0478c02f65289a5530ee8078f883b56b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd73805893c65138a3f8df2823982b28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfff7e78a97ea2951048dfe821284cd9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32a118f8ebcddd18d93beb6835d889a8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('430ee41e6cd8aecac527a97130633b71', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e06d14b3147899708fb36daeed76eec', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00cb2e22ced3d7751d5ada939c8b12ee', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca27986d085ab9829bd166e6779dd0a8', false);
    ___arguments.context.pageData['publicHolsFound'] = 0;
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('i10') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('518cbb1abaeec733dd8cda0ad08c81cf', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('i30') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('i40') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/518cbb1abaeec733dd8cda0ad08c81cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca27986d085ab9829bd166e6779dd0a8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb6926832144ca9edf05fd1abae71687', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/2f43a9389fe7613db21b7c4523c3bc34/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ingredientsUpdateMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/07a61fc5e197615c7845b49bb7711926/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/f8adc219258b21dd2f2ec6537b470b09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/634f8fba3489534e709485f54ef51b28/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var newDate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    newDate = (new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('43539abda31876b774cbc596bed6ab12'))['minDate'] = newDate;

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/970897b5964b14a9a124fcb3402f069d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(Math.round(((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) + 1);
  if (Math.round(((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) + 1 < 14) {
    ___arguments.context.pageData['timeLine'] = ([Math.round(((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) + 1,' day',Math.round(((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) > 1 ? 's.' : '.'].join(''));
  } else {
    ___arguments.context.pageData['timeLine'] = ([Math.round((((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) / 7),' Wks.',''].join(''));
  }

  return (getObjectProperty(___arguments.context.pageData, 'timeLine'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/049d86de1bd9f26dc3017adf1e1b8097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var harvestRange2, harvestRange1, x, fullList, item, varHarvestRange, matchVar1, iLoop1, elementPerDay, finishedList, indexDay, iLoop2, searchPublicEvents, error, textOutput, varEventTo, varMenuTo, varMenuFrom, varEventFrom, varEventDays, varMenuDays;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function findHarvestRange() {
  if ((getObjectProperty(___arguments.context.pageData, 'indexCalcFrom')) <= (getObjectProperty(___arguments.context.pageData, 'indexCalcTo'))) {
    harvestRange1 = (getObjectProperty((fullList[(x - 1)]), 'HarString')).slice(((getObjectProperty(___arguments.context.pageData, 'indexCalcFrom')) - 1), getObjectProperty(___arguments.context.pageData, 'indexCalcTo'));
  } else {
    harvestRange2 = (getObjectProperty((fullList[(x - 1)]), 'HarString')).slice(0, getObjectProperty(___arguments.context.pageData, 'indexCalcTo'));
    harvestRange1 = (getObjectProperty((fullList[(x - 1)]), 'HarString')).slice(((getObjectProperty(___arguments.context.pageData, 'indexCalcFrom')) - 1), 365);
    harvestRange1 = String(harvestRange1) + String(harvestRange2);
  }
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function oldDecJanLogic() {
  while (!(iLoop2 >= getValueLength((getObjectProperty(___arguments.context.pageData, 'harvestRange2'))))) {
    iLoop2 = (typeof iLoop2 == 'number' ? iLoop2 : 0) + 1;
    if ((getObjectProperty(___arguments.context.pageData, 'harvestRange2')).charAt((iLoop2 - 1)) == '1') {
      matchVar1 = (typeof matchVar1 == 'number' ? matchVar1 : 0) + 1;
    }
    if (iLoop2 % (getObjectProperty(___arguments.context.pageData, 'skip')) == 0 && (getObjectProperty(___arguments.context.pageData, 'harvestRange2')).charAt((iLoop2 - 1)) == '1') {
      varHarvestRange = String(varHarvestRange) + String('l');
    } else if (iLoop2 % (getObjectProperty(___arguments.context.pageData, 'skip')) == 0 && (getObjectProperty(___arguments.context.pageData, 'harvestRange2')).charAt((iLoop2 - 1)) == '0') {
      varHarvestRange = String(varHarvestRange) + String('.');
    }
  }
}

/**
 * Describe this function...
 */
async function displayPublicHols() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba9ccf94d3e3ad6da9b25d5efd0b0595'))['opacity'] = 0.5;
  searchPublicEvents = ['dateFrom after \'',((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate')))).toISOString()),'\' && dateFrom before \'',((new Date((getObjectProperty(___arguments.context.pageData, 'toDate')))).toISOString()),'\' && location LIKE \'',(getObjectProperty(___arguments.context.appData, 'ukNation')),'\''].join('');
  ___arguments.context.pageData['publicHolsFound'] = (await Backendless.Data.of('events').find(Backendless.DataQueryBuilder.create().setWhereClause(searchPublicEvents).setPageSize(10)));
  if ((getObjectProperty(___arguments.context.pageData, 'publicHolsFound')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba9ccf94d3e3ad6da9b25d5efd0b0595'))['opacity'] = 1;
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('430ee41e6cd8aecac527a97130633b71', (getObjectProperty(___arguments.context.pageData, 'publicHolsFound')));
}

/**
 * Describe this function...
 */
async function sportingEvents() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b146c2d1979e3642fe8dc6848c79bee6'))['opacity'] = 0.5;
  ___arguments.context.pageData['majorSportsFound'] = 0;
  ___arguments.context.pageData['majorSportsFound'] = (await Backendless.Data.of('events').find(Backendless.DataQueryBuilder.create().setWhereClause((['dateFrom after \'',((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate')))).toISOString()),'\' && dateFrom before \'',((new Date((getObjectProperty(___arguments.context.pageData, 'toDate')))).toISOString()),'\' && contentCatCode LIKE 500','','',''].join(''))).setPageSize(10)));
  ___arguments.context.pageData['noSportsFound'] = ((getObjectProperty(___arguments.context.pageData, 'majorSportsFound')).length);
  if ((getObjectProperty(___arguments.context.pageData, 'majorSportsFound')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b146c2d1979e3642fe8dc6848c79bee6'))['opacity'] = 1;
  }
  console.log('MMMMMMMMMMMMMMMMMMMMMM');
  console.log(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'majorSportsFound'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cfff7e78a97ea2951048dfe821284cd9', (getObjectProperty(___arguments.context.pageData, 'majorSportsFound')));
}

/**
 * Describe this function...
 */
async function staffHolidayDisplayFunction() {
  try {
    ___arguments.context.pageData['whereClause'] = (['','(','dateFrom after \'',((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate')))).toISOString()),'\' && dateFrom before \'',((new Date((getObjectProperty(___arguments.context.pageData, 'toDate')))).toISOString()),'\' or dateTo after \'',((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate')))).toISOString()),'\' && DateTo before \'',((new Date((getObjectProperty(___arguments.context.pageData, 'toDate')))).toISOString()),'\') && contentCatCode LIKE 200',''].join(''));
    ___arguments.context.pageData['havingClause'] = (String('businessLinkId LIKE ') + String(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')));
    ___arguments.context.pageData['returnedStaff'] = (await Backendless.Data.of('events').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'whereClause'))).setHavingClause((['businessLinkId LIKE \'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''))).setPageSize(10)));
    ___arguments.context.pageData['totalStaffHols'] = ((getObjectProperty(___arguments.context.pageData, 'returnedStaff')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32a118f8ebcddd18d93beb6835d889a8', (getObjectProperty(___arguments.context.pageData, 'returnedStaff')));

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function buildSportsEventText() {
  try {
    (function (message) { alert(message) })('\'buildingSportsEventText;\' running!');
    varMenuFrom = (getObjectProperty(___arguments.context.pageData, 'menuFrom'));
    varMenuTo = (getObjectProperty(___arguments.context.pageData, 'menuTo'));
    ___arguments.context.pageData['eventFrom'] = (getObjectProperty(___arguments.context.pageData, 'dateFrom'));
    ___arguments.context.pageData['eventTo'] = (getObjectProperty(___arguments.context.pageData, 'dateTo'));
    varEventFrom = (getObjectProperty(___arguments.context.pageData, 'eventFrom'));
    varEventTo = (getObjectProperty(___arguments.context.pageData, 'eventTo'));
    varMenuDays = Math.round(((getObjectProperty(___arguments.context.pageData, 'menuTo')) - (getObjectProperty(___arguments.context.pageData, 'menuFrom'))) / 86000000);
    varEventDays = Math.round(((getObjectProperty(___arguments.context.pageData, 'eventTo')) - (getObjectProperty(___arguments.context.pageData, 'eventFrom'))) / 86000000);
    if (varEventFrom >= varMenuFrom && varEventTo <= varMenuTo) {
      textOutput = ['Event runs from - ',((new Date(varEventFrom)).toLocaleDateString()),' for ',varEventDays,' days of menu.'].join('');
      console.log(textOutput);
    }
    if (varEventFrom > varMenuFrom && varEventFrom <= varMenuTo && varEventTo > varMenuTo) {
      textOutput = ['Event runs from -',((new Date(varEventFrom)).toLocaleDateString()),'to end of menu.',''].join('');
      console.log(textOutput);
    }
    if (varEventFrom < varMenuFrom && varEventTo > varMenuFrom && varEventTo <= varMenuTo) {
      textOutput = ['Event runs from start of menu ','to ',((new Date(varEventTo)).toLocaleDateString()),''].join('');
      console.log(textOutput);
    }

  } catch (error) {
    console.log(error);

  }
}


  ___arguments.context.pageData['menuNamesCount'] = ((generateUUID().long()).toUpperCase());
  ___arguments.context.pageData['menuId'] = (getObjectProperty((await Backendless.Data.of('menuNames').save( ({ [`toFromDates`]: [[(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getDate()) <= 9 ? String('0') + String(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getDate()) : (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getMonth() + 1) <= 9 ? String('0') + String(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getMonth() + 1) : (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getMonth() + 1),''].join(''),' to ',[(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getDate()) < 10 ? String('0') + String(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getDate()) : (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getMonth() + 1) < 10 ? String('0') + String(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getMonth() + 1) : (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getMonth() + 1),''].join('')].join(''),[`menuRanked`]: undefined,[`menuCannotBeDeleted`]: false,[`menuName`]: (getObjectProperty(___arguments.context.pageData, 'menuName')),[`menuNotes`]: (getObjectProperty(___arguments.context.pageData, 'menuNotes')),[`menuRequiredFrom`]: (getObjectProperty(___arguments.context.pageData, 'fromDate')),[`menuRequiredTo`]: (getObjectProperty(___arguments.context.pageData, 'toDate')),[`kitchenId`]: (getObjectProperty(___arguments.context.appData, 'selectedId')),[`userId`]: (getObjectProperty(___arguments.context.pageData, 'userId')),[`menuId`]: (getObjectProperty(___arguments.context.pageData, 'menuNamesCount')) }) )), 'objectId'));
  ___arguments.context.pageData['fromMonth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))).getMonth() + 1);
  ___arguments.context.pageData['fromDay'] = (new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))).getDate());
  ___arguments.context.pageData['toMonth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))).getMonth() + 1);
  ___arguments.context.pageData['toDay'] = (new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))).getDate());
  indexDay = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  ___arguments.context.pageData['indexCalcFrom'] = (indexDay[((getObjectProperty(___arguments.context.pageData, 'fromMonth')) - 1)] + (getObjectProperty(___arguments.context.pageData, 'fromDay')));
  ___arguments.context.pageData['indexCalcTo'] = (indexDay[((getObjectProperty(___arguments.context.pageData, 'toMonth')) - 1)] + (getObjectProperty(___arguments.context.pageData, 'toDay')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00cb2e22ced3d7751d5ada939c8b12ee', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b5815facf7e2df7ff7af0c305b6380d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca27986d085ab9829bd166e6779dd0a8', false);
  fullList = [];
  addItemToList(fullList, (await Backendless.Data.of('ecoFoodCore1').find(Backendless.DataQueryBuilder.create().setWhereClause((String('group = \'Vegetable\''))).setSortBy('produceName').setPageSize(100))));
  finishedList = [];
  await displayPublicHols();
  await sportingEvents();
  await staffHolidayDisplayFunction();
  var x_end = fullList.length;
  var x_inc = 1;
  if (1 > x_end) {
    x_inc = -x_inc;
  }
  for (x = 1; x_inc >= 0 ? x <= x_end : x >= x_end; x += x_inc) {
    varHarvestRange = '';
    matchVar1 = 0;
    iLoop1 = 0;
    await findHarvestRange();
    if (getValueLength(harvestRange1) >= 60) {
      ___arguments.context.pageData['skip'] = (getValueLength(harvestRange1) / 60);
      elementPerDay = 1;
    }
    if (getValueLength(harvestRange1) < 60) {
      ___arguments.context.pageData['skip'] = 1;
      elementPerDay = 60 / getValueLength(harvestRange1);
    }
    var iLoop1_end = getValueLength(harvestRange1);
    var iLoop1_inc = Math.abs((getObjectProperty(___arguments.context.pageData, 'skip')));
    if (1 > iLoop1_end) {
      iLoop1_inc = -iLoop1_inc;
    }
    for (iLoop1 = 1; iLoop1_inc >= 0 ? iLoop1 <= iLoop1_end : iLoop1 >= iLoop1_end; iLoop1 += iLoop1_inc) {
      if (harvestRange1.charAt((iLoop1 - 1)) == '1') {
        varHarvestRange = String(varHarvestRange) + String('lllllllll'.slice(0, elementPerDay));
        matchVar1 = (typeof matchVar1 == 'number' ? matchVar1 : 0) + (getObjectProperty(___arguments.context.pageData, 'skip'));
      } else if (harvestRange1.charAt((iLoop1 - 1)) == '0') {
        varHarvestRange = String(varHarvestRange) + String('.........'.slice(0, elementPerDay));
      }
    }
    (fullList[(x - 1)])['percentage'] = (Math.round((100 / iLoop1) * matchVar1));
    (fullList[(x - 1)])['percentageRange'] = varHarvestRange;
  }
  ___arguments.context.pageData['filteredByPercentage'] = (await asyncListFilter(fullList, async (item) => {


   return ((getObjectProperty(item, 'percentage')) >= 0);
  }));
  ___arguments.context.pageData['sortByPercentage'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'filteredByPercentage')), -1, async (item) => {


   return (getObjectProperty(item, 'percentage'));
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0b5815facf7e2df7ff7af0c305b6380d', (getObjectProperty(___arguments.context.pageData, 'sortByPercentage')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/e37dc8461c0f082101f353c86381d346/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/f118cfc5c504f29f6e5175b8a279b10a/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'percentage')),'% - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'produceName')),' [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'ecoCoreId')),']'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var varNewId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  varNewId = (await Backendless.Data.of('menuIngredients').save( ({ [`dateListed`]: (new Date()),[`coreListingId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'objectId')),[`humanString`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'produceName')),[`kitchenId`]: (getObjectProperty(___arguments.context.appData, 'selectedId')),[`menuId`]: (getObjectProperty(___arguments.context.pageData, 'menuNamesCount')) }) ));
  await Backendless.Data.of('menuIngredients').setRelation(varNewId, 'coreListingID', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'objectId'))]);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f118cfc5c504f29f6e5175b8a279b10a'))['opacity'] = 0.5;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/07964a4feb8102e6ecef0fec9a17d5f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([[(new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))).getMonth() + 1)].join(''),'[',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b452e76c50b4438f7f8e5e4205534e1d'), 'percentageRange')),']',[(new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))).getMonth() + 1)].join('')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/64a132dfc8046b1884698d66008bc476/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74e1333737b9c3e3a08989260de47092'), 'name')),'','','','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/2c73948acbc18c798e7a085b223852b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'publicHolsFound')).length)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/009d434595f1b34fbc659bce27e30403/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('430ee41e6cd8aecac527a97130633b71', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/5e47b8fa6f4f9b6ee4477a6df1df075c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var error, textOutput, varEventTo, varMenuTo, varMenuFrom, varEventFrom, varEventDays, varMenuDays;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'noSportsFound')) + String(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/febaf6583ea39174c70aba27b2463ece/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32a118f8ebcddd18d93beb6835d889a8', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/91e831f8ac2b0f58b7c875948553a0e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var textOutput, varEventFrom, varEventTo, varEventDays, varMenuFrom, varMenuTo, varMenuDays;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function declareVariables() {
  varMenuFrom = (getObjectProperty(___arguments.context.pageData, 'fromDate'));
  varMenuTo = (getObjectProperty(___arguments.context.pageData, 'toDate'));
  varEventFrom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4068b953c8affadcc8227b78b39fcd3f'), 'dateFrom'));
  varEventTo = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4068b953c8affadcc8227b78b39fcd3f'), 'dateTo'));
  varMenuDays = Math.round((varMenuTo - varMenuFrom) / 86000000);
  varEventDays = Math.round((varEventTo - varEventFrom) / 86000000) + 1;
  ___arguments.context.pageData[textOutput] = 'No Staff matches!';
}

/**
 * Describe this function...
 */
async function testForEventEndingAfterMenu() {
  if (varEventTo >= varMenuFrom && varEventTo >= varMenuTo) {
    textOutput = ['Last ',Math.round((varEventTo - varMenuTo) / 86000000),Math.round((varEventTo - varMenuTo) / 86000000) > 1 ? ' days of menu' : ' day of menu'].join('');
    console.log(textOutput);
  }
}

/**
 * Describe this function...
 */
async function testForEventStartingBeforeMenu() {
  console.log('Started \'testForEventStartingBeforeMenu\'');
  if (varEventFrom <= varMenuFrom && varEventFrom <= varMenuTo) {
    textOutput = ['First  ',Math.round((varMenuFrom - varEventFrom) / 86000000),Math.round((varMenuFrom - varEventFrom) / 86000000) > 1 ? ' days of menu' : ' day of menu'].join('');
    console.log(textOutput);
  }
}

/**
 * Describe this function...
 */
async function testForEventFallsWithinMenu() {
  textOutput = [((new Date(varEventFrom)).toLocaleDateString()),' for  ',varEventDays,varEventDays > 1 ? ' days of menu' : ' day of menu'].join('');
  console.log(textOutput);
}


  await declareVariables();
  await testForEventFallsWithinMenu();
  await testForEventStartingBeforeMenu();
  await testForEventEndingAfterMenu();

  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4068b953c8affadcc8227b78b39fcd3f'), 'userTag')),' [ ',textOutput,' ].',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/e29770456823e3bcb347da5e569d803c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'totalStaffHols')) + String(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfff7e78a97ea2951048dfe821284cd9', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/a12855c4a17893c64b884938f2e4044c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'description')),',',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'name')),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/c3a926081458e7c2ee580548d22a9988/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'location'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/279818289ba83fbf247838b86e9c7edd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var textOutput, error, varEventTo, varMenuTo, varMenuFrom, varEventFrom, varEventDays, varMenuDays;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    varMenuFrom = (getObjectProperty(___arguments.context.pageData, 'fromDate'));
    varMenuTo = (getObjectProperty(___arguments.context.pageData, 'toDate'));
    varEventFrom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'dateFrom'));
    varEventTo = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'dateTo'));
    varMenuDays = Math.round(((getObjectProperty(___arguments.context.pageData, 'menuTo')) - (getObjectProperty(___arguments.context.pageData, 'menuFrom'))) / 86000000);
    varEventDays = Math.round((varEventTo - varEventFrom) / 86000000) + 1;
    if (varEventFrom >= varMenuFrom && varEventTo <= varMenuTo) {
      textOutput = ['Event runs from - ',((new Date(varEventFrom)).toLocaleDateString()),' for ',varEventDays,varEventDays > 1 ? ' days of menu.' : ' day of menu.'].join('');
      console.log(textOutput);
    }
    if (varEventFrom > varMenuFrom && varEventFrom <= varMenuTo && varEventTo > varMenuTo) {
      textOutput = ['Event runs from -',((new Date(varEventFrom)).toLocaleDateString()),'to end of menu.'].join('');
      console.log(textOutput);
    }
    if (varEventFrom < varMenuFrom && varEventTo > varMenuFrom && varEventTo <= varMenuTo) {
      textOutput = ['Event runs from start of menu ','to ',((new Date(varEventTo)).toLocaleDateString())].join('');
      console.log(textOutput);
    }

  } catch (error) {
    console.log(error);

  }

  return textOutput

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/e74feb4be01f21ae2ebc9edaf98116f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74e1333737b9c3e3a08989260de47092'), 'dateFrom')))).toDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/ca27986d085ab9829bd166e6779dd0a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/0478c02f65289a5530ee8078f883b56b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('516b01e8d14c58ce634339f73a39b628', true);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('516b01e8d14c58ce634339f73a39b628', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/bd73805893c65138a3f8df2823982b28/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.pageData['editMenuDetails'] = ___arguments.selectedRecord;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c98459826e7b81886e8d69eb23e0ea8', true);
  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('9c98459826e7b81886e8d69eb23e0ea8', true);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/e3a8c4f970a8f9280598f3bc192fe103/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('9c98459826e7b81886e8d69eb23e0ea8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c98459826e7b81886e8d69eb23e0ea8', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1ingredientsTopMenu/components/2bf8d3c645c8ddc8cd93a984b748dbf8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    
  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/1produceIngredients/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inviteNewUser1', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1produceIngredients/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/1produceIngredients/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bad8a9f39a4944583a0388f2b6282598', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb6926832144ca9edf05fd1abae71687', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1produceIngredients/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb6926832144ca9edf05fd1abae71687', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba525ce8888ecc140ea8202876d37858', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bad8a9f39a4944583a0388f2b6282598', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11a8431abe07ed737f0fc2587568fce8', false);
  ___arguments.context.pageData['producerListingsPageData'] = (await Promise.all((await Backendless.Data.of('producerListings').find(Backendless.DataQueryBuilder.create().setWhereClause((['producerId = \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId2')),'\''].join(''))).setPageSize(20))).map(async item => {; return [({ [`Planted`]: (getObjectProperty(item, 'humanPlantingDate')) }), ({ [`PlantedDays`]: (Number.parseFloat((((getObjectProperty(item, 'plantingDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(0)) }), ({ [`Name`]: (getObjectProperty(item, 'listingName')) }), ({ [`Harvest`]: (getObjectProperty(item, 'humanHarvestFromDate')) }), ({ [`HarvestDays`]: (Number.parseFloat((((getObjectProperty(item, 'harvestFromDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(0)) }), ({ [`ref1`]: (getObjectProperty(item, 'ref1')) }), ({ [`ref2`]: (getObjectProperty(item, 'ref2')) }), ({ [`Ref3`]: (getObjectProperty(item, 'ref3')) })];})));
  if ((getObjectProperty(___arguments.context.pageData, 'producerListingsPageData')).length > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11a8431abe07ed737f0fc2587568fce8', true);
  }
  ___arguments.context.pageData['groupToggle'] = 'Vegetable';
  ___arguments.context.pageData['dateError'] = 'Save';
  try {
    ___arguments.context.pageData['publicHolsFound'] = 0;
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('p40') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bad8a9f39a4944583a0388f2b6282598', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/1produceIngredients/components/518cbb1abaeec733dd8cda0ad08c81cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb6926832144ca9edf05fd1abae71687', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bad8a9f39a4944583a0388f2b6282598', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1produceIngredients/components/0478c02f65289a5530ee8078f883b56b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba525ce8888ecc140ea8202876d37858', true);
  ___arguments.context.pageData['plantingDate'] = 0;
  ___arguments.context.pageData['harvestFromDate'] = 0;
  ___arguments.context.pageData['harvestDays'] = 0;
  ___arguments.context.pageData['inputRef1'] = '';
  ___arguments.context.pageData['inputRef2'] = '';
  ___arguments.context.pageData['inputRef3'] = '';
  ___arguments.context.pageData['selectedProduce'] = ___arguments.selectedRecord;
  console.log('selected produce selected details - ');
  console.log(getObjectProperty(___arguments.context.pageData, 'selectedProduce'));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['group = \'',(getObjectProperty(___arguments.context.pageData, 'groupToggle')),'\'','',''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Full catalogue list filtered by ') + String(getObjectProperty(___arguments.context.pageData, 'groupToggle')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/1produceIngredients/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1produceIngredients/components/a448acbc86c81046ecd149f854582858/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('producerListings').save( ({ [`harvestDays`]: (getObjectProperty(___arguments.context.pageData, 'harvestDays')),[`humanHarvestFromDate`]: ((new Date((getObjectProperty(___arguments.context.pageData, 'harvestFromDate')))).toISOString()).slice(0, 10),[`harvestFromDate`]: (getObjectProperty(___arguments.context.pageData, 'harvestFromDate')),[`humanHarvestToDate`]: undefined,[`harvestToDate`]: undefined,[`businessName`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessTag')),[`humanPlantingDate`]: ((new Date((getObjectProperty(___arguments.context.pageData, 'plantingDate')))).toISOString()).slice(0, 10),[`plantingDate`]: (getObjectProperty(___arguments.context.pageData, 'plantingDate')),[`doNotDelete`]: 1,[`ecoFoodId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedBusiness')), 'objectId')),[`extendRange`]: false,[`humanString`]: undefined,[`listingName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedProduce')), 'produceName')),[`produceListingLive`]: false,[`producerId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`ref1`]: (getObjectProperty(___arguments.context.pageData, 'inputRef1')),[`ref2`]: (getObjectProperty(___arguments.context.pageData, 'inputRef2')),[`ref3`]: (getObjectProperty(___arguments.context.pageData, 'inputRef3')),[`unitSale`]: undefined,[`userId`]: (getObjectProperty(___arguments.context.appData, 'selectedId')) }) );
  ___arguments.context.pageData['producerListingsPageData'] = (await Promise.all((await Backendless.Data.of('producerListings').find(Backendless.DataQueryBuilder.create().setWhereClause((['producerId = \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId2')),'\''].join(''))).setPageSize(20))).map(async item => {; return [({ [`Planted`]: (getObjectProperty(item, 'humanPlantingDate')) }), ({ [`PlantedDays`]: (Number.parseFloat((((getObjectProperty(item, 'plantingDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(0)) }), ({ [`Name`]: (getObjectProperty(item, 'listingName')) }), ({ [`Harvest`]: (getObjectProperty(item, 'humanHarvestFromDate')) }), ({ [`HarvestDays`]: (Number.parseFloat((((getObjectProperty(item, 'harvestFromDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(0)) }), ({ [`ref1`]: (getObjectProperty(item, 'ref1')) }), ({ [`ref2`]: (getObjectProperty(item, 'ref2')) }), ({ [`Ref3`]: (getObjectProperty(item, 'ref3')) })];})));
  console.log('updated list of produce listing');
  console.log(getObjectProperty(___arguments.context.pageData, 'producerListingsPageData'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba525ce8888ecc140ea8202876d37858', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11a8431abe07ed737f0fc2587568fce8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11a8431abe07ed737f0fc2587568fce8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1produceIngredients/components/bbb4ca948267ff18951411a851389503/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba525ce8888ecc140ea8202876d37858', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/1produceIngredients/components/61f3dee8ce781dc81bab92488cc89b58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['groupToggle'] = 'Vegetable';
    ___arguments.context.pageData['fruitTog'] = false;
    ___arguments.context.pageData['herbTog'] = false;
    ___arguments.context.pageData['cutTog'] = false;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/1produceIngredients/components/24b6a443df2c7938c0382f9d6c38ff9e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['groupToggle'] = 'Cut Flower';
    ___arguments.context.pageData['vegTog'] = false;
    ___arguments.context.pageData['fruitTog'] = false;
    ___arguments.context.pageData['herbTog'] = false;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/1produceIngredients/components/99a85065c1bedb0d9ac21a68f2e8e608/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['groupToggle'] = 'Fruit';
    ___arguments.context.pageData['vegTog'] = false;
    ___arguments.context.pageData['herbTog'] = false;
    ___arguments.context.pageData['cutTog'] = false;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/1produceIngredients/components/3d62d1e813ccd8e86cb2faae8a281b18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['groupToggle'] = 'Herb';
    ___arguments.context.pageData['vegTog'] = false;
    ___arguments.context.pageData['fruitTog'] = false;
    ___arguments.context.pageData['cutTog'] = false;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/1produceIngredients/components/f2771478acdd8db80e3c3c214418c5b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('on chenage event - ');
  console.log(getObjectProperty(___arguments.context.pageData, 'plantingDate'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/1produceIngredients/components/9df875b89c7e6e9ba2f832e8991cbb51/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'plantingDate')) > (getObjectProperty(___arguments.context.pageData, 'harvestFromDate'))) {
    ___arguments.context.pageData['errorSave'] = 'Planting date cannot be after Harvest date';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a448acbc86c81046ecd149f854582858', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a448acbc86c81046ecd149f854582858', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/4ColumnTablet/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function logicToggle() {
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z4') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
  }
}

/**
 * Describe this function...
 */
async function onEnterToggle() {
  if ((getObjectProperty(___arguments.context.appData, 'screenWidth')) < 350) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1208cf08fd68dbe66be8f1382d386348', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3617e4e2b4f686667af2724314f102b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06407179012458ebb37982c4c226dde', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c9f506de24b8eb2e4d87a73f0fd759', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e78475b135c178dcc21e29e40257c86', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68fd61f8f1484857e68ebaec7c2dfcdc', false);
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b41e40df7ff5ec9312bd973e8efea49', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', false);
    ___arguments.context.pageData['currentRoomContentNo'] = 0;
    ___arguments.context.pageData['displayBuildingContentsList'] = false;

  } catch (error) {
    console.log(error);

  }
}


  ___arguments.context.appData['screenWidth'] = ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'));
  ___arguments.context.pageData['baseFontSize'] = 20;
  ___arguments.context.pageData['fontSize'] = (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 480 ? (getObjectProperty(___arguments.context.pageData, 'baseFontSize')) : (getObjectProperty(___arguments.context.pageData, 'baseFontSize')) * (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) / 1200));
  ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'systemGrey'));
  ___arguments.context.pageData['stringWeeks'] = ['1st week', '2nd week', '3rd week', '4th week'];
  ___arguments.context.pageData['stringDays'] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  ___arguments.context.pageData['firstDay'] = ['0', '0', '0', '0', '0', '0', '0'];
  ___arguments.context.pageData['stringMonths'] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  ___arguments.context.pageData['chkMon'] = false;
  ___arguments.context.pageData['chkTue'] = false;
  ___arguments.context.pageData['chkWed'] = false;
  ___arguments.context.pageData['chkThu'] = false;
  ___arguments.context.pageData['chkFri'] = false;
  ___arguments.context.pageData['chkSat'] = false;
  ___arguments.context.pageData['chkSun'] = false;
  ___arguments.context.pageData['incMon'] = 0;
  ___arguments.context.pageData['incTue'] = 0;
  ___arguments.context.pageData['incWed'] = 0;
  ___arguments.context.pageData['incThu'] = 0;
  ___arguments.context.pageData['incFri'] = 0;
  ___arguments.context.pageData['incSat'] = 0;
  ___arguments.context.pageData['incSun'] = 0;
  await onEnterToggle();
  await logicToggle();
  try {
    ___arguments.context.pageData['structureWhereClause'] = (['businessLinkId = ','\'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
    ___arguments.context.pageData['showStructuresLogic'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);

  } catch (error) {

  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['elementContentLogic'] = false;
  ___arguments.context.pageData['listContentsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = false;
  ___arguments.context.pageData['contentRowPickLogic'] = false;
  ___arguments.context.pageData['assignContentRowLogic'] = false;
  ___arguments.context.pageData['structureWhereClause'] = 'nil';
  ___arguments.context.pageData['levelWhereClause'] = 'nil';
  ___arguments.context.pageData['unitWhereClause'] = 'nil';
  ___arguments.context.pageData['roomWhereClause'] = 'nil';
  ___arguments.context.pageData['toggleLogic1'] = false;
  ___arguments.context.pageData['showStructuresLogic'] = false;
  ___arguments.context.pageData['showLevelsLogic'] = false;
  ___arguments.context.pageData['showUnitsLogic'] = false;
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['showContentsLogic'] = false;

  },
  /* handler:onBeforeEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      ___arguments.context.pageData['fontSize'] = (___arguments.screenWidth <= 480 ? 24 : 24 * (___arguments.screenWidth / 1200));

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/4ColumnTablet/components/2ea3700cbb7b1542d4aacfe691539997/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['structureWhereClause'] = (['businessLinkId = ','\'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z40') + 1 > 0) {
      ___arguments.context.pageData['showStructuresLogic'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/75b8d47cbbcde4e7505381283f12004c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function uiPath() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79df042c1e47cbc92b2fb925884fac37'))['borderColor'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('75b8d47cbbcde4e7505381283f12004c'))['borderColor'] = '#616161';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0fa7ec537f80fd64b5396da6eef5293'))['borderColor'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0fa7ec537f80fd64b5396da6eef5293'))['backroundColor'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0fa7ec537f80fd64b5396da6eef5293'))['borderWidth'] = '4px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
  ___arguments.context.pageData['ptUnitName'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79df042c1e47cbc92b2fb925884fac37'))['borderColor'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79df042c1e47cbc92b2fb925884fac37'))['backroundColor'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79df042c1e47cbc92b2fb925884fac37'))['borderWidth'] = '2px';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function dataPath() {
  ___arguments.context.pageData['showLevelsLogic'] = true;
  // +structure has been selected. set showStructureLogic
  // to false to stop 'repeat' on structures.
  ___arguments.context.pageData['showStructuresLogic'] = false;
  ___arguments.context.pageData['ptStructureName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'Name'));
  ___arguments.context.pageData['ptStructureId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'ptStructureId'));
  ___arguments.context.appData['ptStructureId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'objectId'));
  ___arguments.context.appData['buildingDetails'] = ___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d');
  ___arguments.context.pageData['assignedContentLogic'] = false;
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['levelWhereClause'] = (['ptStructureId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'ptStructureId')),'\'','',''].join(''));
}


  await dataPath();
  await uiPath();

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'Name')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('75b8d47cbbcde4e7505381283f12004c'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/d95e083832186834a95bbc6130d72935/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/87049db2f23b475a7f466f12f8fd8e04/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/19315d86676cb5f92d3c8901d6c4c633/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessTag')),' / Buildings.','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19315d86676cb5f92d3c8901d6c4c633'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/84f5b9cef733787e69b6fcd26043d403/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function uiPath() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0f4fe909d171ba6830dbca198b2e37c5', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79df042c1e47cbc92b2fb925884fac37'))['borderColor'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0fa7ec537f80fd64b5396da6eef5293'))['borderColor'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0fa7ec537f80fd64b5396da6eef5293'))['borderWidth'] = '2px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('152f795866d9412b595628e2c1b600a6'))['borderColor'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('152f795866d9412b595628e2c1b600a6'))['borderWidth'] = '4px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function dataPath() {
  ___arguments.context.pageData['showUnitsLogic'] = true;
  ___arguments.context.pageData['showLevelsLogic'] = false;
  ___arguments.context.pageData['ptLevelName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'Name'));
  ___arguments.context.pageData['ptLevelRef'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'Ref'));
  ___arguments.context.pageData['levelColour'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'levelColour'));
  ___arguments.context.appData['ptLevelName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'Name'));
  ___arguments.context.appData['levelDetails'] = ___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b');
  ___arguments.context.pageData['ptLevelId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'ptLevelId'));
  ___arguments.context.appData['ptLevelId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'objectId'));
  ___arguments.context.appData['ptLevelId2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'objectId'));
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = false;
  ___arguments.context.pageData['unitWhereClause'] = (['ptLevelId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'ptLevelId')),'\'','',''].join(''));
  ___arguments.context.pageData['ptUnitName'] = '';
}


  await dataPath();
  await uiPath();

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('84f5b9cef733787e69b6fcd26043d403'))['borderLeftWidth'] = '20px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('84f5b9cef733787e69b6fcd26043d403'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('84f5b9cef733787e69b6fcd26043d403'))['borderColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'levelColour'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('84f5b9cef733787e69b6fcd26043d403'))['color'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'levelColour'));

  },
  /* handler:onStyleAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'Name')),' [index - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'Ref')),' ]'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/f0fa7ec537f80fd64b5396da6eef5293/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var myTx;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showLevelsLogic')) == true) {
    myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTx;

      _uow.find('ptLevelAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'levelWhereClause'))).setPageSize(10)).setOpResultId('levelData');

    })();

    ___arguments.context.appData['levelsFound'] = (getObjectProperty(((await myTx.execute()).getResults()), 'levelData.result'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8db5c66a3a9e50e5296c179d0dc43715', (getObjectProperty(___arguments.context.appData, 'levelsFound')));
  }
  if ((getObjectProperty(___arguments.context.appData, 'levelsFound')) == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7965c274685fc221e666990910e983ac', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', undefined);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/4ea5b442e3829e4843eeb2c36416b3a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var myTX;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showStructuresLogic'] = true;
  ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
  ___arguments.context.pageData['currentStructureId'] = (getObjectProperty(___arguments.context.pageData, 'ptElementId'));
  await Backendless.Data.of('ptStructureAssign').save( ({ [`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`Name`]: (getObjectProperty(___arguments.context.pageData, 'Name')),[`Ref`]: (getObjectProperty(___arguments.context.pageData, 'newStructureRef')) }) );
  await Backendless.Data.of('ptStructureElement').save( ({ [`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`ptElementId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`NLA`]: undefined,[`description`]: 'not included in new structure form',[`Ref`]: (getObjectProperty(___arguments.context.pageData, 'newStructureRef')),[`Name`]: (getObjectProperty(___arguments.context.pageData, 'Name')) }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
  ___arguments.context.pageData['Name'] = '';
  ___arguments.context.pageData['newStructureRef'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/656f42d37ae484c31baa49cac9d22d7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/b7eecd2c8ba572552511f9def39bdfbd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, myTX, x, levelColour, businessId;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    myTX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTX;

      _uow.create('ptLevelElement', ({ [`levelColour`]: (getObjectProperty(___arguments.context.appData, 'levelColour')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`levelptElementId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`NLA`]: undefined,[`levelDescription`]: 'not included in new structure form',[`levelRef`]: (getObjectProperty(___arguments.context.pageData, 'newLevelRef')),[`levelName`]: (getObjectProperty(___arguments.context.pageData, 'newLevelName')) }));
      _uow.create('ptLevelAssign', ({ [`levelColour`]: (getObjectProperty(___arguments.context.appData, 'levelColour')),[`ptLevelId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`Name`]: (getObjectProperty(___arguments.context.pageData, 'newLevelName')),[`ref`]: (getObjectProperty(___arguments.context.pageData, 'newLevelRef')),[`structureRelation`]: (getObjectProperty(___arguments.context.appData, 'buildingDetails')) }));

    })();

    await myTX.execute();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', undefined);
    ___arguments.context.pageData['newLevelRef'] = '';
    ___arguments.context.pageData['newLevelName'] = '';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/8d74ff2c1eb9856cfdb9aba6c7f1429d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newUnit, myTX;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
  myTX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTX;

    _uow.create('ptUnitElement', ({ [`department`]: 'department x',[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`ptElementId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`NLA`]: undefined,[`description`]: 'not included in new structure form',[`Ref`]: (getObjectProperty(___arguments.context.pageData, 'newUnitRef')),[`Name`]: (getObjectProperty(___arguments.context.pageData, 'newUnitName')) }));
    newUnit = (_uow.create('ptUnitAssign', ({ [`levelRef`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelRef')),[`levelName`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelName')),[`unitColour`]: (getObjectProperty(___arguments.context.appData, 'unitColour')),[`ptElementId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`ptLevelId`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`Name`]: (getObjectProperty(___arguments.context.pageData, 'newUnitName')),[`Ref`]: (getObjectProperty(___arguments.context.pageData, 'newUnitRef')) })));
    _uow.addToRelation('ptUnitAssign', newUnit, 'levelRelation', [(getObjectProperty(___arguments.context.appData, 'ptLevelId'))]);

  })();

  await myTX.execute();
  ___arguments.context.appData['unitRef'] = (getObjectProperty(___arguments.context.pageData, 'newUnitRef'));
  ___arguments.context.pageData['newUnitRef'] = '';
  ___arguments.context.pageData['newUnitName'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/76edd0fb8f7e6be869ba90b6bcc3369b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function toggle() {
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', false);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function dataPath() {
  ___arguments.context.appData['unitDetailsApp'] = ___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f');
  ___arguments.context.pageData['roomIds'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'roomIds'));
  ___arguments.context.pageData['contentsIds'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'contentsIds'));
  ___arguments.context.pageData['showRoomsLogic'] = true;
  ___arguments.context.pageData['showUnitsLogic'] = false;
  ___arguments.context.pageData['ptUnitName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'Name'));
  ___arguments.context.pageData['unitCreatedBy'] = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'ownerId')), Backendless.DataQueryBuilder.create().setProperties('userTag'))), 'userTag'));
  ___arguments.context.pageData['unitCreatedDate'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'created'));
  ___arguments.context.pageData['unitModifiedDate'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'updated'));
  ___arguments.context.appData['unitDetails'] = ___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f');
  ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'unitColour'));
  ___arguments.context.appData['unitObjectId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'objectId'));
  ___arguments.context.appData['ptUnitName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'Name'));
  ___arguments.context.appData['unitRef'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'Ref'));
  ___arguments.context.pageData['ptUnitId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'ptUnitId'));
  ___arguments.context.appData['ptUnitId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'ptUnitId'));
  ___arguments.context.appData['ptElementId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'ptElementId'));
  ___arguments.context.pageData['roomWhereClause'] = (['ptUnitId = ','\'',(getObjectProperty(___arguments.context.pageData, 'ptUnitId')),'\'','',''].join(''));
}

/**
 * Describe this function...
 */
async function uiPath() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aecaf3e4db85f389ba714b2f34fee193'))['borderColor'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aecaf3e4db85f389ba714b2f34fee193'))['borderWidth'] = '4px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('152f795866d9412b595628e2c1b600a6'))['borderColor'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('152f795866d9412b595628e2c1b600a6'))['borderWidth'] = '2px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
}


  await toggle();
  await dataPath();
  await uiPath();

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(['[',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'Ref')),'] - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'Name'))].join('')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('76edd0fb8f7e6be869ba90b6bcc3369b'))['borderLeftWidth'] = '20px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('76edd0fb8f7e6be869ba90b6bcc3369b'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('76edd0fb8f7e6be869ba90b6bcc3369b'))['borderColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'unitColour'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('76edd0fb8f7e6be869ba90b6bcc3369b'))['color'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'unitColour'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/152f795866d9412b595628e2c1b600a6/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item, myTx;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'showUnitsLogic')) == true) {
      myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = myTx;

        _uow.find('ptUnitAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'unitWhereClause'))).setPageSize(50)).setOpResultId('unitData');

      })();

      ___arguments.context.appData['unitsFound'] = (getObjectProperty(((await myTx.execute()).getResults()), 'unitData.result'));
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc351717f183cc7871898f6551770208', (await asyncListSort((getObjectProperty(___arguments.context.appData, 'unitsFound')), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    })));
    if ((getObjectProperty(___arguments.context.appData, 'unitsFound')) == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24dadd7f65bcfdf406723185977919be', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', undefined);
    }

  } catch (error) {

  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/20f74a9e9d69d4a8fc3ff7112d5f18ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/4b6e3c419b916815550f95fb6f1ca2e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'ptStructureName')),' / Level.','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4b6e3c419b916815550f95fb6f1ca2e2'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/e702e5a74736912702ed97667bc4c3e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function dataPath() {
  ___arguments.context.appData['ptStructureId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptStructureId'));
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = true;
  ___arguments.context.pageData['ptRoomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.appData['ptRoomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.pageData['ptRoomId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptElementId'));
  ___arguments.context.pageData['ptRoomId2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptRoomId'));
  ___arguments.context.appData['ptRoomIdAppData'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptRoomId'));
  ___arguments.context.appData['ptRoomIdSelected'] = ___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc');
  ___arguments.context.appData['roomRef'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'Ref'));
  ___arguments.context.appData['roomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.pageData['contentWhereClause'] = (['ptRoomId = ','\'',(getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),'\'','',''].join(''));
  ___arguments.context.pageData['levelWhereClause'] = (['ptStructureId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptStructureId')),'\'','',''].join(''));
}

/**
 * Describe this function...
 */
async function uiPath() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aecaf3e4db85f389ba714b2f34fee193'))['borderColor'] = '#616161';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e65fd593bef46d26017dce0690ce278f'))['borderColor'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aecaf3e4db85f389ba714b2f34fee193'))['borderWidth'] = '2px';
}


  await dataPath();
  await uiPath();

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName')),((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : '',''].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e702e5a74736912702ed97667bc4c3e9'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/aecaf3e4db85f389ba714b2f34fee193/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item, displayRoomTx;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'showRoomsLogic')) == true) {
    displayRoomTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = displayRoomTx;

      _uow.find('ptRoomAssign', Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),'','','',''].join(''))).setPageSize(10)).setOpResultId('roomData');

    })();

    ___arguments.context.appData['roomsFound'] = (getObjectProperty(((await displayRoomTx.execute()).getResults()), 'roomData.result'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('07613b843ce6e63b560d8037679e71c1', (await asyncListSort((getObjectProperty(___arguments.context.appData, 'roomsFound')), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    })));
  }
  if ((getObjectProperty(___arguments.context.appData, 'roomsFound')) == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ddc26bb802b9842298d721957a8868d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f67846cb2f0c95b896ad449c7dd9db58', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/fc76ef85fc5c5ecb0c58e95eb6313e94/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fc76ef85fc5c5ecb0c58e95eb6313e94'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/0afff5b896332b981362cbe76b6fbd55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, text, i, myTX;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    var i_end = getValueLength((getObjectProperty(___arguments.context.pageData, 'rsContentName')));
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      if ((getObjectProperty(___arguments.context.pageData, 'rsContentName')).charAt((i - 1)) == ',') {
        text = [(getObjectProperty(___arguments.context.pageData, 'rsContentName')).slice(0, i - 1),'%',(getObjectProperty(___arguments.context.pageData, 'rsContentName')).slice(((i + 1) - 1), getValueLength((getObjectProperty(___arguments.context.pageData, 'rsContentName'))))].join('');
        ___arguments.context.pageData['rsContentName'] = text;
      }
    }
    myTX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTX;

      _uow.create('ptContentAssign', ({ [`ptRoomId`]: (getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),[`ptLevelId`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`ptContentId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`name`]: (getObjectProperty(___arguments.context.pageData, 'rsContentName')),[`ref`]: (getObjectProperty(___arguments.context.pageData, 'partCode')),[`purchaseOrder`]: (getObjectProperty(___arguments.context.pageData, 'purchaseOrder')) }));
      _uow.create('ptContentElement', ({ [`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`ptElementId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`NLA`]: undefined,[`description`]: 'not included in new structure form',[`ref`]: (getObjectProperty(___arguments.context.pageData, 'partCode')),[`name`]: (getObjectProperty(___arguments.context.pageData, 'rsContentName')) }));

    })();

    await myTX.execute();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/8da6202ff1811307dbe7d04f1e444b74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['toggleLogic1'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/e65fd593bef46d26017dce0690ce278f/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var myTx, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function schedulesRead() {
  myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTx;

    _uow.find('scheduleAssign', Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(10)).setOpResultId('currentRoomSchedules');

  })();

  await myTx.execute();
  ___arguments.context.appData['schedulesFoundNo'] = ((getObjectProperty(((await myTx.execute()).getResults()), 'currentRoomSchedules.result')).length);
  ___arguments.context.appData['schedulesFound1'] = (getObjectProperty(((await myTx.execute()).getResults()), 'currentRoomSchedules.result'));
}


  if ((getObjectProperty(___arguments.context.pageData, 'assignedContentLogic')) == true) {
    myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTx;

      _uow.find('ptContentAssign', Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(10)).setOpResultId('currentRoomContent');
      _uow.find('ptContentElement', Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'levelWhereClause')),'',''].join(''))).setPageSize(10)).setOpResultId('contentBuildingCurrent');

    })();

    await myTx.execute();
    ___arguments.context.pageData['currentRoomContentNo'] = ((getObjectProperty(((await myTx.execute()).getResults()), 'currentRoomContent.result')).length);
    ___arguments.context.pageData['currentRoomContent'] = (getObjectProperty(((await myTx.execute()).getResults()), 'currentRoomContent.result'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ca29e6c7955edb18bab7f4b37e631ca6', (getObjectProperty(___arguments.context.pageData, 'currentRoomContent')));
    ___arguments.context.pageData['contentBuildingCurrentNo'] = ((getObjectProperty(((await myTx.execute()).getResults()), 'contentBuildingCurrent.result')).length);
    ___arguments.context.pageData['contentBuildingCurrent'] = (getObjectProperty(((await myTx.execute()).getResults()), 'contentBuildingCurrent.result'));
    if ((getObjectProperty(___arguments.context.pageData, 'displayBuildingContentsList')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd0a851826861d2b0177799eff25cf19', (getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrent')));
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/54638bd14fd9dbebeedbb4acd35991f7/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var myTx;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showStructuresLogic')) == true) {
    myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTx;

      _uow.find('ptStructureAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'structureWhereClause'))).setPageSize(10)).setOpResultId('structureData');

    })();

    ___arguments.context.appData['structuresFound'] = (getObjectProperty(((await myTx.execute()).getResults()), 'structureData.result'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bba7378144bf1cc89143088b41f8809e', (getObjectProperty(___arguments.context.appData, 'structuresFound')));
  }
  if ((getObjectProperty(___arguments.context.appData, 'structuresFound')) == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('914186e37a53051a3c9f5181d3b736b6', undefined);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/d70f3c6e5a5de8d750ea335e1a2c9f44/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'ptLevelName')),' / Units.','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d70f3c6e5a5de8d750ea335e1a2c9f44'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/96e383e7d3878d78d9ab6728cd92f948/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ptStructureName'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96e383e7d3878d78d9ab6728cd92f948'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/0f4fe909d171ba6830dbca198b2e37c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showStructuresLogic'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/075a0889360c383ec253091ee54c29ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, newRoom, myTX;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['showRoomsLogic'] = true;
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    myTX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTX;

      newRoom = (_uow.create('ptRoomAssign', ({ [`ptElementId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`ptRoomId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),[`ptLevelId`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`roomName`]: (getObjectProperty(___arguments.context.pageData, 'roomName')),[`Ref`]: (getObjectProperty(___arguments.context.pageData, 'roomRef')) })));
      _uow.create('ptRoomElement', ({ [`cleanToggle`]: (getObjectProperty(___arguments.context.pageData, 'togClean')),[`inspectToggle`]: (getObjectProperty(___arguments.context.pageData, 'togInspect')),[`linkToCalToggle`]: (getObjectProperty(___arguments.context.pageData, 'rogLink')),[`repairToggle`]: (getObjectProperty(___arguments.context.pageData, 'togRepair')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`ptElementId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`NLA`]: undefined,[`description`]: 'not included in new structure form',[`Ref`]: (getObjectProperty(___arguments.context.pageData, 'roomRef')),[`RoomName`]: (getObjectProperty(___arguments.context.pageData, 'roomName')) }));

    })();

    await myTX.execute();
    ___arguments.context.pageData['roomRef'] = '';
    ___arguments.context.pageData['roomName'] = '';
    ___arguments.context.pageData['listContentsLogic'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ddc26bb802b9842298d721957a8868d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f67846cb2f0c95b896ad449c7dd9db58', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/a3ef5cda2906478e835e42a2424ce033/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).indexOf('%') + 1 > 0 ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).indexOf('%') + 1) - 1) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')),'',((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : '',''].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3ef5cda2906478e835e42a2424ce033'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/73fa549929e8852831ad6efb4b36b9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
  ___arguments.context.pageData['displayBuildingContentsList'] = (!(getObjectProperty(___arguments.context.pageData, 'displayBuildingContentsList')));
  if ((getObjectProperty(___arguments.context.pageData, 'displayBuildingContentsList')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/57d4d8635534c731e4f55946da069baa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    await Backendless.Data.of('ptContentAssign').deepSave( (await Backendless.Data.of('ptContentAssign').save( ({ [`ptRoomId`]: (getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),[`ptLevelId`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`ptContentId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`Name`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')) }) )) );
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57d4d8635534c731e4f55946da069baa'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')).indexOf('%') + 1 > 0 ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')).indexOf('%') + 1) - 1) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name'))) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/84b795ad2c339453f8eea2b96b13c88e/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b41e40df7ff5ec9312bd973e8efea49', undefined);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/49ba50433a0bc86e331c8c5881997c78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['',(getObjectProperty(___arguments.context.pageData, 'ptRoomName')),' contents [x',(getObjectProperty(___arguments.context.pageData, 'currentRoomContentNo')),'].'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49ba50433a0bc86e331c8c5881997c78'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/f811512de8ab81b50043d5a30952c9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['View building content [',(getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrentNo')),'].'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f811512de8ab81b50043d5a30952c9c9'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/3349df3bba07de7428396a9b969247a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ptStructureName'))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3349df3bba07de7428396a9b969247a4'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/843bb96269af2832817543bc6c1249b3/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item, myTx;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('///// currentRoomSchedules, where clause = ') + String([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join('')));
  if ((getObjectProperty(___arguments.context.pageData, 'assignedContentLogic')) == true) {
    myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTx;

      _uow.find('scheduleAssign', Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setSortBy('nextDate').setPageSize(10)).setOpResultId('currentRoomSchedules');

    })();

    await myTx.execute();
    ___arguments.context.appData['schedulesFoundNo'] = ((getObjectProperty(((await myTx.execute()).getResults()), 'currentRoomSchedules.result')).length);
    ___arguments.context.appData['schedulesFound1'] = (getObjectProperty(((await myTx.execute()).getResults()), 'currentRoomSchedules.result'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deb11ff683ba3beef1f3ba5eda920d2f', (getObjectProperty(___arguments.context.appData, 'schedulesFound1')));
    ___arguments.context.pageData['currentSchedulesNo'] = (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('deb11ff683ba3beef1f3ba5eda920d2f')).length);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/44acb41ca44d16cac65fc738770e3f2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Currently ',(getObjectProperty(___arguments.context.pageData, 'currentSchedulesNo')),' assigned.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('44acb41ca44d16cac65fc738770e3f2d'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/5c2a87b7134e2d74dfbf9b363b3e2d7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'HumanTaskName')) + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'paused')) == 0 ? [' [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'timeAllowed')),' mins].'].join('') : ' -'))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5c2a87b7134e2d74dfbf9b363b3e2d7d'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/b2149cafd5f179de850df1c6087a0566/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'definitionText')) + String(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2149cafd5f179de850df1c6087a0566'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.4);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/86de3a49fa1f86ad52023843aed20d88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Next date - ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'nextDate')))).toDateString()).slice(0, 15) == ((new Date()).toDateString()).slice(0, 15) ? 'Today, ' : null,((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'nextDate')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'nextDate')))).toLocaleDateString()),', in ',Math.ceil(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'timeStamp')) - ((new Date()).valueOf())) / 86400000 + 0),Math.ceil(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'timeStamp')) - ((new Date()).valueOf())) / 86400000 + 0) > 1 ? ' days.' : ' day.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86de3a49fa1f86ad52023843aed20d88'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/5afc4dcf2fa10b35a41ac1179a175b88/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5afc4dcf2fa10b35a41ac1179a175b88'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/9f7b92f5252f5f6f233473d339fbe693/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5')['paused'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')));
  await Backendless.Data.of('scheduleAssign').save(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), true);

  },
  /* handler:onClick */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4caf2e6e92e78e2d7675e02a054fa5fb', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4caf2e6e92e78e2d7675e02a054fa5fb', false);
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == true ? 'pause circle outline' : 'play circle outline')

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/4caf2e6e92e78e2d7675e02a054fa5fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == 1) {
    await Backendless.Data.of('scheduleAssign').remove( ___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5') );
    if ((getObjectProperty(___arguments.context.pageData, 'currentSchedulesNo')) == 1) {
      (getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected'))['scheduleAssigned'] = false;
      await Backendless.Data.of('ptRoomAssign').save((getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected')), true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/219f81aa243b06ce55795f7d64b1e809/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9'), 'objectId'));
  console.log(String('Name = ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9'), 'Name')));
  await Backendless.Data.of('ptContentAssign').remove( ___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9') );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/00c26e21cba78e146064395778cfcdac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/381ed6943ce9c1285f3cb41faec6c0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      ___arguments.context.pageData['rsContentName'] = null;
  ___arguments.context.pageData['partCode'] = null;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/d363ed784b421a83983c6741619f23e4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d363ed784b421a83983c6741619f23e4'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/52ae5176f2e6d6afa11e32121fd13093/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('52ae5176f2e6d6afa11e32121fd13093'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/895e4b8a98a9a51852056196ed76aae2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('895e4b8a98a9a51852056196ed76aae2'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/54b285fecc2805b18f38a5689cb88c2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Created - ',((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).toLocaleDateString()),', ',Math.round(((new Date()).valueOf()) / 86400000) - Math.round(((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).valueOf()) / 86400000),Math.round(((new Date()).valueOf()) / 86400000) - Math.round(((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).valueOf()) / 86400000) < 2 ? ' in last 24 hours.' : ' days ago.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('54b285fecc2805b18f38a5689cb88c2f'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.4);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/c6f85b22f558ff085ae83e7eda183e98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('User - ') + String(getObjectProperty(___arguments.context.pageData, 'unitCreatedBy')))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6f85b22f558ff085ae83e7eda183e98'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/30ce20f8ca9f3ac2aa47319893f84277/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('30ce20f8ca9f3ac2aa47319893f84277'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/82b461284ba8cd310e488f18d14800dc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('82b461284ba8cd310e488f18d14800dc'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.8);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/57480aec8ecfe394b8083848abe82f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', undefined);
  ___arguments.context.pageData['copyUnitName'] = (getObjectProperty(___arguments.context.appData, 'ptUnitName'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/d548ed06b08827688258547327e847c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var loop1, newUnitsLoop, listOfRoomsIds, foundRoomRef, newPtUnitAssign, saveUnitsList, mainLoop, listOfUnits, j, newRoomList, saveRoomsList, saveSchedulesList, saveContentsList, copyRoomRef, createNewUnitsTX, foundSchedules, foundElements, saveNewRoomsList, resultReadTablesTX, readTablesTX, copyElements, copySchedules, y, x, j3Loop, newptRoomIds, j3, saveNewSchedulesList, x3, j2Loop, j2, saveNewElementsList, x2, newRoomDetails, j1Loop, j1, x1, l, k;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function createNewUnits() {
  saveUnitsList = [];
  saveContentsList = [];
  saveSchedulesList = [];
  saveRoomsList = [];
  listOfRoomsIds = [];
  newRoomList = [];
  mainLoop = 0;
  var mainLoop_end = listOfUnits.length;
  var mainLoop_inc = 1;
  if (1 > mainLoop_end) {
    mainLoop_inc = -mainLoop_inc;
  }
  for (mainLoop = 1; mainLoop_inc >= 0 ? mainLoop <= mainLoop_end : mainLoop >= mainLoop_end; mainLoop += mainLoop_inc) {
    listOfRoomsIds = [];
    var j_list = (getObjectProperty(___arguments.context.pageData, 'foundRoomRefPageData'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(j, 'ptUnitId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'ptUnitId'))) {
        addItemToList(listOfRoomsIds, ({ [`originalRoomId`]: (getObjectProperty(j, 'ptRoomId')),[`newRoomId`]: (generateUUID().long()).toUpperCase() }));
      }
    }
    ___arguments.context.pageData['newUnitId'] = ((generateUUID().long()).toUpperCase());
    newPtUnitAssign = ({ [`levelName`]: (getObjectProperty(___arguments.context.appData, 'ptLevelName')),[`levelRef`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelRef')),[`levelColour`]: (getObjectProperty(___arguments.context.pageData, 'levelColour')),[`objectId`]: (generateUUID().long()).toUpperCase(),[`unitColour`]: (getObjectProperty(___arguments.context.appData, 'unitColour')),[`ptElementId`]: (getObjectProperty(___arguments.context.appData, 'ptElementId')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'newUnitId')),[`ptLevelId`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`Name`]: (getObjectProperty(___arguments.context.pageData, 'ptUnitName')),[`Ref`]: listOfUnits[(mainLoop - 1)] });
    addItemToList(saveUnitsList, newPtUnitAssign);
    for (var newUnitsLoop_index in foundRoomRef) {
      newUnitsLoop = foundRoomRef[newUnitsLoop_index];
      for (var loop1_index in listOfRoomsIds) {
        loop1 = listOfRoomsIds[loop1_index];
        if ((getObjectProperty(newUnitsLoop, 'ptRoomId')) == (getObjectProperty(loop1, 'originalRoomId'))) {
          await loopThrough();
        }
      }
    }
  }
  await sendToTables();
}

/**
 * Describe this function...
 */
async function sendToTables() {
  createNewUnitsTX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = createNewUnitsTX;

    _uow.bulkCreate('ptRoomAssign', saveRoomsList);
    _uow.bulkCreate('ptContentAssign', saveContentsList);
    _uow.bulkCreate('scheduleAssign', saveSchedulesList);
    _uow.bulkCreate('ptUnitAssign', saveUnitsList);

  })();

  await createNewUnitsTX.execute();
}

/**
 * Describe this function...
 */
async function saveRoomRef() {
  console.log(saveNewRoomsList);
  createNewUnitsTX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = createNewUnitsTX;

    _uow.bulkCreate('ptRoomAssign', saveNewRoomsList);

  })();

  console.log((await createNewUnitsTX.execute()));
}

/**
 * Describe this function...
 */
async function readTables() {
  ___arguments.context.pageData['showRoomsLogic'] = true;
  readTablesTX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = readTablesTX;

    copyRoomRef = (_uow.find('ptRoomAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'ptUnitIdWhereClause'))).setPageSize(100)).setOpResultId('copyRoomRef'));
    copySchedules = (_uow.find('scheduleAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'ptUnitIdWhereClause'))).setPageSize(100)).setOpResultId('copySchedules'));
    copyElements = (_uow.find('ptContentAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'ptUnitIdWhereClause'))).setPageSize(100)).setOpResultId('copyElements'));

  })();

  resultReadTablesTX = (await readTablesTX.execute());
  foundElements = [];
  foundRoomRef = [];
  foundSchedules = [];
  foundElements = (getObjectProperty((resultReadTablesTX.getResults()), 'copyElements.result'));
  foundRoomRef = (getObjectProperty((resultReadTablesTX.getResults()), 'copyRoomRef.result'));
  foundSchedules = (getObjectProperty((resultReadTablesTX.getResults()), 'copySchedules.result'));
  ___arguments.context.pageData['foundRoomRefPageData'] = foundRoomRef;
}

/**
 * Describe this function...
 */
async function oldSaveDELETE() {
  for (var j_index2 in foundElements) {
    j = foundElements[j_index2];
    j['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
    j['objectId'] = ((generateUUID().long()).toUpperCase());
    j['doNotDelete'] = 0;
  }
  console.log(foundRoomRef);
  for (var j_index4 in foundRoomRef) {
    j = foundRoomRef[j_index4];
    j['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
    ___arguments.context.pageData['ptRoomNew'] = ((generateUUID().long()).toUpperCase());
    j['ptRoomId'] = (getObjectProperty(___arguments.context.pageData, 'ptRoomNew'));
    j['objectId'] = ((generateUUID().long()).toUpperCase());
    j['doNotDelete'] = 0;
    for (var j_index3 in foundSchedules) {
      j = foundSchedules[j_index3];
      j['unitRef'] = (listOfUnits[(newUnitsLoop - 1)]);
      j['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
      j['ptRoomId'] = (getObjectProperty(___arguments.context.pageData, 'ptRoomNew'));
      j['objectId'] = ((generateUUID().long()).toUpperCase());
      j['doNotDelete'] = 0;
    }
  }
}

/**
 * Describe this function...
 */
async function loopThroughArrays() {
  for (var j_index5 in listOfRoomsIds) {
    j = listOfRoomsIds[j_index5];
    if ((getObjectProperty(j, 'ptUnitId')) == (getObjectProperty(___arguments.context.appData, 'ptUnitId'))) {
      console.log('matched room to unit');
      j['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
      j['ptRoomId'] = ((generateUUID().long()).toUpperCase());
      j['objectId'] = ((generateUUID().long()).toUpperCase());
      j['doNotDelete'] = 0;
      console.log('foundElements[var] =');
      console.log(foundElements);
      for (var x_index in foundElements) {
        x = foundElements[x_index];
        console.log('match contents');
        if ((getObjectProperty(x, 'ptUnitId')) == (getObjectProperty(___arguments.context.appData, 'ptUnitId'))) {
          ___arguments.context.pageData['matchRoomId'] = (getObjectProperty(x, 'ptRoomId'));
          if ((getObjectProperty(x, 'ptRoomId')) == (getObjectProperty(___arguments.context.pageData, 'matchRoomId'))) {
            x['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
            x['ptRoomId'] = (getObjectProperty(j, 'ptRoomId'));
            x['doNotDelete'] = 0;
            console.log('contents amende details - ');
            console.log(x);
          }
        }
      }
      for (var y_index in foundSchedules) {
        y = foundSchedules[y_index];
        console.log('match schedules');
        if ((getObjectProperty(x, 'ptUnitId')) == (getObjectProperty(___arguments.context.appData, 'ptUnitId'))) {
          y['unitRef'] = (listOfUnits[(newUnitsLoop - 1)]);
          y['ptRoomId'] = (getObjectProperty(j, 'ptRoomId'));
          y['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
          y['objectId'] = ((generateUUID().long()).toUpperCase());
          y['doNotDelete'] = 0;
          console.log('schedules amended details - ');
          console.log(y);
        }
      }
    }
  }
  console.log('listOfRoomsIds[var]');
  console.log(listOfRoomsIds);
}

/**
 * Describe this function...
 */
async function createNoRooms() {
  mainLoop = 0;
  listOfRoomsIds = [];
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'foundRoomRefPageData'));
  for (var j_index6 in j_list2) {
    j = j_list2[j_index6];
    if ((getObjectProperty(j, 'ptUnitId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'ptUnitId'))) {
      addItemToList(listOfRoomsIds, ({ [`originalRoomId`]: (getObjectProperty(j, 'ptRoomId')),[`newRoomId`]: (generateUUID().long()).toUpperCase() }));
    } else {
      console.log('NOT matched*********');
    }
  }
  var newUnitsLoop_end = listOfUnits.length;
  var newUnitsLoop_inc = 1;
  if (1 > newUnitsLoop_end) {
    newUnitsLoop_inc = -newUnitsLoop_inc;
  }
  for (newUnitsLoop = 1; newUnitsLoop_inc >= 0 ? newUnitsLoop <= newUnitsLoop_end : newUnitsLoop >= newUnitsLoop_end; newUnitsLoop += newUnitsLoop_inc) {
    console.log('=  Start of loop                                      =');
    mainLoop = (typeof mainLoop == 'number' ? mainLoop : 0) + 1;
    console.log('listOfRoomdIds [should not change] = ');
    console.log(listOfRoomsIds);
    console.log('===============================');
    saveNewRoomsList = [];
    saveNewElementsList = [];
    saveNewSchedulesList = [];
    loop1 = 0;
    ___arguments.context.pageData['newUnitId'] = ((generateUUID().long()).toUpperCase());
    newptRoomIds = [];
    for (var j_index7 in listOfRoomsIds) {
      j = listOfRoomsIds[j_index7];
      addItemToList(newptRoomIds, ((generateUUID().long()).toUpperCase()));
    }
    console.log('newptRoomIds [should change each unit created] for this loop is = ');
    console.log(newptRoomIds);
    console.log('==========================');
    newPtUnitAssign = ({ [`levelName`]: (getObjectProperty(___arguments.context.appData, 'ptLevelName')),[`levelRef`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelRef')),[`contentsIds`]: undefined,[`roomIds`]: undefined,[`objectId`]: (generateUUID().long()).toUpperCase(),[`unitColour`]: (getObjectProperty(___arguments.context.appData, 'unitColour')),[`ptElementId`]: (getObjectProperty(___arguments.context.appData, 'ptElementId')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'newUnitId')),[`ptLevelId`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`Name`]: (getObjectProperty(___arguments.context.pageData, 'ptUnitName')),[`Ref`]: listOfUnits[(mainLoop - 1)] });
    j1Loop = 0;
    console.log('foundRoomRef[var] = ');
    console.log(foundRoomRef);
    console.log('===================================');
    for (var j1_index in foundRoomRef) {
      j1 = foundRoomRef[j1_index];
      j1Loop = (typeof j1Loop == 'number' ? j1Loop : 0) + 1;
      for (var x1_index in listOfRoomsIds) {
        x1 = listOfRoomsIds[x1_index];
        console.log(['ptRoomId [ j1] \'foundRoomRef[var]  - "',(getObjectProperty(j1, 'ptRoomId')),'" should equal - originalRoomId [x1] ( aka unit rooms to be copied) = "',(getObjectProperty(x1, 'originalRoomId')),'" //  j1Loop = ',j1Loop].join(''));
        if ((getObjectProperty(j1, 'ptRoomId')) == (getObjectProperty(x1, 'originalRoomId'))) {
          newRoomDetails = (Object.assign(j1, ({ [`doNotDelete`]: 0,[`created`]: ((new Date()).valueOf()),[`objectId`]: ['','',(generateUUID().long()).toUpperCase()].join(''),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'newUnitId')),[`ptRoomId`]: newptRoomIds[(j1Loop - 1)] })));
          addItemToList(saveNewRoomsList, newRoomDetails);
          console.log('amended room to create new room');
          console.log(newRoomDetails);
        } else {
          console.log('no match of roomIds');
        }
      }
    }
    j2Loop = 0;
    j3 = 0;
    await sendToTables();
  }
}

/**
 * Describe this function...
 */
async function loopThrough() {
  for (var j_index8 in foundRoomRef) {
    j = foundRoomRef[j_index8];
    if ((getObjectProperty(j, 'ptRoomId')) == (getObjectProperty(loop1, 'originalRoomId'))) {
      addItemToList(saveRoomsList, ({ [`created`]: ((new Date()).valueOf()),[`Ref`]: (getObjectProperty(j, 'Ref')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`doNotDelete`]: 0,[`ownerId`]: (getObjectProperty(j, 'ownerId')),[`ptElementId`]: (getObjectProperty(j, 'ptElementId')),[`ptLevelId`]: (getObjectProperty(j, 'ptLevelId')),[`ptRoomId`]: (getObjectProperty(loop1, 'newRoomId')),[`ptStructureId`]: (getObjectProperty(j, 'ptStructureId')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'newUnitId')),[`roomName`]: (getObjectProperty(j, 'roomName')),[`scheduleAssigned`]: (getObjectProperty(j, 'scheduleAssigned')),[`objectId`]: (generateUUID().long()).toUpperCase() }));
    }
  }
  for (var k_index in foundElements) {
    k = foundElements[k_index];
    if ((getObjectProperty(k, 'ptRoomId')) == (getObjectProperty(loop1, 'originalRoomId'))) {
      addItemToList(saveContentsList, ({ [`Name`]: (getObjectProperty(k, 'Name')),[`created`]: ((new Date()).valueOf()),[`businessLinkId`]: (getObjectProperty(k, 'businessLinkId')),[`doNotDelete`]: 0,[`ownerId`]: (getObjectProperty(k, 'ownerId')),[`ptContentId`]: (getObjectProperty(k, 'ptContentId')),[`ptElementId`]: (getObjectProperty(k, 'ptElementId')),[`ptLevelId`]: (getObjectProperty(k, 'ptLevelId')),[`ptRoomId`]: (getObjectProperty(loop1, 'newRoomId')),[`ptStructureId`]: (getObjectProperty(k, 'ptStructureId')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'newUnitId')),[`roomName`]: (getObjectProperty(k, 'roomName')),[`objectId`]: (generateUUID().long()).toUpperCase() }));
    }
  }
  for (var l_index in foundSchedules) {
    l = foundSchedules[l_index];
    if ((getObjectProperty(l, 'ptRoomId')) == (getObjectProperty(loop1, 'originalRoomId'))) {
      addItemToList(saveSchedulesList, ({ [`HumanTaskName`]: (getObjectProperty(l, 'HumanTaskName')),[`businessLinkId`]: (getObjectProperty(l, 'businessLinkId')),[`dateNow`]: (getObjectProperty(l, 'dateNow')),[`dayOfMonth`]: (getObjectProperty(l, 'dayOfMonth')),[`definitionText`]: (getObjectProperty(l, 'definitionText')),[`deleteDay`]: (getObjectProperty(l, 'deleteDay')),[`doNotDelete`]: 0,[`humanTaskDescription`]: (getObjectProperty(l, 'humanTaskDescription')),[`humanTaskRef`]: (getObjectProperty(l, 'humanTaskRef')),[`monthOfYear`]: (getObjectProperty(l, 'monthOfYear')),[`nextDate`]: (getObjectProperty(l, 'nextDate')),[`nextDateSystem`]: (getObjectProperty(l, 'nextDateSystem')),[`nextDateText`]: (getObjectProperty(l, 'nextDateText')),[`ownerId`]: (getObjectProperty(l, 'ownerId')),[`paused`]: (getObjectProperty(l, 'paused')),[`ptLevelId`]: (getObjectProperty(l, 'ptLevelId')),[`ptLevelName`]: (getObjectProperty(l, 'ptLevelName')),[`ptLevelRef`]: (getObjectProperty(l, 'ptLevelRef')),[`ptStructureId`]: (getObjectProperty(l, 'ptStructureId')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'newUnitId')),[`roomName`]: (getObjectProperty(l, 'roomName')),[`roomRef`]: (getObjectProperty(l, 'roomRef')),[`scheduleElementId`]: (getObjectProperty(l, 'scheduleElementId')),[`scheduleType`]: (getObjectProperty(l, 'scheduleType')),[`timeAllowed`]: (getObjectProperty(l, 'timeAllowed')),[`timeStamp`]: (getObjectProperty(l, 'timeStamp')),[`unitName`]: (getObjectProperty(l, 'unitName')),[`unitRef`]: (getObjectProperty(l, 'unitRef')),[`weekDayNo`]: (getObjectProperty(l, 'weekDayNo')),[`xDays`]: (getObjectProperty(l, 'xDays')),[`xMonths`]: (getObjectProperty(l, 'xMonths')),[`xWeeks`]: (getObjectProperty(l, 'xWeeks')),[`ptRoomId`]: (getObjectProperty(loop1, 'newRoomId')),[`created`]: ((new Date()).valueOf()),[`objectId`]: (generateUUID().long()).toUpperCase() }));
    }
  }
}


  ___arguments.context.pageData['ptUnitIdWhereClause'] = (['ptUnitId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'ptUnitId')),'\''].join(''));
  copyRoomRef = [];
  listOfUnits = (getObjectProperty(___arguments.context.pageData, 'copyRoomRef')).split(',');
  console.log('new \'Ref\' for rooms :');
  console.log(listOfUnits);
  console.log('new \'Ref\' for rooms :');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', false);
  await readTables();
  await createNewUnits();
  ___arguments.context.pageData['roomRef'] = '';
  ___arguments.context.pageData['roomName'] = '';
  ___arguments.context.pageData['listContentsLogic'] = true;
  ___arguments.context.pageData['showUnitsLogic'] = true;
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.appData['unitRef'] = '';
  ___arguments.context.appData['ptUnitName'] = '';
  ___arguments.context.pageData['ptUnitName'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/cc862d0e5a9f58512897297a25a24be6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('ptRoomAssign').remove( ___arguments.context.getComponentDataStoreByUid('5393db845943aad7814dc428a9c364ff') );
  await Backendless.Data.of('scheduleAssign').bulkDelete( (['ptRoomId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5393db845943aad7814dc428a9c364ff'), 'ptRoomId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/53025edbec3d03e42b11d78288a4c063/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var chips;


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('57ea156f6879183f97a1e409931939fc', (await Backendless.Data.of('ptChips').find(Backendless.DataQueryBuilder.create().setPageSize(10))));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/559be948199a9ac63d552bdf5315cda4/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('53025edbec3d03e42b11d78288a4c063')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/8898c04f68621a2c421594e28c8774d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/1a9eb4ec2be149748eb460b86d6750f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/1789f748f56a280711277b918ce58053/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/b1d6cb5fb512af173e183728e0680188/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/1c7d91e688320b4f9bc59b044f98b186/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/5ab951accd9b2c6c074de4be72f6afc6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ab951accd9b2c6c074de4be72f6afc6'))['color'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dc4708ccec8138457e2ea1ff803c3894'), 'levelColour'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/2c7ac696309234e142c52e09a6c69a26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(['','','',(getObjectProperty(___arguments.context.appData, 'ptUnitName'))].join('')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c7ac696309234e142c52e09a6c69a26'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/90e4a8191fafc3b52dbfcfeb3df17b0a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3617e4e2b4f686667af2724314f102b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/ca9edc35bfc3edfcd038ce0a7af8e6ef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'ptStructureName')),'','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca9edc35bfc3edfcd038ce0a7af8e6ef'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/16a413374c475a73f0ec21ee9b4b029d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(['[',(getObjectProperty(___arguments.context.appData, 'unitRef')),'] - ',''].join('')) + String(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('16a413374c475a73f0ec21ee9b4b029d'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/28541503164d69f7528ab23ad93daf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('28541503164d69f7528ab23ad93daf7c'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/94dfb781d57d5c65abd972feb8e544f1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('94dfb781d57d5c65abd972feb8e544f1'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/4add5911379d38cfed0d69a68ac147ef/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4add5911379d38cfed0d69a68ac147ef'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/3ecb42ac69e5f1ea8eaabcaa15caf054/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3ecb42ac69e5f1ea8eaabcaa15caf054'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/83a8ac2a9f6f625962f24b2dfa93701b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83a8ac2a9f6f625962f24b2dfa93701b'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/98259ad37ec1c50673de4af2e584a2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('98259ad37ec1c50673de4af2e584a2cd'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/bda4638d2a573af5bcc3fa37debc9e4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06407179012458ebb37982c4c226dde', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3617e4e2b4f686667af2724314f102b', undefined);
  ___arguments.context.pageData['drsInput'] = '';
  ___arguments.context.pageData['definedScheduleAs'] = (['Repeat every ',(getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) > 0 ? (getObjectProperty(___arguments.context.pageData, 'stringWeeks'))[((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1)] : '[unknown]',' week of month, on ',(getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) > 0 ? (getObjectProperty(___arguments.context.pageData, 'stringDays'))[((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1)] : '[unknown]','','','',''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/6086f6ed0cbbb75d79693f428819b7a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c9f506de24b8eb2e4d87a73f0fd759', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3617e4e2b4f686667af2724314f102b', undefined);
  ___arguments.context.pageData['everyNoWeeks'] = 0;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/5959bd9442927752dd8e4c2b45fd20ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e78475b135c178dcc21e29e40257c86', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3617e4e2b4f686667af2724314f102b', undefined);
  ___arguments.context.pageData['numberInput'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/b56c83c8f8aef7dfd0fbad790d433dc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68fd61f8f1484857e68ebaec7c2dfcdc', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3617e4e2b4f686667af2724314f102b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/4b94334bda4838b508418f8cc2a829ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newSchedule2, myTx;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68fd61f8f1484857e68ebaec7c2dfcdc', undefined);
  myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTx;

    newSchedule2 = (_uow.create('scheduleAssign', ({ [`ptLevelRef`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'levelRef')),[`ptLevelName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'levelName')),[`timeStamp`]: ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getFullYear())].join('')))).valueOf()),[`nextDateSystem`]: (new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getFullYear())].join('')))),[`timeAllowed`]: (getObjectProperty(___arguments.context.pageData, 'timeAllowed')),[`unitName`]: (getObjectProperty(___arguments.context.appData, 'ptUnitName')),[`unitRef`]: (getObjectProperty(___arguments.context.appData, 'unitRef')),[`roomName`]: (getObjectProperty(___arguments.context.appData, 'roomName')),[`ptLevelId`]: (getObjectProperty(___arguments.context.appData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.appData, 'ptStructureId')),[`monthOfYear`]: (new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getMonth() + 1),[`dayOfMonth`]: (new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getUTCDate()),[`xMonths`]: (Number((getObjectProperty(___arguments.context.pageData, 'everyXMonths')))),[`nextDateText`]: [(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getFullYear())].join(''),[`scheduleType`]: 3,[`ptUnitId`]: (getObjectProperty(___arguments.context.appData, 'ptUnitId')),[`definitionText`]: ['','','Occurring every ',(getObjectProperty(___arguments.context.pageData, 'everyXMonths')) > 0 ? String(getObjectProperty(___arguments.context.pageData, 'everyXMonths')) + String(' months.') : '[ enter ]'].join(''),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName3')),[`HumanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName3')),[`businessLinkId `]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`nextDate`]: ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getFullYear())].join('')))).valueOf()),[`scheduleElementId`]: (getObjectProperty((await Backendless.Data.of('scheduleElement').save( ({ [`ptLevelId`]: (getObjectProperty(___arguments.context.appData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.appData, 'ptStructureId')),[`monthOfYear`]: (new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getMonth() + 1),[`dayOfMonth`]: (new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getUTCDate()),[`xMonths`]: (getObjectProperty(___arguments.context.pageData, 'everyXMonths')),[`businessId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')),[`firstDate`]: ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getFullYear())].join('')))).valueOf()),[`definitionText`]: ['','','Occurring every ',(getObjectProperty(___arguments.context.pageData, 'everyXMonths')) > 0 ? String(getObjectProperty(___arguments.context.pageData, 'everyXMonths')) + String(' months.') : '[ enter ]'].join(''),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName3')),[`humanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName3')),[`instructionSourceId`]: (generateUUID().long()),[`scheduleType`]: 3,[`weekDayNo`]: (getObjectProperty(___arguments.context.pageData, 'dayOfWeek')),[`xWeeks`]: (getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) }) )), 'objectId')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')) })));
    _uow.addToRelation('scheduleAssign', newSchedule2, 'relationUnitId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);
    _uow.addToRelation('scheduleAssign', newSchedule2, 'relationLevelId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);

  })();

  await myTx.execute();
  (getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected'))['scheduleAssigned'] = true;
  await Backendless.Data.of('ptRoomAssign').save((getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected')), true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/f1394f287fee09eb3881a27962fcc102/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newSchedule, myTx, instructionSourceIdVar;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06407179012458ebb37982c4c226dde', undefined);
  console.log('businessLinkID - ');
  console.log(getObjectProperty(___arguments.context.appData, 'businessLinkId2'));
  console.log('businessLinkID - END ');
  instructionSourceIdVar = (generateUUID().long());
  myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTx;

    newSchedule = (_uow.create('scheduleAssign', ({ [`ptLevelRef`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'levelRef')),[`ptLevelName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'levelName')),[`timeStamp`]: ((new Date(([(getObjectProperty(___arguments.context.pageData, 'month')),'/',(getObjectProperty(___arguments.context.pageData, 'day')),'/',(getObjectProperty(___arguments.context.pageData, 'year'))].join('')))).valueOf()),[`nextDateSystem`]: ((new Date(([(getObjectProperty(___arguments.context.pageData, 'month')),'/',(getObjectProperty(___arguments.context.pageData, 'day')),'/',(getObjectProperty(___arguments.context.pageData, 'year'))].join('')))).valueOf()),[`unitName`]: (getObjectProperty(___arguments.context.appData, 'ptUnitName')),[`unitRef`]: (getObjectProperty(___arguments.context.appData, 'unitRef')),[`timeAllowed`]: (getObjectProperty(___arguments.context.pageData, 'timeAllowed')),[`roomName`]: (getObjectProperty(___arguments.context.appData, 'roomName')),[`ptLevelId`]: (getObjectProperty(___arguments.context.appData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.appData, 'ptStructureId')),[`nextDateText`]: [(getObjectProperty(___arguments.context.pageData, 'month')),'/',(getObjectProperty(___arguments.context.pageData, 'day')),'/',(getObjectProperty(___arguments.context.pageData, 'year'))].join(''),[`weekDayNo`]: (getObjectProperty(___arguments.context.pageData, 'dayOfWeek')),[`xWeeks`]: (getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')),[`scheduleType`]: 1,[`ptUnitId`]: (getObjectProperty(___arguments.context.appData, 'ptUnitId')),[`definitionText`]: String(['Repeat every ',(getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) > 0 ? String((getObjectProperty(___arguments.context.pageData, 'stringWeeks'))[((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1)]) : '[unknown]',' week of month, on ',(getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) > 0 ? String((getObjectProperty(___arguments.context.pageData, 'stringDays'))[((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1)]) : '[unknown]'].join('')),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName')),[`humanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`nextDate`]: ((new Date(([(getObjectProperty(___arguments.context.pageData, 'month')),'/',(getObjectProperty(___arguments.context.pageData, 'day')),'/',(getObjectProperty(___arguments.context.pageData, 'year'))].join('')))).valueOf()),[`scheduleElementId`]: (getObjectProperty((await Backendless.Data.of('scheduleElement').save( ({ [`ptLevelId`]: (getObjectProperty(___arguments.context.appData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.appData, 'ptStructureId')),[`businessId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')),[`firstDate`]: ((new Date(([(getObjectProperty(___arguments.context.pageData, 'month')),'/',(getObjectProperty(___arguments.context.pageData, 'day')),'/',(getObjectProperty(___arguments.context.pageData, 'year'))].join('')))).valueOf()),[`definitionText`]: ['Repeat every ',(getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) > 0 ? String((getObjectProperty(___arguments.context.pageData, 'stringWeeks'))[((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1)]) : '[unknown]',' week of month, on ',(getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) > 0 ? String((getObjectProperty(___arguments.context.pageData, 'stringDays'))[((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1)]) : '[unknown]'].join(''),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName')),[`humanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName')),[`instructionSourceId`]: instructionSourceIdVar,[`scheduleType`]: 1,[`weekDayNo`]: (getObjectProperty(___arguments.context.pageData, 'dayOfWeek')),[`xWeeks`]: (getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) }) )), 'objectId')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')) })));
    _uow.addToRelation('scheduleAssign', newSchedule, 'relationUnitId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);
    _uow.addToRelation('scheduleAssign', newSchedule, 'relationLevelId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);
    (getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected'))['scheduleAssigned'] = true;
    _uow.upsert('ptRoomAssign', (getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected')));

  })();

  await myTx.execute();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var year, month, calcNewDayOfMonth, j, i, triggerOK, dayOfMonth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dayOfWeekPicked')) == 1 && (getObjectProperty(___arguments.context.pageData, 'weekPicked')) == 1) {
    year = (new Date((new Date())).getFullYear());
    dayOfMonth = (new Date((new Date())).getDate());
    month = (new Date((new Date())).getMonth() + 1);
    triggerOK = false;
    for (i = 1; i <= 7; i++) {
      if ((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1 == (new Date(((new Date((['',month,'/',i,'/',year,''].join('')))).valueOf())).getDay())) {
        break;
      }
    }
    calcNewDayOfMonth = i + ((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1) * 7;
    if (i + ((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1) * 7 <= (new Date((new Date())).getDate())) {
      month = (typeof month == 'number' ? month : 0) + 1;
      if (month > 12) {
        year = (typeof year == 'number' ? year : 0) + 1;
        month = 1;
      }
      for (j = 1; j <= 7; j++) {
        if ((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1 == (new Date(((new Date((['',month,'/',j,'/',year,''].join('')))).valueOf())).getDay())) {
          calcNewDayOfMonth = j + ((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1) * 7;
          break;
        }
      }
    }
    ___arguments.context.pageData['year'] = year;
    ___arguments.context.pageData['month'] = month;
    ___arguments.context.pageData['day'] = calcNewDayOfMonth;
    return (String('First available date ') + String(['',calcNewDayOfMonth,'/',(getObjectProperty(___arguments.context.pageData, 'stringMonths'))[(month - 1)],'/',year,''].join('')));
  }

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/72d4610948b820417f067eb8aa4a0f3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, newSchedule, myTx;

/**
 * Describe this function...
 */
async function transactionFeamWork() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e78475b135c178dcc21e29e40257c86', undefined);
  try {
    myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = myTx;

      newSchedule = (_uow.create('scheduleAssign', ({ [`ptLevelRef`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'levelRef')),[`ptLevelName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'levelName')),[`timeStamp`]: ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getFullYear())].join('')))).valueOf()),[`nextDateSystem`]: (new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getFullYear())].join('')))),[`timeAllowed`]: (getObjectProperty(___arguments.context.pageData, 'timeAllowed')),[`unitName`]: (getObjectProperty(___arguments.context.appData, 'ptUnitName')),[`unitRef`]: (getObjectProperty(___arguments.context.appData, 'unitRef')),[`roomName`]: (getObjectProperty(___arguments.context.appData, 'roomName')),[`ptLevelId`]: (getObjectProperty(___arguments.context.appData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.appData, 'ptStructureId')),[`nextDateText`]: [(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getFullYear())].join(''),[`xDays`]: (Number((getObjectProperty(___arguments.context.pageData, 'numberInput')))),[`scheduleType`]: 4,[`ptUnitId`]: (getObjectProperty(___arguments.context.appData, 'ptUnitId')),[`definitionText`]: ['','','Occurring every ',(getObjectProperty(___arguments.context.pageData, 'numberInput')) > 0 ? String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String(' days.') : '[ enter ]'].join(''),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName4')),[`HumanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName4')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`nextDate`]: ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getFullYear())].join('')))).valueOf()),[`scheduleElementId`]: (getObjectProperty((await Backendless.Data.of('scheduleElement').save( ({ [`ptLevelId`]: (getObjectProperty(___arguments.context.appData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.appData, 'ptStructureId')),[`businessId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')),[`firstDate`]: ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getFullYear())].join('')))).valueOf()),[`definitionText`]: ['','','Occurring every ',(getObjectProperty(___arguments.context.pageData, 'numberInput')) > 0 ? String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String(' days.') : '[ enter ]'].join(''),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName4')),[`humanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName4')),[`instructionSourceId`]: (generateUUID().long()),[`scheduleType`]: 4,[`xDays`]: (Number((getObjectProperty(___arguments.context.pageData, 'numberInput')))) }) )), 'objectId')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')) })));
      _uow.addToRelation('scheduleAssign', newSchedule, 'relationUnitId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);
      _uow.addToRelation('scheduleAssign', newSchedule, 'relationLevelId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);

    })();

    console.log((await myTx.execute()));
    (getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected'))['scheduleAssigned'] = true;
    await Backendless.Data.of('ptRoomAssign').save((getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected')), true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/d7e6014a0be722c98ad2476a295f8594/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, newSchedule, myTx, y, instructionSourceIdVar, days, i, firstDateTimestamp, scheduleSourceId, x, from, dateSelected, copyDateSelected;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c9f506de24b8eb2e4d87a73f0fd759', undefined);
  try {
    scheduleSourceId = (generateUUID().long());
    for (i = 1; i <= 7; i++) {
      if ((getObjectProperty(___arguments.context.pageData, 'firstDay'))[((i + 0) - 1)] == 1) {
        i = (typeof i == 'number' ? i : 0) + -1;
        break;
      }
    }
    copyDateSelected = ((new Date((getObjectProperty(___arguments.context.pageData, '2DatePick')))).toDateString());
    dateSelected = copyDateSelected;
    from = ((new Date(dateSelected)).valueOf());
    days = 86400000;
    for (x = 0; x <= 6; x++) {
      if ((new Date((new Date(((from - 0) + (x + 0) * days)))).getDay()) - 0 == i - 0) {
        firstDateTimestamp = (from - 0) + (x + 0) * days;
        break;
      }
    }
    var y_start = i - 0;
    var y_inc = 1;
    if (y_start > 7) {
      y_inc = -y_inc;
    }
    for (y = y_start; y_inc >= 0 ? y <= 7 : y >= 7; y += y_inc) {
      if ((getObjectProperty(___arguments.context.pageData, 'firstDay'))[(y - 1)] == 1) {
        console.log(String('  //  trigger date =  ') + String((new Date((firstDateTimestamp + (y - (i + 1)) * days))).toLocaleDateString()));
        console.log(String('  //  trigger date without convert to // date from timestamp =  ') + String(firstDateTimestamp + (y - (i + 1)) * days));
        console.log(['  //  firstDateTimestamp =  ',firstDateTimestamp,'  //  y =  ',y,'  //  i =  ',i,'  //  days =  ',days].join(''));
        myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
        await ( async () => {
          const _uow = myTx;

          newSchedule = (_uow.create('scheduleAssign', ({ [`ptLevelRef`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'levelRef')),[`ptLevelName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'unitDetailsApp')), 'levelName')),[`timeStamp`]: (new Date((firstDateTimestamp + (y - (i + 1)) * days))),[`nextDateSystem`]: undefined,[`timeAllowed`]: (getObjectProperty(___arguments.context.pageData, 'timeAllowed')),[`unitName`]: (getObjectProperty(___arguments.context.appData, 'ptUnitName')),[`unitRef`]: (getObjectProperty(___arguments.context.appData, 'unitRef')),[`roomName`]: (getObjectProperty(___arguments.context.appData, 'roomName')),[`ptLevelId`]: (getObjectProperty(___arguments.context.appData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.appData, 'ptStructureId')),[`xWeeks`]: (getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')),[`nextDateText`]: ((new Date((firstDateTimestamp + (y - (i + 1)) * days))).toLocaleDateString()),[`scheduleType`]: 2,[`ptUnitId`]: (getObjectProperty(___arguments.context.appData, 'ptUnitId')),[`definitionText`]: ['',(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 0 ? '!! No week interval entered !!' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 1 ? ' Every week' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 2 ? 'Every fortnight' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) > 2 ? [' Every ',(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')),' weeks'].join('') : ', on ',(getObjectProperty(___arguments.context.pageData, 'chkMon')) == true ? ' [Monday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkTue')) == true ? ' [Tuesday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkWed')) == true ? ' [Wednesday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkThu')) == true ? ' [Thursday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkFri')) == true ? ' [Friday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkSat')) == true ? ' [Saturday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkSun')) == true ? ' [Sunday]' : null,'.',''].join(''),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName2')),[`HumanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName2')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`nextDate`]: firstDateTimestamp + (y - (i + 1)) * days,[`scheduleElementId`]: (getObjectProperty((await Backendless.Data.of('scheduleElement').save( ({ [`ptLevelId`]: (getObjectProperty(___arguments.context.appData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.appData, 'ptStructureId')),[`businessId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')),[`firstDate`]: firstDateTimestamp + (y - (i + 1)) * days,[`definitionText`]: ['',(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 0 ? '!! No week interval entered !!' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 1 ? ' Every week' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 2 ? 'Every fortnight' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) > 2 ? [' Every ',(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')),' weeks'].join('') : ', on ',(getObjectProperty(___arguments.context.pageData, 'chkMon')) == true ? ' [Monday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkTue')) == true ? ' [Tuesday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkWed')) == true ? ' [Wednesday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkThu')) == true ? ' [Thursday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkFri')) == true ? ' [Friday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkSat')) == true ? ' [Saturday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkSun')) == true ? ' [Sunday]' : null,'.',''].join(''),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName2')),[`humanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName2')),[`instructionSourceId`]: instructionSourceIdVar,[`scheduleType`]: 2,[`weekDayNo`]: y,[`xWeeks`]: (getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) }) )), 'objectId')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')),[`roomRef`]: (getObjectProperty(___arguments.context.appData, 'roomRef')) })));
          _uow.addToRelation('scheduleAssign', newSchedule, 'relationUnitId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);
          _uow.addToRelation('scheduleAssign', newSchedule, 'relationLevelId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);

        })();

        console.log((await myTx.execute()));
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/b8bbfbecc255a0f732bbf8fb0e2f865f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['dayOfWeek'] = 2;
  ___arguments.context.pageData['dayOfWeekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8bbfbecc255a0f732bbf8fb0e2f865f'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46d4deef022567f9ac8e4fce63ef6c54'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('134e7d568e1ee847f6eb9abefbdbb9f5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca84db457e571e757182f2634f047866'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8563a84dd61877a762736091767ecb6'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b26b3116af3987988a663663ebb1cd93'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9def47a481e76bcdf7512931df8b25ca'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f8351362e1836f81fb431576add4010d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ce6d84a6d0c4028b6de0669d3c8d263'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f1a654b70d247d9afc5267d127f24ce'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3fb9136fb99817fd544fad564932e1c'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e2eed7bf9c3698e524867c405c6038d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66cdf56aee9e67b4e86cf884a2eecf2'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8bbfbecc255a0f732bbf8fb0e2f865f'))['background-color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46d4deef022567f9ac8e4fce63ef6c54'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/621964c62fd9c161131fabcbec275aee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'green'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/610c3cad81476c160d98fa53410c9bba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'black'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/0236dd336c8baec6daaad4f870556d94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'blue'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/0a322aa722cfa71c763a1d879929d536/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'teal'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/4a7a75ded80e27968a8431d9247f3f55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'orange'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/658116bf833d1654cd2f85530bca8065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'yellow'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/42ae8a5796b314513b41fd37dc541ad7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'purple'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/807e5193d09d9c5ec8d48891c667c249/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'brown'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/c76ee6719d13977b2494bf7805e7a9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'lime'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/33a9b0e533a8064c598e474831d3b1b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'pink'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/0e45bd5bed94f17e6f8931c5a19a4a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'grey'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/93fd7ea4ccc504026c452341d31b5adf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['unitColour'] = (getObjectProperty(___arguments.context.appData, 'red'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'unitColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3471e13baee23f1379823c33bea2cf1d'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/a9a6963264e31ef95e7741188b3c989a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, myTX;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'green'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/de762fc404a9adddfd6bcf0cba2aaa6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, myTX;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'black'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/15177771ca6b71ec8a31d5289006a049/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, myTX;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'blue'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/7b2a007f882e96858d36966aac193155/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, myTX;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'teal'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/9073df36cef90d0bd8568f9440932c1f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, myTX;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'orange'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/9dadc481b38920143ed4b1e93bb1d697/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'yellow'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/c54ff42306c7422d069beab1aa0b0ba1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'purple'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/b323ee73579f2d4e021ad9ce8c69b4c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'brown'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/26f9551eceff0a0123bf5b8c418db318/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'lime'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/ca2ba43a4ff46e46594dc71872dfa172/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'pink'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/ae2b1d27d4d5d239b6643987c2a296ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'grey'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/2d2ef9715d32ed68d9948cfe48f22edc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['levelColour'] = (getObjectProperty(___arguments.context.appData, 'red'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderColor'] = (getObjectProperty(___arguments.context.appData, 'levelColour'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f8e0a47edb6c1e1b0ea5b150372b022'))['borderLeftWidth'] = '20px';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/ace73f53bd165b3c397f6e91125c6bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ace73f53bd165b3c397f6e91125c6bb2'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb6bf6037a998c1d50d66e3e7b2a1c05'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3ee67b6904c7cff2d6c6410a660828e5'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a08cea188dc7a2dfc51dcee346e842f'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4975a7586623e62ee3cb2002aee60dbc'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c6998ce5f89c3e7356f80e773cdd409'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb13d2e4844c14771dbb95d3b0c9ebaf'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1ae19fcdd699370f8bdfa486d63adccc'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ace73f53bd165b3c397f6e91125c6bb2'))['background-color'] = '#F15c45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb6bf6037a998c1d50d66e3e7b2a1c05'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['everyXMonths'] = 1;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/3ee67b6904c7cff2d6c6410a660828e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ace73f53bd165b3c397f6e91125c6bb2'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb6bf6037a998c1d50d66e3e7b2a1c05'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3ee67b6904c7cff2d6c6410a660828e5'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a08cea188dc7a2dfc51dcee346e842f'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4975a7586623e62ee3cb2002aee60dbc'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c6998ce5f89c3e7356f80e773cdd409'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb13d2e4844c14771dbb95d3b0c9ebaf'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1ae19fcdd699370f8bdfa486d63adccc'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3ee67b6904c7cff2d6c6410a660828e5'))['background-color'] = '#F15c45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a08cea188dc7a2dfc51dcee346e842f'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['everyXMonths'] = 2;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/4975a7586623e62ee3cb2002aee60dbc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ace73f53bd165b3c397f6e91125c6bb2'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb6bf6037a998c1d50d66e3e7b2a1c05'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3ee67b6904c7cff2d6c6410a660828e5'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a08cea188dc7a2dfc51dcee346e842f'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4975a7586623e62ee3cb2002aee60dbc'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c6998ce5f89c3e7356f80e773cdd409'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb13d2e4844c14771dbb95d3b0c9ebaf'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1ae19fcdd699370f8bdfa486d63adccc'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4975a7586623e62ee3cb2002aee60dbc'))['background-color'] = '#F15c45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c6998ce5f89c3e7356f80e773cdd409'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['everyXMonths'] = 3;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/bb13d2e4844c14771dbb95d3b0c9ebaf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ace73f53bd165b3c397f6e91125c6bb2'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb6bf6037a998c1d50d66e3e7b2a1c05'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3ee67b6904c7cff2d6c6410a660828e5'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a08cea188dc7a2dfc51dcee346e842f'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4975a7586623e62ee3cb2002aee60dbc'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c6998ce5f89c3e7356f80e773cdd409'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb13d2e4844c14771dbb95d3b0c9ebaf'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1ae19fcdd699370f8bdfa486d63adccc'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb13d2e4844c14771dbb95d3b0c9ebaf'))['background-color'] = '#F15c45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a08cea188dc7a2dfc51dcee346e842f'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['everyXMonths'] = 6;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/16ae7242bdb395f288d2bd41fb0a6deb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function resetPeriodBttns() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ace73f53bd165b3c397f6e91125c6bb2'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb6bf6037a998c1d50d66e3e7b2a1c05'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3ee67b6904c7cff2d6c6410a660828e5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a08cea188dc7a2dfc51dcee346e842f'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4975a7586623e62ee3cb2002aee60dbc'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c6998ce5f89c3e7356f80e773cdd409'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb13d2e4844c14771dbb95d3b0c9ebaf'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1ae19fcdd699370f8bdfa486d63adccc'))['color'] = '#F15C45';
}


  await resetPeriodBttns();
  if ((getObjectProperty(___arguments.context.pageData, 'everyXMonths')) == 1) {
    try {
      await resetPeriodBttns();
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ace73f53bd165b3c397f6e91125c6bb2'))['background-color'] = '#F15c45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb6bf6037a998c1d50d66e3e7b2a1c05'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['everyXMonths'] = 1;

    } catch (error) {
      console.log(error);

    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'everyXMonths')) == 2) {
    try {
      await resetPeriodBttns();
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3ee67b6904c7cff2d6c6410a660828e5'))['background-color'] = '#F15c45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a08cea188dc7a2dfc51dcee346e842f'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['everyXMonths'] = 2;

    } catch (error) {
      console.log(error);

    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'everyXMonths')) == 3) {
    try {
      await resetPeriodBttns();
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4975a7586623e62ee3cb2002aee60dbc'))['background-color'] = '#F15c45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c6998ce5f89c3e7356f80e773cdd409'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['everyXMonths'] = 3;

    } catch (error) {
      console.log(error);

    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'everyXMonths')) == 6) {
    await resetPeriodBttns();
    try {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb13d2e4844c14771dbb95d3b0c9ebaf'))['background-color'] = '#F15c45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1ae19fcdd699370f8bdfa486d63adccc'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['everyXMonths'] = 6;

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/5817a2b264861686eedf57ada918519a/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/1b7f2b3cbb9e450e06948836781642dc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['displayText'] = (['Every ',(getObjectProperty(___arguments.context.pageData, 'numberInput')),' days.'].join(''));

  return ([(getObjectProperty(___arguments.context.pageData, 'numberInput')),(getObjectProperty(___arguments.context.pageData, 'numberInput')) > 0 ? null : 'Enter frequency.',(getObjectProperty(___arguments.context.pageData, 'numberInput')) == 1 ? ' [every day]' : null,(getObjectProperty(___arguments.context.pageData, 'numberInput')) == 2 ? ' [every other day.]' : null,(getObjectProperty(___arguments.context.pageData, 'numberInput')) == 7 ? ' [weekly.]' : null,(getObjectProperty(___arguments.context.pageData, 'numberInput')) == 14 ? ' [Fortnightly.]' : null,(getObjectProperty(___arguments.context.pageData, 'numberInput')) > 731 ? ' [2 years max. frequency]' : null,(getObjectProperty(___arguments.context.pageData, 'numberInput')) == 365 ? ' [Yearly.]' : null].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/4a2bca641c5532051b1999b10be383de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('1'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/cafa53ca5c7478384113c5ffc8e9f2ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('2'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/dcef8e938787af9a065d77c2c1f6a588/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('3'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/a21426cbdc651dabf07f73fda0471cc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('4'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/3268051391aa7bfa75ef9a686acd122e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('5'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/72d4e50f8d6ce62a10544093c9c23a83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('6'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/11841117c35e4f24ed52f72db1d5ff01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('7'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/f434efb64dfdd43ab388bdb3d3c37d9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/a8ab667c033b74ee8fa686cbf71c1c25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('9'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/c46925bcbcda510f489c5956294c7eb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['numberInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('0'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/3b91e36ec95c63cdb418191541a80c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['numberInput'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/bc378ec839d64161166e0f6de4b9d84b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Starting on ',(getObjectProperty(___arguments.context.pageData, 'schedule4Date')) > 0 ? [(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule4Date'))).getFullYear())].join('') : '[ enter ]',' and occurring every ',(getObjectProperty(___arguments.context.pageData, 'numberInput')) > 0 ? String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String(' days.') : '[ enter ]'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/10d36a8dfd6c4e57778260a5ef77b3cb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Starting on ',(getObjectProperty(___arguments.context.pageData, 'schedule3Date')) > 0 ? [(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getUTCDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'schedule3Date'))).getFullYear())].join('') : '[ enter ]',' and occurring every ',(getObjectProperty(___arguments.context.pageData, 'everyXMonths')) > 0 ? String(getObjectProperty(___arguments.context.pageData, 'everyXMonths')) + String(' months.') : '[ enter ]'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/77c2ce5a35c5e08897129544f8118c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('be74882c4bf534cf9bbdc2ee93c4206e'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('189d430c171c9ce6774656dc8e98b16e'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18b82cd623b5cf6b23ea2de965842ec2'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c33a4b6846e890cb8389d125295df601'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d54ef6c7a77548edca808d6635c10d9'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79277fca834fb466d74c69833507cfac'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77c2ce5a35c5e08897129544f8118c1b'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('421c7ef7d25d741cf5ceee11b977b986'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77c2ce5a35c5e08897129544f8118c1b'))['background-color'] = '#F15c45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('421c7ef7d25d741cf5ceee11b977b986'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['everyNoWeeks'] = 4;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/9d54ef6c7a77548edca808d6635c10d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('be74882c4bf534cf9bbdc2ee93c4206e'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('189d430c171c9ce6774656dc8e98b16e'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18b82cd623b5cf6b23ea2de965842ec2'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c33a4b6846e890cb8389d125295df601'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d54ef6c7a77548edca808d6635c10d9'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79277fca834fb466d74c69833507cfac'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77c2ce5a35c5e08897129544f8118c1b'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('421c7ef7d25d741cf5ceee11b977b986'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d54ef6c7a77548edca808d6635c10d9'))['background-color'] = '#F15c45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79277fca834fb466d74c69833507cfac'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['everyNoWeeks'] = 3;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/18b82cd623b5cf6b23ea2de965842ec2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('be74882c4bf534cf9bbdc2ee93c4206e'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('189d430c171c9ce6774656dc8e98b16e'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18b82cd623b5cf6b23ea2de965842ec2'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c33a4b6846e890cb8389d125295df601'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d54ef6c7a77548edca808d6635c10d9'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79277fca834fb466d74c69833507cfac'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77c2ce5a35c5e08897129544f8118c1b'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('421c7ef7d25d741cf5ceee11b977b986'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18b82cd623b5cf6b23ea2de965842ec2'))['background-color'] = '#F15c45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c33a4b6846e890cb8389d125295df601'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['everyNoWeeks'] = 2;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/be74882c4bf534cf9bbdc2ee93c4206e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('be74882c4bf534cf9bbdc2ee93c4206e'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('189d430c171c9ce6774656dc8e98b16e'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18b82cd623b5cf6b23ea2de965842ec2'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c33a4b6846e890cb8389d125295df601'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d54ef6c7a77548edca808d6635c10d9'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79277fca834fb466d74c69833507cfac'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77c2ce5a35c5e08897129544f8118c1b'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('421c7ef7d25d741cf5ceee11b977b986'))['color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('be74882c4bf534cf9bbdc2ee93c4206e'))['background-color'] = '#F15c45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('189d430c171c9ce6774656dc8e98b16e'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['everyNoWeeks'] = 1;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/a5cd4e28153e1935784f6ea418f1b17e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function resetBttns2() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('be74882c4bf534cf9bbdc2ee93c4206e'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('189d430c171c9ce6774656dc8e98b16e'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18b82cd623b5cf6b23ea2de965842ec2'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c33a4b6846e890cb8389d125295df601'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d54ef6c7a77548edca808d6635c10d9'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79277fca834fb466d74c69833507cfac'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77c2ce5a35c5e08897129544f8118c1b'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('421c7ef7d25d741cf5ceee11b977b986'))['color'] = '#F15C45';
}


  await resetBttns2();
  if ((getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 1) {
    try {
      await resetBttns2();
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('be74882c4bf534cf9bbdc2ee93c4206e'))['background-color'] = '#F15c45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('189d430c171c9ce6774656dc8e98b16e'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['everyNoWeeks'] = 1;

    } catch (error) {
      console.log(error);

    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 2) {
    try {
      await resetBttns2();
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18b82cd623b5cf6b23ea2de965842ec2'))['background-color'] = '#F15c45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c33a4b6846e890cb8389d125295df601'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['everyNoWeeks'] = 2;

    } catch (error) {
      console.log(error);

    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 3) {
    try {
      await resetBttns2();
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d54ef6c7a77548edca808d6635c10d9'))['background-color'] = '#F15c45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79277fca834fb466d74c69833507cfac'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['everyNoWeeks'] = 3;

    } catch (error) {
      console.log(error);

    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 4) {
    try {
      await resetBttns2();
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77c2ce5a35c5e08897129544f8118c1b'))['background-color'] = '#F15c45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('421c7ef7d25d741cf5ceee11b977b986'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['everyNoWeeks'] = 4;

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/19545dd96af5055666cc1bcf88eed301/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['incMon'] = ((getObjectProperty(___arguments.context.pageData, 'incMon')) + 1);
  if ((getObjectProperty(___arguments.context.pageData, 'incMon')) % 2 == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19545dd96af5055666cc1bcf88eed301'))['background-color'] = '#F15C45';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6371d867167adb48897ac23acccdcc11'))['color'] = '#F6f6f4';
    ___arguments.context.pageData['chkMon'] = true;
    (getObjectProperty(___arguments.context.pageData, 'firstDay'))[1] = '1';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19545dd96af5055666cc1bcf88eed301'))['background-color'] = '#F6f6f4';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6371d867167adb48897ac23acccdcc11'))['color'] = '#F15C45';
    ___arguments.context.pageData['chkMon'] = false;
    (getObjectProperty(___arguments.context.pageData, 'firstDay'))[1] = '0';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/b57d67ae050377d75523c451267b3e5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['incTue'] = ((getObjectProperty(___arguments.context.pageData, 'incTue')) + 1);
    if ((getObjectProperty(___arguments.context.pageData, 'incTue')) % 2 == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b57d67ae050377d75523c451267b3e5c'))['background-color'] = '#F15C45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3670bfcb8435f4cc2013518a0fb3cee'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['chkTue'] = true;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[2] = '1';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b57d67ae050377d75523c451267b3e5c'))['background-color'] = '#F6f6f4';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3670bfcb8435f4cc2013518a0fb3cee'))['color'] = '#F15C45';
      ___arguments.context.pageData['chkTue'] = false;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[2] = '0';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/1ad63c427e248543ee98a2393acfdd6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['incWed'] = ((getObjectProperty(___arguments.context.pageData, 'incWed')) + 1);
    if ((getObjectProperty(___arguments.context.pageData, 'incWed')) % 2 == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1ad63c427e248543ee98a2393acfdd6e'))['background-color'] = '#F15C45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a338b8d2c19fe47eb3fcd301040161a3'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['chkWed'] = true;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[3] = '1';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1ad63c427e248543ee98a2393acfdd6e'))['background-color'] = '#F6f6f4';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a338b8d2c19fe47eb3fcd301040161a3'))['color'] = '#F15C45';
      ___arguments.context.pageData['chkWed'] = false;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[3] = '0';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/8ca4bfa49a5ac5d84b2d075ed44de044/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['incThu'] = ((getObjectProperty(___arguments.context.pageData, 'incThu')) + 1);
    if ((getObjectProperty(___arguments.context.pageData, 'incThu')) % 2 == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8ca4bfa49a5ac5d84b2d075ed44de044'))['background-color'] = '#F15C45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b4110335f18be22d4381e479bae7755'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['chkThu'] = true;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[4] = '1';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8ca4bfa49a5ac5d84b2d075ed44de044'))['background-color'] = '#F6f6f4';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b4110335f18be22d4381e479bae7755'))['color'] = '#F15C45';
      ___arguments.context.pageData['chkThu'] = false;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[4] = '0';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/456323c32b4845f92d3ba435e70edeaa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['incFri'] = ((getObjectProperty(___arguments.context.pageData, 'incFri')) + 1);
    if ((getObjectProperty(___arguments.context.pageData, 'incFri')) % 2 == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('456323c32b4845f92d3ba435e70edeaa'))['background-color'] = '#F15C45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8e5ba03441c5196cd0d4785c70ca3752'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['chkFri'] = true;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[5] = '1';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('456323c32b4845f92d3ba435e70edeaa'))['background-color'] = '#F6f6f4';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8e5ba03441c5196cd0d4785c70ca3752'))['color'] = '#F15C45';
      ___arguments.context.pageData['chkFri'] = false;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[5] = '0';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/22a8040e4bb90f5ac651e22e93dfd99b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['incSat'] = ((getObjectProperty(___arguments.context.pageData, 'incSat')) + 1);
    if ((getObjectProperty(___arguments.context.pageData, 'incSat')) % 2 == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22a8040e4bb90f5ac651e22e93dfd99b'))['background-color'] = '#F15C45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('892311485168710512b3d5395fadf643'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['chkSat'] = true;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[6] = '1';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22a8040e4bb90f5ac651e22e93dfd99b'))['background-color'] = '#F6f6f4';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('892311485168710512b3d5395fadf643'))['color'] = '#F15C45';
      ___arguments.context.pageData['chkSat'] = false;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[6] = '0';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/89846ee91e8ad41fb75cd89784c5fabe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['incSun'] = ((getObjectProperty(___arguments.context.pageData, 'incSun')) + 1);
    if ((getObjectProperty(___arguments.context.pageData, 'incSun')) % 2 == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('89846ee91e8ad41fb75cd89784c5fabe'))['background-color'] = '#F15C45';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77b14fcb6f56694310a90e140288052c'))['color'] = '#F6f6f4';
      ___arguments.context.pageData['chkSun'] = true;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[0] = '1';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('89846ee91e8ad41fb75cd89784c5fabe'))['background-color'] = '#F6f6f4';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('77b14fcb6f56694310a90e140288052c'))['color'] = '#F15C45';
      ___arguments.context.pageData['chkSun'] = false;
      (getObjectProperty(___arguments.context.pageData, 'firstDay'))[0] = '0';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/7b4660631982e72344e9f05b00e45584/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedDate'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/83171a575a3b7e09aab1071ac8339cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['',(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 0 ? '!! No week interval entered !!' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 1 ? ' Every week' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 2 ? 'Every fortnight' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) > 2 ? [' Every ',(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')),' weeks'].join('') : ', on ',(getObjectProperty(___arguments.context.pageData, 'chkMon')) == true ? ' [Monday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkTue')) == true ? ' [Tuesday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkWed')) == true ? ' [Wednesday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkThu')) == true ? ' [Thursday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkFri')) == true ? ' [Friday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkSat')) == true ? ' [Saturday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkSun')) == true ? ' [Sunday]' : null,'.',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/134e7d568e1ee847f6eb9abefbdbb9f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['dayOfWeek'] = 3;
  ___arguments.context.pageData['dayOfWeekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8bbfbecc255a0f732bbf8fb0e2f865f'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46d4deef022567f9ac8e4fce63ef6c54'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('134e7d568e1ee847f6eb9abefbdbb9f5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca84db457e571e757182f2634f047866'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8563a84dd61877a762736091767ecb6'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b26b3116af3987988a663663ebb1cd93'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9def47a481e76bcdf7512931df8b25ca'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f8351362e1836f81fb431576add4010d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ce6d84a6d0c4028b6de0669d3c8d263'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f1a654b70d247d9afc5267d127f24ce'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3fb9136fb99817fd544fad564932e1c'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e2eed7bf9c3698e524867c405c6038d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66cdf56aee9e67b4e86cf884a2eecf2'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('134e7d568e1ee847f6eb9abefbdbb9f5'))['background-color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca84db457e571e757182f2634f047866'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/e8563a84dd61877a762736091767ecb6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['dayOfWeek'] = 4;
  ___arguments.context.pageData['dayOfWeekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8bbfbecc255a0f732bbf8fb0e2f865f'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46d4deef022567f9ac8e4fce63ef6c54'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('134e7d568e1ee847f6eb9abefbdbb9f5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca84db457e571e757182f2634f047866'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8563a84dd61877a762736091767ecb6'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b26b3116af3987988a663663ebb1cd93'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9def47a481e76bcdf7512931df8b25ca'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f8351362e1836f81fb431576add4010d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ce6d84a6d0c4028b6de0669d3c8d263'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f1a654b70d247d9afc5267d127f24ce'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3fb9136fb99817fd544fad564932e1c'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e2eed7bf9c3698e524867c405c6038d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66cdf56aee9e67b4e86cf884a2eecf2'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8563a84dd61877a762736091767ecb6'))['background-color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b26b3116af3987988a663663ebb1cd93'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/9def47a481e76bcdf7512931df8b25ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['dayOfWeek'] = 5;
  ___arguments.context.pageData['dayOfWeekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8bbfbecc255a0f732bbf8fb0e2f865f'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46d4deef022567f9ac8e4fce63ef6c54'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('134e7d568e1ee847f6eb9abefbdbb9f5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca84db457e571e757182f2634f047866'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8563a84dd61877a762736091767ecb6'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b26b3116af3987988a663663ebb1cd93'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9def47a481e76bcdf7512931df8b25ca'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f8351362e1836f81fb431576add4010d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ce6d84a6d0c4028b6de0669d3c8d263'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f1a654b70d247d9afc5267d127f24ce'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3fb9136fb99817fd544fad564932e1c'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e2eed7bf9c3698e524867c405c6038d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66cdf56aee9e67b4e86cf884a2eecf2'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9def47a481e76bcdf7512931df8b25ca'))['background-color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f8351362e1836f81fb431576add4010d'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/7ce6d84a6d0c4028b6de0669d3c8d263/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['dayOfWeek'] = 6;
  ___arguments.context.pageData['dayOfWeekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8bbfbecc255a0f732bbf8fb0e2f865f'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46d4deef022567f9ac8e4fce63ef6c54'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('134e7d568e1ee847f6eb9abefbdbb9f5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca84db457e571e757182f2634f047866'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8563a84dd61877a762736091767ecb6'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b26b3116af3987988a663663ebb1cd93'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9def47a481e76bcdf7512931df8b25ca'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f8351362e1836f81fb431576add4010d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ce6d84a6d0c4028b6de0669d3c8d263'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f1a654b70d247d9afc5267d127f24ce'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3fb9136fb99817fd544fad564932e1c'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e2eed7bf9c3698e524867c405c6038d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66cdf56aee9e67b4e86cf884a2eecf2'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ce6d84a6d0c4028b6de0669d3c8d263'))['background-color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f1a654b70d247d9afc5267d127f24ce'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/a3fb9136fb99817fd544fad564932e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['dayOfWeek'] = 7;
  ___arguments.context.pageData['dayOfWeekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8bbfbecc255a0f732bbf8fb0e2f865f'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46d4deef022567f9ac8e4fce63ef6c54'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('134e7d568e1ee847f6eb9abefbdbb9f5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca84db457e571e757182f2634f047866'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8563a84dd61877a762736091767ecb6'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b26b3116af3987988a663663ebb1cd93'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9def47a481e76bcdf7512931df8b25ca'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f8351362e1836f81fb431576add4010d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ce6d84a6d0c4028b6de0669d3c8d263'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f1a654b70d247d9afc5267d127f24ce'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3fb9136fb99817fd544fad564932e1c'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e2eed7bf9c3698e524867c405c6038d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66cdf56aee9e67b4e86cf884a2eecf2'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3fb9136fb99817fd544fad564932e1c'))['background-color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/22111c95b2bae2f3f721b0a3d422f865/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['dayOfWeek'] = 1;
  ___arguments.context.pageData['dayOfWeekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8bbfbecc255a0f732bbf8fb0e2f865f'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46d4deef022567f9ac8e4fce63ef6c54'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('134e7d568e1ee847f6eb9abefbdbb9f5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ca84db457e571e757182f2634f047866'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8563a84dd61877a762736091767ecb6'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b26b3116af3987988a663663ebb1cd93'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9def47a481e76bcdf7512931df8b25ca'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f8351362e1836f81fb431576add4010d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7ce6d84a6d0c4028b6de0669d3c8d263'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f1a654b70d247d9afc5267d127f24ce'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3fb9136fb99817fd544fad564932e1c'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6e2eed7bf9c3698e524867c405c6038d'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66cdf56aee9e67b4e86cf884a2eecf2'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22111c95b2bae2f3f721b0a3d422f865'))['background-color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c66cdf56aee9e67b4e86cf884a2eecf2'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/eff5c6e16b11172f8941d75f737e9d5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['everyNthWeek2'] = '1';
  ___arguments.context.pageData['weekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eff5c6e16b11172f8941d75f737e9d5d'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8ffbea383c3cd55e1c6188166676a41'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('71960a2840655608322389aeebe550b5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f6948b3c620cea756ea485c22636b90c'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0dce9706d401eeafce7ecfc59c2749a9'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4379121e3b97b30ba77f68c43e6980af'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1667e587c64db047dca49fe8d1ee93f4'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36f39508af890727c39f1a249db49cc1'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eff5c6e16b11172f8941d75f737e9d5d'))['background-color'] = '#F15c45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8ffbea383c3cd55e1c6188166676a41'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/71960a2840655608322389aeebe550b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['everyNthWeek2'] = '2';
  ___arguments.context.pageData['weekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eff5c6e16b11172f8941d75f737e9d5d'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8ffbea383c3cd55e1c6188166676a41'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('71960a2840655608322389aeebe550b5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f6948b3c620cea756ea485c22636b90c'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0dce9706d401eeafce7ecfc59c2749a9'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4379121e3b97b30ba77f68c43e6980af'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1667e587c64db047dca49fe8d1ee93f4'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36f39508af890727c39f1a249db49cc1'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('71960a2840655608322389aeebe550b5'))['background-color'] = '#F15c45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f6948b3c620cea756ea485c22636b90c'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/0dce9706d401eeafce7ecfc59c2749a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['everyNthWeek2'] = '3';
  ___arguments.context.pageData['weekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eff5c6e16b11172f8941d75f737e9d5d'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8ffbea383c3cd55e1c6188166676a41'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('71960a2840655608322389aeebe550b5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f6948b3c620cea756ea485c22636b90c'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0dce9706d401eeafce7ecfc59c2749a9'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4379121e3b97b30ba77f68c43e6980af'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1667e587c64db047dca49fe8d1ee93f4'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36f39508af890727c39f1a249db49cc1'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0dce9706d401eeafce7ecfc59c2749a9'))['background-color'] = '#F15c45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4379121e3b97b30ba77f68c43e6980af'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/1667e587c64db047dca49fe8d1ee93f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.pageData['everyNthWeek2'] = '4';
  ___arguments.context.pageData['weekPicked'] = 1;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eff5c6e16b11172f8941d75f737e9d5d'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8ffbea383c3cd55e1c6188166676a41'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('71960a2840655608322389aeebe550b5'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f6948b3c620cea756ea485c22636b90c'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0dce9706d401eeafce7ecfc59c2749a9'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4379121e3b97b30ba77f68c43e6980af'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1667e587c64db047dca49fe8d1ee93f4'))['background-color'] = '#F6f6f4';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36f39508af890727c39f1a249db49cc1'))['color'] = '#F15C45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1667e587c64db047dca49fe8d1ee93f4'))['background-color'] = '#F15c45';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36f39508af890727c39f1a249db49cc1'))['color'] = '#F6f6f4';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/0fdee86cf8459cdfb4f95055b2b5c6a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    
  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/a2354c5b8f82826e7eb1a8558fd75fad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('1'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/7981fa0de588a0220c844b3aa0f9b8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'numberInput')) + String('2'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/10d70fcfe12f8f7a9489d3545f24247f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String('3'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/8bbf49fe21da63f4c0b35ccb7ac8929b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String('4'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/94bc84dc9b46b28d721fb32ea5f489f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String('5'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/d30e7276221575a7a633471155d7be85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String('6'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/02a5849fc6b1f92784c61fcb483ed50d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String('7'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/dca7eaa79cc5ebd53cbe33ba64e2b40b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String('8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/199f7e4c753d603a5281767c3108f379/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String('9'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/266ca10fa34605534bf90dbae1af9bc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String(' '));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/8b4b0a0ddeb228191b471dab309c787e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['drsInput'] = (String(getObjectProperty(___arguments.context.pageData, 'drsInput')) + String(' '));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/4ColumnTablet/components/ef447756d927cbf1107d061e123879cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var year, month, calcNewDayOfMonth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Repeat every ',(getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) > 0 ? [(getObjectProperty(___arguments.context.pageData, 'stringWeeks'))[((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1)],'','',''].join('') : '[unknown]',' week of month, on ',(getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) > 0 ? [(getObjectProperty(___arguments.context.pageData, 'stringDays'))[((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1)],'','',''].join('') : '[unknown]','.  ',['',calcNewDayOfMonth,'/',(getObjectProperty(___arguments.context.pageData, 'stringMonths'))[(month - 1)],'/',year,''].join(''),'',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/4ColumnTablet/components/eda1a663fb4902ad708a992c44f77e45/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() + (86400 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, calcNewDayOfMonth, month, year, j, i, triggerOK, dayOfMonth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  try {
    year = (new Date((getObjectProperty(___arguments.context.pageData, 'datePick1'))).getFullYear());
    dayOfMonth = (new Date((getObjectProperty(___arguments.context.pageData, 'datePick1'))).getDate());
    month = (new Date((getObjectProperty(___arguments.context.pageData, 'datePick1'))).getMonth() + 1);
    triggerOK = false;
    for (i = 1; i <= 7; i++) {
      if ((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1 == (new Date(((new Date((['',month,'/',i,'/',year,''].join('')))).valueOf())).getDay())) {
        break;
      }
    }
    calcNewDayOfMonth = i + ((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1) * 7;
    if (i + ((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1) * 7 <= (new Date((getObjectProperty(___arguments.context.pageData, 'datePick1'))).getDate())) {
      month = (typeof month == 'number' ? month : 0) + 1;
      if (month > 12) {
        year = (typeof year == 'number' ? year : 0) + 1;
      }
      for (j = 1; j <= 7; j++) {
        if ((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1 == (new Date(((new Date((['',month,'/',j,'/',year,''].join('')))).valueOf())).getDay())) {
          calcNewDayOfMonth = j + ((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1) * 7;
          calcNewDayOfMonth = j;
          break;
        }
      }
    }
    ___arguments.context.pageData['year'] = year;
    ___arguments.context.pageData['month'] = month;
    ___arguments.context.pageData['day'] = calcNewDayOfMonth;
    await Backendless.Data.of('scheduleAssign').save( ({ [`definitionText`]: String(['Repeat every ',(getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) > 0 ? String((getObjectProperty(___arguments.context.pageData, 'stringWeeks'))[((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1)]) : '[unknown]',' week of month, on ',(getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) > 0 ? String((getObjectProperty(___arguments.context.pageData, 'stringDays'))[((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1)]) : '[unknown]'].join('')),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName')),[`humanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName')),[`businessId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`nextDate`]: ((new Date(([(getObjectProperty(___arguments.context.pageData, 'month')),'/',(getObjectProperty(___arguments.context.pageData, 'day')),'/',(getObjectProperty(___arguments.context.pageData, 'year'))].join('')))).valueOf()),[`scheduleElementId`]: (getObjectProperty((await Backendless.Data.of('scheduleElement').save( ({ [`businessId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')),[`firstDate`]: ((new Date(([(getObjectProperty(___arguments.context.pageData, 'month')),'/',(getObjectProperty(___arguments.context.pageData, 'day')),'/',(getObjectProperty(___arguments.context.pageData, 'year'))].join('')))).valueOf()),[`definitionText`]: String(['Repeat every ',(getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) > 0 ? String((getObjectProperty(___arguments.context.pageData, 'stringWeeks'))[((getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) - 1)]) : '[unknown]',' week of month, on ',(getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) > 0 ? String((getObjectProperty(___arguments.context.pageData, 'stringDays'))[((getObjectProperty(___arguments.context.pageData, 'dayOfWeek')) - 1)]) : '[unknown]'].join('')),[`humanTaskRef`]: (getObjectProperty(___arguments.context.appData, 'taskRef')),[`humanTaskDescription`]: (getObjectProperty(___arguments.context.pageData, 'scheduleLongName')),[`humanTaskName`]: (getObjectProperty(___arguments.context.pageData, 'scheduleShortName')),[`instructionSourceId`]: (generateUUID().long()),[`scheduleType`]: 1,[`weekDayNo`]: (getObjectProperty(___arguments.context.pageData, 'dayOfWeek')),[`xWeeks`]: (getObjectProperty(___arguments.context.pageData, 'everyNthWeek2')) }) )), 'objectId')),[`ptRoomId`]: (getObjectProperty(___arguments.context.appData, 'ptRoomIdAppData')) }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/4ColumnTablet/components/a7c9f506de24b8eb2e4d87a73f0fd759/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['defineShedule2'] = (['',(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 0 ? '!! No week interval entered !!' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 1 ? ' Every week' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) == 2 ? 'Every fortnight' : null,(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')) > 2 ? [' Every ',(getObjectProperty(___arguments.context.pageData, 'everyNoWeeks')),' weeks'].join('') : ', on ',(getObjectProperty(___arguments.context.pageData, 'chkMon')) == true ? ' [Monday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkTue')) == true ? ' [Tuesday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkWed')) == true ? ' [Wednesday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkThu')) == true ? ' [Thursday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkFri')) == true ? ' [Friday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkSat')) == true ? ' [Saturday]' : null,(getObjectProperty(___arguments.context.pageData, 'chkSun')) == true ? ' [Sunday]' : null,'.',''].join(''));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/4ColumnTablet/components/94399c41e69d73f2006db541ae86e226/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var error, myTX, text, i;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (___arguments.keyCode == 13) {
    try {
      ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
      var i_end = getValueLength((getObjectProperty(___arguments.context.pageData, 'rsContentName')));
      var i_inc = 1;
      if (1 > i_end) {
        i_inc = -i_inc;
      }
      for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
        if ((getObjectProperty(___arguments.context.pageData, 'rsContentName')).charAt((i - 1)) == ',') {
          text = [(getObjectProperty(___arguments.context.pageData, 'rsContentName')).slice(0, i - 1),'%',(getObjectProperty(___arguments.context.pageData, 'rsContentName')).slice(((i + 1) - 1), getValueLength((getObjectProperty(___arguments.context.pageData, 'rsContentName'))))].join('');
          ___arguments.context.pageData['rsContentName'] = text;
        }
      }
      myTX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = myTX;

        _uow.create('ptContentAssign', ({ [`ptRoomId`]: (getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),[`ptUnitId`]: (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),[`ptLevelId`]: (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),[`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`ptContentId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`name`]: (getObjectProperty(___arguments.context.pageData, 'rsContentName')),[`ref`]: (getObjectProperty(___arguments.context.pageData, 'partCode')),[`purchaseOrder`]: (getObjectProperty(___arguments.context.pageData, 'purchaseOrder')) }));
        _uow.create('ptContentElement', ({ [`ptStructureId`]: (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`ptElementId`]: (getObjectProperty(___arguments.context.pageData, 'ptElementId')),[`NLA`]: undefined,[`description`]: 'not included in new structure form',[`ref`]: (getObjectProperty(___arguments.context.pageData, 'partCode')),[`name`]: (getObjectProperty(___arguments.context.pageData, 'rsContentName')) }));

      })();

      await myTX.execute();
      ___arguments.context.pageData['rsContentName'] = '';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/4ColumnTablet/components/1f1cee58458a7e8890d8daad6f0b01ae/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'ptUnitName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/DELETE/components/e66a79092a255981cdb9a501886b9ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var deleteTableLoop, DeleteTable, erroCheck, checkTableLoop;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  erroCheck = false;
  DeleteTable = (await Backendless.Data.of('DELETETABLES').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  for (var checkTableLoop_index in DeleteTable) {
    checkTableLoop = DeleteTable[checkTableLoop_index];
    if ((getObjectProperty(checkTableLoop, 'deleteRequired')) == 1 && (getObjectProperty(checkTableLoop, 'tableName')).indexOf('scheduleNextDay') + 1 == 1) {
      erroCheck = true;
    }
  }
  if (erroCheck == false) {
    for (var deleteTableLoop_index in DeleteTable) {
      deleteTableLoop = DeleteTable[deleteTableLoop_index];
      if ((getObjectProperty(deleteTableLoop, 'tableName')).indexOf('scheduleNextDay') + 1 == 1 || (getObjectProperty(deleteTableLoop, 'deleteRequired')) == 0) {
      } else {
        console.log(['DELETING ',(getObjectProperty(deleteTableLoop, 'tableName')),' /// Total deleted = ',(await Backendless.Data.of((getObjectProperty(deleteTableLoop, 'tableName'))).bulkDelete( 'objectId IS NOT NULL && doNotDelete = 0' ))].join(''));
      }
    }
  } else {
    console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
    console.log('XXXXXXXXXXXXXX--TABLE DELETION FAULT--XXXXXXXXXXXXXXXXXXXXXXXX');
    console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inviteNewUser1', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bad8a9f39a4944583a0388f2b6282598', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb6926832144ca9edf05fd1abae71687', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('ingredientsOptionsBlock is not used for navigation');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb6926832144ca9edf05fd1abae71687', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abd65d98a8f13eb14258508f56a82ccc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba525ce8888ecc140ea8202876d37858', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abd65d98a8f13eb14258508f56a82ccc', false);
  ___arguments.context.pageData['producerListingsPageData'] = (await Promise.all((await Backendless.Data.of('producerListings').find(Backendless.DataQueryBuilder.create().setWhereClause((['producerId = \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId2')),'\''].join(''))).setPageSize(20))).map(async item => {; return [({ [`Planted`]: (getObjectProperty(item, 'humanPlantingDate')) }), ({ [`PlantedDays`]: (Number.parseFloat((((getObjectProperty(item, 'plantingDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(0)) }), ({ [`Name`]: (getObjectProperty(item, 'listingName')) }), ({ [`Harvest`]: (getObjectProperty(item, 'humanHarvestFromDate')) }), ({ [`HarvestDays`]: (Number.parseFloat((((getObjectProperty(item, 'harvestFromDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(0)) }), ({ [`ref1`]: (getObjectProperty(item, 'ref1')) }), ({ [`ref2`]: (getObjectProperty(item, 'ref2')) }), ({ [`Ref3`]: (getObjectProperty(item, 'ref3')) })];})));
  console.log('producerListingsPageData ================================');
  console.log(getObjectProperty(___arguments.context.pageData, 'producerListingsPageData'));
  console.log('finished map items run ');
  ___arguments.context.pageData['groupToggle'] = 'Vegetable';
  ___arguments.context.pageData['dateError'] = 'Save';
  try {
    ___arguments.context.pageData['publicHolsFound'] = 0;
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('p10') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('p20') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('518cbb1abaeec733dd8cda0ad08c81cf', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/XX1produceIngredients/components/518cbb1abaeec733dd8cda0ad08c81cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb6926832144ca9edf05fd1abae71687', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bad8a9f39a4944583a0388f2b6282598', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/e37dc8461c0f082101f353c86381d346/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/0478c02f65289a5530ee8078f883b56b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba525ce8888ecc140ea8202876d37858', true);
  ___arguments.context.pageData['selectedProduce'] = ___arguments.selectedRecord;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ba525ce8888ecc140ea8202876d37858')));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['group = \'',(getObjectProperty(___arguments.context.pageData, 'groupToggle')),'\'','',''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Full catalogue list filtered by ') + String(getObjectProperty(___arguments.context.pageData, 'groupToggle')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/XX1produceIngredients/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/a448acbc86c81046ecd149f854582858/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('producerListings').save( ({ [`harvestDays`]: (getObjectProperty(___arguments.context.pageData, 'harvestDays')),[`humanHarvestFromDate`]: (new Intl.DateTimeFormat(undefined, undefined).format((getObjectProperty(___arguments.context.pageData, 'harvestFromDate')))),[`harvestFromDate`]: (getObjectProperty(___arguments.context.pageData, 'harvestFromDate')),[`humanHarvestToDate`]: undefined,[`harvestToDate`]: undefined,[`businessName`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessTag')),[`humanPlantingDate`]: (new Intl.DateTimeFormat(undefined, undefined).format((getObjectProperty(___arguments.context.pageData, 'plantingDate')))),[`plantingDate`]: (getObjectProperty(___arguments.context.pageData, 'plantingDate')),[`doNotDelete`]: 1,[`ecoFoodId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedBusiness')), 'objectId')),[`extendRange`]: false,[`humanString`]: undefined,[`listingName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedProduce')), 'produceName')),[`produceListingLive`]: false,[`producerId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`ref1`]: (getObjectProperty(___arguments.context.pageData, 'inputRef1')),[`ref2`]: (getObjectProperty(___arguments.context.pageData, 'inputRef2')),[`ref3`]: (getObjectProperty(___arguments.context.pageData, 'inputRef3')),[`unitSale`]: undefined,[`userId`]: (getObjectProperty(___arguments.context.appData, 'selectedId')) }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abd65d98a8f13eb14258508f56a82ccc', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abd65d98a8f13eb14258508f56a82ccc', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba525ce8888ecc140ea8202876d37858', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/bbb4ca948267ff18951411a851389503/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ba525ce8888ecc140ea8202876d37858', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/XX1produceIngredients/components/61f3dee8ce781dc81bab92488cc89b58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['groupToggle'] = 'Vegetable';
    ___arguments.context.pageData['fruitTog'] = false;
    ___arguments.context.pageData['herbTog'] = false;
    ___arguments.context.pageData['cutTog'] = false;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/XX1produceIngredients/components/24b6a443df2c7938c0382f9d6c38ff9e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['groupToggle'] = 'Cut Flower';
    ___arguments.context.pageData['vegTog'] = false;
    ___arguments.context.pageData['fruitTog'] = false;
    ___arguments.context.pageData['herbTog'] = false;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/XX1produceIngredients/components/99a85065c1bedb0d9ac21a68f2e8e608/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['groupToggle'] = 'Fruit';
    ___arguments.context.pageData['vegTog'] = false;
    ___arguments.context.pageData['herbTog'] = false;
    ___arguments.context.pageData['cutTog'] = false;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/XX1produceIngredients/components/3d62d1e813ccd8e86cb2faae8a281b18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['groupToggle'] = 'Herb';
    ___arguments.context.pageData['vegTog'] = false;
    ___arguments.context.pageData['fruitTog'] = false;
    ___arguments.context.pageData['cutTog'] = false;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/XX1produceIngredients/components/8f0886af92d41e02152b75a8e45503a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('7381334f1ffd06da0b870a7832a2cb4c'), 'humanPlantingDate')),(Number.parseFloat((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7381334f1ffd06da0b870a7832a2cb4c'), 'plantingDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(1)) > '1' ? ' [ +' : ' [ ',(Number.parseFloat((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7381334f1ffd06da0b870a7832a2cb4c'), 'plantingDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(0)),' ]','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/XX1produceIngredients/components/691833d84dbb6198bac8bba84b789d34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Produce list for - ') + String(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessTag')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/XX1produceIngredients/components/abd65d98a8f13eb14258508f56a82ccc/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f458bb4a162532d14dc2c678b0535f48', (await Backendless.Data.of('producerListings').find(Backendless.DataQueryBuilder.create().setWhereClause((['producerId = \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId2')),'\''].join(''))).setPageSize(20))));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/XX1produceIngredients/components/f2771478acdd8db80e3c3c214418c5b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('on chenage event - ');
  console.log(getObjectProperty(___arguments.context.pageData, 'plantingDate'));
  ___arguments.context.pageData['plantingDateEntered'] = 1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/XX1produceIngredients/components/9df875b89c7e6e9ba2f832e8991cbb51/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'plantingDate')) > (getObjectProperty(___arguments.context.pageData, 'harvestFromDate'))) {
    ___arguments.context.pageData['errorSave'] = 'Planting date cannot be after Harvest date';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b784a0c88f580248685846e860450648', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('913968c83e08d24836381d58cd77c3f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a448acbc86c81046ecd149f854582858', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b784a0c88f580248685846e860450648', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('913968c83e08d24836381d58cd77c3f4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a448acbc86c81046ecd149f854582858', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/XX1produceIngredients/components/4344ae58e3baad5450286c9805fdf509/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b784a0c88f580248685846e860450648', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a448acbc86c81046ecd149f854582858', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('913968c83e08d24836381d58cd77c3f4', true);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/XX1produceIngredients/components/12085af868e85698a8486634ac48aa98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b861b34cf859b85bbc6a83f4a5aaa8'), 'humanHarvestFromDate')),(Number.parseFloat((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b861b34cf859b85bbc6a83f4a5aaa8'), 'harvestFromDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(1)) > '1' ? ' [ +' : ' [ ',(Number.parseFloat((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b861b34cf859b85bbc6a83f4a5aaa8'), 'harvestFromDate')) - ((new Date()).valueOf())) / 86400000)).toFixed(0)),' ]','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/addBusinessTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/addBusinessTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('inviteNewUser1', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/addBusinessTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/addBusinessTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addBusinessTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    var error;


  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    if ((___arguments.context.appData['userRole']).indexOf('z10') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    if ((___arguments.context.appData['userRole']).indexOf('z20') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', true);
    }
    if ((___arguments.context.appData['userRole']).indexOf('z30') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/addressTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/addressTopMenu/components/99bc9b32664aade9c3b844c4bb66cd63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('typeOfBusinessRegistration', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/addressTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('inviteNewUser1', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/addressTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/addressTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addressTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    var error;


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    if ((___arguments.context.appData['userRole']).indexOf('g10') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/adminUniversal/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userTopMenu10', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var founderLiveVar;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function testForFounder() {
  ___arguments.context.appData['adminText'] = 'Human Resource admin.';
  founderLiveVar = [];
  ___arguments.context.appData['founderLive'] = 0;
  if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.founderControl')) == 1 && (getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('a00') + 1 > 0) {
    ___arguments.context.appData['adminText'] = '!! You can only add an \'Owner\' at this point. However, you can change an owners role by using the ‘Update User Roles’ button. No card payments are required.';
  }
}

/**
 * Describe this function...
 */
async function toggleComponents() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb081e4b90bd8a75e728c5f4d658f408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('184663650ea4dbc39778f698e8e83ad8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fdcdcf3cc1c5ef3a3756f228cd4822ae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3bcb0894cd7d94fadfe6d5d0203be08', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cafe52fb3af87358bf67e8b137ef466', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f71fcb535ea78377881af18eb09d7866', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7cf1a0268f476cf4462cd39244423d6d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('193a7e38a69a119b527c568598b90315', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f8dbc3c3d0ade19b77724d8d13dd195', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f650335748ef59475de045dd9b1cbd6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7baaa318137d155951d8b0be1e49c731', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df0be15b025647f9a7043cbeb3f117cb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('764751a3c07fcb4a904bbd413be9659f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4c5d718d54caa7a77394dbc5ffe849b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('84cce94864c319e1d32b93661e7abbb5', false);
}


  console.log('check from building management display logic at end');
  await toggleComponents();
  await testForFounder();
  if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.contractDaysWork')) == 0) {
    ___arguments.context.appData['holidayRequestDisplayText'] = 'Request a holiday.';
  } else {
    ___arguments.context.appData['holidayRequestDisplayText'] = 'System can confirm holidays requests 24/7.';
  }
  console.log('////////// userRoleTrimmed[appData] = ');
  ___arguments.context.appData['userRoleTrimmed'] = ((getObjectProperty(___arguments.context.appData, 'userRole')).slice(0, (getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('*') + 1));
  console.log(getObjectProperty(___arguments.context.appData, 'userRoleTrimmed'));
  console.log('/////////  close userRoleTrimmed.');
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('c') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fdcdcf3cc1c5ef3a3756f228cd4822ae', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('d') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3bcb0894cd7d94fadfe6d5d0203be08', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('z') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cafe52fb3af87358bf67e8b137ef466', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('184663650ea4dbc39778f698e8e83ad8', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df0be15b025647f9a7043cbeb3f117cb', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('p') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f71fcb535ea78377881af18eb09d7866', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('s') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7cf1a0268f476cf4462cd39244423d6d', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('f') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('193a7e38a69a119b527c568598b90315', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('i') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f8dbc3c3d0ade19b77724d8d13dd195', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('o') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f650335748ef59475de045dd9b1cbd6', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('g') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7baaa318137d155951d8b0be1e49c731', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('z') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('84cce94864c319e1d32b93661e7abbb5', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('z') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4c5d718d54caa7a77394dbc5ffe849b', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('w') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('764751a3c07fcb4a904bbd413be9659f', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('Removed from business') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb081e4b90bd8a75e728c5f4d658f408', true);
  }
  console.log('override logic to prevent \'building management\' from displaying');
  if ((getObjectProperty(___arguments.context.appData, 'buildingManagementVisable')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('184663650ea4dbc39778f698e8e83ad8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fdcdcf3cc1c5ef3a3756f228cd4822ae', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3bcb0894cd7d94fadfe6d5d0203be08', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cafe52fb3af87358bf67e8b137ef466', false);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/adminUniversal/components/f71fcb535ea78377881af18eb09d7866/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('1produceIngredients', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/7cf1a0268f476cf4462cd39244423d6d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('salesEnquiryTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/193a7e38a69a119b527c568598b90315/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ordersDeliverTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/4f8dbc3c3d0ade19b77724d8d13dd195/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('1ingredientsTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/2f650335748ef59475de045dd9b1cbd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ordersTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/7baaa318137d155951d8b0be1e49c731/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('goodsInTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/764751a3c07fcb4a904bbd413be9659f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('businessDetailsTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/84cce94864c319e1d32b93661e7abbb5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('addressTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/b4c5d718d54caa7a77394dbc5ffe849b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('addBusinessTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/a0baa97b54f32293dc657c4d2abe2b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.appData, 'adminText')) + String(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/adminUniversal/components/2cafe52fb3af87358bf67e8b137ef466/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('4ColumnTablet', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/f3bcb0894cd7d94fadfe6d5d0203be08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('familyTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/184663650ea4dbc39778f698e8e83ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('unitView', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/adminUniversal/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function closeMajorTabs() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c798b31934df2de200e7a19166ba53b6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c8908b77beb0f1145363703ed9123b3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c58bc675b9350caae2d0f9dba19017a', undefined);
}


  await closeMajorTabs();
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('b10') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('b20') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('b30') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('b40') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51a231edb5d589f195d8be3f90c535af', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function onEnterToggle() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6989dcb970bc90431542d04f5f8a4c2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d2692d8d808560c1cd7f0a89eec96fd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df0be15b025647f9a7043cbeb3f117cb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c798b31934df2de200e7a19166ba53b6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c8908b77beb0f1145363703ed9123b3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c58bc675b9350caae2d0f9dba19017a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cefc4b94602bce1b8764004f85cd238', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51a231edb5d589f195d8be3f90c535af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a596d7c351bbbca2c71edbed8aff6e2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d52478eca1450309b8818382bee8c1dd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5f5cfa7e738a796f5ef90326c3c734', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('086edab8415cc3c157621291262b8e1f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae0d248eeff1cc6a86e372abb11dfb8f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6b1b64ac9ab4b39a4587679dd91c7e2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73f8c2be4159c991a3f5099a9d760b12', false);

  } catch (error) {
    console.log(error);

  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function logicToggle() {
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('b') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df0be15b025647f9a7043cbeb3f117cb', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w1') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c798b31934df2de200e7a19166ba53b6', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w3') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c8908b77beb0f1145363703ed9123b3', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w2') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c58bc675b9350caae2d0f9dba19017a', undefined);
  }
}


  await onEnterToggle();
  await logicToggle();

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    var error;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/c798b31934df2de200e7a19166ba53b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function closeMajorTabs() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df0be15b025647f9a7043cbeb3f117cb', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c8908b77beb0f1145363703ed9123b3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c58bc675b9350caae2d0f9dba19017a', undefined);
}


  await closeMajorTabs();
  (function (message) { alert(message) })('///direct to business holiday year settings');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/4c8908b77beb0f1145363703ed9123b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function closeMajorTabs() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df0be15b025647f9a7043cbeb3f117cb', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c798b31934df2de200e7a19166ba53b6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c58bc675b9350caae2d0f9dba19017a', undefined);
}


  await closeMajorTabs();
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w32') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a596d7c351bbbca2c71edbed8aff6e2', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w33') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d52478eca1450309b8818382bee8c1dd', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w34') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf5f5cfa7e738a796f5ef90326c3c734', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/3c58bc675b9350caae2d0f9dba19017a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function closeMajorTabs() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df0be15b025647f9a7043cbeb3f117cb', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c798b31934df2de200e7a19166ba53b6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c8908b77beb0f1145363703ed9123b3', undefined);
}


  await closeMajorTabs();
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w21') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('086edab8415cc3c157621291262b8e1f', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w22') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae0d248eeff1cc6a86e372abb11dfb8f', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w23') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6b1b64ac9ab4b39a4587679dd91c7e2', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/ff6c31a6e44c56f8b44bfbf8f8884698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/cf5f5cfa7e738a796f5ef90326c3c734/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness'));
  ___arguments.context.pageData['viewEventsWhere'] = (['businessLinkId = \'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\' and contentCatCode = \'100\''].join(''));
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('w31') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d2692d8d808560c1cd7f0a89eec96fd', true);
    console.log('display \'displayAddBusyPeriodContainer"');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6989dcb970bc90431542d04f5f8a4c2', false);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/businessDetailsTopMenu/components/9d2692d8d808560c1cd7f0a89eec96fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f6989dcb970bc90431542d04f5f8a4c2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/businessName/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/deCompressFunction/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var txResult, myTx, listOfObjects, eof, foundField, colour, name2, objectId, length2, iconPosition, roomTextLength, unPackColumn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function unPackField(unPackColumn) {
  listOfObjects = [];
  foundField = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'foundField'))[0]), unPackColumn));
  while (!(iconPosition == 0)) {
    iconPosition = foundField.indexOf('') + 1;
    roomTextLength = foundField.indexOf('©') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 4) - 1), iconPosition + 6))));
    objectId = foundField.slice(((iconPosition + 7) - 1), iconPosition + length2 + 6);
    iconPosition = foundField.indexOf('◊') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 1) - 1), iconPosition + 3))));
    name2 = foundField.slice(((iconPosition + 4) - 1), iconPosition + length2 + 3);
    iconPosition = foundField.indexOf('∑') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 1) - 1), iconPosition + 3))));
    colour = foundField.slice(((iconPosition + 4) - 1), iconPosition + length2 + 3);
    addItemToList(listOfObjects, ({ [`objectId`]: objectId,[`roomName`]: name2,[`colour`]: colour }));
    foundField = foundField.slice(((foundField.indexOf('©') + 1 + 1) - 1), foundField.length);
    eof = foundField.indexOf('') + 1;
    if (eof == 0) {
      break;
    }
  }
  return listOfObjects
}


  myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTx;

    _uow.find('unitTable', Backendless.DataQueryBuilder.create().setWhereClause('objectId = \'70FE51F1-9D56-4EA2-A489-ABE7E9AB9EEE\'').setPageSize(10)).setOpResultId('testFieldRead');

  })();

  txResult = (await myTx.execute());
  ___arguments.context.pageData['foundField'] = (getObjectProperty((txResult.getResults()), 'testFieldRead.result'));
  console.log(await unPackField('roomIds'));
  console.log(await unPackField('contentsIds'));
  console.log(await unPackField('schedulesIds'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/defaultPageLayout1/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/distancePick/components/db8fa93fb7e9212c0cbb9ee77197541f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['radius'] = '1';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('producerRegistration4', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/distancePick/components/d18c2fdb70e15726ff6dfdd19bd2c3ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.appData['radius'] = '2';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('producerRegistration4', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/distancePick/components/09a357b94a287b27f0d1141a5dbbd2a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.appData['radius'] = '4';
  await ( async function (pageName, pageData) { BackendlessUI.goToPage(pageName, pageData) })('producerRegistration4', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/distancePick/components/d4d3d9fed147e64c973b5211ea8dbf8f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['radius'] = '6';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('producerRegistration4', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/distancePick/components/35a249a92a97eceda2b3b19c66dfc45c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['radius'] = '10';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('producerRegistration4List', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/distancePick/components/a0b8db65bc6c2d528895bdaf59c2062c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/distancePick/components/a176a1fe7778846f53dd2f2c8f69c8fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'tradingText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/distancePick/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/familyTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/familyTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('inviteNewUser1', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/familyTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/familyTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/familyTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33328183b5a5e4de6ec19eadf145bf2b', false);
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userSpecificRoles')).indexOf('p10') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userSpecificRoles')).indexOf('p20') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userSpecificRoles')).indexOf('p30') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userSpecificRoles')).indexOf('p40') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33328183b5a5e4de6ec19eadf145bf2b', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/goodsInTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/goodsInTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('inviteNewUser1', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/goodsInTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/goodsInTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/goodsInTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54f9785d3bd478bc96f1cd57988359c8', false);
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('g10') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('g20') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('g30') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('g40') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54f9785d3bd478bc96f1cd57988359c8', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function onEnterToggle() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6163ecf8498625d82a5165fc67480cd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b41e40df7ff5ec9312bd973e8efea49', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1016be1da81e2e81ec635e9d7b36b6c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0f4fe909d171ba6830dbca198b2e37c5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f3f2606c62ea7c18bf5b709345a5a24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a8a4c9fd473b42d84b4b2a827c27ac49', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7efafbd14ee45ea58d6467819167cee', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9218cd226f559659011c436a344f4352', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8a58ae07daff59ece0095ad2afb9fa4f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94bc36c4bd463ca734032f8ca4833538', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('678a96c9f3ed893b7d425ab790954beb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c9b9a0b8a015e18daac3f958989138c', false);
    ___arguments.context.pageData['currentRoomContentNo'] = 0;
    ___arguments.context.pageData['displayBuildingContentsList'] = false;

  } catch (error) {
    console.log(error);

  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function logicToggle() {
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z4') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
  }
}


  await onEnterToggle();
  await logicToggle();

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['elementContentLogic'] = false;
  ___arguments.context.pageData['listContentsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = false;
  ___arguments.context.pageData['contentRowPickLogic'] = false;
  ___arguments.context.pageData['assignContentRowLogic'] = false;
  ___arguments.context.pageData['structureWhereClause'] = 'nil';
  ___arguments.context.pageData['levelWhereClause'] = 'nil';
  ___arguments.context.pageData['unitWhereClause'] = 'nil';
  ___arguments.context.pageData['roomWhereClause'] = 'nil';
  ___arguments.context.pageData['toggleLogic1'] = false;
  ___arguments.context.pageData['showStructuresLogic'] = false;
  ___arguments.context.pageData['showLevelsLogic'] = false;
  ___arguments.context.pageData['showUnitsLogic'] = false;
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['showContentsLogic'] = false;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/2ea3700cbb7b1542d4aacfe691539997/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['structureWhereClause'] = (['businessLinkId = ','\'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z40') + 1 > 0) {
      ___arguments.context.pageData['showStructuresLogic'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/75b8d47cbbcde4e7505381283f12004c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showLevelsLogic'] = true;
  ___arguments.context.pageData['showStructuresLogic'] = false;
  ___arguments.context.pageData['ptStructureName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'Name'));
  ___arguments.context.pageData['ptStructureId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'ptStructureId'));
  ___arguments.context.pageData['levelWhereClause'] = (['ptStructureId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5844513e6097bafacc831dd5e552b0d'), 'ptStructureId')),'\'','',''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0f4fe909d171ba6830dbca198b2e37c5', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/d95e083832186834a95bbc6130d72935/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/87049db2f23b475a7f466f12f8fd8e04/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/19315d86676cb5f92d3c8901d6c4c633/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessTag')),' / Buildings.','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/84f5b9cef733787e69b6fcd26043d403/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showUnitsLogic'] = true;
  ___arguments.context.pageData['showLevelsLogic'] = false;
  ___arguments.context.pageData['ptLevelName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'Name'));
  ___arguments.context.pageData['ptLevelId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'ptLevelId'));
  ___arguments.context.pageData['unitWhereClause'] = (['ptLevelId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cef17e14848e4c7286aeec5f37d11a1b'), 'ptLevelId')),'\'','',''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f3f2606c62ea7c18bf5b709345a5a24', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/f0fa7ec537f80fd64b5396da6eef5293/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', false);
  if ((getObjectProperty(___arguments.context.pageData, 'showLevelsLogic')) == true) {
    ___arguments.context.pageData['levelPickRowData'] = (await asyncListSort((await Backendless.Data.of('ptLevelAssign').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'levelWhereClause'))).setPageSize(10))), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8db5c66a3a9e50e5296c179d0dc43715', (getObjectProperty(___arguments.context.pageData, 'levelPickRowData')));
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/4ea5b442e3829e4843eeb2c36416b3a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
  ___arguments.context.pageData['currentStructureId'] = (getObjectProperty(___arguments.context.pageData, 'ptElementId'));
  await Backendless.Data.of('ptStructureAssign').save( ({ 'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'Name': (getObjectProperty(___arguments.context.pageData, 'Name')),'Ref': (getObjectProperty(___arguments.context.pageData, 'newStructureRef')) }) );
  await Backendless.Data.of('ptStructureElement').save( ({ 'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'ptElementId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'NLA': undefined,'description': 'not included in new structure form','Ref': (getObjectProperty(___arguments.context.pageData, 'newStructureRef')),'Name': (getObjectProperty(___arguments.context.pageData, 'Name')) }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
  ___arguments.context.pageData['Name'] = '';
  ___arguments.context.pageData['newStructureRef'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/656f42d37ae484c31baa49cac9d22d7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/b7eecd2c8ba572552511f9def39bdfbd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
  await Backendless.Data.of('ptLevelAssign').save( ({ 'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'Name': (getObjectProperty(___arguments.context.pageData, 'newLevelName')),'ref': (getObjectProperty(___arguments.context.pageData, 'newLevelRef')) }) );
  await Backendless.Data.of('ptLevelElement').save( ({ 'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'ptElementId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'NLA': undefined,'description': 'not included in new structure form','ref': (getObjectProperty(___arguments.context.pageData, 'newLevelRef')),'Name': (getObjectProperty(___arguments.context.pageData, 'newLevelName')) }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', undefined);
  ___arguments.context.pageData['newLevelRef'] = '';
  ___arguments.context.pageData['newLevelName'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/94bc36c4bd463ca734032f8ca4833538/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['showStructuresLogic'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('678a96c9f3ed893b7d425ab790954beb', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c9b9a0b8a015e18daac3f958989138c', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac88d0e838b8d8e405164fb8761894c2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/8d74ff2c1eb9856cfdb9aba6c7f1429d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
  await Backendless.Data.of('ptUnitAssign').save( ({ 'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'Name': (getObjectProperty(___arguments.context.pageData, 'newUnitName')),'ref': (getObjectProperty(___arguments.context.pageData, 'newUnitRef')) }) );
  await Backendless.Data.of('ptUnitElement').save( ({ 'department': 'department x','businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'ptElementId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'NLA': undefined,'description': 'not included in new structure form','Ref': (getObjectProperty(___arguments.context.pageData, 'newUnitRef')),'Name': (getObjectProperty(___arguments.context.pageData, 'newUnitName')) }) );
  ___arguments.context.pageData['newUnitRef'] = '';
  ___arguments.context.pageData['newUnitName'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/76edd0fb8f7e6be869ba90b6bcc3369b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showRoomsLogic'] = true;
  ___arguments.context.pageData['showUnitsLogic'] = false;
  ___arguments.context.pageData['ptUnitName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'Name'));
  ___arguments.context.pageData['ptUnitId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'ptUnitId'));
  ___arguments.context.pageData['roomWhereClause'] = (['ptUnitId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c007e1195e8b7233a0a34cfbbe1af92f'), 'ptUnitId')),'\'','',''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a8a4c9fd473b42d84b4b2a827c27ac49', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/152f795866d9412b595628e2c1b600a6/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', false);
    if ((getObjectProperty(___arguments.context.pageData, 'showUnitsLogic')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc351717f183cc7871898f6551770208', (await asyncListSort((await Backendless.Data.of('ptUnitAssign').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'unitWhereClause'))).setPageSize(10))), -1, async (item) => {


       return (getObjectProperty(item, 'Name'));
      })));
    }

  } catch (error) {
    console.log(String('unitWhereClause / unitView to \'unitPickRow\' repeater') + String(error));

  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/20f74a9e9d69d4a8fc3ff7112d5f18ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/4b6e3c419b916815550f95fb6f1ca2e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'ptStructureName')),' / Level.','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/e702e5a74736912702ed97667bc4c3e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['showRoomsLogic'] = false;
    ___arguments.context.pageData['assignedContentLogic'] = true;
    ___arguments.context.pageData['ptRoomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
    ___arguments.context.pageData['ptRoomId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptElementId'));
    ___arguments.context.pageData['ptRoomId2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptRoomId'));
    ___arguments.context.pageData['contentWhereClause'] = (['ptRoomId = ','\'',(getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),'\'','',''].join(''));
    ___arguments.context.pageData['levelWhereClause'] = (['ptStructureId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptStructureId')),'\'','',''].join(''));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7efafbd14ee45ea58d6467819167cee', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1016be1da81e2e81ec635e9d7b36b6c', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/aecaf3e4db85f389ba714b2f34fee193/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', false);
  if ((getObjectProperty(___arguments.context.pageData, 'showRoomsLogic')) == true) {
    console.log(getObjectProperty(___arguments.context.pageData, 'roomWhereClause'));
    console.log([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ','Ref = \'','MT1','\''].join(''));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('07613b843ce6e63b560d8037679e71c1', (await Backendless.Data.of('ptRoomAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),'','','',''].join(''))).setPageSize(30))));
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/fc76ef85fc5c5ecb0c58e95eb6313e94/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'ptUnitName')) + String(' / Rooms'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/b2b78485c2695a8b75a6330390f18e42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  // allow user to define & save a new room AND assign the new room (element)
  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    ___arguments.context.pageData['roomRef'] = '';
    ___arguments.context.pageData['roomName'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1016be1da81e2e81ec635e9d7b36b6c', undefined);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('businessDefineSchedule', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/0afff5b896332b981362cbe76b6fbd55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    await Backendless.Data.of('ptContentAssign').save( ({ 'ptRoomId': (getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'ptContentId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'name': (getObjectProperty(___arguments.context.pageData, 'rsContentName')),'ref': (getObjectProperty(___arguments.context.pageData, 'partCode')) }) );
    await Backendless.Data.of('ptContentElement').save( ({ 'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'ptElementId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'NLA': undefined,'description': 'not included in new structure form','ref': (getObjectProperty(___arguments.context.pageData, 'partCode')),'name': (getObjectProperty(___arguments.context.pageData, 'rsContentName')) }) );
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', undefined);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e65fd593bef46d26017dce0690ce278f')));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/8da6202ff1811307dbe7d04f1e444b74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['toggleLogic1'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/b272a65b0845bebfb065d8feb54b52da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'togCalendar')) == true) {
    console.log('togClean is ON');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf7c809849fc8c9104aeef24dae911e6'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bfb1b6ff26d1dbb3593917c60328a57'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e91439048965055fdb5719688176e221'))['opacity'] = 0.3;
    console.log(___arguments.value);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/e65fd593bef46d26017dce0690ce278f/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'assignedContentLogic')) == true) {
    ___arguments.context.pageData['currentRoomContent'] = (await asyncListSort((await Backendless.Data.of('ptContentAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'levelWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(40))), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    }));
    ___arguments.context.pageData['currentRoomContentNo'] = ((getObjectProperty(___arguments.context.pageData, 'currentRoomContent')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ca29e6c7955edb18bab7f4b37e631ca6', (getObjectProperty(___arguments.context.pageData, 'currentRoomContent')));
    ___arguments.context.pageData['contentBuildingCurrent'] = (await asyncListSort((await Backendless.Data.of('ptContentElement').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'levelWhereClause')),'',''].join(''))).setPageSize(40))), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    }));
    ___arguments.context.pageData['contentBuildingCurrentNo'] = ((getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrent')).length);
    if ((getObjectProperty(___arguments.context.pageData, 'displayBuildingContentsList')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd0a851826861d2b0177799eff25cf19', (getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrent')));
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/191c36517d58d5c19b77085bb5cd982a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('381ed6943ce9c1285f3cb41faec6c0fe')));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/3aaa0867ca67806f844d2369511ce13c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'togClean')) == true) {
    console.log('togClean is ON');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('15cdf5f1812fa00f0acdec26f7ce7ab3'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf7c809849fc8c9104aeef24dae911e6'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e91439048965055fdb5719688176e221'))['opacity'] = 0.3;
    console.log(___arguments.value);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/68374bd8a967c352aa26b835541cbd8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'togInspect')) == true) {
    console.log('togInspect is ON');
    ___arguments.context.pageData['periodName'] = 'Light Year';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('15cdf5f1812fa00f0acdec26f7ce7ab3'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf7c809849fc8c9104aeef24dae911e6'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bfb1b6ff26d1dbb3593917c60328a57'))['opacity'] = 0.3;
    console.log(___arguments.value);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/c2afe0fe1baaf366a83dd0edbb93df56/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'togRepair')) == true) {
    console.log('togClean is ON');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('15cdf5f1812fa00f0acdec26f7ce7ab3'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bfb1b6ff26d1dbb3593917c60328a57'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e91439048965055fdb5719688176e221'))['opacity'] = 0.3;
    console.log(___arguments.value);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/54638bd14fd9dbebeedbb4acd35991f7/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'showStructuresLogic')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bba7378144bf1cc89143088b41f8809e', (await asyncListSort((await Backendless.Data.of('ptStructureAssign').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'structureWhereClause'))).setPageSize(10))), 1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    })));
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/d70f3c6e5a5de8d750ea335e1a2c9f44/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'ptLevelName')),' / Units.','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/96e383e7d3878d78d9ab6728cd92f948/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ptStructureName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/d9642b83d8ed4efa13482a4c375e0b6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ptLevelName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/c4c538e8c5686044be6d809ce8d58aae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ptRoomName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/a8d6eb28b74d6df9da25c44d4aea126a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ptUnitName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/0f4fe909d171ba6830dbca198b2e37c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showStructuresLogic'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/075a0889360c383ec253091ee54c29ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['showRoomsLogic'] = true;
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    await Backendless.Data.of('ptRoomAssign').save( ({ 'ptRoomId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'roomName': (getObjectProperty(___arguments.context.pageData, 'roomName')),'Ref': (getObjectProperty(___arguments.context.pageData, 'roomRef')) }) );
    await Backendless.Data.of('ptRoomElement').save( ({ 'cleanToggle': (getObjectProperty(___arguments.context.pageData, 'togClean')),'inspectToggle': (getObjectProperty(___arguments.context.pageData, 'togInspect')),'linkToCalToggle': (getObjectProperty(___arguments.context.pageData, 'rogLink')),'repairToggle': (getObjectProperty(___arguments.context.pageData, 'togRepair')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'ptElementId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'NLA': undefined,'description': 'not included in new structure form','Ref': (getObjectProperty(___arguments.context.pageData, 'roomRef')),'RoomName': (getObjectProperty(___arguments.context.pageData, 'roomName')) }) );
    ___arguments.context.pageData['roomRef'] = '';
    ___arguments.context.pageData['roomName'] = '';
    ___arguments.context.pageData['listContentsLogic'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/a3ef5cda2906478e835e42a2424ce033/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    console.log(String('get repeater data for assignContentRow[Name]') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')));
    await Backendless.Data.of('ptContentAssign').addRelation((getObjectProperty((await Backendless.Data.of('ptContentAssign').save( ({ 'ptRoomId': (getObjectProperty(___arguments.context.pageData, 'ptRoomId')),'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'ptContentId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'Name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')) }) )), 'objectId')), 'ptContentLink', [(getObjectProperty((await Backendless.Data.of('ptContentElement').save( ({ 'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'ptElementId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'NLA': undefined,'description': 'not included in new structure form','ref': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Ref')),'Name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')) }) )), 'objectId'))]);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/73fa549929e8852831ad6efb4b36b9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
  ___arguments.context.pageData['displayBuildingContentsList'] = (!(getObjectProperty(___arguments.context.pageData, 'displayBuildingContentsList')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/0b41e40df7ff5ec9312bd973e8efea49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/57d4d8635534c731e4f55946da069baa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    await Backendless.Data.of('ptContentAssign').save( ({ 'ptRoomId': (getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'ptContentId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'Name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')) }) );
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/84b795ad2c339453f8eea2b96b13c88e/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b41e40df7ff5ec9312bd973e8efea49', undefined);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/49ba50433a0bc86e331c8c5881997c78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Current Room Contents [',(getObjectProperty(___arguments.context.pageData, 'currentRoomContentNo')),'].'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/f811512de8ab81b50043d5a30952c9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['View building content [',(getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrentNo')),'].'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/houseKeepingTopMenu/components/ac88d0e838b8d8e405164fb8761894c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/infoPage/components/6528b2f6f8ffbca8fa180e08435896f7/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
      await Backendless.Data.of('appData').save(___arguments.newObject, true);
  console.log(___arguments.newObject);

  },
  /* handler:onObjectUpdate */
  /* handler:onObjectCreate */
  ['onObjectCreate'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('object updated');
  console.log(getObjectProperty(___arguments.newObject, 'Details'));
  console.log('object updated ---------- end');

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./pages/invitedSignUp2/components/a6ded58cabab013125843f76779d42b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, varNewUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function matchUniqueIdUsedTooMuch() {
  ___arguments.context.pageData['matchedUniqueId'] = (await Backendless.Data.of('userInvites').find(Backendless.DataQueryBuilder.create().setWhereClause((['inviteCode = \'',(getObjectProperty(___arguments.context.pageData, 'uniqueCode')),'\''].join(''))).setPageSize(1)));
}


  if ((getObjectProperty(___arguments.context.pageData, 'password1')) != (getObjectProperty(___arguments.context.pageData, 'password2'))) {
    ___arguments.context.pageData['statusMessageText'] = 'Passwords do not match';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7dfef0525c7e8443fdb578a3fbd65589'))['background-color'] = '#ff0000';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7dfef0525c7e8443fdb578a3fbd65589', true);
  } else {
    try {
      varNewUser = (await Backendless.UserService.register( new Backendless.User({ 'email': (getObjectProperty(___arguments.context.pageData, 'email')),'password': (getObjectProperty(___arguments.context.pageData, 'password1')),'userTag': (getObjectProperty(___arguments.context.pageData, 'inviteUserTag')),'nameFirst': (getObjectProperty(___arguments.context.pageData, 'inviteFirst')),'nameSurname': (getObjectProperty(___arguments.context.pageData, 'inviteSurname')) }) ));
      ___arguments.context.pageData['newTeamMember'] = (await Backendless.Data.of('userConnections').save( ({ [`contractDaysWork`]: 28,[`holidaysAllowed`]: 28,[`usersObjectId`]: (getObjectProperty(varNewUser, 'objectId')),[`businessObjectId`]: String(getObjectProperty(___arguments.context.pageData, 'businessLinkId')),[`businessLinkId`]: String(getObjectProperty(___arguments.context.pageData, 'businessLinkId')),[`businessTag`]: String(getObjectProperty(___arguments.context.pageData, 'businessName')),[`initialEmail`]: String(getObjectProperty(___arguments.context.pageData, 'inviteEmail')),[`lastLogin`]: (new Date()),[`tradingStyleGroup`]: (Number((getObjectProperty(___arguments.context.pageData, 'businessTradingStyle')))),[`userRole`]: String(getObjectProperty(___arguments.context.pageData, 'inviteRoleString')),[`userTag`]: (getObjectProperty(varNewUser, 'userTag')),[`tradingCode`]: (Number((getObjectProperty(___arguments.context.pageData, 'tradingCode')))) }) ));
      await Backendless.Data.of('userConnections').addRelation((getObjectProperty(___arguments.context.pageData, 'newTeamMember')), 'userRoleAccessID2', [String(getObjectProperty(___arguments.context.pageData, 'inviteRole'))]);
      await Backendless.Data.of('userConnections').addRelation((getObjectProperty(___arguments.context.pageData, 'newTeamMember')), 'connections', [(getObjectProperty(varNewUser, 'objectId'))]);
      await Backendless.Data.of('userConnections').addRelation((getObjectProperty(___arguments.context.pageData, 'newTeamMember')), 'relationToBusinessDetails', [String(getObjectProperty(___arguments.context.pageData, 'businessLinkId'))]);
      ___arguments.context.pageData['statusMessageText'] = 'Welcome to EcoFood';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7dfef0525c7e8443fdb578a3fbd65589'))['background-color'] = '#00ff00';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7dfef0525c7e8443fdb578a3fbd65589', true);

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        ___arguments.context.pageData['statusMessageText'] = 'User already exists.';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7dfef0525c7e8443fdb578a3fbd65589', true);
      }

    } finally {
      await Backendless.Data.of('userInvites').remove( (String(getObjectProperty(___arguments.context.pageData, 'objectIdPluck')) + String('')) );
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd3a8d8f3e570f4cf22bc7b37dbf0be', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa398f3fd17b13f8aa77c6c74eedd9eb', true);

    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (___arguments.context.pageData['inviteRegBttn'])

  },  
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/invitedSignUp2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    var error;


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa398f3fd17b13f8aa77c6c74eedd9eb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d613189b0cbadf33ae420cbc3731cc7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c1f8c57d5e6cd771f5b6468c6836c5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69c3851812f86a1c2178e138e18d5bb8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d28e3619b9d1adf9eca09e81ed8d9e8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99928806d3158d7e9ef9c94af06e9352', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e335d3557178e4edc2f8528c2d5ee5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1942d95584563c1cafcd2882c3f13b6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ded58cabab013125843f76779d42b1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b41f9edf01dbbf9f9865f616aa54b173', false);
    ___arguments.context.pageData['inviteRegBttn'] = 'Click to sign in for first time.';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/invitedSignUp2/components/b41f9edf01dbbf9f9865f616aa54b173/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, varNewUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('\'add to my list of businesses\' clicked');
  try {
    ___arguments.context.pageData['inviteSignIn'] = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'email')), (getObjectProperty(___arguments.context.pageData, 'password1')), false  ));
    console.log(String('inviteSignIn =') + String(getObjectProperty(___arguments.context.pageData, 'inviteSignIn')));
    console.log('add business. 1');
    console.log(String('userId[page data]') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'userId')));
    ___arguments.context.pageData['newTeamMember'] = (await Backendless.Data.of('userConnections').save( ({ [`holidaysAllowed`]: 28,[`ukNations`]: String(getObjectProperty(___arguments.context.pageData, 'ukNation')),[`userTagFromUserConnections`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'userTag')),[`usersObjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`businessObjectId`]: String(getObjectProperty(___arguments.context.pageData, 'businessLinkId')),[`businessLinkId`]: String(getObjectProperty(___arguments.context.pageData, 'businessLinkId')),[`businessTag`]: String(getObjectProperty(___arguments.context.pageData, 'businessName')),[`initialEmail`]: String(getObjectProperty(___arguments.context.pageData, 'inviteEmail')),[`lastLogin`]: (new Date()),[`tradingStyleGroup`]: (Number((getObjectProperty(___arguments.context.pageData, 'businessTradingStyle')))),[`userRole`]: String(getObjectProperty(___arguments.context.pageData, 'inviteRoleString')),[`userSpecificRoles`]: String(getObjectProperty(___arguments.context.pageData, 'inviteRole')),[`userTag`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'userTag')),[`tradingCode`]: (Number((getObjectProperty(___arguments.context.pageData, 'tradingCode')))) }) ));
    console.log('add business. 2');
    await Backendless.Data.of('userConnections').addRelation((getObjectProperty(___arguments.context.pageData, 'newTeamMember')), 'connections', [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'))]);
    console.log('add business. 3');
    console.log('========= adding \'relationToBusinessDetails\' =');
    console.log(String('parent object [newTeamMember[page data] =') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newTeamMember')), 'objectId')));
    console.log(String('children object [businessLinkId] = ') + String(getObjectProperty(___arguments.context.pageData, 'businessLinkId')));
    console.log('starting add objects ------');
    await Backendless.Data.of('userConnections').addRelation((getObjectProperty(___arguments.context.pageData, 'newTeamMember')), 'relationToBusinessDetails', [String(getObjectProperty(___arguments.context.pageData, 'businessLinkId'))]);
    console.log('add business. 4');
    console.log('========= FINISHED \'relationToBusinessDetails\' =');
    ___arguments.context.pageData['statusMessageText'] = 'Welcome to EcoFood';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7dfef0525c7e8443fdb578a3fbd65589'))['background-color'] = '#00ff00';

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
      ___arguments.context.pageData['statusMessageText'] = 'User already exists.';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7dfef0525c7e8443fdb578a3fbd65589', true);
    }

  } finally {
    await Backendless.Data.of('userInvites').remove( (String(getObjectProperty(___arguments.context.pageData, 'objectIdPluck')) + String('')) );
    if ((getObjectProperty(___arguments.context.pageData, 'businessTradingStyle')) == 10) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'businessTradingStyle')) == 20) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/invitedSignUp2/components/191971868a8322358c2f7c1fc73b9904/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    await Backendless.Messaging.sendEmail(([(getObjectProperty(___arguments.context.pageData, 'inviteSentByTag')),', invite for ',(getObjectProperty(___arguments.context.pageData, 'inviteName')),' to join "',(getObjectProperty(___arguments.context.pageData, 'businessTag')),'", as ',(getObjectProperty(___arguments.context.pageData, 'inviteRoleString')),' has FAILED.'].join('')), new Backendless.Bodyparts({ htmlmessage: (['<h1><span style="font-size:36px"><span style="font-family:Verdana,Geneva,sans-serif"><span style="color:#f15c45">Eco</span><span style="color:#fbc632">Food</span><span style="color:#f15c45">Safe</span></span></span></h1>','<p><span style="font-family:Verdana,Geneva,sans-serif"><span style="font-size:12px"><span style="color:null">Hi ',(getObjectProperty(___arguments.context.pageData, 'inviteSentByTag')),',</span></span></span></p>','<p><span style="font-family:verdana,geneva,sans-serif;"><span style="font-size: 12px;">An invite you sent has expired. Please resend the invite if it is still required.</span></span></p>','<p><span style="font-family:verdana,geneva,sans-serif;"><span style="font-size: 12px;">Details -</span></span></p>','<p><span style="font-family:verdana,geneva,sans-serif;"><span style="font-size: 12px;">Invite sent to - ',(getObjectProperty(___arguments.context.pageData, 'inviteName')),'</span></span></p>','<p><span style="font-family:verdana,geneva,sans-serif;"><span style="font-size: 12px;">For the business - ',(getObjectProperty(___arguments.context.pageData, 'businessTag')),'</span></span></p>','<p><span style="font-family:verdana,geneva,sans-serif;"><span style="font-size: 12px;">As the role of - ',(getObjectProperty(___arguments.context.pageData, 'inviteRoleString')),'</span></span></p>','<p><span style="font-family:verdana,geneva,sans-serif;"><span style="font-size:12px;">You can sign-in to EcoFoodSafe by clicking&nbsp;<a href="https://eu.backendlessappcontent.com/45F4AD7D-0C9A-4A6A-FF23-2666FDC93000/7F2FE6D0-B7ED-4D21-9F2A-9C0C2AF3373C/files/ui-builder/containers/default/index.html?page=signIn2">here</a>.</span>&nbsp;</span></p> </body> </html>'].join('')) }), ensureArray((String(getObjectProperty(___arguments.context.pageData, 'inviteSentByEmail')))), undefined);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
      ___arguments.context.pageData['statusMessageText'] = 'User already exists.';
    }

  } finally {
    (function () { window.history.back(); })();

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/invitedSignUp2/components/481d10bdce2a1542afbeba1a7992a7bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, userExists, searchCodes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function keepForLater() {
  ___arguments.context.pageData['inviteEmail'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteEmail']));
  ___arguments.context.pageData['inviteRoleString'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteRoleString']));
  ___arguments.context.pageData['businessTag'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['businessName']));
  ___arguments.context.pageData['inviteSentBy'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteSentBy']));
  ___arguments.context.pageData['inviteName'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteName']));
  ___arguments.context.pageData['inviteSentByTag'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteSentByTag']));
  ___arguments.context.pageData['inviteSentTime'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteSentTime']));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function businessDetails() {
  ___arguments.context.pageData['businessLinkId'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['businessLinkId']));
  ___arguments.context.pageData['businessTradingStyle'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['businessTradingStyle']));
  ___arguments.context.pageData['tradingCode'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['tradingCode']));
  ___arguments.context.pageData['businessName'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['businessName']));
}

/**
 * Describe this function...
 */
async function inviteFromDetails() {
  ___arguments.context.pageData['inviteSentBy'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteSentBy']));
  ___arguments.context.pageData['inviteSentByTag'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteSentByTag']));
}

/**
 * Describe this function...
 */
async function inviteToDetails() {
  ___arguments.context.pageData['inviteEmail'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteEmail']));
  ___arguments.context.pageData['inviteName'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteName']));
  ___arguments.context.pageData['inviteRole'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteRole']));
  ___arguments.context.pageData['inviteRoleString'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteRoleString']));
  ___arguments.context.pageData['inviteObjectId'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['ObjectId']));
}

/**
 * Describe this function...
 */
async function inviteUniqueDetails() {
  ___arguments.context.pageData['created'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['created']));
  ___arguments.context.pageData['timeNow1'] = ((new Date()).valueOf());
  ___arguments.context.pageData['userId'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['userId']));
  ___arguments.context.pageData['created2'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['inviteSentTime']));
  ___arguments.context.pageData['ageOfInvite'] = ((getObjectProperty(___arguments.context.pageData, 'timeNow1')) - (getObjectProperty(___arguments.context.pageData, 'created2')));
}

/**
 * Describe this function...
 */
async function testForExistingUser() {
  console.log(String('searching for - ') + String(['email = \'',(getObjectProperty(___arguments.context.pageData, 'email')),'\''].join('')));
  ___arguments.context.pageData['userExisits2'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email LIKE \'',(getObjectProperty(___arguments.context.pageData, 'email')),'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['userAlreadyOnSystem'] = (JSON.stringify(((getObjectProperty(___arguments.context.pageData, 'userExisits2')).map(item => item['objectId']))));
}


  try {
    userExists = false;
    ___arguments.context.pageData['objectIdPluck'] = false;
    searchCodes = ['inviteCode = \'',(getObjectProperty(___arguments.context.pageData, 'userUniqueCode')),'\''].join('');
    ___arguments.context.pageData['matchedUniqueId'] = (await Backendless.Data.of('userInvites').find(Backendless.DataQueryBuilder.create().setWhereClause(searchCodes).setPageSize(1)));
    ___arguments.context.pageData['objectIdPluck'] = ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).map(item => item['objectId']));
    await businessDetails();
    await inviteFromDetails();
    await inviteToDetails();
    await inviteUniqueDetails();
    await testForExistingUser();
    if (getValueLength((getObjectProperty(___arguments.context.pageData, 'userAlreadyOnSystem'))) == 40) {
      userExists = true;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'matchedUniqueId')).length < 1) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('invalidCodeExplained', undefined);
    }
    if (userExists == true && (getObjectProperty(___arguments.context.pageData, 'ageOfInvite')) / 3600000 < 25) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e335d3557178e4edc2f8528c2d5ee5b', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b41f9edf01dbbf9f9865f616aa54b173', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('481d10bdce2a1542afbeba1a7992a7bb', false);
    }
    if (userExists == false && (getObjectProperty(___arguments.context.pageData, 'ageOfInvite')) / 3600000 < 25) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('481d10bdce2a1542afbeba1a7992a7bb', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c1f8c57d5e6cd771f5b6468c6836c5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69c3851812f86a1c2178e138e18d5bb8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d28e3619b9d1adf9eca09e81ed8d9e8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e335d3557178e4edc2f8528c2d5ee5b', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1942d95584563c1cafcd2882c3f13b6', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ded58cabab013125843f76779d42b1', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'ageOfInvite')) / 3600000 > 25) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d613189b0cbadf33ae420cbc3731cc7', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a7dec5797566d34c6b3af3c424dee36', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('481d10bdce2a1542afbeba1a7992a7bb', false);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/invitedSignUp2/components/dd7a31dff1df87de8b4e7dc351a68a4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('signin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/invitesView/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var adminWhereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('/// invitesView ///////');
  console.log(String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length < 1 ? String('No invites pending.') + String('') : ((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length == 1 ? String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length) + String(' pending invite.') : String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length) + String(' pending invites.'))) + String(''));
  console.log(getObjectProperty(___arguments.context.appData, 'invitesForBusiness'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c6470f34cf79204868d48a5fa10f4989', (getObjectProperty(___arguments.context.appData, 'invitesForBusiness')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/invitesView/components/3776554893c756adb103d0479e46239a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('invitesLiveForDays = ');
  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays'));
  console.log('dateNow timestamp = ');
  console.log((new Date()).valueOf());
  console.log('7 days in milliseconds = ');
  console.log(3600000 * 24 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays')));
  console.log('inviteDate plus 7 days = ');
  console.log(3600000 * 24 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays')) + ((new Date()).valueOf()));
  console.log('date string result - ');
  console.log((new Date((3600000 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays'))))).toLocaleDateString());
  console.log((new Date(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) + 3600000 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays'))))).toString());
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(((new Date((3600000 * 24 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays')) + ((new Date()).valueOf())))).toDateString()).slice(4, 10));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invitesView/components/5aadebace99eb39254aefe3e07769285/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(subsequenceFromEndLast(((new Date((3600000 * 24 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays')) + ((new Date()).valueOf())))).toDateString()), 3));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invitesView/components/74ff0b26cf084385576dccaf2f92a201/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime'))) / 86400000)) + String(' days ago.');
  }
  if (0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime'))) / 86400000) == 0) {
    varLogIn = String('Today.');
  }
  if (0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime'))) / 86400000) == 1) {
    varLogIn = String('Yesterday.');
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invitesView/components/76963d1dd08b7a5f2ceba26dc53bfeee/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('76963d1dd08b7a5f2ceba26dc53bfeee'))['opacity'] = 1;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/invitesView/components/90728d16ce54f8f91bf148fb06e4fd29/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteEmail')),'',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invitesView/components/6986cd0ceaf32d6cae61a7fef5657fe9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, emailBody, emailSubject, varNewInvite;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    if ((new Date(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) + 3600000 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays'))))) < ((new Date()).valueOf())) {
      ___arguments.context.appData['selectedUserDetails'] = ___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c');
      ___arguments.context.pageData['userCode'] = (generateUUID().short());
      ___arguments.context.appData['existingUser'] = 1;
      varNewInvite = (await Backendless.Data.of('userInvites').save( ({ [`tradingCode`]: (getObjectProperty(___arguments.context.appData, 'tradingCode')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`inviteName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteName')),[`inviteText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteText')),[`inviteEmail`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteEmail')),[`inviteRole`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteRole')),[`inviteRoleString`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteRoleString')),[`businessName`]: (getObjectProperty(___arguments.context.appData, 'businessName')),[`userId`]: (getObjectProperty(___arguments.context.appData, 'userId')),[`inviteSentByTag`]: (getObjectProperty(___arguments.context.appData, 'userTag')),[`inviteSentBy`]: (getObjectProperty(___arguments.context.appData, 'userEmail')),[`inviteCode`]: (getObjectProperty(___arguments.context.pageData, 'userCode')),[`businessTradingStyle`]: (getObjectProperty(___arguments.context.appData, 'tradingStyleGroup')),[`inviteSentTime`]: ((new Date()).valueOf()),[`userExistsInt`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'userExistsInt')) }) ));
      ___arguments.context.pageData['statusMessageText'] = 'Welcome to EcoFood';
      if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteText'))) > 1) {
        ___arguments.context.pageData['welcomeTextWritten'] = (['<hr /> <p>&nbsp;</p>',(getObjectProperty(___arguments.context.appData, 'userTag')),' has added a personal note -</p>',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteText')),'<hr /> <p>&nbsp;</p>'].join(''));
      } else {
        ___arguments.context.pageData['welcomeTextWritten'] = (['<p><span style="font-family:Verdana,Geneva,sans-serif">Hopefully this isn&#39;t the first time you\'ve heard of EcoFoodSafe. If you\'re concerned please do contact </span>',(getObjectProperty(___arguments.context.appData, 'userTag')),'<span style="font-family:Verdana,Geneva,sans-serif"> at </span>',(getObjectProperty(___arguments.context.appData, 'userEmail')),'<span style="font-family:Verdana,Geneva,sans-serif"> for a full explaination.</span></p>'].join(''));
      }
      emailSubject = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteText')),', invite to join ',(getObjectProperty(___arguments.context.appData, 'userTag')),' at "',(getObjectProperty(___arguments.context.appData, 'businessName')),'", as ',(getObjectProperty(___arguments.context.pageData, 'selectedRole.roleName')),'.'].join('');
      emailBody = ['','',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteName')),'<span style="font-family:Verdana,Geneva,sans-serif">,</span>',(getObjectProperty(___arguments.context.pageData, 'welcomeTextWritten')),'<p><span style="font-family:Verdana,Geneva,sans-serif">The 15 second elevator pitch for your business using EcoFoodSafe would&nbsp;be this...</span></p>  <p><em><span style="font-family:Verdana,Geneva,sans-serif">&quot;We match over-production of crops with commercial kitchens often within &#39;zero miles&#39; of each other. The produce is&nbsp;picked and delivered on&nbsp;the same day. There are no subscriptions charged. The price quoted is the final price the kitchen&nbsp;will pay. No contracts, no adverts. Just fresh local produce delivered.&quot;</span></em></p>','<p><span style="font-family:Verdana,Geneva,sans-serif">To sign up -</span></p>  <p><span style="font-family:Verdana,Geneva,sans-serif">Copy this&nbsp;unique code -</span></p>  ',(getObjectProperty(___arguments.context.pageData, 'userCode')),'<p><span style="font-family:Verdana,Geneva,sans-serif">its ensures you are linked to the correct business. When you move on to the sign-up page, paste the code into the box.</span></p>  <p><span style="font-family:Verdana,Geneva,sans-serif">Now follow this <a href="https://www.fork2fork.co.uk?page=invitedSignUp2">link</a>&nbsp;to our sign-up page for users who have been invited.</span></p>'].join('');
      await Backendless.Messaging.sendEmail(emailSubject, new Backendless.Bodyparts({ htmlmessage: emailBody }), ensureArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteEmail'))), undefined);
      await Backendless.Data.of('userInvites').remove( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'objectId')) );
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userTopMenu10', undefined);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/invitesView/components/d318d88811a6c81c3218b18b5c5747d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invitesView/components/588c881fa89bada1d5360d0aa58b76ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('\'Date Now\' converted to Timestamp looks like - ');
  console.log((new Date()).valueOf());
  console.log('inviteSentTime[usersDetailsPanel\' repeater');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime'));
  console.log('selectedBusiness.invitesLiveForDays[appData] = ');
  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays'));
  console.log('invite expires - timestamp value - ');
  console.log((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) + 3600000 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays')));
  console.log('Invite Expires calulated value - ');
  console.log(new Date(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) + 3600000 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays')))));

  return ((new Date(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) + 3600000 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays'))))) < ((new Date()).valueOf()) ? 'Expired! - Send new invite?' : 'Not Expired, Click to return to Admin menu.')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invitesView/components/01aa299c5fff71e72e4832b80b1d3bc8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')))).toTimeString()).slice(0, 5)))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invitesView/components/3e91a2db704d48babcf11446da73ccbd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'inviteSentTime')) + 3600000 * (getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays'))))) < ((new Date()).valueOf()) ? 'Expired!' : 'Expires - ')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kitchenAbout/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/7ac784f2bd5ab6061676e6bbf9a25335/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a405f681dba730f302452c151ef2702e', null);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8287998e706abfeec95f3f46119ce464', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/12534d7808f47ff8e50b48f95cb5cf37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58a9dcbe99f341bdf99cc22c7a1f00cc', null);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1889c3fcf989a68cc8578d228cab1e8f', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/41cb02dd35ccacb19b31958dfcae66ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('96b8a3ab6912719ecf947e75fcbc7191', null);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850db7e487a30e2f0d666d8b3698eb22', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/0874e62909799b248ab4e558ccfa462a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a405f681dba730f302452c151ef2702e', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8287998e706abfeec95f3f46119ce464', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/075fae3c2111a4dbb623cbc308d31229/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58a9dcbe99f341bdf99cc22c7a1f00cc', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1889c3fcf989a68cc8578d228cab1e8f', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/f5e796cf1074b5068078877a82f8ae2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('96b8a3ab6912719ecf947e75fcbc7191', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('850db7e487a30e2f0d666d8b3698eb22', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/b533ab3f51b6ff99b13e6d16d4d27e23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('kitchenRegistration2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/c6c9784b9d6ebd57fa2f1fa97e2a0c36/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('kitchenRegistration2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/cd83637abe7bdb497ef640bbbd815a6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('kitchenRegistration2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/febaf6583ea39174c70aba27b2463ece/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('kitchenRegistration2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenAbout/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegLocation/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('producerAdmin1', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegLocation/components/a188114d83f81f8b07a2c5fe99a751ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('clicked on kitchen location');
  console.log('test to see if userLoc[appData] already in use - ');
  console.log(getObjectProperty(___arguments.context.appData, 'userLoc'));
  console.log('////// did it pront a location?');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userRegUniversal', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegLocation/components/3f621b679fa88c968339095d08a8b0d1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'tradingText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kitchenRegLocation/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/d1fc970e669372568936a58fd8672af9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['businessType'] = 'Kitchen';
    ___arguments.context.appData['tradingStyle'] = 'Cafe';
    ___arguments.context.appData['tradingCode'] = 10;
    ___arguments.context.appData['tradingStyleGroup'] = 20;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'nextPage')), undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/f5d80df568bc2ebee8b89a0c2b1e65c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['businessType'] = 'Kitchen';
    ___arguments.context.appData['tradingStyle'] = 'Pub with Food';
    ___arguments.context.appData['tradingCode'] = 12;
    ___arguments.context.appData['tradingStyleGroup'] = 20;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'nextPage')), undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/0c15de4f5c0145b271e68ae3a2afbafc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['businessType'] = 'Kitchen';
    ___arguments.context.appData['tradingStyle'] = 'Busy Kitchen';
    ___arguments.context.appData['tradingCode'] = 13;
    ___arguments.context.appData['tradingStyleGroup'] = 20;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'nextPage')), undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/f062f9bf7b9814b42a6673779c0bb559/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['businessType'] = 'Kitchen';
    ___arguments.context.appData['tradingStyle'] = 'Events Catering';
    ___arguments.context.appData['tradingCode'] = 14;
    ___arguments.context.appData['tradingStyleGroup'] = 20;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'nextPage')), undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/306e88938026897110a61f18e8c2af66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['businessType'] = 'Kitchen';
    ___arguments.context.appData['tradingStyle'] = 'Green Grocer';
    ___arguments.context.appData['tradingCode'] = 15;
    ___arguments.context.appData['tradingStyleGroup'] = 25;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'nextPage')), undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/92ee369c65aa969ee4f700bd64b43173/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['businessType'] = 'Kitchen';
    ___arguments.context.appData['tradingStyle'] = 'Works Canteen';
    ___arguments.context.appData['tradingCode'] = 11;
    ___arguments.context.appData['tradingStyleGroup'] = 20;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'nextPage')), undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kitchenRegistration2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
      ___arguments.context.pageData['nextPage'] = 'kitchenRegLocation';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/loginBackendless/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var user, error, password, username, stayLoggedIn, logging, buttonLogin;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, stayLoggedIn  ));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  username = (___arguments.context.dataModel['username']);
  password = (___arguments.context.dataModel['password']);
  stayLoggedIn = (___arguments.context.dataModel['stayLoggedIn']);
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((error['code']) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    ___arguments.context.appData['currentUser'] = user;
  }

  },  
  /* handler:onSubmit *//* content */
}));

define('./pages/loginBackendless/components/6d7b09fc8c04707fa6291e69b80c05d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('passwordRecover', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/numberGen1/components/75d70f7f95c2647d55b1128d97ab0ef9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var x, storedRandom, i, isThisUnique, numberSet;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  numberSet = [];
  numberSet = (getObjectProperty(___arguments.context.pageData, 'numbersToUse')).split(',');
  storedRandom = [];
  x = 0;
  for (i = 1; i <= 100; i++) {
    x = (typeof x == 'number' ? x : 0) + 1;
    isThisUnique = mathRandomInt(numberSet.slice(-1)[0] * 1000, (Number(([numberSet[0],numberSet[1],numberSet[2],numberSet.slice(-1)[0]].join('')))));
    if (storedRandom.length == 0) {
      addItemToList(storedRandom, isThisUnique);
    } else {
      if (storedRandom.indexOf(isThisUnique) + 1 == 0) {
        addItemToList(storedRandom, isThisUnique);
      } else {
        i = (typeof i == 'number' ? i : 0) + -1;
      }
    }
  }
  console.log(storedRandom);
  console.log(x);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/numberGen1/components/043cdf0b6029baa22ef822780d88ba98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var codesToSave, i;

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pickCharacters'] = '12345679XYZ';
  codesToSave = [];
  console.log('///// start');
  for (i = 1; i <= 5000; i++) {
    ___arguments.context.pageData['randomPick1'] = (mathRandomInt(1, 11));
    ___arguments.context.pageData['randomPick2'] = (mathRandomInt(1, 11));
    ___arguments.context.pageData['randomPick3'] = (mathRandomInt(1, 11));
    ___arguments.context.pageData['randomPick4'] = (mathRandomInt(1, 11));
    codesToSave['code'] = ([(getObjectProperty(___arguments.context.pageData, 'pickCharacters')).charAt(((getObjectProperty(___arguments.context.pageData, 'randomPick1')) - 1)),(getObjectProperty(___arguments.context.pageData, 'pickCharacters')).charAt(((getObjectProperty(___arguments.context.pageData, 'randomPick2')) - 1)),(getObjectProperty(___arguments.context.pageData, 'pickCharacters')).charAt(((getObjectProperty(___arguments.context.pageData, 'randomPick3')) - 1)),(getObjectProperty(___arguments.context.pageData, 'pickCharacters')).charAt(((getObjectProperty(___arguments.context.pageData, 'randomPick4')) - 1))].join(''));
  }
  console.log('///// finish');
  console.log((await BackendlessUI.Functions.Custom['fn_461d17e665f8b6391823125f6307ab14'](codesToSave)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/numberGen1/components/fec5fe66ac88a5e1466c26d819ed09e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var randomList, codeListVar, item;

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  codeListVar = [];
  randomList = [];
  codeListVar = [({ [`code`]: (await BackendlessUI.Functions.Custom['fn_a85d11be1bc25c0c58e939cc4e39dbeb']('digit4Code', null, null, null, null, null, null, null, 'c11', null, 288, null, null, null)),[`objectId`]: undefined })];
  console.log(codeListVar);
  randomList = (await Promise.all(codeListVar.map(async item => {; return (mathRandomInt(1, 6000));})));
  await Backendless.Data.of('digit4Code288').bulkUpsert( randomList );
  console.log('done');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersDeliverTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersDeliverTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('inviteNewUser1', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersDeliverTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersDeliverTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersDeliverTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    var error;


  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('559bb7a9449f5605afa1cc59723a5245', false);
    if ((___arguments.context.appData['userRole']).indexOf('f10') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    if ((___arguments.context.appData['userRole']).indexOf('f20') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', true);
    }
    if ((___arguments.context.appData['userRole']).indexOf('f30') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', true);
    }
    if ((___arguments.context.appData['userRole']).indexOf('f40') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('559bb7a9449f5605afa1cc59723a5245', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/ordersTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('inviteNewUser1', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ordersTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    var error;


  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    if ((___arguments.context.appData['userRole']).indexOf('o10') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    if ((___arguments.context.appData['userRole']).indexOf('i20') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', true);
    }
    if ((___arguments.context.appData['userRole']).indexOf('i30') + 1 > 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/passwordRecover/components/4641c8cb6f0597610bb5b1fce8828044/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.UserService.restorePassword((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'emailInput')));

  },
  /* handler:onClick *//* content */
}));

define('./pages/passwordRecovery/components/4641c8cb6f0597610bb5b1fce8828044/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36464978e54866f8fc98ffcdb55b059e', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/passwordRecovery/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36464978e54866f8fc98ffcdb55b059e', false);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/produceAboutPAge/components/930ba81e08e8db0132057ce23e978513/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['tradingText'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/produceAboutPAge/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/produceAboutPAge/components/67ae80132021264eba0e7dff9de4e1a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('producerRegistration3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producePick/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/producePick/components/e9bef2b8351babbb16b14c6222a21eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db38119e921d4c9f40b27f4b2688f063', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producePick/components/d92d49c757d8409e92ed869ea7fda01b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db38119e921d4c9f40b27f4b2688f063', true);

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('94cd0ecf25e628c200fd446e50dd6a97'), 'created')))).toLocaleString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producePick/components/8dd374af745a6b6c17fd2267cd23bc4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['skip'] = '';
  console.log(['group = \'Vegetable\'',' && ','produceName =',(getObjectProperty(___arguments.context.pageData, 'searchString'))].join(''));
  if ((getObjectProperty(___arguments.context.pageData, 'skip')) == '1') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('053deda3495c2174330a9d6681082065', (await Backendless.Data.of('ecoFoodCore1').find(Backendless.DataQueryBuilder.create().setWhereClause((['group = \'Vegetable\'',' &&','produceName =',(getObjectProperty(___arguments.context.pageData, 'searchString'))].join(''))).setSortBy('produceName').setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/producePick/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var fullList;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  fullList = [];
  addItemToList(fullList, (await Backendless.Data.of('ecoFoodCore1').find(Backendless.DataQueryBuilder.create().setWhereClause((String('group = \'Vegetable\''))).setSortBy('produceName').setPageSize(100))));
  (fullList[9])['percentage'] = 'testing';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('053deda3495c2174330a9d6681082065', fullList);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/producerRegistration2/components/d1fc970e669372568936a58fd8672af9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['businessType'] = 'Producer';
    ___arguments.context.appData['tradingStyle'] = 'Home Garden';
    ___arguments.context.appData['tradingCode'] = 1;
    ___arguments.context.appData['tradingStyleGroup'] = 10;
    ___arguments.context.appData['busTradingCode'] = 1;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('produceAboutPAge', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration2/components/f5d80df568bc2ebee8b89a0c2b1e65c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['businessType'] = 'Producer';
    ___arguments.context.appData['tradingStyle'] = 'Green Space Grower';
    ___arguments.context.appData['tradingCode'] = 2;
    ___arguments.context.appData['tradingStyleGroup'] = 10;
    ___arguments.context.appData['busTradingCode'] = 1;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('produceAboutPAge', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration2/components/0c15de4f5c0145b271e68ae3a2afbafc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['businessType'] = 'Producer';
    ___arguments.context.appData['tradingStyle'] = 'Allotment';
    ___arguments.context.appData['tradingCode'] = 3;
    ___arguments.context.appData['tradingStyleGroup'] = 10;
    ___arguments.context.appData['busTradingCode'] = 1;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('produceAboutPAge', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration2/components/306e88938026897110a61f18e8c2af66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['businessType'] = 'Producer';
    ___arguments.context.appData['tradingStyle'] = 'Market Farmer';
    ___arguments.context.appData['tradingCode'] = 4;
    ___arguments.context.appData['tradingStyleGroup'] = 10;
    ___arguments.context.appData['busTradingCode'] = 1;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('produceAboutPAge', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration2/components/f8292c3eab9a721f9d82e3649d8e11a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['businessType'] = 'Producer';
    ___arguments.context.appData['tradingStyle'] = 'Commmercial Farmer';
    ___arguments.context.appData['tradingCode'] = 5;
    ___arguments.context.appData['tradingStyleGroup'] = 10;
    ___arguments.context.appData['busTradingCode'] = 5;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('produceAboutPAge', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration2/components/9cb270395d9452abd38ade9a60e12d16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['businessType'] = 'Producer';
    ___arguments.context.appData['tradingStyle'] = 'Vertical Farming';
    ___arguments.context.appData['tradingCode'] = 6;
    ___arguments.context.appData['tradingStyleGroup'] = 10;
    ___arguments.context.appData['busTradingCode'] = 1;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('produceAboutPAge', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration2/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration3/components/a188114d83f81f8b07a2c5fe99a751ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log('clicked on reg3');
  ___arguments.context.appData['userLoc'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('distancePick', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration3/components/3f621b679fa88c968339095d08a8b0d1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['tradingText'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration3/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4/components/febaf6583ea39174c70aba27b2463ece/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item, whereClause, locationPoint, lat, lng, location2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c967f854c66acffad348d19d2834a09', true);
    location2 = (getObjectProperty(___arguments.context.appData, 'userLoc'));
    lat = (getObjectProperty(location2, 'lat'));
    lng = (getObjectProperty(location2, 'lng'));
    locationPoint = ((new Backendless.Data.Point().setX(lng).setY(lat)).asWKT());
    ___arguments.context.appData['userLocNow'] = locationPoint;
    whereClause = ['distanceOnSphere(\'',locationPoint,'\',geoLoc) < mi(',String(getObjectProperty(___arguments.context.appData, 'radius')),')'].join('');
    console.log('find kitchens - start');
    ___arguments.context.appData['kitchensFound'] = (await Backendless.Data.of('kitchens').find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setPageSize(100)));
    console.log('find kitchens - finish');
    ___arguments.context.appData['numberKitchensFound'] = ((getObjectProperty(___arguments.context.appData, 'kitchensFound')).length);
    ___arguments.context.appData['noKitchensFound'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchensFound')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) > '0');
    })).length);
    ___arguments.context.appData['kitchens1'] = (getObjectProperty(___arguments.context.appData, 'kitchensFound'));
    ___arguments.context.appData['kitchens7842'] = (getObjectProperty(___arguments.context.appData, 'kitchensFound'));
    ___arguments.context.appData['kitchens7843'] = (getObjectProperty(___arguments.context.appData, 'kitchensFound'));
    ___arguments.context.appData['kitchens7844'] = (getObjectProperty(___arguments.context.appData, 'kitchensFound'));
    ___arguments.context.appData['kitchens7846'] = (getObjectProperty(___arguments.context.appData, 'kitchensFound'));
    ___arguments.context.appData['kitchens7841'] = (getObjectProperty(___arguments.context.appData, 'kitchensFound'));
    ___arguments.context.appData['kitchens5'] = (getObjectProperty(___arguments.context.appData, 'kitchensFound'));
    ___arguments.context.appData['kitchens4613'] = (getObjectProperty(___arguments.context.appData, 'kitchensFound'));
    ___arguments.context.appData['restaurants1'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchens1')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) == '1');
    })).length);
    ___arguments.context.appData['restaurants7842'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchens7842')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) == '7842');
    })).length);
    ___arguments.context.appData['restaurants7843'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchens7843')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) == '7843');
    })).length);
    ___arguments.context.appData['restaurants7844'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchens7844')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) == '7844');
    })).length);
    ___arguments.context.appData['restaurants7846'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchens7846')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) == '7846');
    })).length);
    ___arguments.context.appData['restaurants7841'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchens7841')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) == '7841');
    })).length);
    ___arguments.context.appData['restaurants5'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchens5')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) == '5');
    })).length);
    ___arguments.context.appData['restaurants4613'] = ((await asyncListFilter((getObjectProperty(___arguments.context.appData, 'kitchens4613')), async (item) => {


     return ((getObjectProperty(item, 'typeNum')) == '4613');
    })).length);
    await Backendless.Data.of('UserLocations').save( ({ [`GeoLoc`]: (getObjectProperty(___arguments.context.appData, 'userLocNow')),[`kitchens7844`]: (getObjectProperty(___arguments.context.appData, 'restaurants7844')),[`kitchens7846`]: (getObjectProperty(___arguments.context.appData, 'restaurants7846')),[`kitchens5`]: (getObjectProperty(___arguments.context.appData, 'restaurants5')),[`kitchens7841`]: (getObjectProperty(___arguments.context.appData, 'restaurants7841')),[`kitchens7842`]: (getObjectProperty(___arguments.context.appData, 'restaurants7842')),[`kitchens7843`]: (getObjectProperty(___arguments.context.appData, 'restaurants7843')),[`kitchens1`]: (getObjectProperty(___arguments.context.appData, 'restaurants1')),[`kitchens4613`]: (getObjectProperty(___arguments.context.appData, 'restaurants4613')),[`radiusSearch`]: (getObjectProperty(___arguments.context.appData, 'radius')),[`userType`]: (getObjectProperty(___arguments.context.appData, 'type')),[`userTrading`]: (getObjectProperty(___arguments.context.appData, 'trading')),[`noKitchensFound`]: (getObjectProperty(___arguments.context.appData, 'noKitchensFound')) }) );
    if ((getObjectProperty(___arguments.context.appData, 'noKitchensFound')) < '3') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4add887a8ec4833363bde20a928c6e8e', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/producerRegistration4/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    ___arguments.context.appData['businessStyle'] = 'Producer';
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userRegUniversal', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4/components/3c2b27c99f7c899719aa5524eee4404b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.appData, 'noKitchensFound')) < '1' ? 'Nope, no ' : String('Sorry, it looks like we can only find ') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'noKitchensFound')))),' commercial kitchens within a radius of ',(JSON.stringify((getObjectProperty(___arguments.context.appData, 'radius')))),' miles. To increase the search click on ‘Change Distance’ button below.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4/components/930ba81e08e8db0132057ce23e978513/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['tradingText'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4/components/ad1af9e788a8396cb37fe1638a2c870d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('producerRegistration4List', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4/components/c15aad4d929371ccfafd0861519d235d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('distancePick', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4/components/2a81a638b322683856989c4f3688f738/bundle.js', [], () => ({
  /* content */
  /* handler:markersLogic */
  async ['markersLogic'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty(___arguments.context.appData, 'kitchens5')).map(async item => {; return ({ [`color`]: undefined,[`description`]: undefined,[`coordinates`]: (getObjectProperty(item, 'geoLoc')) });})))

  },
  /* handler:markersLogic */
  /* handler:centerLogic */
  ['centerLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'userLoc'))

  },
  /* handler:centerLogic */
  /* content */
}))

define('./pages/producerRegistration4List/components/febaf6583ea39174c70aba27b2463ece/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/009d434595f1b34fbc659bce27e30403/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('distancePick', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    ___arguments.context.appData['businessStyle'] = 'Producer';
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userRegUniversal', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/9eccc93e27f3236d96728758630c4f77/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['x ',(getObjectProperty(___arguments.context.appData, 'restaurants1')),' - ',(await BackendlessUI.Functions.Custom['fn_5cf5dbc753056ca91dc2c9c78a2441d8']((getObjectProperty(___arguments.context.appData, 'restaurants1')))),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/4d679034b3061bd9a62b93b7c1ae2692/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['x ',(getObjectProperty(___arguments.context.appData, 'restaurants7842')),' - ',(await BackendlessUI.Functions.Custom['fn_5cf5dbc753056ca91dc2c9c78a2441d8']((getObjectProperty(___arguments.context.appData, 'restaurants7842')))),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/e2ea157ee4829559888781945b7cd68c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['x ',(getObjectProperty(___arguments.context.appData, 'restaurants7843')),' - ',(await BackendlessUI.Functions.Custom['fn_5cf5dbc753056ca91dc2c9c78a2441d8']((getObjectProperty(___arguments.context.appData, 'restaurants7843')))),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/40064b657b36606d4ef41c3963871089/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['x ',(getObjectProperty(___arguments.context.appData, 'restaurants7844')),' - ',(await BackendlessUI.Functions.Custom['fn_5cf5dbc753056ca91dc2c9c78a2441d8']((getObjectProperty(___arguments.context.appData, 'restaurants7844')))),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/4de7d6f6450dc1a1f453863d6e3ca772/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['x ',(getObjectProperty(___arguments.context.appData, 'restaurants7846')),' - ',(await BackendlessUI.Functions.Custom['fn_5cf5dbc753056ca91dc2c9c78a2441d8']((getObjectProperty(___arguments.context.appData, 'restaurants7846')))),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/e452864c5a948e577919f004ee38ba1d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['x ',(getObjectProperty(___arguments.context.appData, 'restaurants7841')),' - ',(await BackendlessUI.Functions.Custom['fn_ac6a83c67b17a47876aa60415ea8abf3']((getObjectProperty(___arguments.context.appData, 'restaurants7841')))),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/bf12af19b6ede4c9871e9dd4568c3f91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['x ',(getObjectProperty(___arguments.context.appData, 'restaurants5')),' - ',(await BackendlessUI.Functions.Custom['fn_5cf5dbc753056ca91dc2c9c78a2441d8']((getObjectProperty(___arguments.context.appData, 'restaurants5')))),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/5e73b7ac21a19ca5c26138ad7ca78469/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['x ',(getObjectProperty(___arguments.context.appData, 'restaurants4613')),' - ',(await BackendlessUI.Functions.Custom['fn_ced9e76a9c5d3ed5ff04eac55a1be327']((getObjectProperty(___arguments.context.appData, 'restaurants4613')))),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/62c3581ce9343b1106ace7c103aac47f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);
    ___arguments.context.pageData['panelTitle'] = 'Restaurants';
    ___arguments.context.pageData['line1'] = 'Restaurants demand the best ingredients and will be happy to pay, but they will be the first to refuse produce.';
    if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 1) {
      ___arguments.context.pageData['line2'] = 'Restaurant\'s don\'t always need large amounts. They have starters and unique dishes that demand the freshest produce they will advertise to entice customers on their social media. Your produce will make them look good!';
    }
    if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 2) {
      ___arguments.context.pageData['line2'] = 'Restaurant\'s don\'t always need large amounts. They have starters and unique dishes that demand the freshest produce they will advertise to entice customers on their social media. Your produce will make them look good!';
    }
    if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 3) {
      ___arguments.context.pageData['line2'] = 'Restaurant\'s don\'t always need large amounts. They have starters and unique dishes that demand the freshest produce they will advertise to entice customers on their social media. Your produce will make them look good!';
    }
    if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 4) {
      ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
    }
    if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 5) {
      ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
    }
    if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 6) {
      ___arguments.context.pageData['line2'] = 'Restaurants don\'t always need large amounts. They have starters and unique dishes that demand the freshest produce they will advertise to entice customers on their social media. Your produce will make them look good!';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/0257042cac46f89e8b7ecdfbd94ad62c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/f66d6411eab65c5361945178a028a61d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.appData, 'tradingStyle')),' ( ',(getObjectProperty(___arguments.context.appData, 'numberKitchensFound')),' ), Radius ',(getObjectProperty(___arguments.context.appData, 'radius')),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/b897e62c7fbab7b891fd3017c8e244f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'line1')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/841976ad9fa357fc6f7e6f22cd61bc4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String(___arguments.context.pageData['line2']))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/359161c5f70e7e4788e38669e2b4c40c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);
  ___arguments.context.pageData['panelTitle'] = 'Hotels etc';
  ___arguments.context.pageData['line1'] = 'Hugh market here. All are working to please guests. They are all very social savvy and will ‘talk up’ their ability to source local produce.';
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 1) {
    ___arguments.context.pageData['line2'] = 'Hotels consumption of produce will be beyond the ‘Home Garden’, but they will still be interested in the local produce for smaller functions and ’top tables’ at functions. Guest Houses are great to have within your radius. They often build bespoke meals for quest who have requested meals in advance.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 2) {
    ___arguments.context.pageData['line2'] = 'Hotels consumption of produce will be beyond the ‘Green space’, but they will still be interested in the local produce for smaller functions and ’top tables’ at functions. Guest Houses are great to have within your radius. They often build bespoke meals for quest who have requested meals in advance.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 3) {
    ___arguments.context.pageData['line2'] = 'Hotels consumption of produce will be beyond the modest ‘allotment’, but they will still be interested in the local produce for smaller functions and ’top tables’ at functions. Guest Houses are great to have within your radius. They often build bespoke meals for quest who have requested meals in advance. *** IMPORTANT *** Has a renter of an allotment you may not be allowed to sell and produce. Check you bylaws or contract before placing produce please.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 4) {
    ___arguments.context.pageData['line2'] = 'Hotels are looking for quantity and quality, so Market Farmer’s are in a prime position to fulfil current and future orders. ';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 5) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order. Ciommercial production can benefit by getting fast payment for produce.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 6) {
    ___arguments.context.pageData['line2'] = 'Hotels consumption of produce will be beyond the ‘Home Garden’, but they will still be interested in the local produce for smaller functions and ’top tables’ at functions. Guest Houses are great to have within your radius. They often build bespoke meals for quest who have requested meals in advance.';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/01ee88cd2e2bed5743d4c58b2b18f76d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('bars blurb ');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);
  ___arguments.context.pageData['panelTitle'] = 'Pubs with Food';
  ___arguments.context.pageData['line1'] = 'We can’t differentiate between ‘Gastro Pubs’ and ‘bag of crisps pubs’, but you’ll know what’s in your area. Gastro Pubs are mad about the best of produce, don’t let them down. ';
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 1) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 2) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 3) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 4) {
    ___arguments.context.pageData['line2'] = 'Pubs with food are looking for quantity and quality, so Market Farmer’s are in a prime position to fulfil current and future orders. ';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 5) {
    ___arguments.context.pageData['line2'] = 'Pubs with food are looking for quantity and quality, so Market Farmer’s are in a prime position to fulfil current and future orders. ';
  }
  if ((getObjectProperty(___arguments.context.appData, 'trading')) == 6) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/e215479eb86cdb11b98d69b5b6a5f337/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('takeaway blurb');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);
  ___arguments.context.pageData['panelTitle'] = 'Takeaways';
  ___arguments.context.pageData['line1'] = 'What does a takeaway want? Volume produce delivered ready to go. Look out for an additional addendum request.';
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 1) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 2) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 3) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 4) {
    ___arguments.context.pageData['line2'] = 'When you receive an order from any kitchen, they may add a request for extra work to be done on the produce. One such request might be for ‘Potatoes washed’. You can reply with an updated price to cover the cost of the request, and if it’s acceptable, the kitchen will place an order.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 5) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'trading')) == 6) {
    ___arguments.context.pageData['line2'] = '';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/4599698f831d72a37b0cbe482cd35df1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('mobile blurb');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);
  ___arguments.context.pageData['panelTitle'] = 'Food Trucks';
  ___arguments.context.pageData['line1'] = 'There isn’t a lot of ‘Mobile Caterer’s’ around, but the one’s with a van and a pitch fight daily to keep customers coming. They need the best produce delivered during the ‘Golden Hour’ to allow them quick to turn your produce into something special for the lunch trade.';
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 1) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 2) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 3) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 4) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 5) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 6) {
    ___arguments.context.pageData['line2'] = '[vf]Restaurants don\'t always need large amounts. They have starters and special dishes which demand the very freshest of produce which they will advertise to entice customers.';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/f101d767ed56e9b63a2285c22c9d2fa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('all other');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);
  ___arguments.context.pageData['panelTitle'] = 'Others';
  ___arguments.context.pageData['line1'] = 'This group is a bit of a muddle. Many commercial kitchens placed in this group are restaurants and takeaways, which are wrongly categorised. ';
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 1) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 2) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 3) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 4) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 5) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'trading')) == 6) {
    ___arguments.context.pageData['line2'] = '';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/3dcd2c01321662a91b511572a81cc654/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('hotel blurb');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);
  ___arguments.context.pageData['panelTitle'] = 'Care Homes & Hospitals';
  ___arguments.context.pageData['line1'] = 'Hospitals will not be ordering, but caring premises such as Nursing Homes and Child care might develop menus for special events and particular clients.';
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 1) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 2) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 3) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 4) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'busTradingCode')) == 5) {
    ___arguments.context.pageData['line2'] = '';
  }
  if ((getObjectProperty(___arguments.context.appData, 'trading')) == 6) {
    ___arguments.context.pageData['line2'] = '';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/64a3ff11180ef7cfbdb46391e9656a45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091faeb4433948d363d10ea16e1e82', true);
  ___arguments.context.pageData['panelTitle'] = 'Restaurants';
  ___arguments.context.pageData['line1'] = 'Our database lists all retailers, which is a problem. Not all retailers will be interested in local produce. The retailers we want are ‘Green Grocers’';
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 1) {
    ___arguments.context.pageData['line2'] = 'Home Garden’s may struggle to fulfil ‘green grocers’ demands for volume, but there is always a place for fresh produce, which helps promote their shop.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 2) {
    ___arguments.context.pageData['line2'] = 'Green Space Grower’s  may struggle to fulfil ‘green grocers’ demands for volume, but there is always a place for fresh produce, which helps promote their shop.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 3) {
    ___arguments.context.pageData['line2'] = 'Allotments may struggle to fulfil ‘green grocers’ demands for volume, but there is always a place for fresh produce, which helps promote their shop.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 4) {
    ___arguments.context.pageData['line2'] = 'Green Grocers are always looking for the best crop before anyone else. You’re in a great position to sell quantity and quality.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 5) {
    ___arguments.context.pageData['line2'] = 'Green Grocers are always looking for the best crop before anyone else. You’re in a great position to sell quantity and quality.';
  }
  if ((getObjectProperty(___arguments.context.appData, 'tradingCode')) == 6) {
    ___arguments.context.pageData['line2'] = 'Green Grocers are not a good fit, they will typically be looking for keen price points.';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/5626f6c6e0feddf32a1a662d6678a1d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['panelTitle'])

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/producerRegistration4List/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/d195868358f99ba13e0e583d728b4b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userRegUniversal', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/producerRegistration4List/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02b9820b592158a392ae63a2e04115b9', false);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/roomDrillDown/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/roomDrillDown/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function my_4ColumnDisplay() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f3f2606c62ea7c18bf5b709345a5a24', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0f4fe909d171ba6830dbca198b2e37c5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a8a4c9fd473b42d84b4b2a827c27ac49', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7efafbd14ee45ea58d6467819167cee', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af5aecb8aec981d6b4d68f1655ddfaee', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5ba6372099a751c50a2b9436fe4def2', false);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function logicToggle() {
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z4') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
  }
}

/**
 * Describe this function...
 */
async function onEnterToggle() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b41e40df7ff5ec9312bd973e8efea49', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1016be1da81e2e81ec635e9d7b36b6c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5fca8d6c1f7a7519bf716ad55b9c4f6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0fa7ec537f80fd64b5396da6eef5293', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eed75f61fd9a38c8d2c6f837d48c7cb7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58d327c282ce5c05581ba9b4881c6fe3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94bc36c4bd463ca734032f8ca4833538', false);
    ___arguments.context.pageData['currentRoomContentNo'] = 0;
    ___arguments.context.pageData['displayBuildingContentsList'] = false;

  } catch (error) {
    console.log(error);

  }
}


  console.log('todo - assign schedule to 3rd party ie nursing home relatives');
  ___arguments.context.pageData['baseFontSize'] = 20;
  ___arguments.context.pageData['fontSize'] = (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 480 ? (getObjectProperty(___arguments.context.pageData, 'baseFontSize')) : (getObjectProperty(___arguments.context.pageData, 'baseFontSize')) * (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) / 1200));
  await onEnterToggle();
  await logicToggle();
  await my_4ColumnDisplay();
  try {
    ___arguments.context.pageData['structureWhereClause'] = (['businessLinkId = ','\'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
    ___arguments.context.pageData['showStructuresLogic'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['elementContentLogic'] = false;
  ___arguments.context.pageData['listContentsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = false;
  ___arguments.context.pageData['contentRowPickLogic'] = false;
  ___arguments.context.pageData['assignContentRowLogic'] = false;
  ___arguments.context.pageData['structureWhereClause'] = 'nil';
  ___arguments.context.pageData['levelWhereClause'] = 'nil';
  ___arguments.context.pageData['unitWhereClause'] = 'nil';
  ___arguments.context.pageData['roomWhereClause'] = 'nil';
  ___arguments.context.pageData['toggleLogic1'] = false;
  ___arguments.context.pageData['showStructuresLogic'] = false;
  ___arguments.context.pageData['showLevelsLogic'] = false;
  ___arguments.context.pageData['showUnitsLogic'] = false;
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['showContentsLogic'] = false;

  },
  /* handler:onBeforeEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      ___arguments.context.pageData['fontSize'] = (___arguments.screenWidth <= 480 ? 24 : 24 * (___arguments.screenWidth / 1200));

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/roomDrillDown/components/2ea3700cbb7b1542d4aacfe691539997/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['structureWhereClause'] = (['businessLinkId = ','\'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z40') + 1 > 0) {
      ___arguments.context.pageData['showStructuresLogic'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/roomDrillDown/components/e702e5a74736912702ed97667bc4c3e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function dataPath() {
  ___arguments.context.appData['ptStructureId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptStructureId'));
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = true;
  ___arguments.context.pageData['ptRoomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.appData['ptRoomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.pageData['ptRoomId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptElementId'));
  ___arguments.context.pageData['ptRoomId2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptRoomId'));
  ___arguments.context.appData['ptRoomIdAppData'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptRoomId'));
  ___arguments.context.appData['ptRoomIdSelected'] = ___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc');
  ___arguments.context.appData['roomRef'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'Ref'));
  ___arguments.context.appData['roomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.pageData['contentWhereClause'] = (['ptRoomId = ','\'',(getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),'\'','',''].join(''));
  ___arguments.context.pageData['levelWhereClause'] = (['ptStructureId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptStructureId')),'\'','',''].join(''));
}

/**
 * Describe this function...
 */
async function uiPath() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aecaf3e4db85f389ba714b2f34fee193'))['borderColor'] = '#616161';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a8a4c9fd473b42d84b4b2a827c27ac49', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec874c4a88230be1270e5f8d0b039a73', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e65fd593bef46d26017dce0690ce278f'))['borderColor'] = '#F15C45';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7efafbd14ee45ea58d6467819167cee', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b75c4c5adc312926c391f105ef3d856d', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8a4c9fd473b42d84b4b2a827c27ac49'))['borderWidth'] = '4px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aecaf3e4db85f389ba714b2f34fee193'))['borderWidth'] = '2px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
}


  await dataPath();
  await uiPath();

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e702e5a74736912702ed97667bc4c3e9'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/aecaf3e4db85f389ba714b2f34fee193/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var foundItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showRoomsLogic')) == true) {
    foundItems = (await Backendless.Data.of('ptRoomAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),'','','',''].join(''))).setPageSize(30)));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('07613b843ce6e63b560d8037679e71c1', foundItems);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/roomDrillDown/components/fc76ef85fc5c5ecb0c58e95eb6313e94/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fc76ef85fc5c5ecb0c58e95eb6313e94'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/8da6202ff1811307dbe7d04f1e444b74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['toggleLogic1'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/roomDrillDown/components/e65fd593bef46d26017dce0690ce278f/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'assignedContentLogic')) == true) {
    ___arguments.context.pageData['currentRoomSchedules'] = (await Backendless.Data.of('scheduleAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(40)));
    ___arguments.context.pageData['currentSchedulesNo'] = ((getObjectProperty(___arguments.context.pageData, 'currentRoomSchedules')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deb11ff683ba3beef1f3ba5eda920d2f', (getObjectProperty(___arguments.context.pageData, 'currentRoomSchedules')));
    ___arguments.context.pageData['currentRoomContent'] = (await asyncListSort((await Backendless.Data.of('ptContentAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(40))), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    }));
    ___arguments.context.pageData['currentRoomContentNo'] = ((getObjectProperty(___arguments.context.pageData, 'currentRoomContent')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ca29e6c7955edb18bab7f4b37e631ca6', (getObjectProperty(___arguments.context.pageData, 'currentRoomContent')));
    ___arguments.context.pageData['contentBuildingCurrent'] = (await asyncListSort((await Backendless.Data.of('ptContentElement').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'levelWhereClause')),'',''].join(''))).setPageSize(40))), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    }));
    ___arguments.context.pageData['contentBuildingCurrentNo'] = ((getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrent')).length);
    if ((getObjectProperty(___arguments.context.pageData, 'displayBuildingContentsList')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd0a851826861d2b0177799eff25cf19', (getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrent')));
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/roomDrillDown/components/c4c538e8c5686044be6d809ce8d58aae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ptRoomName'))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4c538e8c5686044be6d809ce8d58aae'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/a8d6eb28b74d6df9da25c44d4aea126a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(['[',(getObjectProperty(___arguments.context.appData, 'unitRef')),'] - ',(getObjectProperty(___arguments.context.appData, 'ptUnitName'))].join('')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8d6eb28b74d6df9da25c44d4aea126a'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/a3ef5cda2906478e835e42a2424ce033/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).indexOf('%') + 1 > 0 ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).indexOf('%') + 1) - 1) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name'))) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3ef5cda2906478e835e42a2424ce033'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/84b795ad2c339453f8eea2b96b13c88e/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b41e40df7ff5ec9312bd973e8efea49', undefined);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/roomDrillDown/components/49ba50433a0bc86e331c8c5881997c78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['',(getObjectProperty(___arguments.context.pageData, 'ptRoomName')),' contents [x',(getObjectProperty(___arguments.context.pageData, 'currentRoomContentNo')),'].'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49ba50433a0bc86e331c8c5881997c78'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      console.log((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/roomDrillDown/components/843bb96269af2832817543bc6c1249b3/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'assignedContentLogic')) == true) {
    ___arguments.context.pageData['currentRoomSchedules'] = (await asyncListSort((await Backendless.Data.of('scheduleAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(40))), -1, async (item) => {


     return (getObjectProperty(item, 'nextDate'));
    }));
    ___arguments.context.pageData['currentSchedulesNo'] = ((getObjectProperty(___arguments.context.pageData, 'currentRoomSchedules')).length);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/roomDrillDown/components/44acb41ca44d16cac65fc738770e3f2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Currently ',(getObjectProperty(___arguments.context.pageData, 'currentSchedulesNo')),' assigned.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('44acb41ca44d16cac65fc738770e3f2d'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/5c2a87b7134e2d74dfbf9b363b3e2d7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'HumanTaskName')) + String(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5c2a87b7134e2d74dfbf9b363b3e2d7d'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/b2149cafd5f179de850df1c6087a0566/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'definitionText')) + String(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2149cafd5f179de850df1c6087a0566'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.4);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/86de3a49fa1f86ad52023843aed20d88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Next date - ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'nextDate')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'nextDate')))).toLocaleDateString())].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86de3a49fa1f86ad52023843aed20d88'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/5afc4dcf2fa10b35a41ac1179a175b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('businessDefineSchedule', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5afc4dcf2fa10b35a41ac1179a175b88'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/9f7b92f5252f5f6f233473d339fbe693/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5')['paused'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')));
  await Backendless.Data.of('scheduleAssign').save(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), true);

  },
  /* handler:onClick */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4caf2e6e92e78e2d7675e02a054fa5fb', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4caf2e6e92e78e2d7675e02a054fa5fb', false);
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == true ? 'pause circle outline' : 'play circle outline')

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/4caf2e6e92e78e2d7675e02a054fa5fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == 1) {
    await Backendless.Data.of('scheduleAssign').remove( ___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5') );
    if ((getObjectProperty(___arguments.context.pageData, 'currentSchedulesNo')) == 1) {
      (getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected'))['scheduleAssigned'] = false;
      await Backendless.Data.of('ptRoomAssign').save((getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected')), true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/roomDrillDown/components/219f81aa243b06ce55795f7d64b1e809/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9'), 'objectId'));
  console.log(String('Name = ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9'), 'Name')));
  await Backendless.Data.of('ptContentAssign').remove( ___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9') );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/roomDrillDown/components/d0a565dd30142692331c8a4602426b1a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d0a565dd30142692331c8a4602426b1a'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/d99625bb7d09845bf005b7d488bb3bad/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d99625bb7d09845bf005b7d488bb3bad'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/9c3e1ea9fdae579e945800bdd0da576b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9c3e1ea9fdae579e945800bdd0da576b'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(['[',(getObjectProperty(___arguments.context.appData, 'unitRef')),'] - ',(getObjectProperty(___arguments.context.appData, 'ptUnitName'))].join('')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/1b44702a7f12a825952a3f2a49fba80a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b44702a7f12a825952a3f2a49fba80a'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/eaba1a1a02850a8b9765695e8bc90331/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eaba1a1a02850a8b9765695e8bc90331'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/3d7da5f63dc192856f7ce41e65e724e6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3d7da5f63dc192856f7ce41e65e724e6'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/54b285fecc2805b18f38a5689cb88c2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Created - ',((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).toLocaleDateString()),', ',Math.round(((new Date()).valueOf()) / 86400000) - Math.round(((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).valueOf()) / 86400000),Math.round(((new Date()).valueOf()) / 86400000) - Math.round(((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).valueOf()) / 86400000) < 2 ? ' in last 24 hours.' : ' days ago.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('54b285fecc2805b18f38a5689cb88c2f'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.4);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/c6f85b22f558ff085ae83e7eda183e98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('User - ') + String(getObjectProperty(___arguments.context.pageData, 'unitCreatedBy')))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6f85b22f558ff085ae83e7eda183e98'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/82b461284ba8cd310e488f18d14800dc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('82b461284ba8cd310e488f18d14800dc'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.8);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/roomDrillDown/components/cc862d0e5a9f58512897297a25a24be6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.Data.of('ptRoomAssign').remove( ___arguments.context.getComponentDataStoreByUid('5393db845943aad7814dc428a9c364ff') );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/salesEnquiryTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/salesEnquiryTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('inviteNewUser1', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/salesEnquiryTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/salesEnquiryTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signin/components/a6ded58cabab013125843f76779d42b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, matchedToBusiness;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.UserService.logout();
  ___arguments.context.appData['viewBank'] = 'canView';
  try {
    try {
      await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'userEmail')), (getObjectProperty(___arguments.context.pageData, 'password1')), false  );

    } catch (error) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ad84ecfc36a0ff8545be8185993bffc', true);

    }
    ___arguments.context.pageData['statusMessage'] = (String('User logged in.') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'userTag')));
    ___arguments.context.appData['userDetails'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['userTag'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'userTag'));
    ___arguments.context.appData['userEmail'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
    ___arguments.context.appData['userId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    ___arguments.context.appData['currentBusinessId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'businessId'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd3a8d8f3e570f4cf22bc7b37dbf0be', false);
    matchedToBusiness = (await Backendless.Data.of('usersInBusiness').find(Backendless.DataQueryBuilder.create().setWhereClause((['usersObjectId LIKE \'',(getObjectProperty(___arguments.context.appData, 'userId')),'\''].join(''))).setPageSize(10)));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b8f29cf5fc1e1b772b29b09da234aa18', matchedToBusiness);

  } catch (error) {
    ___arguments.context.pageData['statusMessage'] = (String('Login failed. Server returned an error.') + String(getObjectProperty(error, 'message')));

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b8f29cf5fc1e1b772b29b09da234aa18', true);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signin/components/2cf103bb48b368ecfae225389c9b5f9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedBusiness'] = ___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b');
  console.log('/////////// selectedBusiness[appData] = ');
  console.log(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'));
  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness'));
  console.log('business name = ');
  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessTag'));
  console.log('invitesLiveForDays= ');
  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness.invitesLiveForDays'));
  ___arguments.context.appData['softwareProductName'] = (getObjectProperty(___arguments.context.appData, 'selectedBusiness.softwareProductName'));
  ___arguments.context.appData['userLevelString'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'userLevelString'));
  await Backendless.Data.of('userConnections').save( ({ [`lastLogin`]: (new Date()),[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'objectId')) }) );
  ___arguments.context.appData['userLevel'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'userLevel'));
  console.log('////////  userLevel[appData] = ');
  console.log(getObjectProperty(___arguments.context.appData, 'userLevel'));
  console.log('close ////////  userLevel[appData] = ');
  ___arguments.context.appData['userRoleAccessID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'userRoleAccessID2'));
  ___arguments.context.appData['isFounder'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'isFounder'));
  ___arguments.context.appData['selectedUsersObjectId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'objectId'));
  ___arguments.context.appData['selectedObjectId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'businessObjectId'));
  ___arguments.context.appData['businessLinkId2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'businessLinkId'));
  ___arguments.context.appData['holidaysAllowed'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'holidaysAllowed')) * 1.28571429);
  ___arguments.context.appData['userNameFirstFromUsersInBusiness'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'nameFirst'));
  ___arguments.context.appData['userNameSurnameFromUsersInBusiness'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'nameSurname'));
  ___arguments.context.appData['userInitialEmailFromUsersInBusiness'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'initialEmail'));
  ___arguments.context.appData['userTagFromUsersInBusiness'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'userTagFromUserConnections'));
  ___arguments.context.appData['userRoleFromUserConnections'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'userRole'));
  ___arguments.context.appData['selectedId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'usersObjectId'));
  ___arguments.context.appData['ukNation'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'ukNation'));
  ___arguments.context.appData['tradingStyleGroup'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'tradingStyleGroup'));
  ___arguments.context.appData['tradingCode'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'tradingStyleGroup'));
  ___arguments.context.appData['businessName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'businessTag'));
  ___arguments.context.appData['userRole'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'userRoleString'));
  ___arguments.context.appData['businessLinkId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'businessObjectId'));
  ___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b')['lastLogin'] = (new Date());
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d983e0982059971ea5316f994c4a60b'), 'businessTag'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/signin/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      console.log('PRODUCTION 300 (5mins)');
  ___arguments.context.pageData['timeOutLength'] = 300;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ad84ecfc36a0ff8545be8185993bffc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46742208946a11d812981268704b53e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a184126c838b74a3c886ba8341e7ed7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c61831e8d6b8fc72416868684d2c1fe8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aca612d8a391d6f88008ab888078ee08', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4dcb5c97585d2c4274ed77db6582c608', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6dcee4d80d22ed5aa538dbe8f48a1d29', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c2d3dd8b62cd155847864e8989613c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23373242726803dd263dedde63689745', false);
  ___arguments.context.appData['globalHolidayErrorChecks'] = 6;
  ___arguments.context.appData['black'] = '#000000';
  ___arguments.context.appData['brown'] = '#7A5D5F';
  ___arguments.context.appData['pink'] = '#EF8BC9';
  ___arguments.context.appData['red'] = '#DD4864';
  ___arguments.context.appData['orange'] = '#EA775D';
  ___arguments.context.appData['yellow'] = '#FAE965';
  ___arguments.context.appData['green'] = '#5FC981';
  ___arguments.context.appData['teal'] = '#67D7C1';
  ___arguments.context.appData['blue'] = '#559DE1';
  ___arguments.context.appData['purple'] = '#8365B4';
  ___arguments.context.appData['grey'] = '#D5D3E4';
  ___arguments.context.appData['lime'] = '#cddc39';
  ___arguments.context.appData['systemGrey'] = '#616161';
  ___arguments.context.appData['systemRed'] = '#F15C45	';
  ___arguments.context.appData['systemYellow'] = '#FBC632';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/signin/components/e5b810b8a6581a631f3c73dbc123d209/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signin/components/f09dc3bf6e3b5b85a9ae8e7a2974d947/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9e335d3557178e4edc2f8528c2d5ee5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ded58cabab013125843f76779d42b1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46742208946a11d812981268704b53e2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a184126c838b74a3c886ba8341e7ed7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eb8bb788c9bcc29b4a8f4c875d811fc', false);
  ___arguments.context.pageData['userEmail'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signin/components/46742208946a11d812981268704b53e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  ___arguments.context.pageData['resetAttempts'] = 0;
  if (((new RegExp('(\\w+)@(\\w+)\\.(\\w+)', 'gm')).test((getObjectProperty(___arguments.context.pageData, 'userEmail')))) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fd3a8d8f3e570f4cf22bc7b37dbf0be'))['borderColor'] = 'red';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fd3a8d8f3e570f4cf22bc7b37dbf0be'))['border-width'] = 8;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fd3a8d8f3e570f4cf22bc7b37dbf0be'))['borderColor'] = '#4DA54E';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fd3a8d8f3e570f4cf22bc7b37dbf0be'))['border-width'] = 3;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eb8bb788c9bcc29b4a8f4c875d811fc', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c61831e8d6b8fc72416868684d2c1fe8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ad84ecfc36a0ff8545be8185993bffc', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46742208946a11d812981268704b53e2', false);
    await new Promise(r => setTimeout(r, 500 || 0));
    ___arguments.context.pageData['resetCode'] = ((generateUUID().short()).toUpperCase());
    await Backendless.Data.of('userPasswordReset').save( ({ [`resetCode`]: (getObjectProperty(___arguments.context.pageData, 'resetCode')),[`timeOutOnReset`]: (new Date((new Date()).getTime() + ((getObjectProperty(___arguments.context.pageData, 'timeOutLength')) * 1000))) }) );
    if (getObjectProperty(___arguments.context.pageData, 'timerRunning')) {
      ___arguments.context.pageData['timerRunning'] = false;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('c772559c797d464912c87c75fe584828');
    } else {
      ___arguments.context.pageData['timerRunning'] = true;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).start() })('c772559c797d464912c87c75fe584828');
      await Backendless.Messaging.sendEmail('Password reset requested for Fork2Fork.co.uk', new Backendless.Bodyparts({ htmlmessage: (['<!doctype html> <html> <head> 	<title>HTML Editor - Full Version</title> </head> <body> <h2><span style="font-family:arial,helvetica,sans-serif;">Fork2Fork</span></h2>  <h3><span style="font-family:arial,helvetica,sans-serif;">Password request.</span></h3>  <p><span style="font-family:arial,helvetica,sans-serif;">Hi,</span></p>  <p><span style="font-family:arial,helvetica,sans-serif;">We recieved a request to reset a password for one of our subscribers.</span></p>  <p><font face="arial, helvetica, sans-serif">To reset the password you will need to enter this reset code - ',(getObjectProperty(___arguments.context.pageData, 'resetCode')),'</font></p>  <p><font face="arial, helvetica, sans-serif">Thanks for using Fork2Fork to help us all eat sustainably.</font></p>  <p><font face="arial, helvetica, sans-serif">Regards,</font></p>  <p><font face="arial, helvetica, sans-serif">Admin Team</font></p>  <p style="font-style: italic;">&nbsp;</p>  <p style="font-style: italic;">&nbsp;</p> </body> </html>'].join('')) }), ensureArray([(getObjectProperty(___arguments.context.pageData, 'userEmail'))]), undefined);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46742208946a11d812981268704b53e2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aca612d8a391d6f88008ab888078ee08', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signin/components/4dcb5c97585d2c4274ed77db6582c608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'resetAttempts')) < 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23373242726803dd263dedde63689745', false);
    list = (await Backendless.Data.of('userPasswordReset').find(Backendless.DataQueryBuilder.create().setWhereClause((['resetCode=\'',(getObjectProperty(___arguments.context.pageData, 'resetCodeEntered')),'\''].join(''))).setPageSize(10)));
    if (list.length > 0) {
      if ((new Date()) > (getObjectProperty((list[0]), 'timeOutOnReset'))) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aca612d8a391d6f88008ab888078ee08', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46742208946a11d812981268704b53e2', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c61831e8d6b8fc72416868684d2c1fe8', false);
        ___arguments.context.pageData['resetCode'] = '';
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6dcee4d80d22ed5aa538dbe8f48a1d29', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aca612d8a391d6f88008ab888078ee08', false);
      }
      await Backendless.Data.of('userPasswordReset').remove( (list[0]) );
    } else {
      ___arguments.context.pageData['resetAttempts'] = ((getObjectProperty(___arguments.context.pageData, 'resetAttempts')) + 1);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23373242726803dd263dedde63689745', true);
    }
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signin/components/bb988ed82e6d201a36b140f858089f98/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4dcb5c97585d2c4274ed77db6582c608', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/signin/components/97b8cf684b955498e8c540c2b9388158/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['userDetail'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty(___arguments.context.pageData, 'userEmail')),'\''].join(''))).setPageSize(1)));
  console.log({ [`objectId`]: (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'userDetail'))[0]), 'objectId')) });
  console.log({ [`objectId`]: (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'userDetail'))[0]), 'objectId')),[`password`]: (getObjectProperty(___arguments.context.pageData, 'newPassword')) });
  await Backendless.UserService.update( new Backendless.User(({ [`objectId`]: (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'userDetail'))[0]), 'objectId')),[`password`]: (getObjectProperty(___arguments.context.pageData, 'newPassword')) })) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6dcee4d80d22ed5aa538dbe8f48a1d29', false);
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signin/components/c772559c797d464912c87c75fe584828/bundle.js', [], () => ({
  /* content */
  /* handler:onTimerEnd */
  async ['onTimerEnd'](___arguments) {
    var list;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aca612d8a391d6f88008ab888078ee08', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23373242726803dd263dedde63689745', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c2d3dd8b62cd155847864e8989613c8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6dcee4d80d22ed5aa538dbe8f48a1d29', false);
  await Backendless.Data.of('userPasswordReset').remove( (list[0]) );

  },
  /* handler:onTimerEnd */
  /* content */
}))

define('./pages/signin/components/414cb8e892744fa67788c768470c6e08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testFieldCompression/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var txResult, myTx, listOfObjects, eof, foundField, colour, name2, objectId, length2, iconPosition, roomTextLength, inputField, unPackColumn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function unPackField(unPackColumn, inputField) {
  listOfObjects = [];
  foundField = (getObjectProperty((inputField[0]), unPackColumn));
  while (!(iconPosition == 0)) {
    iconPosition = foundField.indexOf('') + 1;
    roomTextLength = foundField.indexOf('©') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 4) - 1), iconPosition + 6))));
    objectId = foundField.slice(((iconPosition + 7) - 1), iconPosition + length2 + 6);
    iconPosition = foundField.indexOf('◊') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 1) - 1), iconPosition + 3))));
    name2 = foundField.slice(((iconPosition + 4) - 1), iconPosition + length2 + 3);
    iconPosition = foundField.indexOf('∑') + 1;
    length2 = (Number((foundField.slice(((iconPosition + 1) - 1), iconPosition + 3))));
    colour = foundField.slice(((iconPosition + 4) - 1), iconPosition + length2 + 3);
    addItemToList(listOfObjects, ({ [`objectId`]: objectId,[`roomName`]: name2,[`colour`]: colour }));
    foundField = foundField.slice(((foundField.indexOf('©') + 1 + 1) - 1), foundField.length);
    eof = foundField.indexOf('') + 1;
    if (eof == 0) {
      break;
    }
  }
  return listOfObjects
}


  myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTx;

    _uow.find('ptUnitAssign', Backendless.DataQueryBuilder.create().setWhereClause('objectId = \'5E9CE823-E03F-460A-A253-D1B568F6DF8C\'').setPageSize(10)).setOpResultId('testFieldRead');

  })();

  txResult = (await myTx.execute());
  ___arguments.context.pageData['foundField'] = (getObjectProperty((txResult.getResults()), 'testFieldRead.result'));
  console.log(txResult);
  console.log((await BackendlessUI.Functions.Custom['fn_99a570aeed997a122be7a512bad9a462']('roomIds', (getObjectProperty(___arguments.context.pageData, 'foundField')))));
  console.log((await BackendlessUI.Functions.Custom['fn_99a570aeed997a122be7a512bad9a462']('contentsIds', (getObjectProperty(___arguments.context.pageData, 'foundField')))));
  console.log((await BackendlessUI.Functions.Custom['fn_99a570aeed997a122be7a512bad9a462']('schedulesIds', (getObjectProperty(___arguments.context.pageData, 'foundField')))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/testFindinMap/components/febaf6583ea39174c70aba27b2463ece/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testFindinMap/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error, item;


  try {
    console.log('start find \'kitchensFound"');
    ___arguments.context.appData['kitchensFound'] = (await Backendless.Data.of('kitchens').find(Backendless.DataQueryBuilder.create().setWhereClause('distanceOnSphere(\'POINT(-5.798469675395774 54.583558303264645)\',geoLoc) < mi(1)').setPageSize(100)));
    console.log('end find \'kitchensFound"');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/testFindinMap/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.appData['isFounder'] = true;
    ___arguments.context.appData['businessStyle'] = 'Producer';
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userRegUniversal', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testFindinMap/components/3c2b27c99f7c899719aa5524eee4404b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.appData, 'noKitchensFound')) < '1' ? 'Nope, no ' : String('Sorry, it looks like we can only find ') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'noKitchensFound')))),' commercial kitchens within a radius of ',(JSON.stringify((getObjectProperty(___arguments.context.appData, 'radius')))),' miles. To increase the search click on ‘Change Distance’ button below.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/testFindinMap/components/930ba81e08e8db0132057ce23e978513/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['tradingText'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/testFindinMap/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('0typeOfBusinessRegistration', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testFindinMap/components/ad1af9e788a8396cb37fe1638a2c870d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('producerRegistration4List', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testFindinMap/components/c15aad4d929371ccfafd0861519d235d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('distancePick', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testFindinMap/components/2a81a638b322683856989c4f3688f738/bundle.js', [], () => ({
  /* content */
  /* handler:markersLogic */
  ['markersLogic'](___arguments) {
    var item;

  },
  /* handler:markersLogic */
  /* handler:centerLogic */
  ['centerLogic'](___arguments) {
    
  },
  /* handler:centerLogic */
  /* content */
}))

define('./pages/testFire/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var search, currentAsignedSchedules, x, nextRepeatDays, asTimeStamp, newMonth, firstDateTimestamp, nextDateVar, days, xCounter, from, requiredDayOfWeek, dateSelected, copyDateSelected, dateTask, i, scheduleSourceId, year, calcNewDayOfMonth, month, j, triggerOK, dayOfMonth, nowVar, loopCount, businessDetails;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  nowVar = (new Date());
  businessDetails = (await Backendless.Data.of('businessDetails').find(Backendless.DataQueryBuilder.create().setProperties(['businessName', 'objectId', 'paidPlan']).setPageSize(100)));
  console.log('businessDetails result = ');
  console.log(businessDetails);
  for (var j_index in businessDetails) {
    j = businessDetails[j_index];
    currentAsignedSchedules = [];
    loopCount = (typeof loopCount == 'number' ? loopCount : 0) + 1;
    search = ['nextDateText = \'','',[(new Date(nowVar).getMonth() + 1),'/',(new Date((new Date(nowVar.getTime() + (86400 * 1000)))).getDate()),'/',(new Date(nowVar).getFullYear())].join(''),'\'','&&','businessId = \'',(getObjectProperty(j, 'objectId')),'\' ','','','',''].join('');
    console.log('search?');
    console.log(search);
    currentAsignedSchedules = (await Backendless.Data.of('scheduleAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(search).setPageSize(100)));
    console.log('found schedules');
    console.log(currentAsignedSchedules);
    if (currentAsignedSchedules.length < 1) {
      console.log('no schedules found in this company');
    } else {
      for (var x_index in currentAsignedSchedules) {
        x = currentAsignedSchedules[x_index];
        if ((getObjectProperty(x, 'scheduleType')) == 1) {
          console.log(getObjectProperty(x, 'HumanTaskName'));
          year = (new Date((new Date())).getFullYear());
          dayOfMonth = (new Date((new Date())).getDate());
          month = 0 + (new Date((new Date())).getMonth() + 1);
          triggerOK = false;
          for (i = 1; i <= 7; i++) {
            if ((getObjectProperty(x, 'weekDayNo')) - 1 == (new Date(((new Date((['',month,'/',i,'/',year,''].join('')))).valueOf())).getDay())) {
              break;
            }
          }
          calcNewDayOfMonth = i + ((getObjectProperty(x, 'xWeeks')) - 1) * 7;
          if (i + ((getObjectProperty(x, 'xWeeks')) - 1) * 7 <= (new Date((new Date())).getDate())) {
            month = (typeof month == 'number' ? month : 0) + 1;
            if (month > 12) {
              year = (typeof year == 'number' ? year : 0) + 1;
            }
            for (j = 1; j <= 7; j++) {
              if ((getObjectProperty(x, 'weekDayNo')) - 1 == (new Date(((new Date((['',month,'/',j,'/',year,''].join('')))).valueOf())).getDay())) {
                calcNewDayOfMonth = j + ((getObjectProperty(x, 'xWeeks')) - 1) * 7;
                break;
              }
            }
          }
          nextDateVar = ((new Date(([month,'/',calcNewDayOfMonth,'/',year].join('')))).valueOf());
          x['nextDateText'] = ([month,'/',calcNewDayOfMonth,'/',year].join(''));
          x['nextDate'] = nextDateVar;
          x['created'] = (new Date());
          await Backendless.Data.of('scheduleAssign').save( x );
        }
        if ((getObjectProperty(x, 'scheduleType')) == 2) {
          scheduleSourceId = (generateUUID().long());
          i = 0;
          dateTask = (new Date((getObjectProperty(x, 'nextDateText'))));
          copyDateSelected = (new Date(dateTask.getTime() + (((getObjectProperty(x, 'xWeeks')) * 604800) * 1000)));
          requiredDayOfWeek = (new Date(dateTask).getDay());
          dateSelected = copyDateSelected;
          from = ((new Date(dateSelected)).valueOf());
          days = 86400000;
          for (xCounter = 0; xCounter <= 6; xCounter++) {
            if ((new Date((new Date(((from - 0) + (xCounter + 0) * days)))).getDay()) - 0 == requiredDayOfWeek) {
              firstDateTimestamp = (from - 0) + (xCounter + 0) * days;
              break;
            }
          }
          nextDateVar = ((new Date(([(new Date(firstDateTimestamp).getMonth() + 1),'/',(new Date(firstDateTimestamp).getDate()),'/',(new Date(firstDateTimestamp).getFullYear())].join('')))).valueOf());
          x['nextDateText'] = ([(new Date(firstDateTimestamp).getMonth() + 1),'/',(new Date(firstDateTimestamp).getDate()),'/',(new Date(firstDateTimestamp).getFullYear())].join(''));
          x['nextDate'] = firstDateTimestamp;
          x['created'] = (new Date());
          await Backendless.Data.of('scheduleAssign').save( x );
        }
        if ((getObjectProperty(x, 'scheduleType')) == 3) {
          newMonth = (getObjectProperty(x, 'monthOfYear')) + (getObjectProperty(x, 'xMonths'));
          asTimeStamp = (new Date((getObjectProperty(x, 'nextDateText'))));
          asTimeStamp.setMonth(newMonth);
          x['nextDateText'] = ([(new Date(asTimeStamp).getMonth() + 1),'/',(new Date(asTimeStamp).getDate()),'/',(new Date(asTimeStamp).getFullYear())].join(''));
          x['nextDate'] = asTimeStamp;
          x['created'] = (new Date());
          x['monthOfYear'] = newMonth;
          await Backendless.Data.of('scheduleAssign').save( x );
        }
        if ((getObjectProperty(x, 'scheduleType')) == 4) {
          asTimeStamp = (new Date((getObjectProperty(x, 'nextDateText'))));
          nextRepeatDays = (new Date(asTimeStamp.getTime() + ((86400 * (getObjectProperty(x, 'xDays'))) * 1000)));
          x['nextDateText'] = ([(new Date(nextRepeatDays).getMonth() + 1),'/',(new Date(nextRepeatDays).getDate()),'/',(new Date(nextRepeatDays).getFullYear())].join(''));
          x['nextDate'] = (nextRepeatDays.valueOf());
          x['created'] = (new Date());
          await Backendless.Data.of('scheduleAssign').save( x );
        }
      }
    }
  }
  console.log(['Hi, \'nextDayTasks1\' was triggered at ',(new Date()),'.',currentAsignedSchedules.length,' matching records for whereClause = ',search].join(''));
  await Backendless.Messaging.sendEmail('nextDayTacks1 has fired', new Backendless.Bodyparts({ textmessage: (['Hi, \'nextDayTasks1\' was triggered at ',(new Date()),'.',currentAsignedSchedules.length,' matching records for whereClause = ',search].join('')) }), ensureArray('admin@ecofoodsafe.com'), undefined);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/testcloudCode/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, list, search, currentAsignedSchedules, x, nextRepeatDays, asTimeStamp, newMonth, firstDateTimestamp, nextDateVar, days, xCounter, from, requiredDayOfWeek, dateSelected, copyDateSelected, dateTask, i, scheduleSourceId, year, calcNewDayOfMonth, month, j, triggerOK, dayOfMonth, nowVar, loopCount, businessDetails;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

/**
 * Describe this function...
 */
async function nextDayTasks() {
  list = [];
  nowVar = (new Date());
  businessDetails = (await Backendless.Data.of('businessDetails').find(Backendless.DataQueryBuilder.create().setWhereClause('paidplan = 1').setProperties(['businessName', 'objectId', 'paidPlan']).setPageSize(100)));
  for (var j_index in businessDetails) {
    j = businessDetails[j_index];
    currentAsignedSchedules = [];
    loopCount = (typeof loopCount == 'number' ? loopCount : 0) + 1;
    search = ['nextDateText = \'','',[(new Date(nowVar).getMonth() + 1),'/',(new Date((new Date(nowVar.getTime() + (86400 * 1000)))).getDate()),'/',(new Date(nowVar).getFullYear())].join(''),'\'',' &&',' businessId = \'',(getObjectProperty(j, 'objectId')),'\' ','','','',''].join('');
    console.log(search);
    currentAsignedSchedules = (await Backendless.Data.of('scheduleAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(search).setPageSize(100)));
    console.log('as found \'currentAssignedSchedules\' = ');
    console.log(currentAsignedSchedules);
    if (currentAsignedSchedules.length < 1) {
    } else {
      for (var x_index in currentAsignedSchedules) {
        x = currentAsignedSchedules[x_index];
        if ((getObjectProperty(x, 'scheduleType')) == 1) {
          year = (new Date((new Date())).getFullYear());
          dayOfMonth = (new Date((new Date())).getDate());
          month = 0 + (new Date((new Date())).getMonth() + 1);
          triggerOK = false;
          for (i = 1; i <= 7; i++) {
            if ((getObjectProperty(x, 'weekDayNo')) - 1 == (new Date(((new Date((['',month,'/',i,'/',year,''].join('')))).valueOf())).getDay())) {
              break;
            }
          }
          calcNewDayOfMonth = i + ((getObjectProperty(x, 'xWeeks')) - 1) * 7;
          if (i + ((getObjectProperty(x, 'xWeeks')) - 1) * 7 <= (new Date((new Date())).getDate())) {
            month = (typeof month == 'number' ? month : 0) + 1;
            if (month > 12) {
              year = (typeof year == 'number' ? year : 0) + 1;
            }
            for (j = 1; j <= 7; j++) {
              if ((getObjectProperty(x, 'weekDayNo')) - 1 == (new Date(((new Date((['',month,'/',j,'/',year,''].join('')))).valueOf())).getDay())) {
                calcNewDayOfMonth = j + ((getObjectProperty(x, 'xWeeks')) - 1) * 7;
                break;
              }
            }
          }
          nextDateVar = ((new Date(([month,'/',calcNewDayOfMonth,'/',year].join('')))).valueOf());
          x['nextDateText'] = ([month,'/',calcNewDayOfMonth,'/',year].join(''));
          x['nextDate'] = nextDateVar;
          x['created'] = (new Date());
          addItemToList(list, x);
        }
        if ((getObjectProperty(x, 'scheduleType')) == 2) {
          scheduleSourceId = (generateUUID().long());
          i = 0;
          dateTask = (new Date((getObjectProperty(x, 'nextDateText'))));
          copyDateSelected = (new Date(dateTask.getTime() + (((getObjectProperty(x, 'xWeeks')) * 604800) * 1000)));
          requiredDayOfWeek = (new Date(dateTask).getDay());
          dateSelected = copyDateSelected;
          from = ((new Date(dateSelected)).valueOf());
          days = 86400000;
          for (xCounter = 0; xCounter <= 6; xCounter++) {
            if ((new Date((new Date(((from - 0) + (xCounter + 0) * days)))).getDay()) - 0 == requiredDayOfWeek) {
              firstDateTimestamp = (from - 0) + (xCounter + 0) * days;
              break;
            }
          }
          nextDateVar = ((new Date(([(new Date(firstDateTimestamp).getMonth() + 1),'/',(new Date(firstDateTimestamp).getDate()),'/',(new Date(firstDateTimestamp).getFullYear())].join('')))).valueOf());
          x['nextDateText'] = ([(new Date(firstDateTimestamp).getMonth() + 1),'/',(new Date(firstDateTimestamp).getDate()),'/',(new Date(firstDateTimestamp).getFullYear())].join(''));
          x['nextDate'] = firstDateTimestamp;
          x['created'] = (new Date());
          addItemToList(list, x);
        }
        if ((getObjectProperty(x, 'scheduleType')) == 3) {
          newMonth = (getObjectProperty(x, 'monthOfYear')) + (getObjectProperty(x, 'xMonths'));
          asTimeStamp = (new Date((getObjectProperty(x, 'nextDateText'))));
          asTimeStamp.setMonth(newMonth);
          x['nextDateText'] = ([(new Date(asTimeStamp).getMonth() + 1),'/',(new Date(asTimeStamp).getDate()),'/',(new Date(asTimeStamp).getFullYear())].join(''));
          x['nextDate'] = asTimeStamp;
          x['created'] = (new Date());
          x['monthOfYear'] = newMonth;
          addItemToList(list, x);
        }
        if ((getObjectProperty(x, 'scheduleType')) == 4) {
          asTimeStamp = (new Date((getObjectProperty(x, 'nextDateText'))));
          nextRepeatDays = (new Date(asTimeStamp.getTime() + ((86400 * (getObjectProperty(x, 'xDays'))) * 1000)));
          x['nextDateText'] = ([(new Date(nextRepeatDays).getMonth() + 1),'/',(new Date(nextRepeatDays).getDate()),'/',(new Date(nextRepeatDays).getFullYear())].join(''));
          x['nextDate'] = (nextRepeatDays.valueOf());
          x['created'] = (new Date());
          addItemToList(list, x);
        }
      }
    }
    console.log('updated \'currentAsignedSchedules\' = ');
    console.log(currentAsignedSchedules);
  }
}


  await nextDayTasks();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/timer/components/a078e616790892a8a6a56e6ba868ad1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'timerRunning')) {
    ___arguments.context.pageData['timerRunning'] = false;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('63b175384a2428a86098f54151280658');
  } else {
    ___arguments.context.pageData['timerRunning'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).start() })('63b175384a2428a86098f54151280658');
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'timerRunning')) ? 'Stop' : 'Start')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/timer/components/8b6881c8e604a50c664a596ad0d895b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).reset() })('63b175384a2428a86098f54151280658');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/timer/components/63b175384a2428a86098f54151280658/bundle.js', [], () => ({
  /* content */
  /* handler:onTimerEnd */
  ['onTimerEnd'](___arguments) {
      console.log('Timer end');

  },
  /* handler:onTimerEnd */
  /* content */
}))

define('./pages/unitDrillDown/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function my_4ColumnDisplay() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a8a4c9fd473b42d84b4b2a827c27ac49', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7efafbd14ee45ea58d6467819167cee', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e5ba6372099a751c50a2b9436fe4def2', false);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function logicToggle() {
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z4') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
  }
}

/**
 * Describe this function...
 */
async function onEnterToggle() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b41e40df7ff5ec9312bd973e8efea49', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1016be1da81e2e81ec635e9d7b36b6c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94bc36c4bd463ca734032f8ca4833538', false);
    ___arguments.context.pageData['currentRoomContentNo'] = 0;
    ___arguments.context.pageData['displayBuildingContentsList'] = false;

  } catch (error) {
    console.log(error);

  }
}


  console.log('todo - assign schedule to 3rd party ie nursing home relatives');
  ___arguments.context.pageData['baseFontSize'] = 20;
  ___arguments.context.pageData['fontSize'] = (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 480 ? (getObjectProperty(___arguments.context.pageData, 'baseFontSize')) : (getObjectProperty(___arguments.context.pageData, 'baseFontSize')) * (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) / 1200));
  await onEnterToggle();
  await logicToggle();
  await my_4ColumnDisplay();
  try {
    ___arguments.context.pageData['structureWhereClause'] = (['businessLinkId = ','\'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z40') + 1 > 0) {
      ___arguments.context.pageData['showStructuresLogic'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('signin', undefined);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['elementContentLogic'] = false;
  ___arguments.context.pageData['listContentsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = false;
  ___arguments.context.pageData['contentRowPickLogic'] = false;
  ___arguments.context.pageData['assignContentRowLogic'] = false;
  ___arguments.context.pageData['structureWhereClause'] = 'nil';
  ___arguments.context.pageData['levelWhereClause'] = 'nil';
  ___arguments.context.pageData['unitWhereClause'] = 'nil';
  ___arguments.context.pageData['roomWhereClause'] = 'nil';
  ___arguments.context.pageData['toggleLogic1'] = false;
  ___arguments.context.pageData['showStructuresLogic'] = false;
  ___arguments.context.pageData['showLevelsLogic'] = false;
  ___arguments.context.pageData['showUnitsLogic'] = false;
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['showContentsLogic'] = false;

  },
  /* handler:onBeforeEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['fontSize'] = (___arguments.screenWidth <= 480 ? 24 : 24 * (___arguments.screenWidth / 1200));
  console.log(getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/unitDrillDown/components/2ea3700cbb7b1542d4aacfe691539997/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['structureWhereClause'] = (['businessLinkId = ','\'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
    if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('z40') + 1 > 0) {
      ___arguments.context.pageData['showStructuresLogic'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/94bc36c4bd463ca734032f8ca4833538/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['showStructuresLogic'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54638bd14fd9dbebeedbb4acd35991f7', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('678a96c9f3ed893b7d425ab790954beb', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c9b9a0b8a015e18daac3f958989138c', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea3700cbb7b1542d4aacfe691539997', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac88d0e838b8d8e405164fb8761894c2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/e702e5a74736912702ed97667bc4c3e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function dataPath() {
  ___arguments.context.appData['ptStructureId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptStructureId'));
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.pageData['assignedContentLogic'] = true;
  ___arguments.context.pageData['ptRoomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.appData['ptRoomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.pageData['ptRoomId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptElementId'));
  ___arguments.context.pageData['ptRoomId2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptRoomId'));
  ___arguments.context.appData['ptRoomIdAppData'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptRoomId'));
  ___arguments.context.appData['ptRoomIdSelected'] = ___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc');
  ___arguments.context.appData['roomRef'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'Ref'));
  ___arguments.context.appData['roomName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName'));
  ___arguments.context.pageData['contentWhereClause'] = (['ptRoomId = ','\'',(getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),'\'','',''].join(''));
  ___arguments.context.pageData['levelWhereClause'] = (['ptStructureId = ','\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'ptStructureId')),'\'','',''].join(''));
}

/**
 * Describe this function...
 */
async function uiPath() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('843bb96269af2832817543bc6c1249b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aecaf3e4db85f389ba714b2f34fee193'))['borderColor'] = '#616161';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a8a4c9fd473b42d84b4b2a827c27ac49', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec874c4a88230be1270e5f8d0b039a73', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e65fd593bef46d26017dce0690ce278f'))['borderColor'] = '#F15C45';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7efafbd14ee45ea58d6467819167cee', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b75c4c5adc312926c391f105ef3d856d', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8a4c9fd473b42d84b4b2a827c27ac49'))['borderWidth'] = '4px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aecaf3e4db85f389ba714b2f34fee193'))['borderWidth'] = '2px';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', false);
}


  await dataPath();
  await uiPath();

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'roomName')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f44d1779d9de529830680ee4925f5bc'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e702e5a74736912702ed97667bc4c3e9'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/aecaf3e4db85f389ba714b2f34fee193/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var foundItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'showRoomsLogic')) == true) {
    foundItems = (await Backendless.Data.of('ptRoomAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),'','','',''].join(''))).setPageSize(30)));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('07613b843ce6e63b560d8037679e71c1', foundItems);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/unitDrillDown/components/fc76ef85fc5c5ecb0c58e95eb6313e94/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fc76ef85fc5c5ecb0c58e95eb6313e94'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/b2b78485c2695a8b75a6330390f18e42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  // allow user to define & save a new room AND assign the new room (element)
  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    ___arguments.context.appData['taskName'] = (getObjectProperty(___arguments.context.pageData, 'taskName'));
    ___arguments.context.appData['taskRef'] = (getObjectProperty(___arguments.context.pageData, 'taskRef'));
    ___arguments.context.pageData['roomRef'] = '';
    ___arguments.context.pageData['roomName'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1016be1da81e2e81ec635e9d7b36b6c', undefined);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('businessDefineSchedule', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/0afff5b896332b981362cbe76b6fbd55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, text, i;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    var i_end = (getObjectProperty(___arguments.context.pageData, 'rsContentName')).length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      if ((getObjectProperty(___arguments.context.pageData, 'rsContentName')).charAt((i - 1)) == ',') {
        text = [(getObjectProperty(___arguments.context.pageData, 'rsContentName')).slice(0, i - 1),'%',(getObjectProperty(___arguments.context.pageData, 'rsContentName')).slice(((i + 1) - 1), (getObjectProperty(___arguments.context.pageData, 'rsContentName')).length)].join('');
        ___arguments.context.pageData['rsContentName'] = text;
      }
    }
    await Backendless.Data.of('ptContentAssign').deepSave( ({ 'ptRoomId': (getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'ptContentId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'name': (getObjectProperty(___arguments.context.pageData, 'rsContentName')),'ref': (getObjectProperty(___arguments.context.pageData, 'partCode')),'purchaseOrder': (getObjectProperty(___arguments.context.pageData, 'purchaseOrder')) }) );
    await Backendless.Data.of('ptContentElement').deepSave( ({ 'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'ptElementId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'NLA': undefined,'description': 'not included in new structure form','ref': (getObjectProperty(___arguments.context.pageData, 'partCode')),'name': (getObjectProperty(___arguments.context.pageData, 'rsContentName')) }) );
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/8da6202ff1811307dbe7d04f1e444b74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['toggleLogic1'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/b272a65b0845bebfb065d8feb54b52da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'togCalendar')) == true) {
    console.log('togClean is ON');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf7c809849fc8c9104aeef24dae911e6'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bfb1b6ff26d1dbb3593917c60328a57'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e91439048965055fdb5719688176e221'))['opacity'] = 0.3;
    console.log(___arguments.value);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/unitDrillDown/components/e65fd593bef46d26017dce0690ce278f/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'assignedContentLogic')) == true) {
    ___arguments.context.pageData['currentRoomSchedules'] = (await Backendless.Data.of('scheduleAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(40)));
    ___arguments.context.pageData['currentSchedulesNo'] = ((getObjectProperty(___arguments.context.pageData, 'currentRoomSchedules')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deb11ff683ba3beef1f3ba5eda920d2f', (getObjectProperty(___arguments.context.pageData, 'currentRoomSchedules')));
    ___arguments.context.pageData['currentRoomContent'] = (await asyncListSort((await Backendless.Data.of('ptContentAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(40))), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    }));
    ___arguments.context.pageData['currentRoomContentNo'] = ((getObjectProperty(___arguments.context.pageData, 'currentRoomContent')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ca29e6c7955edb18bab7f4b37e631ca6', (getObjectProperty(___arguments.context.pageData, 'currentRoomContent')));
    ___arguments.context.pageData['contentBuildingCurrent'] = (await asyncListSort((await Backendless.Data.of('ptContentElement').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'levelWhereClause')),'',''].join(''))).setPageSize(40))), -1, async (item) => {


     return (getObjectProperty(item, 'Name'));
    }));
    ___arguments.context.pageData['contentBuildingCurrentNo'] = ((getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrent')).length);
    if ((getObjectProperty(___arguments.context.pageData, 'displayBuildingContentsList')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd0a851826861d2b0177799eff25cf19', (getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrent')));
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/unitDrillDown/components/3aaa0867ca67806f844d2369511ce13c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'togClean')) == true) {
    console.log('togClean is ON');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('15cdf5f1812fa00f0acdec26f7ce7ab3'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf7c809849fc8c9104aeef24dae911e6'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e91439048965055fdb5719688176e221'))['opacity'] = 0.3;
    console.log(___arguments.value);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/unitDrillDown/components/68374bd8a967c352aa26b835541cbd8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'togInspect')) == true) {
    console.log('togInspect is ON');
    ___arguments.context.pageData['periodName'] = 'Light Year';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('15cdf5f1812fa00f0acdec26f7ce7ab3'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf7c809849fc8c9104aeef24dae911e6'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bfb1b6ff26d1dbb3593917c60328a57'))['opacity'] = 0.3;
    console.log(___arguments.value);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/unitDrillDown/components/c2afe0fe1baaf366a83dd0edbb93df56/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'togRepair')) == true) {
    console.log('togClean is ON');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('15cdf5f1812fa00f0acdec26f7ce7ab3'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4bfb1b6ff26d1dbb3593917c60328a57'))['opacity'] = 0.3;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e91439048965055fdb5719688176e221'))['opacity'] = 0.3;
    console.log(___arguments.value);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/unitDrillDown/components/c4c538e8c5686044be6d809ce8d58aae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ptRoomName'))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4c538e8c5686044be6d809ce8d58aae'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/a8d6eb28b74d6df9da25c44d4aea126a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(['[',(getObjectProperty(___arguments.context.appData, 'unitRef')),'] - ',(getObjectProperty(___arguments.context.appData, 'ptUnitName'))].join('')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a8d6eb28b74d6df9da25c44d4aea126a'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/075a0889360c383ec253091ee54c29ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, newRoom;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['showRoomsLogic'] = true;
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    console.log('1/3 launch \'save object\' and \'relation\' creation - ');
    newRoom = (await Backendless.Data.of('ptRoomAssign').save( ({ 'ptRoomId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'roomName': (getObjectProperty(___arguments.context.pageData, 'roomName')),'Ref': (getObjectProperty(___arguments.context.pageData, 'roomRef')) }) ));
    console.log('2/3 save object completed');
    await Backendless.Data.of('ptRoomAssign').addRelation(newRoom, 'relationPtUnitId', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))]);
    console.log('3/3 add object completed');
    await Backendless.Data.of('ptRoomElement').deepSave( ({ 'cleanToggle': (getObjectProperty(___arguments.context.pageData, 'togClean')),'inspectToggle': (getObjectProperty(___arguments.context.pageData, 'togInspect')),'linkToCalToggle': (getObjectProperty(___arguments.context.pageData, 'rogLink')),'repairToggle': (getObjectProperty(___arguments.context.pageData, 'togRepair')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'ptElementId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'NLA': undefined,'description': 'not included in new structure form','Ref': (getObjectProperty(___arguments.context.pageData, 'roomRef')),'RoomName': (getObjectProperty(___arguments.context.pageData, 'roomName')) }) );
    ___arguments.context.pageData['roomRef'] = '';
    ___arguments.context.pageData['roomName'] = '';
    ___arguments.context.pageData['listContentsLogic'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/a3ef5cda2906478e835e42a2424ce033/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).indexOf('%') + 1 > 0 ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name')).indexOf('%') + 1) - 1) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'Name'))) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('492effe96c25676777e79a2c3b7e3984'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3ef5cda2906478e835e42a2424ce033'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/73fa549929e8852831ad6efb4b36b9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d7e8245a0be28dadb17b9942ba287af', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
  ___arguments.context.pageData['displayBuildingContentsList'] = (!(getObjectProperty(___arguments.context.pageData, 'displayBuildingContentsList')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/0b41e40df7ff5ec9312bd973e8efea49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/57d4d8635534c731e4f55946da069baa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['ptElementId'] = ((generateUUID().long()).toUpperCase());
    await Backendless.Data.of('ptContentAssign').deepSave( (await Backendless.Data.of('ptContentAssign').addRelation((await Backendless.Data.of('ptContentAssign').save( ({ 'ptRoomId': (getObjectProperty(___arguments.context.pageData, 'ptRoomId2')),'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'ptUnitId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'ptContentId': (getObjectProperty(___arguments.context.pageData, 'ptElementId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'Name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')) }) )), 'relationUnitAssign', [(getObjectProperty(___arguments.context.appData, 'unitObjectId'))])) );
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57d4d8635534c731e4f55946da069baa'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.7);

  },
  /* handler:onStyleAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')).indexOf('%') + 1 > 0 ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')).slice(0, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name')).indexOf('%') + 1) - 1) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'Name'))) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'created'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'created'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('536b760bbb321f68e51606cc6af78b2f'), 'created'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/84b795ad2c339453f8eea2b96b13c88e/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b41e40df7ff5ec9312bd973e8efea49', undefined);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/unitDrillDown/components/49ba50433a0bc86e331c8c5881997c78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['',(getObjectProperty(___arguments.context.pageData, 'ptRoomName')),' contents [x',(getObjectProperty(___arguments.context.pageData, 'currentRoomContentNo')),'].'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('49ba50433a0bc86e331c8c5881997c78'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/f811512de8ab81b50043d5a30952c9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['View building content [',(getObjectProperty(___arguments.context.pageData, 'contentBuildingCurrentNo')),'].'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f811512de8ab81b50043d5a30952c9c9'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      console.log((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/unitDrillDown/components/843bb96269af2832817543bc6c1249b3/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'assignedContentLogic')) == true) {
    ___arguments.context.pageData['currentRoomSchedules'] = (await asyncListSort((await Backendless.Data.of('scheduleAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),' && ',(getObjectProperty(___arguments.context.pageData, 'contentWhereClause'))].join(''))).setPageSize(40))), -1, async (item) => {


     return (getObjectProperty(item, 'nextDate'));
    }));
    ___arguments.context.pageData['currentSchedulesNo'] = ((getObjectProperty(___arguments.context.pageData, 'currentRoomSchedules')).length);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/unitDrillDown/components/44acb41ca44d16cac65fc738770e3f2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Currently ',(getObjectProperty(___arguments.context.pageData, 'currentSchedulesNo')),' assigned.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('44acb41ca44d16cac65fc738770e3f2d'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/5c2a87b7134e2d74dfbf9b363b3e2d7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'HumanTaskName')) + String(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5c2a87b7134e2d74dfbf9b363b3e2d7d'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/b2149cafd5f179de850df1c6087a0566/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'definitionText')) + String(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2149cafd5f179de850df1c6087a0566'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.4);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/86de3a49fa1f86ad52023843aed20d88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Next date - ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'nextDate')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8a4bf3e4bda739fe032d91b69b18a1f5'), 'nextDate')))).toLocaleDateString())].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86de3a49fa1f86ad52023843aed20d88'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/5afc4dcf2fa10b35a41ac1179a175b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('businessDefineSchedule', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5afc4dcf2fa10b35a41ac1179a175b88'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/9f7b92f5252f5f6f233473d339fbe693/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5')['paused'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')));
  await Backendless.Data.of('scheduleAssign').save(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), true);

  },
  /* handler:onClick */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4caf2e6e92e78e2d7675e02a054fa5fb', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4caf2e6e92e78e2d7675e02a054fa5fb', false);
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == true ? 'pause circle outline' : 'play circle outline')

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/4caf2e6e92e78e2d7675e02a054fa5fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5'), 'paused')) == 1) {
    await Backendless.Data.of('scheduleAssign').remove( ___arguments.context.getComponentDataStoreByUid('6154b7d5dffa75171aa7b7b4417c80e5') );
    if ((getObjectProperty(___arguments.context.pageData, 'currentSchedulesNo')) == 1) {
      (getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected'))['scheduleAssigned'] = false;
      await Backendless.Data.of('ptRoomAssign').save((getObjectProperty(___arguments.context.appData, 'ptRoomIdSelected')), true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/219f81aa243b06ce55795f7d64b1e809/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9'), 'objectId'));
  console.log(String('Name = ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9'), 'Name')));
  await Backendless.Data.of('ptContentAssign').remove( ___arguments.context.getComponentDataStoreByUid('388fce9f37b80f899b95233e167d3af9') );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e65fd593bef46d26017dce0690ce278f', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/00c26e21cba78e146064395778cfcdac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/381ed6943ce9c1285f3cb41faec6c0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      ___arguments.context.pageData['rsContentName'] = null;
  ___arguments.context.pageData['partCode'] = null;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/unitDrillDown/components/d0a565dd30142692331c8a4602426b1a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d0a565dd30142692331c8a4602426b1a'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/d99625bb7d09845bf005b7d488bb3bad/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d99625bb7d09845bf005b7d488bb3bad'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/9c3e1ea9fdae579e945800bdd0da576b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9c3e1ea9fdae579e945800bdd0da576b'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(['[',(getObjectProperty(___arguments.context.appData, 'unitRef')),'] - ',(getObjectProperty(___arguments.context.appData, 'ptUnitName'))].join('')) + String(((new Date(([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('')))).valueOf()) == ((new Date(([(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getMonth() + 1),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate'))).getFullYear())].join('')))).valueOf()) ? ' [New]' : ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/1b44702a7f12a825952a3f2a49fba80a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b44702a7f12a825952a3f2a49fba80a'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/eaba1a1a02850a8b9765695e8bc90331/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eaba1a1a02850a8b9765695e8bc90331'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/3d7da5f63dc192856f7ce41e65e724e6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3d7da5f63dc192856f7ce41e65e724e6'))['font-size'] = (getObjectProperty(___arguments.context.pageData, 'fontSize'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/895e4b8a98a9a51852056196ed76aae2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('895e4b8a98a9a51852056196ed76aae2'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.5);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/54b285fecc2805b18f38a5689cb88c2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Created - ',((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).toLocaleDateString()),', ',Math.round(((new Date()).valueOf()) / 86400000) - Math.round(((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).valueOf()) / 86400000),Math.round(((new Date()).valueOf()) / 86400000) - Math.round(((new Date((getObjectProperty(___arguments.context.pageData, 'unitCreatedDate')))).valueOf()) / 86400000) < 2 ? ' in last 24 hours.' : ' days ago.'].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('54b285fecc2805b18f38a5689cb88c2f'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.4);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/c6f85b22f558ff085ae83e7eda183e98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('User - ') + String(getObjectProperty(___arguments.context.pageData, 'unitCreatedBy')))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c6f85b22f558ff085ae83e7eda183e98'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/30ce20f8ca9f3ac2aa47319893f84277/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('30ce20f8ca9f3ac2aa47319893f84277'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.6);

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('@@@@@ logic of onclick \'copy units\'  @@@@@@');
  console.log('all data held on unit selected - ');
  console.log(getObjectProperty(___arguments.context.appData, 'unitDetailsApp'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/82b461284ba8cd310e488f18d14800dc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('82b461284ba8cd310e488f18d14800dc'))['font-size'] = ((getObjectProperty(___arguments.context.pageData, 'fontSize')) * 0.8);

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/57480aec8ecfe394b8083848abe82f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/d548ed06b08827688258547327e847c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var i, copyRoomRef, listOfUnits, newPtUnitAssign, scheduleLoop, copySchedules, elementsLoop, copyElements, saveNewUnitsLoop, newUnitsLoop, unitsNoLoop;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

/**
 * Describe this function...
 */
async function copyAndSaveUnit() {
  ___arguments.context.pageData['showRoomsLogic'] = true;
  copyRoomRef = (await Backendless.Data.of('ptRoomAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),'','','',''].join(''))).setPageSize(100)));
  copySchedules = (await Backendless.Data.of('scheduleAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),'','','',''].join(''))).setPageSize(100)));
  copyElements = (await Backendless.Data.of('ptContentAssign').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty(___arguments.context.pageData, 'roomWhereClause')),'','','',''].join(''))).setPageSize(100)));
  var unitsNoLoop_end = listOfUnits.length;
  var unitsNoLoop_inc = 1;
  if (1 > unitsNoLoop_end) {
    unitsNoLoop_inc = -unitsNoLoop_inc;
  }
  for (unitsNoLoop = 1; unitsNoLoop_inc >= 0 ? unitsNoLoop <= unitsNoLoop_end : unitsNoLoop >= unitsNoLoop_end; unitsNoLoop += unitsNoLoop_inc) {
    ___arguments.context.pageData['newUnitId'] = ((generateUUID().long()).toUpperCase());
    newPtUnitAssign = (await Backendless.Data.of('ptUnitAssign').save( ({ 'ptElementId': (getObjectProperty(___arguments.context.appData, 'ptElementId')),'ptUnitId': (getObjectProperty(___arguments.context.pageData, 'newUnitId')),'ptLevelId': (getObjectProperty(___arguments.context.pageData, 'ptLevelId')),'ptStructureId': (getObjectProperty(___arguments.context.pageData, 'ptStructureId')),'businessLinkId': (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'Name': (getObjectProperty(___arguments.context.pageData, 'copyUnitName')),'Ref': listOfUnits[(unitsNoLoop - 1)] }) ));
    await Backendless.Data.of('ptUnitAssign').addRelation(newPtUnitAssign, 'levelRelation', [(getObjectProperty(___arguments.context.appData, 'ptLevelId2'))]);
    for (var newUnitsLoop_index in copyRoomRef) {
      newUnitsLoop = copyRoomRef[newUnitsLoop_index];
      ___arguments.context.pageData['newRoomId'] = ((generateUUID().long()).toUpperCase());
      ___arguments.context.pageData['matchRoom'] = (getObjectProperty(newUnitsLoop, 'ptRoomId'));
      newUnitsLoop['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
      newUnitsLoop['ptRoomId'] = (getObjectProperty(___arguments.context.pageData, 'newRoomId'));
      newUnitsLoop['doNotDelete'] = 0;
      newUnitsLoop['created'] = (new Date());
      delete newUnitsLoop['objectId'];
      saveNewUnitsLoop = (await Backendless.Data.of('ptRoomAssign').save( newUnitsLoop ));
      await Backendless.Data.of('ptRoomAssign').addRelation(saveNewUnitsLoop, 'relationPtUnitId', [(getObjectProperty(newPtUnitAssign, 'objectId'))]);
      for (var elementsLoop_index in copyElements) {
        elementsLoop = copyElements[elementsLoop_index];
        if ((getObjectProperty(___arguments.context.pageData, 'matchRoom')) == (getObjectProperty(elementsLoop, 'ptRoomId'))) {
          elementsLoop['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
          elementsLoop['ptRoomId'] = (getObjectProperty(___arguments.context.pageData, 'newRoomId'));
          elementsLoop['created'] = (new Date());
          elementsLoop['doNotDelete'] = 0;
          delete elementsLoop['objectId'];
          await Backendless.Data.of('ptContentAssign').save( elementsLoop );
        }
      }
      for (var scheduleLoop_index in copySchedules) {
        scheduleLoop = copySchedules[scheduleLoop_index];
        if ((getObjectProperty(___arguments.context.pageData, 'matchRoom')) == (getObjectProperty(scheduleLoop, 'ptRoomId'))) {
          scheduleLoop['ptUnitId'] = (getObjectProperty(___arguments.context.pageData, 'newUnitId'));
          scheduleLoop['ptRoomId'] = (getObjectProperty(___arguments.context.pageData, 'newRoomId'));
          scheduleLoop['created'] = (new Date());
          scheduleLoop['doNotDelete'] = 0;
          delete scheduleLoop['objectId'];
          await Backendless.Data.of('scheduleAssign').addRelation((await Backendless.Data.of('scheduleAssign').save( scheduleLoop )), 'relationUnitId', [(getObjectProperty(newPtUnitAssign, 'objectId'))]);
        }
      }
    }
  }
}


  copyRoomRef = [];
  listOfUnits = (getObjectProperty(___arguments.context.pageData, 'copyRoomRef')).split(',');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', false);
  await copyAndSaveUnit();
  ___arguments.context.pageData['roomRef'] = '';
  ___arguments.context.pageData['roomName'] = '';
  ___arguments.context.pageData['listContentsLogic'] = true;
  ___arguments.context.pageData['showUnitsLogic'] = true;
  ___arguments.context.pageData['showRoomsLogic'] = false;
  ___arguments.context.appData['unitRef'] = '';
  ___arguments.context.appData['ptUnitName'] = '';
  ___arguments.context.pageData['ptUnitName'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec874c4a88230be1270e5f8d0b039a73', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a8a4c9fd473b42d84b4b2a827c27ac49', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('152f795866d9412b595628e2c1b600a6', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/cc862d0e5a9f58512897297a25a24be6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.Data.of('ptRoomAssign').remove( ___arguments.context.getComponentDataStoreByUid('5393db845943aad7814dc428a9c364ff') );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aecaf3e4db85f389ba714b2f34fee193', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/53025edbec3d03e42b11d78288a4c063/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var chips;


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('57ea156f6879183f97a1e409931939fc', (await Backendless.Data.of('ptChips').find(Backendless.DataQueryBuilder.create().setPageSize(10))));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/unitDrillDown/components/559be948199a9ac63d552bdf5315cda4/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('53025edbec3d03e42b11d78288a4c063')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/unitDrillDown/components/1789f748f56a280711277b918ce58053/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5cff38ef0a1b38eb99da65a8b18699d2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/b1d6cb5fb512af173e183728e0680188/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('284837d831aff3a17618d5b382f863a8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitDrillDown/components/1c7d91e688320b4f9bc59b044f98b186/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('381ed6943ce9c1285f3cb41faec6c0fe', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitView/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var roomsVar, FinalTx, unitsInStructureVar, levelsInStructureVar, schedulesVar, myTransaction, sortedUnitsInStructure, roomHasSchedules, unitsLoop, unitWeighting, roomWeighting, roomLoop, allPaused, pauseCount, scheduleLoopCount, roomCount, scheduleLoop, runningCount, sortedRooms, levelsInStructureLoop, unuitsIStructureLoop, totalLevelTime, schedulesLoop, duplicateList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function transactionsData() {
  myTransaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTransaction;

    _uow.find('ptLevelAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'structureWhereClause'))).setSortBy((['Ref','',''].join(''))).setPageSize(100)).setOpResultId('levelsInStructure');
    _uow.find('ptUnitAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'structureWhereClause'))).setSortBy((['levelRef','',''].join(''))).setPageSize(100)).setOpResultId('unitsInStructure');
    _uow.find('ptRoomAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'structureWhereClause'))).setPageSize(100)).setOpResultId('allRoomsView');
    _uow.find('scheduleAssign', Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'structureWhereClause'))).setPageSize(100)).setOpResultId('schedules');

  })();

  FinalTx = (await myTransaction.execute());
  schedulesVar = (getObjectProperty((FinalTx.getResults()), 'schedules.result'));
  ___arguments.context.pageData['schedulesInRoom'] = schedulesVar;
  levelsInStructureVar = (getObjectProperty((FinalTx.getResults()), 'levelsInStructure.result'));
  ___arguments.context.pageData['levelsInStructure'] = levelsInStructureVar;
  unitsInStructureVar = (getObjectProperty((FinalTx.getResults()), 'unitsInStructure.result'));
  ___arguments.context.pageData['unitsInStructure'] = unitsInStructureVar;
  roomsVar = (getObjectProperty((FinalTx.getResults()), 'allRoomsView.result'));
  ___arguments.context.pageData['roomsInUnit'] = roomsVar;
}

/**
 * Describe this function...
 */
async function newUnitView() {
  duplicateList = [];
  ___arguments.context.pageData['structureWhereClause'] = (['businessLinkId = ','\'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
  await transactionsData();
  console.log('schedulesInRoom');
  console.log(getObjectProperty(___arguments.context.pageData, 'schedulesInRoom'));
  for (var levelsInStructureLoop_index in levelsInStructureVar) {
    levelsInStructureLoop = levelsInStructureVar[levelsInStructureLoop_index];
    for (var schedulesLoop_index in schedulesVar) {
      schedulesLoop = schedulesVar[schedulesLoop_index];
      if ((getObjectProperty(levelsInStructureLoop, 'objectId')) == (getObjectProperty(schedulesLoop, 'ptLevelId')) && (getObjectProperty(schedulesLoop, 'paused')) == 0) {
        totalLevelTime = (typeof totalLevelTime == 'number' ? totalLevelTime : 0) + (getObjectProperty(levelsInStructureLoop, 'timeAllowed'));
      }
    }
    totalLevelTime = 0;
  }
  sortedRooms = roomsVar;
  sortedUnitsInStructure = unitsInStructureVar;
  for (var unitsLoop_index in sortedUnitsInStructure) {
    unitsLoop = sortedUnitsInStructure[unitsLoop_index];
    roomHasSchedules = false;
    runningCount = 0;
    roomCount = 0;
    unitWeighting = 0;
    allPaused = 0;
    for (var roomLoop_index in sortedRooms) {
      roomLoop = sortedRooms[roomLoop_index];
      allPaused = 0;
      roomWeighting = 0;
      scheduleLoopCount = 0;
      if ((getObjectProperty(unitsLoop, 'ptUnitId')) == (getObjectProperty(roomLoop, 'ptUnitId'))) {
        pauseCount = 0;
        roomCount = (typeof roomCount == 'number' ? roomCount : 0) + 1;
        for (var scheduleLoop_index in schedulesVar) {
          scheduleLoop = schedulesVar[scheduleLoop_index];
          if ((getObjectProperty(scheduleLoop, 'ptRoomId')) == (getObjectProperty(roomLoop, 'ptRoomId'))) {
            roomHasSchedules = true;
            scheduleLoopCount = (typeof scheduleLoopCount == 'number' ? scheduleLoopCount : 0) + 1;
            runningCount = (typeof runningCount == 'number' ? runningCount : 0) + 1;
            if ((getObjectProperty(scheduleLoop, 'paused')) == 1) {
              pauseCount = (typeof pauseCount == 'number' ? pauseCount : 0) + 1;
            } else {
              roomWeighting = (typeof roomWeighting == 'number' ? roomWeighting : 0) + (getObjectProperty(scheduleLoop, 'timeAllowed'));
            }
          }
        }
        if (scheduleLoopCount == pauseCount && scheduleLoopCount > 0) {
          allPaused = 1;
        }
        if (roomCount == 1) {
          unitsLoop['1TimeAllowed'] = roomWeighting;
          unitsLoop['1RoomPaused'] = 0;
          unitsLoop['1RoomName'] = (getObjectProperty(roomLoop, 'roomName'));
          unitsLoop['1RoomTasks'] = scheduleLoopCount;
          unitsLoop['1RoomPaused'] = pauseCount;
          unitsLoop['1AllPaused'] = allPaused;
          unitsLoop['1ScheduleId'] = (getObjectProperty(roomLoop, 'scheduleElementId'));
          unitsLoop['1ptRoomId'] = (getObjectProperty(roomLoop, 'ptRoomId'));
        }
        if (roomCount == 2) {
          unitsLoop['2TimeAllowed'] = roomWeighting;
          unitsLoop['2RoomPaused'] = 0;
          unitsLoop['2RoomName'] = (getObjectProperty(roomLoop, 'roomName'));
          unitsLoop['2RoomTasks'] = scheduleLoopCount;
          unitsLoop['2RoomPaused'] = pauseCount;
          unitsLoop['2AllPaused'] = allPaused;
          unitsLoop['2ScheduleId'] = (getObjectProperty(roomLoop, 'scheduleElementId'));
          unitsLoop['2ptRoomId'] = (getObjectProperty(roomLoop, 'ptRoomId'));
        }
        if (roomCount == 3) {
          unitsLoop['3TimeAllowed'] = roomWeighting;
          unitsLoop['3RoomPaused'] = 0;
          unitsLoop['3RoomName'] = (getObjectProperty(roomLoop, 'roomName'));
          unitsLoop['3RoomTasks'] = scheduleLoopCount;
          unitsLoop['3RoomPaused'] = pauseCount;
          unitsLoop['3AllPaused'] = allPaused;
          unitsLoop['3ScheduleId'] = (getObjectProperty(roomLoop, 'scheduleElementId'));
          unitsLoop['3ptRoomId'] = (getObjectProperty(roomLoop, 'ptRoomId'));
        }
        if (roomCount == 4) {
          unitsLoop['4TimeAllowed'] = roomWeighting;
          unitsLoop['4RoomPaused'] = 0;
          unitsLoop['4RoomName'] = (getObjectProperty(roomLoop, 'roomName'));
          unitsLoop['4RoomTasks'] = scheduleLoopCount;
          unitsLoop['4RoomPaused'] = pauseCount;
          unitsLoop['4AllPaused'] = allPaused;
          unitsLoop['4ScheduleId'] = (getObjectProperty(roomLoop, 'scheduleElementId'));
          unitsLoop['4ptRoomId'] = (getObjectProperty(roomLoop, 'ptRoomId'));
        }
        if (roomCount == 5) {
          unitsLoop['5TimeAllowed'] = roomWeighting;
          unitsLoop['5RoomPaused'] = 0;
          unitsLoop['5RoomName'] = (getObjectProperty(roomLoop, 'roomName'));
          unitsLoop['5RoomTasks'] = scheduleLoopCount;
          unitsLoop['5RoomPaused'] = pauseCount;
          unitsLoop['5AllPaused'] = allPaused;
          unitsLoop['5ScheduleId'] = (getObjectProperty(roomLoop, 'scheduleElementId'));
          unitsLoop['5ptRoomId'] = (getObjectProperty(roomLoop, 'ptRoomId'));
        }
      }
      unitWeighting = (typeof unitWeighting == 'number' ? unitWeighting : 0) + roomWeighting;
      unitsLoop['unitWeighting'] = unitWeighting;
    }
    if (roomHasSchedules == false) {
      unitsLoop['roomHasSchedules'] = roomHasSchedules;
    }
  }
  console.log('sortedUnitsInStructure:');
  console.log(sortedUnitsInStructure);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e7573be3c991b4122ba51e63124b8e8a', sortedUnitsInStructure);
}


  await newUnitView();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/unitView/components/d42d1a4b7019182bfd71447d8234f88e/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79bf6c8b00bf6a5692485ea3c9586c43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d3f8946a759862ca75e4144aa77602c8', false);
  if ((getObjectProperty(___arguments.context.dataModel, 'levelColour')) != (getObjectProperty(___arguments.context.pageData, 'lastLevelColour'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79bf6c8b00bf6a5692485ea3c9586c43', true);
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d42d1a4b7019182bfd71447d8234f88e'))['borderLeftWidth'] = '20px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d42d1a4b7019182bfd71447d8234f88e'))['borderColor'] = (getObjectProperty(___arguments.context.dataModel, 'levelColour'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('114b3f5ec2491876ee7f1f1818416f43', false);
  if ((getObjectProperty(___arguments.context.dataModel, 'roomHasSchedules')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('114b3f5ec2491876ee7f1f1818416f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5333fe486dd82e187bc56418afb590a6', false);
  }
  ___arguments.context.pageData['lastLevelColour'] = (getObjectProperty(___arguments.context.dataModel, 'levelColour'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/unitView/components/6398eaeff7c8cf4b6178807b738883f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1RoomName')) != null ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1RoomName')),[' - x',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1RoomTasks')),'',['','','/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1RoomPaused')),'.','',''].join(''),''].join(''),''].join('') : '-','','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('on click room');
  console.log(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1ptRoomId'));
  console.log('on click room - end');
  console.log(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'schedulesInRoom')), async (item) => {


   return ((getObjectProperty(item, 'ptRoomId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1ptRoomId')));
  }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitView/components/b2781b04c9f885983ca61d1ceaf893d7/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    var returnText, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1RoomPaused')) > 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2781b04c9f885983ca61d1ceaf893d7'))['color'] = '#F15C45';
      returnText = 'pause circle outline';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1AllPaused')) == 1) {
      returnText = 'warning';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1RoomTasks')) == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2781b04c9f885983ca61d1ceaf893d7'))['color'] = '#F15C45';
      returnText = 'warning';
    }

  } catch (error) {
    console.log(error);

  }

  return returnText

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/unitView/components/5333fe486dd82e187bc56418afb590a6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5333fe486dd82e187bc56418afb590a6'))['borderLeftWidth'] = '20px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5333fe486dd82e187bc56418afb590a6'))['borderColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), 'unitColour'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('59189ec80c28cf78f0f8c61ce41625d8', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1RoomTasks')) > 0 ? true : false));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cd4288d769a563daea8d6f870684bdf', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2RoomTasks')) > 0 ? true : false));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b6893df9f1fffa83c959cef3c286a28', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3RoomTasks')) > 0 ? true : false));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ae5a7d567d8f1c87aa8dab53fa12a4c', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4RoomTasks')) > 0 ? true : false));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3d8ab7897cf939211156937e85a91b8', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5RoomTasks')) > 0 ? true : false));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/unitView/components/18c779fd0b19a5dafd47f52bf7223e88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['[ ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), 'levelRef')),'',' ]  / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), 'levelName')),' .'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/9f1f802801b83068fe88b8e48769f178/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['[ ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), 'Ref')),' ].','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/04981b031cb487d853a84e5796dbda08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['[ ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('79bf6c8b00bf6a5692485ea3c9586c43'), 'levelRef')),'',' ]','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/79bf6c8b00bf6a5692485ea3c9586c43/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79bf6c8b00bf6a5692485ea3c9586c43'))['borderColor'] = (getObjectProperty(___arguments.context.dataModel, 'levelColour'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('79bf6c8b00bf6a5692485ea3c9586c43'))['backgroundColor'] = (getObjectProperty(___arguments.context.dataModel, 'levelColour'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/unitView/components/f9c2a0181f487ca824c20c88da073ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), 'unitWeighting'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/b4d2eca99dc8364b03f498a10eb89fd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2RoomName')) != null ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2RoomName')),[' - x',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2RoomTasks')),'',['','','/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2RoomPaused')),'.','',''].join(''),''].join(''),''].join('') : '-','','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2ptRoomId'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitView/components/d62539e85e5146e817a8bfdc4d1f9198/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3RoomName')) != null ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3RoomName')),[' - x',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3RoomTasks')),'',['','','/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3RoomPaused')),'.','',''].join(''),''].join(''),''].join('') : '-','','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/3d98bf66ca895d77c3c5ecb88a77b0d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4RoomName')) != null ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4RoomName')),[' - x',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4RoomTasks')),'',['','','/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4RoomPaused')),'.','',''].join(''),''].join(''),''].join('') : '-','','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/b433abe620383be87718286e022cede8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5RoomName')) != null ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5RoomName')),[' - x',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5RoomTasks')),'',['','','/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5RoomPaused')),'.','',''].join(''),''].join(''),''].join('') : '-','','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/c5df36e86c185687487d52b816686758/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    var returnText, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2RoomPaused')) > 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5df36e86c185687487d52b816686758'))['color'] = '#F15C45';
      returnText = 'pause circle outline';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2AllPaused')) == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5df36e86c185687487d52b816686758'))['color'] = '#F15C45';
      returnText = 'warning';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2RoomTasks')) == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5df36e86c185687487d52b816686758'))['color'] = '#F15C45';
      returnText = 'warning';
    }

  } catch (error) {
    console.log(error);

  }

  return returnText

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/unitView/components/9748e677a3987d224fb8356f91b2687a/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    var returnText, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3RoomPaused')) > 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9748e677a3987d224fb8356f91b2687a'))['color'] = '#F15C45';
      returnText = 'pause circle outline';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3AllPaused')) == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9748e677a3987d224fb8356f91b2687a'))['color'] = '#F15C45';
      returnText = 'warning';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3RoomTasks')) == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9748e677a3987d224fb8356f91b2687a'))['color'] = '#F15C45';
      returnText = 'warning';
    }

  } catch (error) {
    console.log(error);

  }

  return returnText

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/unitView/components/a217fbe8ca5d50f877586948ed87a218/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    var error, returnText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4RoomPaused')) > 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a217fbe8ca5d50f877586948ed87a218'))['color'] = '#F15C45';
      returnText = 'pause circle outline';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4AllPaused')) == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a217fbe8ca5d50f877586948ed87a218'))['color'] = '#F15C45';
      returnText = 'warning';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4RoomTasks')) == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a217fbe8ca5d50f877586948ed87a218'))['color'] = '#F15C45';
      returnText = 'warning';
    }

  } catch (error) {
    console.log(error);

  }

  return returnText

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/unitView/components/dc08bdbc0f34aa72af481f712b57e258/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    var error, returnText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5RoomPaused')) > 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc08bdbc0f34aa72af481f712b57e258'))['color'] = '#F15C45';
      returnText = 'pause circle outline';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5AllPaused')) == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc08bdbc0f34aa72af481f712b57e258'))['color'] = '#F15C45';
      returnText = 'warning';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5RoomTasks')) == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dc08bdbc0f34aa72af481f712b57e258'))['color'] = '#F15C45';
      returnText = 'warning';
    }

  } catch (error) {
    console.log(error);

  }

  return returnText

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/unitView/components/6017eb1f6d5846786c089994e161fd8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '2TimeAllowed'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/5d73570859349f3e94d85f881ff85891/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '3TimeAllowed'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/6cd6b459af8340aa9558c13814373748/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '4TimeAllowed'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/9ed834a8e64c52280c263e6710281944/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '5TimeAllowed'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/9d51aaac696ab2cda6581ea5acf516ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d42d1a4b7019182bfd71447d8234f88e'), '1TimeAllowed'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/6718f87834ea07c95f75aec920d843f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var totalLevelTime, schedulesInRoom, unitsOnLevel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  totalLevelTime = 0;
  var unitsOnLevel_list = (getObjectProperty(___arguments.context.pageData, 'unitsInStructure'));
  for (var unitsOnLevel_index in unitsOnLevel_list) {
    unitsOnLevel = unitsOnLevel_list[unitsOnLevel_index];
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('79bf6c8b00bf6a5692485ea3c9586c43'), 'ptLevelId')) == (getObjectProperty(unitsOnLevel, 'ptLevelId'))) {
      var schedulesInRoom_list = (getObjectProperty(___arguments.context.pageData, 'schedulesInRoom'));
      for (var schedulesInRoom_index in schedulesInRoom_list) {
        schedulesInRoom = schedulesInRoom_list[schedulesInRoom_index];
        if ((getObjectProperty(schedulesInRoom, 'ptLevelId')) == (getObjectProperty(schedulesInRoom, 'ptLevelId'))) {
          totalLevelTime = (typeof totalLevelTime == 'number' ? totalLevelTime : 0) + (getObjectProperty(schedulesInRoom, 'timeAllowed'));
        }
      }
    }
  }

  return ([Math.floor(totalLevelTime / 60),'h:',totalLevelTime - Math.floor(totalLevelTime / 60) * 60,'','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/unitView/components/59189ec80c28cf78f0f8c61ce41625d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d3f8946a759862ca75e4144aa77602c8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/unitView/components/2cd4288d769a563daea8d6f870684bdf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d3f8946a759862ca75e4144aa77602c8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userAddNew2/components/214d15ed99dbc24966e4e26919021e12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, emailBody, emailSubject, varNewInvite, userExists, returnRoleName, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    console.log('inviteRole = ');
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteRole'));
    console.log('options[appData] = ');
    console.log(getObjectProperty(___arguments.context.appData, 'options'));
    returnRoleName = false;
    console.log(await asyncListFind((getObjectProperty(___arguments.context.appData, 'options')), async (item) => {
       console.log('loop running ...');
      console.log([(getObjectProperty((getObjectProperty(item, 'options')), 'objectId')),'  = ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteRole'))].join(''));
      if ((getObjectProperty((getObjectProperty(item, 'options')), 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteRole'))) {
        returnRoleName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteRole'));
      }


     return returnRoleName;
    }));
    console.log('///// close ');
    ___arguments.context.pageData['userCode'] = (generateUUID().short());
    userExists = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteEmail')),'\''].join(''))).setPageSize(1)));
    ___arguments.context.appData['existingUser'] = 0;
    if (getValueLength((userExists.map(item => item['email']))) > 0) {
      ___arguments.context.appData['existingUser'] = 1;
    }
    varNewInvite = (await Backendless.Data.of('userInvites').save( ({ [`tradingCode`]: (getObjectProperty(___arguments.context.appData, 'tradingCode')),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),[`inviteName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteName')),[`inviteText`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'welcomeText')),[`inviteEmail`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteEmail')),[`inviteRole`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteRole')),[`inviteRoleString`]: (getObjectProperty(___arguments.context.pageData, 'selectedRole.userRoleString')),[`businessName`]: (getObjectProperty(___arguments.context.appData, 'businessName')),[`userId`]: (getObjectProperty(___arguments.context.appData, 'userId')),[`inviteSentByTag`]: (getObjectProperty(___arguments.context.appData, 'userTag')),[`inviteSentBy`]: (getObjectProperty(___arguments.context.appData, 'userEmail')),[`inviteCode`]: (getObjectProperty(___arguments.context.pageData, 'userCode')),[`businessTradingStyle`]: (getObjectProperty(___arguments.context.appData, 'tradingStyleGroup')),[`inviteSentTime`]: ((new Date()).valueOf()),[`userExistsInt`]: (getObjectProperty(___arguments.context.appData, 'existingUser')) }) ));
    ___arguments.context.pageData['statusMessageText'] = 'Welcome to EcoFood';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8e2b6aba06dcb2f9aef27c091eb29b5e'))['background-color'] = '#00ff00';
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'welcomeText'))) > 1) {
      ___arguments.context.pageData['welcomeTextWritten'] = (['<hr /> <p>&nbsp;</p>',(getObjectProperty(___arguments.context.appData, 'userTag')),' has added a personal note -</p>',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'welcomeText')),'<hr /> <p>&nbsp;</p>'].join(''));
    } else {
      ___arguments.context.pageData['welcomeTextWritten'] = (['<p><span style="font-family:Verdana,Geneva,sans-serif">Hopefully this isn&#39;t the first time you\'ve heard of EcoFoodSafe. If you\'re concerned please do contact </span>',(getObjectProperty(___arguments.context.appData, 'userTag')),'<span style="font-family:Verdana,Geneva,sans-serif"> at </span>',(getObjectProperty(___arguments.context.appData, 'userEmail')),'<span style="font-family:Verdana,Geneva,sans-serif"> for a full explaination.</span></p>'].join(''));
    }
    emailSubject = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteName')),', invite to join ',(getObjectProperty(___arguments.context.appData, 'userTag')),' at "',(getObjectProperty(___arguments.context.appData, 'businessName')),'", as ',(getObjectProperty(___arguments.context.pageData, 'selectedRole.roleName')),'.'].join('');
    emailBody = ['','',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteName')),'<span style="font-family:Verdana,Geneva,sans-serif">,</span>',(getObjectProperty(___arguments.context.pageData, 'welcomeTextWritten')),'<p><span style="font-family:Verdana,Geneva,sans-serif">The 15 second elevator pitch for your business using EcoFoodSafe would&nbsp;be this...</span></p>  <p><em><span style="font-family:Verdana,Geneva,sans-serif">&quot;We match over-production of crops with commercial kitchens often within &#39;zero miles&#39; of each other. The produce is&nbsp;picked and delivered on&nbsp;the same day. There are no subscriptions charged. The price quoted is the final price the kitchen&nbsp;will pay. No contracts, no adverts. Just fresh local produce delivered.&quot;</span></em></p>','<p><span style="font-family:Verdana,Geneva,sans-serif">To sign up -</span></p>  <p><span style="font-family:Verdana,Geneva,sans-serif">Copy this&nbsp;unique code -</span></p>  ',(getObjectProperty(___arguments.context.pageData, 'userCode')),'<p><span style="font-family:Verdana,Geneva,sans-serif">its ensures you are linked to the correct business. When you move on to the sign-up page, paste the code into the box.</span></p>  <p><span style="font-family:Verdana,Geneva,sans-serif">Now follow this <a href="https://www.fork2fork.co.uk?page=invitedSignUp2">link</a>&nbsp;to our sign-up page for users who have been invited.</span></p>'].join('');
    await Backendless.Messaging.sendEmail(emailSubject, new Backendless.Bodyparts({ htmlmessage: emailBody }), ensureArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteEmail'))), undefined);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
      ___arguments.context.pageData['statusMessageText'] = 'User already exists.';
    }

  } finally {
    (function () { window.history.back(); })();

  }

  },
  /* handler:onClick */
  /* content */
}))
define('./pages/userAddNew2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('571855e85e1829688248254863b87af8', false);
    ___arguments.context.pageData['userLevel'] = (getObjectProperty(___arguments.context.appData, 'selectedBusiness.userLevel'));
    if ((getObjectProperty(___arguments.context.appData, 'isFounder')) == 1) {
      ___arguments.context.appData['options'] = (await Backendless.Data.of('userRoles').find(Backendless.DataQueryBuilder.create().setWhereClause((['businessType = ',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.tradingStyleGroup')),'and userLevel =8','',''].join(''))).setSortBy('userLevel').setPageSize(100)));
    } else {
      ___arguments.context.appData['options'] = (await Backendless.Data.of('userRoles').find(Backendless.DataQueryBuilder.create().setWhereClause((['businessType = ',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.tradingStyleGroup')),'and userLevel <\'',(getObjectProperty(___arguments.context.appData, 'userLevel')) == 8 ? 9 : (getObjectProperty(___arguments.context.appData, 'userLevel')),'\''].join(''))).setSortBy('userLevel').setPageSize(100)));
    }
    console.log('options[appData] = ');
    console.log(getObjectProperty(___arguments.context.appData, 'options'));
    console.log('///// options[appData] = CLOSE');
    if ((getObjectProperty(___arguments.context.appData, 'isFounder')) == 1) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('571855e85e1829688248254863b87af8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e2b6aba06dcb2f9aef27c091eb29b5e', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('571855e85e1829688248254863b87af8', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e2b6aba06dcb2f9aef27c091eb29b5e', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/userAddNew2/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userAddNew2/components/d4e8bfa8bfabf3b8832e52185ce82958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ownerData'] = ((await Backendless.Data.of('userRoles').find(Backendless.DataQueryBuilder.create().setWhereClause((['businessType=',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedBusiness')), 'tradingStyleGroup')),'and userLevel = 8',''].join(''))).setPageSize(10)))[0]);
  await Backendless.Data.of('userConnections').save(({ [`isFounder`]: 0,[`objectId`]: (getObjectProperty(___arguments.context.appData, 'selectedUsersObjectId')),[`userSpecificRoles`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'ownerData')), 'userRoleString')) }), true);
  await Backendless.Data.of('userConnections').setRelation((getObjectProperty(___arguments.context.appData, 'selectedUsersObjectId')), 'userRoleAccessID2', [String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'ownerData')), 'objectId'))]);
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('signin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userAddNew2/components/b0f8b679e66850ed8e28e85fce2663a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e2b6aba06dcb2f9aef27c091eb29b5e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('571855e85e1829688248254863b87af8', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('d6b7c883f9e2cbee4b94701b382e8433', (await Promise.all((getObjectProperty(___arguments.context.appData, 'options')).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'roleName')),[`value`]: (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userAddNew2/components/8e2b6aba06dcb2f9aef27c091eb29b5e/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('d6b7c883f9e2cbee4b94701b382e8433', (await Promise.all((getObjectProperty(___arguments.context.appData, 'options')).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'roleName')),[`value`]: (getObjectProperty(item, 'objectId')),[`roleName`]: (getObjectProperty(item, 'roleName')) });}))));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/userAddNew2/components/d6b7c883f9e2cbee4b94701b382e8433/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('inviteForm - inviteRole var');
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8e2b6aba06dcb2f9aef27c091eb29b5e'), 'inviteRole'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/userHolidayReview/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/userHolidayReview/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var adminWhereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('') + String(adminWhereClause));
  adminWhereClause = ['businessLinkId = \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId')),'\''].join('');
  if ((getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('a00') + 1 > 0) {
    adminWhereClause = ['businessLinkId =\'',(getObjectProperty(___arguments.context.appData, 'businessLinkId')),'\' AND usersObjectId =\'',(getObjectProperty(___arguments.context.appData, 'userId')),'\''].join('');
    console.log(['/// look up user in all businesses //// businessLinkId =\'',(getObjectProperty(___arguments.context.appData, 'businessLinkId')),'\' AND usersObjectId =\'',(getObjectProperty(___arguments.context.appData, 'userId')),'\''].join(''));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c6470f34cf79204868d48a5fa10f4989', (await Backendless.Data.of('usersInBusiness').find(Backendless.DataQueryBuilder.create().setWhereClause(adminWhereClause).setPageSize(20))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/userHolidayReview/components/3e91a2db704d48babcf11446da73ccbd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')) == null) {
    varLogIn = String(' -- ');
  } else {
    varLogIn = String(((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')))).toDateString()).slice(0, 3));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userHolidayReview/components/3776554893c756adb103d0479e46239a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')))).toDateString()).slice(4, 10));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userHolidayReview/components/5aadebace99eb39254aefe3e07769285/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(subsequenceFromEndLast(((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')))).toDateString()), 3));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userHolidayReview/components/74ff0b26cf084385576dccaf2f92a201/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')) == null) {
    varLogIn = String(' -- --');
  } else {
    ___arguments.context.pageData['dateFound'] = ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')))).toDateString());
    varLogIn = String(0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin'))) / 86400000)) + String(' days ago.');
  }
  if (0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin'))) / 86400000) == 0) {
    varLogIn = String('Today.');
  }
  if (0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin'))) / 86400000) == 1) {
    varLogIn = String('Yesterday.');
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userHolidayReview/components/76963d1dd08b7a5f2ceba26dc53bfeee/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('76963d1dd08b7a5f2ceba26dc53bfeee'))['opacity'] = 1;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/userHolidayReview/components/90728d16ce54f8f91bf148fb06e4fd29/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c')['nameFirst']),' ',(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c')['surName'])].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userHolidayReview/components/6986cd0ceaf32d6cae61a7fef5657fe9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6986cd0ceaf32d6cae61a7fef5657fe9', false);
  if ((getObjectProperty(___arguments.context.appData, 'tradingStlyeGroup')) == 10) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b1c20083b75af58ec58126314f81268', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcb69128cff85a987b594d08479894a8', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userHolidayReview/components/cb854ce53d1b0c057f0e5aa7bc66fc37/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcb69128cff85a987b594d08479894a8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b1c20083b75af58ec58126314f81268', false);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/userHolidayReview/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('userTopMenu', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userRegUniversal/components/a6ded58cabab013125843f76779d42b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, varUser, newUserData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

/**
 * Describe this function...
 */
async function saveConnection() {
  newUserData = ({ [`contractDaysWork`]: 28,[`isFounder`]: 1,[`businessObjectId`]: (getObjectProperty(___arguments.context.pageData, 'createdBusinessId')),[`holidaysAllowed`]: 28,[`userDepartment`]: (getObjectProperty(___arguments.context.pageData, 'userDept')),[`usersObjectId`]: (getObjectProperty(varUser, 'objectId')),[`businessLinkId`]: (getObjectProperty(___arguments.context.pageData, 'createdBusinessId')),[`userTag`]: (getObjectProperty(___arguments.context.pageData, 'userTag')),[`businessTag`]: (getObjectProperty(___arguments.context.pageData, 'companyName')),[`tradingCode`]: (getObjectProperty(___arguments.context.appData, 'tradingCode')),[`tradingStyleGroup`]: (getObjectProperty(___arguments.context.appData, 'tradingStyleGroup')),[`userRole`]: 'Founder',[`initialEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')) });
  console.log('newUserData[var] :');
  console.log(newUserData);
  ___arguments.context.pageData['newUser'] = (await Backendless.Data.of('userConnections').save( newUserData ));
  console.log('///////////.  save user complete ////////////');
}

/**
 * Describe this function...
 */
async function createRElation() {
  console.log(['userConnections table, [newUser {pageData}  = ',(getObjectProperty(___arguments.context.pageData, 'newUser')),', // \'connections\' relation name assigned - ',[(getObjectProperty(varUser, 'objectId'))]].join(''));
  await Backendless.Data.of('userConnections').addRelation((getObjectProperty(___arguments.context.pageData, 'newUser')), 'connections', [(getObjectProperty(varUser, 'objectId'))]);
  console.log(['userConnections table, [newUser {pageData}  = ',(getObjectProperty(___arguments.context.pageData, 'newUser')),', // \'userRoleAccessID2\' - ',[(getObjectProperty(___arguments.context.pageData, 'userRole'))]].join(''));
  console.log('add object relation, test userRole[pageData] = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'userRole'));
  await Backendless.Data.of('userConnections').addRelation((getObjectProperty(___arguments.context.pageData, 'newUser')), 'userRoleAccessID2', [(getObjectProperty(___arguments.context.pageData, 'userRole'))]);
  console.log(['userConnections table, [newUser {pageData}  = ',(getObjectProperty(___arguments.context.pageData, 'newUser')),', // \'relationToBusinessDetails\'\' - ',[(getObjectProperty(___arguments.context.pageData, 'createdBusinessId'))]].join(''));
  await Backendless.Data.of('userConnections').addRelation((getObjectProperty(___arguments.context.pageData, 'newUser')), 'relationToBusinessDetails', [(getObjectProperty(___arguments.context.pageData, 'createdBusinessId'))]);
}


  if ((getObjectProperty(___arguments.context.pageData, 'password1')) != (getObjectProperty(___arguments.context.pageData, 'password2'))) {
    ___arguments.context.pageData['statusMessageText'] = 'Passwords do not match';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7dfef0525c7e8443fdb578a3fbd65589'))['background-color'] = '#ff0000';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7dfef0525c7e8443fdb578a3fbd65589', true);
  } else {
    try {
      ___arguments.context.pageData['newBusinessCounter'] = ((generateUUID().long()).toUpperCase());
      varUser = (await Backendless.UserService.register( new Backendless.User({ 'email': (getObjectProperty(___arguments.context.pageData, 'email')),'password': (getObjectProperty(___arguments.context.pageData, 'password1')),'userTag': (getObjectProperty(___arguments.context.pageData, 'userTag')),'newUserCounter': (getObjectProperty(___arguments.context.pageData, 'currentNewUserCounter')) }) ));
      ___arguments.context.pageData['createdBusinessId'] = (getObjectProperty((await Backendless.Data.of('businessDetails').save( ({ [`surname`]: (getObjectProperty(___arguments.context.pageData, 'surname')),[`InvitesLiveForDays`]: 7,[`businessType`]: (getObjectProperty(___arguments.context.appData, 'businessType')),[`founderControl`]: 1,[`ukNation`]: (getObjectProperty(___arguments.context.pageData, 'ukNation')),[`businessTypeInt`]: (getObjectProperty(___arguments.context.appData, 'tradingStyleGroup')),[`businessTradingStyleInt`]: (getObjectProperty(___arguments.context.appData, 'tradingCode')),[`businessGeo`]: (getObjectProperty(___arguments.context.appData, 'userLocNow')),[`businessType`]: (getObjectProperty(___arguments.context.appData, 'businessType')),[`businessName`]: (getObjectProperty(___arguments.context.pageData, 'companyName')),[`founderEmail`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`founderName`]: (getObjectProperty(___arguments.context.pageData, 'userTag')),[`businessTradingStyle`]: (getObjectProperty(___arguments.context.appData, 'tradingStyle')),[`newBusinessCounter`]: (getObjectProperty(___arguments.context.pageData, 'newBusinessCounter')),[`tradingStyleGroup`]: (getObjectProperty(___arguments.context.appData, 'tradingStyleGroup')),[`tradingCode`]: (getObjectProperty(___arguments.context.appData, 'tradingCode')) }) )), 'objectId'));
      if ((getObjectProperty(___arguments.context.appData, 'isFounder')) == true) {
        if ((getObjectProperty(___arguments.context.appData, 'businessStyle')) == 'Producer') {
          ___arguments.context.pageData['userRole'] = '8543E427-40E3-404B-A8BE-A7ED5AEF400E';
          ___arguments.context.pageData['userDept'] = 'Producer';
        }
        if ((getObjectProperty(___arguments.context.appData, 'businessStyle')) == 'Kitchen') {
          ___arguments.context.pageData['userDept'] = 'Kitchen';
          ___arguments.context.pageData['userRole'] = '116461C9-A60B-4BCA-AB38-E2FF881079B5';
        }
        if ((getObjectProperty(___arguments.context.appData, 'businessStyle')) == 'BuildingManagement') {
          ___arguments.context.pageData['userDept'] = 'BuildingManagement';
          ___arguments.context.pageData['userRole'] = '79397D22-9AE3-4A8B-A5A4-57DA4196380A';
        }
      }
      ___arguments.context.pageData['userConnectionObjectId'] = (generateUUID().long());
      await saveConnection();
      await createRElation();
      ___arguments.context.pageData['statusMessageText'] = 'Welcome to EcoFood';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7dfef0525c7e8443fdb578a3fbd65589'))['background-color'] = '#00ff00';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7dfef0525c7e8443fdb578a3fbd65589', true);

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        ___arguments.context.pageData['statusMessageText'] = 'User already exists.';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7dfef0525c7e8443fdb578a3fbd65589', true);
      }

    } finally {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fd3a8d8f3e570f4cf22bc7b37dbf0be', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d32dce9faf92d5e617f280ad5b011f17', true);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userRegUniversal/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, locationPoint, lat, lng, location2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function businessLocation() {
  try {
    ___arguments.context.appData['userLoc'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
    location2 = (getObjectProperty(___arguments.context.appData, 'userLoc'));
    lat = (getObjectProperty(location2, 'lat'));
    lng = (getObjectProperty(location2, 'lng'));
    locationPoint = ((new Backendless.Data.Point().setX(lng).setY(lat)).asWKT());
    ___arguments.context.appData['userLocNow'] = locationPoint;

  } catch (error) {
    console.log(error);

  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d32dce9faf92d5e617f280ad5b011f17', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
  await businessLocation();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/userRegUniversal/components/c8d6d863fef2194d7d0ed869531a51b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('signin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userRegUniversal/components/9129437604aa592d3cde921414b9acfe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (['[ ',(getObjectProperty(___arguments.context.appData, 'businessStyle')),' ]'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userAddNew2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, j;

/**
 * Describe this function...
 */
async function toggleOnLoad() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad9a6ebcf028f257966381b8fd189578', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f5636b9b88649088e096a4fc69a97206', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94936ea6d49c2dc895a4681a555d90c3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87e27ff1d0bd18625db46a6fcf965383', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('844aa89b2acc8c5a5368d2f9fa27f5ac', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf765d9a5fe5f774197b667c8da27f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c54dffc79dd86f9fc86245e2566787e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9db16136ada9672f8377e18e453e34db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bfab1df377ee93aef99c9eee9caf3d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6a9253296335f26b678a79a73bdce14', false);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function readUserData() {
  try {
    console.log('////////////////////////////////');
    console.log('adminText[appData] = ');
    console.log(getObjectProperty(___arguments.context.appData, 'adminText'));
    ___arguments.context.pageData['businessDetailsWhereClause'] = (['objectId LIKE \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId2')),'','','\''].join(''));
    ___arguments.context.pageData['businessHolidayYear'] = [];
    ___arguments.context.pageData['businessHolidayYear'] = (await Backendless.Data.of('businessDetails').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'businessDetailsWhereClause'))).setProperties(['businessName', 'businessHolidayYearLengthWeeks', 'businessHolidayYearStart', 'payCycle', 'holidayCredit']).setPageSize(1)));
    ___arguments.context.pageData['whereClause'] = (['businessLinkId = \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId2')),'\' && contentCatCode = 200 ',' && holidayStatusApproval = 5',''].join(''));
    ___arguments.context.appData['holidayRequest2'] = [];
    ___arguments.context.appData['holidayRequest2'] = (await Backendless.Data.of('holidayView2').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'whereClause'))).setProperties(['usersObjectId', 'dateFrom', 'dateTo', 'businessLinkId', 'noDaysRequested', 'adminApprovedId', 'adminApprovedDate', 'userTag', 'holidaysAllowed', 'holidayStatusApproval', 'holidayFailReport', 'errors']).setPageSize(100)));

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function decideBttnsViewed() {
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a30') + 1 > 0) {
    console.log('toggle \'request holiday\'');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f5636b9b88649088e096a4fc69a97206', true);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a10') + 1 > 0) {
    console.log('toggle \'userAdmin\'');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf765d9a5fe5f774197b667c8da27f75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a480d28dbe87018964691f26146843e', false);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a32') + 1 > 0) {
    console.log('toggle \'holidayAdminBttn\'');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('844aa89b2acc8c5a5368d2f9fa27f5ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829778c316a156f68889341684c469cd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1161d15bb860a605aafacdc6ee171d', false);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a00') + 1 > 0) {
    console.log('toggle \'founder Admin\'');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf765d9a5fe5f774197b667c8da27f75', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function catalogueHolidayRequests() {
  try {
    console.log('error 1 - catalogueHolidayRequests');
    ___arguments.context.pageData['usersHolidaysToDate'] = [];
    ___arguments.context.pageData['holidayRequestReviews'] = [];
    ___arguments.context.pageData['systemPassedRequests'] = [];
    ___arguments.context.pageData['adminPassedRequests'] = [];
    console.log('error 2 - catalogueHolidayRequests');
    var j_list = (getObjectProperty(___arguments.context.appData, 'holidayRequest2'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(j, 'usersObjectId')) == (getObjectProperty(___arguments.context.appData, 'userId'))) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'usersHolidaysToDate')), j);
      }
      if ((getObjectProperty(j, 'holidayStatusApproval')) == '5') {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'systemPassedRequests')), j);
      }
      if ((getObjectProperty(j, 'holidayStatusApproval')) == '10') {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'holidayRequestReviews')), j);
      }
      if ((getObjectProperty(j, 'holidayStatusApproval')) == '15') {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'adminPassedRequests')), j);
      }
    }
    console.log('error 3 - catalogueHolidayRequests');
    ___arguments.context.pageData['lengthUsersHolidaysToDate'] = ((getObjectProperty(___arguments.context.pageData, 'usersHolidaysToDate')).length);
    ___arguments.context.pageData['lengthsystemPassedRequests'] = ((getObjectProperty(___arguments.context.pageData, 'systemPassedRequests')).length);
    ___arguments.context.pageData['lengthholidayRequestReviews'] = ((getObjectProperty(___arguments.context.pageData, 'holidayRequestReviews')).length);
    ___arguments.context.pageData['lengthadminPassedRequests'] = ((getObjectProperty(___arguments.context.pageData, 'adminPassedRequests')).length);
    console.log('error 4 - catalogueHolidayRequests');

  } catch (error) {
    console.log(error);

  }
}


  await toggleOnLoad();
  await decideBttnsViewed();
  await readUserData();
  await catalogueHolidayRequests();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/userTopMenu10/components/2f43a9389fe7613db21b7c4523c3bc34/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('usersUpdate', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/f5636b9b88649088e096a4fc69a97206/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94936ea6d49c2dc895a4681a555d90c3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/f53515d3afabb576307c4e341fe6cf86/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f53515d3afabb576307c4e341fe6cf86'))['minDate'] = (new Date((getObjectProperty(___arguments.value, '1stDayOff'))));
  ___arguments.context.pageData['dateFirstOff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/userTopMenu10/components/797a63fa2748dffae9bdc8bfb9a71ba2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var holidayErrors, slotsReport, error, overLapList, requestedLastDateOff, requestedFirstDateOff, requestedHolidayLength, holidayRequest2, varEventTo, textOutput, varMenuTo, varMenuFrom, varEventFrom, varEventDays, item, daysHolidaysLeft, j, warnError, startsInsideHolidayDays, endsInSideHolidayDays, inSideHolidaysDays, spanHolidayDays, daysError, dateNow, daysToHoliday, blockedListOverlap, blockedWarning, blockedBusyPeriods, totalHolsTakenBeforeRequest, outsideHolidayYear, businessHolidayYear, varHolidayYearStart;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function defineVariables() {
  try {
    holidayErrors = 0;
    requestedHolidayLength = (getObjectProperty(___arguments.context.pageData, 'noOffDaysOff'));
    requestedFirstDateOff = (getObjectProperty(___arguments.context.pageData, 'dateFirstOff'));
    requestedLastDateOff = (getObjectProperty(___arguments.context.pageData, 'dateFirstOff')) + (requestedHolidayLength - 1) * 86400000;
    overLapList = [];
    ___arguments.context.appData['requestedHolidayLength'] = requestedHolidayLength;
    ___arguments.context.appData['requestedFirstDateOff'] = requestedFirstDateOff;
    ___arguments.context.appData['requestedLastDateOff'] = requestedLastDateOff;
    overLapList = [];
    slotsReport = '';

  } catch (error) {
    console.log(error);

  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function pullData() {
  ___arguments.context.pageData['whereClause'] = (['businessLinkId LIKE \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId')),'','','\''].join(''));
  holidayRequest2 = [];
  addItemToList(holidayRequest2, (await Backendless.Data.of('holidayView').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'whereClause'))).setProperties(['usersObjectId', 'holidayStartDate', 'holidayEndDate', 'businessLinkId', 'noDaysRequested', 'adminApprovedId', 'adminApprovedDate', 'userTag', 'holidaysAllowed', 'holidayStatusApproval', 'holidayFailReport', 'errors', null]).setPageSize(100))));
}

/**
 * Describe this function...
 */
async function whereClase() {
  if (varEventFrom >= varMenuFrom && varEventTo <= varMenuTo) {
    textOutput = ['Event runs from - ',((new Date(varEventFrom)).toLocaleDateString()),' for ',varEventDays,' days of menu.'].join('');
  }
  if (varEventFrom > varMenuFrom && varEventFrom <= varMenuTo && varEventTo > varMenuTo) {
    textOutput = ['Event runs from -',((new Date(varEventFrom)).toLocaleDateString()),'to end of menu.',''].join('');
  }
  if (varEventFrom < varMenuFrom && varEventTo > varMenuFrom && varEventTo <= varMenuTo) {
    textOutput = ['Event runs from start of menu ','to ',((new Date(varEventTo)).toLocaleDateString()),''].join('');
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function testHolidaysExceeded() {
  try {
    ___arguments.context.appData['holidayDaysLeftText'] = 'Holidays available - No problem found. \n';
    daysHolidaysLeft = (Number((getObjectProperty(___arguments.context.appData, 'holidaysAllowed')))) - ((Number((getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')))) + (Number((getObjectProperty(___arguments.context.pageData, 'RequestedToDate')))));
    ___arguments.context.pageData['userOwnDetails'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'holidayRequest2')), async (item) => {


     return ((getObjectProperty(item, 'usersObjectId')) == (getObjectProperty(___arguments.context.appData, 'userId')));
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'userOwnDetails')).length > 0) {
      ___arguments.context.pageData['RequestedToDate'] = (((getObjectProperty(___arguments.context.pageData, 'userOwnDetails')).map(item => item['noDaysRequested'])).reduce(function(x, y) {return x + y;}));
    } else {
      ___arguments.context.pageData['RequestedToDate'] = 0;
    }
    if ((getObjectProperty(___arguments.context.appData, 'holidaysAllowed')) - ((Number((getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')))) + (Number((getObjectProperty(___arguments.context.pageData, 'RequestedToDate'))))) <= 0) {
      holidayErrors = (typeof holidayErrors == 'number' ? holidayErrors : 0) + 1;
      ___arguments.context.appData['holidayDaysLeftText'] = (['Holidays available - Failed check.\n','Holidays allowed in year = ',(getObjectProperty(___arguments.context.appData, 'holidaysAllowed')),'\n','Number of days of taken and booked to date = ',(getObjectProperty(___arguments.context.pageData, 'RequestedToDate')),'\n','Number of days requested = ',(getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')),'\n','Total holidays if allowed = ',(Number((getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')))) + (Number((getObjectProperty(___arguments.context.pageData, 'RequestedToDate')))),'\n','____________________ \n'].join(''));
      slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'holidayDaysLeftText'));
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'userOwnDetails')).length > 0) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f12e6feaec28aadeb8557b522584b958', true);
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a3a651ba8ad9dbfba9328d70a25da87', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('472c5587f99e8f132de731e51d223947', (getObjectProperty(___arguments.context.pageData, 'userOwnDetails')));

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function print_start_and_end() {
  console.log(String('holidayStartDate = ') + String((new Date((getObjectProperty(j, 'holidayStartDate')))).toLocaleDateString()));
  console.log(String('requestedFirstDateOff = ') + String((new Date(requestedFirstDateOff)).toLocaleDateString()));
  console.log(String('holidayEndDate = ') + String((new Date((getObjectProperty(j, 'holidayEndDate')))).toLocaleDateString()));
  console.log(String('requestedLastDateOff = ') + String((new Date(requestedLastDateOff)).toLocaleDateString()));
}

/**
 * Describe this function...
 */
async function testSlots() {
  try {
    daysError = 0;
    ___arguments.context.pageData['overlapText'] = (String('No holiday clashes with other staff.') + String('\n'));
    ___arguments.context.pageData['slotsReportText'] = ' ';
    ___arguments.context.pageData['holidaysBooked'] = 'No approved holidays over requested holiday period.';
    var j_list = (getObjectProperty(___arguments.context.appData, 'holidayRequest2'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(j, 'usersObjectId')) != (getObjectProperty(___arguments.context.appData, 'userId'))) {
        ___arguments.context.pageData['fileHolidayDetailsText'] = (['Approved holiday for ',(getObjectProperty(j, 'userTag')),'. From ',((new Date((getObjectProperty(j, 'dateFrom')))).toLocaleDateString()),'to ',((new Date((getObjectProperty(j, 'dateTo')))).toLocaleDateString()),' (',(getObjectProperty(j, 'noDaysRequested')),(getObjectProperty(j, 'noDaysRequested')) > 1 ? ' days) \n' : ' day only) \n','',''].join(''));
        slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.pageData, 'fileHolidayDetailsText'));
        warnError = 0;
        if ((getObjectProperty(j, 'dateFrom')) > requestedFirstDateOff && (getObjectProperty(j, 'dateTo')) < requestedLastDateOff) {
          spanHolidayDays = (typeof spanHolidayDays == 'number' ? spanHolidayDays : 0) + Math.floor(((getObjectProperty(j, 'dateTo')) - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 0;
          warnError = (typeof warnError == 'number' ? warnError : 0) + 1;
          addItemToList(overLapList, j);
          ___arguments.context.pageData['overlapText'] = (['Request spans an approved holiday by ',Math.floor(((getObjectProperty(j, 'dateTo')) - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 0,' days.'].join(''));
          ___arguments.context.appData['slotsOverlapText'] = (['Holiday clashing with other confirmed holidays - Failed check. \n','Request spans an approved holiday by ',Math.floor(((getObjectProperty(j, 'dateTo')) - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 0,' days.','','\n',(getObjectProperty(___arguments.context.pageData, 'fileHolidayDetailsText')),'\n','____________________','\n'].join(''));
          slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'slotsOverlapText'));
        }
        if ((getObjectProperty(j, 'dateFrom')) <= requestedFirstDateOff && (getObjectProperty(j, 'dateTo')) >= requestedLastDateOff) {
          inSideHolidaysDays = (typeof inSideHolidaysDays == 'number' ? inSideHolidaysDays : 0) + Math.floor((requestedLastDateOff - requestedFirstDateOff) / 86400000) + 1;
          warnError = (typeof warnError == 'number' ? warnError : 0) + 1;
          addItemToList(overLapList, j);
          ___arguments.context.pageData['overlapText'] = (['Request falls within an approved holiday by ',Math.floor((requestedLastDateOff - requestedFirstDateOff) / 86400000) + 1,' days.'].join(''));
          ___arguments.context.appData['slotsOverlapText'] = (['Holiday clashing with other confirmed holidays - Failed check. \n','Request falls within an approved holiday by ',Math.floor((requestedLastDateOff - requestedFirstDateOff) / 86400000) + 1,' days.','','\n',(getObjectProperty(___arguments.context.pageData, 'fileHolidayDetailsText')),'\n','____________________','\n'].join(''));
          slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'slotsOverlapText'));
        }
        if ((getObjectProperty(j, 'dateFrom')) <= requestedLastDateOff && (getObjectProperty(j, 'dateTo')) >= requestedLastDateOff && (getObjectProperty(j, 'dateFrom')) >= requestedFirstDateOff) {
          endsInSideHolidayDays = (typeof endsInSideHolidayDays == 'number' ? endsInSideHolidayDays : 0) + Math.floor((requestedLastDateOff - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1;
          warnError = (typeof warnError == 'number' ? warnError : 0) + 1;
          addItemToList(overLapList, j);
          ___arguments.context.pageData['overlapText'] = (['Request runs into the first ',Math.floor((requestedLastDateOff - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1,' days of an approved holiday.'].join(''));
          ___arguments.context.appData['slotsOverlapText'] = (['Holiday clashing with other confirmed holidays - Failed check. \n','Request runs into the first ',Math.floor((requestedLastDateOff - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1,' days of an approved holiday.','','\n',(getObjectProperty(___arguments.context.pageData, 'fileHolidayDetailsText')),'','\n','____________________','\n'].join(''));
          slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'slotsOverlapText'));
        }
        if ((getObjectProperty(j, 'dateTo')) >= requestedFirstDateOff && (getObjectProperty(j, 'dateTo')) <= requestedLastDateOff && (getObjectProperty(j, 'dateFrom')) <= requestedFirstDateOff) {
          startsInsideHolidayDays = (typeof startsInsideHolidayDays == 'number' ? startsInsideHolidayDays : 0) + Math.round(((getObjectProperty(j, 'dateTo')) - requestedFirstDateOff) / 86400000) + 1;
          warnError = (typeof warnError == 'number' ? warnError : 0) + 1;
          addItemToList(overLapList, j);
          ___arguments.context.pageData['overlapText'] = (['Request starts at the end of an approved holiday by ',Math.round(((getObjectProperty(j, 'dateTo')) - requestedFirstDateOff) / 86400000) + 1,' days.'].join(''));
          ___arguments.context.appData['slotsOverlapText'] = (['Holiday clashing with other confirmed holidays - Failed check. \n','Request starts at the end of an approved holiday by ',Math.round(((getObjectProperty(j, 'dateTo')) - requestedFirstDateOff) / 86400000) + 1,' days.','','\n',(getObjectProperty(___arguments.context.pageData, 'fileHolidayDetailsText')),'\n','____________________','\n'].join(''));
          slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'slotsOverlapText'));
        }
      }
    }
    if (overLapList.length > 0) {
      ___arguments.context.pageData['lengthOverLapList'] = (overLapList.length);
      holidayErrors = (typeof holidayErrors == 'number' ? holidayErrors : 0) + 1;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae7faa7b81d62b26fa8fddfa6886a566', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12bb35f1a7b5eca1148f7cf185888205', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7df6c9e4c0852c873dd7468a3b6e7268', false);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('66d4119c57a540d893d4153762983bac', overLapList);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ae7faa7b81d62b26fa8fddfa6886a566', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7df6c9e4c0852c873dd7468a3b6e7268', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12bb35f1a7b5eca1148f7cf185888205', false);
    }

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function minimumNoticeGiven() {
  try {
    dateNow = ((new Date()).valueOf());
    daysToHoliday = dateNow + (requestedHolidayLength - 1) * 86400000;
    ___arguments.context.appData['noticeText'] = (['Notice given for holiday - Pass','\n','____________________','\n'].join(''));
    if (daysToHoliday > requestedFirstDateOff) {
      holidayErrors = (typeof holidayErrors == 'number' ? holidayErrors : 0) + 1;
      ___arguments.context.appData['shortNotice'] = (['!!',requestedHolidayLength,' clear days minimum notice required.'].join(''));
      ___arguments.context.appData['noticeText'] = (['Holiday notice given - Failed check.\n','Requested holiday length is ',requestedHolidayLength,' days. \n','As off today, ',((new Date()).toDateString()),' only ',Math.floor((requestedFirstDateOff - dateNow) / 86400000 + 1),' clear days given. \n','\n','____________________\n'].join(''));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd1fe55ff7247ead57cd4620945a631', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d63f62c194bbaa33b0c2eb4e5b2c07a7', false);
      slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'noticeText'));
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d63f62c194bbaa33b0c2eb4e5b2c07a7', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd1fe55ff7247ead57cd4620945a631', false);
    }

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function testBusyPeriods() {
  try {
    daysError = 0;
    blockedListOverlap = [];
    ___arguments.context.pageData['blockedDatesText'] = (String('PASS - No clashes with business blocked periods. \n'));
    for (var j_index2 in blockedBusyPeriods) {
      j = blockedBusyPeriods[j_index2];
      blockedWarning = 0;
      ___arguments.context.appData['blockedDatesTextReport'] = (['PASS - No clashes with business blocked periods.','\n','____________________','\n'].join(''));
      ___arguments.context.pageData['detailsOfEventText'] = (['Event - ',(getObjectProperty(j, 'description')),'\n','Runs from - ',((new Date((getObjectProperty(j, 'dateFrom')))).toDateString()),' to ',((new Date((getObjectProperty(j, 'dateTo')))).toDateString()),'\n','____________________\n'].join(''));
      if ((getObjectProperty(j, 'dateFrom')) > requestedFirstDateOff && (getObjectProperty(j, 'dateTo')) < requestedLastDateOff) {
        spanHolidayDays = (typeof spanHolidayDays == 'number' ? spanHolidayDays : 0) + Math.floor(((getObjectProperty(j, 'dateTo')) - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1;
        blockedWarning = (typeof blockedWarning == 'number' ? blockedWarning : 0) + 1;
        addItemToList(blockedListOverlap, j);
        ___arguments.context.appData['blockedDatesText'] = (['Request spans a blocked period by ',Math.floor(((getObjectProperty(j, 'dateTo')) - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1,' days.'].join(''));
        ___arguments.context.appData['blockedDatesTextReport'] = (['Holiday clashing with business \'No Holiday\' periods. Failed check. \n','Request spans a blocked period by ',Math.floor(((getObjectProperty(j, 'dateTo')) - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1,' days.','\n',(getObjectProperty(___arguments.context.pageData, 'detailsOfEventText')),'\n'].join(''));
        slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'blockedDatesTextReport'));
      }
      if ((getObjectProperty(j, 'dateFrom')) <= requestedFirstDateOff && (getObjectProperty(j, 'dateTo')) >= requestedLastDateOff) {
        inSideHolidaysDays = (typeof inSideHolidaysDays == 'number' ? inSideHolidaysDays : 0) + Math.floor((requestedLastDateOff - requestedFirstDateOff) / 86400000) + 1;
        blockedWarning = (typeof blockedWarning == 'number' ? blockedWarning : 0) + 1;
        addItemToList(blockedListOverlap, j);
        ___arguments.context.appData['blockedDatesText'] = (['Request falls within a blocked period by ',Math.floor((requestedLastDateOff - requestedFirstDateOff) / 86400000) + 1,' days.'].join(''));
        ___arguments.context.appData['blockedDatesTextReport'] = (['Holiday clashing with business \'No Holiday\' periods. Failed check.\n','Request falls within a blocked period by ',Math.floor((requestedLastDateOff - requestedFirstDateOff) / 86400000) + 1,' days.','\n',(getObjectProperty(___arguments.context.pageData, 'detailsOfEventText')),'\n'].join(''));
        slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'blockedDatesTextReport'));
      }
      if ((getObjectProperty(j, 'dateFrom')) <= requestedLastDateOff && (getObjectProperty(j, 'dateTo')) >= requestedLastDateOff && (getObjectProperty(j, 'restrictedFrom')) >= requestedFirstDateOff) {
        endsInSideHolidayDays = (typeof endsInSideHolidayDays == 'number' ? endsInSideHolidayDays : 0) + Math.floor((requestedLastDateOff - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1;
        blockedWarning = (typeof blockedWarning == 'number' ? blockedWarning : 0) + 1;
        addItemToList(blockedListOverlap, j);
        ___arguments.context.appData['blockedDatesText'] = (['Request runs into the first ',Math.floor((requestedLastDateOff - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1,' days of a blocked period.'].join(''));
        ___arguments.context.appData['blockedDatesTextReport'] = (['[5]Holiday clashing with business \'No Holiday\' periods. Failed check. \n','Request runs into the first ',Math.floor((requestedLastDateOff - (getObjectProperty(j, 'dateFrom'))) / 86400000) + 1,' days of a blocked period.','\n',(getObjectProperty(___arguments.context.pageData, 'detailsOfEventText')),'\n'].join(''));
        slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'blockedDatesTextReport'));
      }
      if ((getObjectProperty(j, 'dateTo')) >= requestedFirstDateOff && (getObjectProperty(j, 'dateFrom')) <= requestedLastDateOff && (getObjectProperty(j, 'restrictedFrom')) <= requestedFirstDateOff) {
        startsInsideHolidayDays = (typeof startsInsideHolidayDays == 'number' ? startsInsideHolidayDays : 0) + Math.round(((getObjectProperty(j, 'dateTo')) - requestedFirstDateOff) / 86400000) + 1;
        blockedWarning = (typeof blockedWarning == 'number' ? blockedWarning : 0) + 1;
        addItemToList(blockedListOverlap, j);
        ___arguments.context.pageData['blockedDatesText'] = (['Request starts at the end of a blocked period by  ',Math.round(((getObjectProperty(j, 'dateTo')) - requestedFirstDateOff) / 86400000) + 1,' days.'].join(''));
        ___arguments.context.appData['blockedDatesTextReport'] = (['Holiday clashing with business \'No Holiday\' periods. Failed check. \n','Request starts at the end of a blocked period by  ',Math.round(((getObjectProperty(j, 'dateTo')) - requestedFirstDateOff) / 86400000) + 1,' days of a blocked period.','\n',(getObjectProperty(___arguments.context.pageData, 'detailsOfEventText')),'\n'].join(''));
        slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'blockedDatesTextReport'));
      }
    }
    if (blockedListOverlap.length > 0) {
      ___arguments.context.pageData['blockedListOverlap'] = (blockedListOverlap.length);
      holidayErrors = (typeof holidayErrors == 'number' ? holidayErrors : 0) + 1;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ea1c0d8eb2625780fa79397cfd7baf3', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8ec7d37653e9a2de362ef90113d51d95', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('065baaabd45ea4be6a239156dc038b34', false);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f0051fff59ac5e61e97b719bbc18565e', blockedListOverlap);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('065baaabd45ea4be6a239156dc038b34', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8ec7d37653e9a2de362ef90113d51d95', false);
    }

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function blockedBusyPeriods2() {
  try {
    ___arguments.context.pageData['blockedPeriodsWhereClause'] = (['businessLinkId LIKE \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId2')),'\' && contentCatCode =','',' 100'].join(''));
    blockedBusyPeriods = [];
    addItemToList(blockedBusyPeriods, (await Backendless.Data.of('events').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'blockedPeriodsWhereClause'))).setProperties(['businessLinkId', 'description', 'dateFrom', 'dateTo']).setPageSize(100))));
    await testBusyPeriods();

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function withinHolidayYear() {
  try {
    ___arguments.context.appData['newYearText'] = (String('withinHolidayYear function \n') + String('Request falls within current holiday year. PASS \n'));
    businessHolidayYear = [];
    outsideHolidayYear = 0;
    businessHolidayYear = (getObjectProperty(___arguments.context.pageData, 'businessHolidayYear'));
    for (var j_index3 in businessHolidayYear) {
      j = businessHolidayYear[j_index3];
      varHolidayYearStart = (getObjectProperty(j, 'businessHolidayYearStart'));
      ___arguments.context.pageData['payCycle'] = (getObjectProperty(j, 'payCycle'));
      ___arguments.context.pageData['holidayCredit'] = (getObjectProperty(j, 'holidayCredit'));
      ___arguments.context.pageData['holidayYearStart'] = (getObjectProperty(j, 'businessHolidayYearStart'));
      ___arguments.context.pageData['weeksInBusinessHolidayYear'] = (getObjectProperty(j, 'businessHolidayYearLengthWeeks'));
      ___arguments.context.pageData['startYearDay'] = (new Date((getObjectProperty(j, 'businessHolidayYearStart'))).getDate());
      ___arguments.context.pageData['startYearMonth'] = (new Date((getObjectProperty(j, 'businessHolidayYearStart'))).getMonth() + 1);
      ___arguments.context.pageData['startYearYear'] = (new Date((new Date())).getFullYear());
      ___arguments.context.pageData['startOfYear'] = ([(getObjectProperty(___arguments.context.pageData, 'startYearDay')),'/',(getObjectProperty(___arguments.context.pageData, 'startYearMonth')),'/',(getObjectProperty(___arguments.context.pageData, 'startYearYear'))].join(''));
      ___arguments.context.pageData['BusinessHolidayStart'] = ((new Date((getObjectProperty(___arguments.context.pageData, 'startOfYear')))).valueOf());
      ___arguments.context.pageData['businessHolidayEnd'] = (((new Date((getObjectProperty(___arguments.context.pageData, 'startOfYear')))).valueOf()) + 31556952000);
      if ((getObjectProperty(___arguments.context.pageData, 'BusinessHolidayStart')) <= requestedLastDateOff && (getObjectProperty(___arguments.context.pageData, 'businessHolidayEnd')) >= requestedLastDateOff && (getObjectProperty(___arguments.context.pageData, 'BusinessHolidayStart')) >= requestedFirstDateOff) {
        outsideHolidayYear = (typeof outsideHolidayYear == 'number' ? outsideHolidayYear : 0) + 1;
        addItemToList(businessHolidayYear, j);
        ___arguments.context.pageData['overlapTextHolidayYear'] = (['!! Fail. Request starts in an old holiday year  ',Math.floor((requestedLastDateOff - (getObjectProperty(___arguments.context.pageData, 'BusinessHolidayStart'))) / 86400000) + 0,' days of an approved holiday.'].join(''));
      }
      if ((getObjectProperty(___arguments.context.pageData, 'businessHolidayEnd')) >= requestedFirstDateOff && (getObjectProperty(___arguments.context.pageData, 'businessHolidayEnd')) <= requestedLastDateOff && (getObjectProperty(___arguments.context.pageData, 'BusinessHolidayStart')) <= requestedFirstDateOff) {
        outsideHolidayYear = (typeof outsideHolidayYear == 'number' ? outsideHolidayYear : 0) + 1;
        addItemToList(businessHolidayYear, j);
        ___arguments.context.pageData['overlapTextHolidayYear'] = (['!! Fail. Request starts in the new holiday year by ',Math.round((requestedLastDateOff - (getObjectProperty(___arguments.context.pageData, 'businessHolidayEnd'))) / 86400000) + 0,' days.'].join(''));
        ___arguments.context.appData['newYearText'] = (['','Fail!! Request runs into the new holiday year by ',Math.round((requestedLastDateOff - (getObjectProperty(___arguments.context.pageData, 'businessHolidayEnd'))) / 86400000) + 0,' days.','\n','____________________','\n'].join(''));
      }
    }
    if (outsideHolidayYear > 0) {
      holidayErrors = (typeof holidayErrors == 'number' ? holidayErrors : 0) + 1;
      slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'newYearText'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3bdc02c7427dcf3e8ce9e9591834ff2', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b5871977cf1cfdebda7c9f3b3a72c89', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b5871977cf1cfdebda7c9f3b3a72c89', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3bdc02c7427dcf3e8ce9e9591834ff2', false);
    }
    ___arguments.context.appData['globalHolidayErrors'] = holidayErrors;

  } catch (error) {
    console.log(error);

  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function holidayToYearRatio() {
  try {
    totalHolsTakenBeforeRequest = 0;
    ___arguments.context.appData['holidayRatioText'] = 'User has earned sufficent days holidays - No problem found.';
    ___arguments.context.pageData['daysSinceStartHolidayYear'] = ((dateNow - (getObjectProperty(___arguments.context.pageData, 'holidayYearStart'))) / 86400000);
    ___arguments.context.pageData['daysBetweenStartOfYearAndHolidayEnd'] = (((getObjectProperty(___arguments.context.appData, 'requestedLastDateOff')) - (getObjectProperty(___arguments.context.pageData, 'holidayYearStart'))) / 86400000);
    ___arguments.context.pageData['holidaysEarnedPerDay'] = ((getObjectProperty(___arguments.context.appData, 'holidaysAllowed')) / 365);
    ___arguments.context.pageData['userHolidaySorted'] = (await asyncListSort((getObjectProperty(___arguments.context.appData, 'holidayRequest2')), 1, async (item) => {


     return (getObjectProperty(item, 'holidayStartDate'));
    }));
    var j_list2 = (getObjectProperty(___arguments.context.pageData, 'userHolidaySorted'));
    for (var j_index4 in j_list2) {
      j = j_list2[j_index4];
      if ((getObjectProperty(j, 'holidayStartDate')) < (getObjectProperty(___arguments.context.pageData, 'dateFirstOff'))) {
        if ((getObjectProperty(j, 'usersObjectId')) == (getObjectProperty(___arguments.context.appData, 'userId'))) {
          totalHolsTakenBeforeRequest = (typeof totalHolsTakenBeforeRequest == 'number' ? totalHolsTakenBeforeRequest : 0) + (getObjectProperty(j, 'noDaysRequested'));
        }
      }
    }
    ___arguments.context.pageData['totalHolsTakenBeforeRequest'] = totalHolsTakenBeforeRequest;
    ___arguments.context.pageData['totalDaysOffAndRequested'] = ((Number((getObjectProperty(___arguments.context.pageData, 'totalHolsTakenBeforeRequest')))) + (Number((getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')))));
    console.log('/// earnedDaysOff[pageData] = ');
    console.log(['holidaysEarnedPerDay[pageData] = ',(getObjectProperty(___arguments.context.pageData, 'holidaysEarnedPerDay')),' x '].join(''));
    console.log(String('daysBetweenStartOfYearAndHolidayEnd[pageData] = ') + String(getObjectProperty(___arguments.context.pageData, 'daysBetweenStartOfYearAndHolidayEnd')));
    ___arguments.context.pageData['earnedDaysOff'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'holidaysEarnedPerDay')) * (getObjectProperty(___arguments.context.pageData, 'daysBetweenStartOfYearAndHolidayEnd'))));
    console.log(['result = ',Math.round((getObjectProperty(___arguments.context.pageData, 'holidaysEarnedPerDay')) * (getObjectProperty(___arguments.context.pageData, 'daysBetweenStartOfYearAndHolidayEnd'))),'eardedDayOff[pageData] ///////// end'].join(''));
    ___arguments.context.pageData['holidaysAvailableEarnedOverTime'] = (Math.round((getObjectProperty(___arguments.context.pageData, 'holidaysEarnedPerDay')) * (getObjectProperty(___arguments.context.pageData, 'daysBetweenStartOfYearAndHolidayEnd')) - totalHolsTakenBeforeRequest));
    ___arguments.context.pageData['holidayBalance'] = ((getObjectProperty(___arguments.context.pageData, 'earnedDaysOff')) - (getObjectProperty(___arguments.context.pageData, 'totalDaysOffAndRequested')));
    if ((getObjectProperty(___arguments.context.pageData, 'holidayBalance')) < 0) {
      if ((getObjectProperty(___arguments.context.pageData, 'holidayCredit')) < 1) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ebb4a77b3848d2ef3f12d6f685bb08b', false);
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f12e6feaec28aadeb8557b522584b958', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a6a503204ae30e8723fd02b817327c9', true);
      holidayErrors = (typeof holidayErrors == 'number' ? holidayErrors : 0) + 1;
      ___arguments.context.appData['holidayRatioText'] = (['Holidays earned  - Failed check.\n','Holiday day\'s earned up to end or requested holiday = = ',(getObjectProperty(___arguments.context.appData, 'earnedDaysOff')),'\n','Number of days of taken before this request =',(getObjectProperty(___arguments.context.pageData, 'totalHolsTakenBeforeRequest')),'\n','Number of days requested = ',(getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')),'\n','This company allows ',(getObjectProperty(___arguments.context.pageData, 'holidayCredit')),'(Holiday credits are set by business and are used to allow the system to approve holidays at the start of a holiday year when users may not have earned enough days holidays.)\n','Balnace is NEGATIVE (FAIL)  ',(getObjectProperty(___arguments.context.pageData, 'holidayBalance')),'\n','____________________'].join(''));
      slotsReport = String(slotsReport) + String(getObjectProperty(___arguments.context.appData, 'holidayRatioText'));
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ebb4a77b3848d2ef3f12d6f685bb08b', true);
    }

  } catch (error) {
    console.log(error);

  }
}


  console.log('start holiday admin 1');
  console.log('///// start holiday request');
  console.log('///// selectedBusinerss[app] = ');
  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness'));
  console.log('///// selectedBusinerss.contractDaysWprk[app] = ');
  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness.contractDaysWork'));
  if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.contractDaysWork')) > 0) {
    console.log('if clause passed - >0');
    console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness.contractDaysWork'));
    console.log('///// passed if text - start holiday request');
    console.log('start holiday admin 2 [in loop]');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94936ea6d49c2dc895a4681a555d90c3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87e27ff1d0bd18625db46a6fcf965383', true);
    await defineVariables();
    console.log('cleared defineVariables');
    await withinHolidayYear();
    console.log('cleared withinHolidayYear');
    await testHolidaysExceeded();
    console.log('cleared testHolidayExceeds');
    await testSlots();
    console.log('cleared testSlots');
    await minimumNoticeGiven();
    console.log('cleared minimumNoticeGiven');
    await blockedBusyPeriods2();
    console.log('cleared blockedBusyPeriods');
    await holidayToYearRatio();
    console.log('cleared holidayToYearRatio');
    ___arguments.context.appData['globalHolidayErrors'] = holidayErrors;
    ___arguments.context.appData['slotsReport'] = slotsReport;
    if (holidayErrors > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6a9253296335f26b678a79a73bdce14', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bfab1df377ee93aef99c9eee9caf3d1', true);
    }
  }
  console.log('end holiday admin 1');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/4a22d91291abf4f19d9de82ffd4381ec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['noOffDaysOff'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/userTopMenu10/components/87483d683ec828d837a8d378f0de59d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'noOffDaysOff'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/1bea751816c82f7555f83d6517214e78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((Number((getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')))) + (Number((getObjectProperty(___arguments.context.pageData, 'RequestedToDate')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/74a40064d9fa5af9f2cbe8824d2884d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('12682c88a29809a841180fe8e2f8dc78'), 'dateTo')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('12682c88a29809a841180fe8e2f8dc78'), 'dateTo')))).toLocaleDateString()).slice(0, 6),((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('12682c88a29809a841180fe8e2f8dc78'), 'dateTo')))).toLocaleDateString()).slice(8, 10),''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/efc894b800ab8a08c1d809b82b73c20a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.pageData, 'dateFirstOff')))).toDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/1b08c188a1cee0b341c8e35718f80b56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('12682c88a29809a841180fe8e2f8dc78'), 'dateFrom')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('12682c88a29809a841180fe8e2f8dc78'), 'dateFrom')))).toLocaleDateString()).slice(0, 6),((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('12682c88a29809a841180fe8e2f8dc78'), 'dateFrom')))).toLocaleDateString()).slice(8, 10),''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/63d2b3e9a6211c9d52e55ba84c58ab58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['holidayErrorsOverlap'] = (['Overlapping Holidays - ',(getObjectProperty(___arguments.context.pageData, 'overlapText')),'!!'].join(''));

  return (['!! Problem - ',(getObjectProperty(___arguments.context.pageData, 'overlapText')),'!!'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/61d3e044c765006dbe1f952eb29a8c5c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4aa9c79cf638c3837745c41477e7728'), 'dateTo')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4aa9c79cf638c3837745c41477e7728'), 'dateTo')))).toLocaleDateString()).slice(0, 6),((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4aa9c79cf638c3837745c41477e7728'), 'dateTo')))).toLocaleDateString()).slice(8, 10),''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/5d993207227245547403bd465c195c76/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['!!! Clash with ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('571ac60eaa1ee51cf1c290bde76ea5c2'), 'description')),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/bf2ad89e2959725ad167e2bbabc89d31/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4aa9c79cf638c3837745c41477e7728'), 'dateFrom')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4aa9c79cf638c3837745c41477e7728'), 'dateFrom')))).toLocaleDateString()).slice(0, 6),((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4aa9c79cf638c3837745c41477e7728'), 'dateFrom')))).toLocaleDateString()).slice(8, 10),''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/b5dc0803f84585ceb2f2515e09e7ccfc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((Number((getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')))) + (Number((getObjectProperty(___arguments.context.pageData, 'RequestedToDate')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/fe01424e8578e1ab37756c06b603aa6c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'earnedDaysOff'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/32d5824ee8b2f0b2d783f2eb0ca8157f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'holidayCredit'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/294ae4ecbdf38513d76c3f7d8bc1957e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Your request clashes with ',(getObjectProperty(___arguments.context.pageData, 'blockedListOverlap')),' restricted business period.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/e9cef1f6ee14d7b12a6c5eaf251c18b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (Math.round(getObjectProperty(___arguments.context.appData, 'holidaysAllowed')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/40b3a0289d1edbdadebfd3f6dd44f067/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'holidayBalance'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/9e781ed13f8a34f43204ef8e02f83705/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Sorry, your request clashes with ',(getObjectProperty(___arguments.context.pageData, 'lengthOverLapList')),' other already confirmed holiday.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/2cf173190cc4a97e92aacee9304bc66d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['You have a balance of ',(getObjectProperty(___arguments.context.pageData, 'holidayBalance')),' days holidays.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/b47a82c46a64c3c19816a158b8565303/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, varNewHolidayRequest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    varNewHolidayRequest = ({ [`description`]: 'Vacation',[`contentCatHuman`]: 'Vacation',[`contentCatCode`]: '200',[`holidayStatusApproval`]: 5,[`noDaysRequested`]: (Number((getObjectProperty(___arguments.context.appData, 'requestedHolidayLength')))),[`dateFrom`]: (getObjectProperty(___arguments.context.appData, 'requestedFirstDateOff')),[`dateTo`]: (getObjectProperty(___arguments.context.appData, 'requestedLastDateOff')),[`holidayRequested`]: (new Date()),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`userId`]: (getObjectProperty(___arguments.context.appData, 'userId')),[`userTag`]: (getObjectProperty(___arguments.context.appData, 'userTag')) });
    ___arguments.context.pageData['parentObjectId'] = (getObjectProperty((await Backendless.Data.of('events').save( varNewHolidayRequest )), 'objectId'));
    await Backendless.Data.of('events').addRelation((getObjectProperty(___arguments.context.pageData, 'parentObjectId')), 'userDetails', [(getObjectProperty(___arguments.context.appData, 'selectedUsersObjectId'))]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bfab1df377ee93aef99c9eee9caf3d1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9db16136ada9672f8377e18e453e34db', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/4a4e6a275da6248ea2f13177edac2269/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, varNewHolidayRequest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    varNewHolidayRequest = ({ [`description`]: 'Vacation',[`contentCatHuman`]: 'Vacation',[`contentCatCode`]: '500',[`errors`]: (getObjectProperty(___arguments.context.appData, 'globalHolidayErrors')),[`holidayStatusApproval`]: 10,[`noDaysRequested`]: (Number((getObjectProperty(___arguments.context.appData, 'requestedHolidayLength')))),[`dateFrom`]: (getObjectProperty(___arguments.context.appData, 'requestedFirstDateOff')),[`dateTo`]: (getObjectProperty(___arguments.context.appData, 'requestedLastDateOff')),[`holidayRequested`]: (new Date()),[`businessLinkId`]: (getObjectProperty(___arguments.context.appData, 'businessLinkId2')),[`userId`]: (getObjectProperty(___arguments.context.appData, 'userId')),[`userTag`]: (getObjectProperty(___arguments.context.appData, 'userTag')),[`holidayFailReport`]: (getObjectProperty(___arguments.context.appData, 'slotsReport')) });
    ___arguments.context.pageData['parentObjectId'] = (getObjectProperty((await Backendless.Data.of('events').save( varNewHolidayRequest )), 'objectId'));
    await Backendless.Data.of('events').addRelation((getObjectProperty(___arguments.context.pageData, 'parentObjectId')), 'userDetails', [(getObjectProperty(___arguments.context.appData, 'selectedUsersObjectId'))]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bfab1df377ee93aef99c9eee9caf3d1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c54dffc79dd86f9fc86245e2566787e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6a9253296335f26b678a79a73bdce14', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/5687e4ad7e427f58e81b4fe6bd47b882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a31') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1161d15bb860a605aafacdc6ee171d', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a32') + 1 > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829778c316a156f68889341684c469cd', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/a0baa97b54f32293dc657c4d2abe2b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['',(getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('a11') + 1 > 0 ? 'Add users. \n' : null,(getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('a12') + 1 > 0 ? 'Update users. \n' : null,(getObjectProperty(___arguments.context.appData, 'userRole')).indexOf('a13') + 1 > 0 ? 'Remove users. \n' : null].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/1dfc4b08b848f868ee212db872a8db68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['!! Total days requested to date over your ',Math.round(getObjectProperty(___arguments.context.appData, 'holidaysAllowed')),' allowance by ',Math.round(((Number((getObjectProperty(___arguments.context.pageData, 'noOffDaysOff')))) + (Number((getObjectProperty(___arguments.context.pageData, 'RequestedToDate'))))) - (getObjectProperty(___arguments.context.appData, 'holidaysAllowed'))),' days!!'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/f12e6feaec28aadeb8557b522584b958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a3a651ba8ad9dbfba9328d70a25da87', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/05f5a85d1fb9d8bbeb4f3245fd986ec5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'holidayRequestDisplayText'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log('user admin tab pressed ........');
    ___arguments.context.appData['invitesForBusiness'] = (await Backendless.Data.of('userInvites').find(Backendless.DataQueryBuilder.create().setWhereClause((['businessLinkId = \'',(getObjectProperty(___arguments.context.appData, 'businessLinkId2')),'\''].join(''))).setPageSize(10)));
    console.log('///////// number of invites for business = ');
    console.log((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length);
    console.log('//////  invitesForBusiness[appData] = ');
    console.log(getObjectProperty(___arguments.context.appData, 'invitesForBusiness'));
    console.log('////////////////////');
    console.log('inviteTextPending[pageData] =');
    console.log(String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length < 1 ? String('No invites pending.') + String('') : ((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length == 1 ? String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length) + String(' pending invite.') : String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length) + String(' pending invites.'))) + String(''));
    ___arguments.context.pageData['inviteTextPending'] = (String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length < 1 ? String('No invites pending.') + String('') : ((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length == 1 ? String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length) + String(' pending invite.') : String((getObjectProperty(___arguments.context.appData, 'invitesForBusiness')).length) + String(' pending invites.'))) + String(''));
    ___arguments.context.appData['options'] = (await Backendless.Data.of('userRoles').find(Backendless.DataQueryBuilder.create().setWhereClause((['businessType = ',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.tradingStyleGroup')),'and ',(getObjectProperty(___arguments.context.appData, 'userLevel')) == 9 ? String('userLevel = 8') + String('') : String('userLevel < ') + String(getObjectProperty(___arguments.context.appData, 'userLevel')),''].join(''))).setSortBy('userLevel').setPageSize(100)));
    if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a11') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a480d28dbe87018964691f26146843e', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a00') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a11') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'userRoleTrimmed')).indexOf('a12') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', true);
    }
    ___arguments.context.pageData['inviteText'] = 'text box data';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/29a8ade9e0a822491438e672f1f5eb17/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRole')).indexOf('Founder') + 1 > 0 ? (getObjectProperty(___arguments.context.appData, 'adminText')) : 'Add users.')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/3ebcb001d3cc867d5fc4df99b0393aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2f06ffd31ed3cffb95ed00dc84aa3b63'), 'dateFrom')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2f06ffd31ed3cffb95ed00dc84aa3b63'), 'dateFrom')))).toLocaleDateString()).slice(0, 6),((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2f06ffd31ed3cffb95ed00dc84aa3b63'), 'dateFrom')))).toLocaleDateString()).slice(8, 10),''].join(''));

  return ([((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2f06ffd31ed3cffb95ed00dc84aa3b63'), 'dateFrom')))).toDateString()).slice(0, 3),', ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2f06ffd31ed3cffb95ed00dc84aa3b63'), 'dateFrom')))).toLocaleDateString()).slice(0, 6),((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2f06ffd31ed3cffb95ed00dc84aa3b63'), 'dateFrom')))).toLocaleDateString()).slice(8, 10),''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/4da995063306373a00c9b182a494661f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('117ebe46c21a2094503b3a052635e2d6'), 'noDaysRequested'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/userTopMenu10/components/5a480d28dbe87018964691f26146843e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('invitesView', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/userTopMenu10/components/829778c316a156f68889341684c469cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('selectedBusiness[appData] = ');
  console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness'));
  console.log('whereClause for events table');
  console.log(['businessLinkId = \'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
  ___arguments.context.pageData['holidaysWaitingWhere'] = (['businessLinkId = \'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad9a6ebcf028f257966381b8fd189578', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/usersUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var noOfOwners, item, adminWhereClause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  noOfOwners = 0;
  adminWhereClause = ['businessLinkId = \'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join('');
  ___arguments.context.pageData['userInBusinessList'] = (await Backendless.Data.of('usersInBusiness').find(Backendless.DataQueryBuilder.create().setWhereClause(adminWhereClause).setPageSize(20)));
  ___arguments.context.pageData['notUsed'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'userInBusinessList')).map(async item => {  if ((getObjectProperty(item, 'userLevel')) == 8) {
      noOfOwners = (typeof noOfOwners == 'number' ? noOfOwners : 0) + 1;
      console.log('found a userLevel = 8');
    }
  ; return noOfOwners;})));
  ___arguments.context.appData['TotalNoOwners'] = noOfOwners;
  if ((getObjectProperty(___arguments.context.pageData, 'userInBusinessList')).length > 0) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c6470f34cf79204868d48a5fa10f4989', (getObjectProperty(___arguments.context.pageData, 'userInBusinessList')));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/usersUpdate/components/3e91a2db704d48babcf11446da73ccbd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')) == null ? String(' -- ') : String(((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')))).toDateString()).slice(0, 3)))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdate/components/3776554893c756adb103d0479e46239a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')))).toDateString()).slice(4, 10));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdate/components/5aadebace99eb39254aefe3e07769285/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(subsequenceFromEndLast(((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')))).toDateString()), 3));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdate/components/74ff0b26cf084385576dccaf2f92a201/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var varLogIn, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin'))) / 86400000)) + String(' days ago.');
  }
  if (0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin'))) / 86400000) == 0) {
    varLogIn = String('Today.');
  }
  if (0 + Math.round((((new Date()).valueOf()) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'lastLogin'))) / 86400000) == 1) {
    varLogIn = String('Yesterday.');
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdate/components/76963d1dd08b7a5f2ceba26dc53bfeee/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('76963d1dd08b7a5f2ceba26dc53bfeee'))['opacity'] = 1;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/usersUpdate/components/90728d16ce54f8f91bf148fb06e4fd29/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'nameFirst')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'surName'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdate/components/6986cd0ceaf32d6cae61a7fef5657fe9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['selectedUserDetails'] = ___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('usersUpdateChange', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/usersUpdate/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/usersUpdate/components/d318d88811a6c81c3218b18b5c5747d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42a832d4cf71cbc115f8a2182828d52c'), 'userTagFromUserConnections'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdate/components/42a832d4cf71cbc115f8a2182828d52c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'TotalNoOwners')) == 1 && (getObjectProperty(___arguments.context.dataModel, 'userLevel')) == 8) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c480a3112cde688db935738e7c82f1c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6986cd0ceaf32d6cae61a7fef5657fe9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bbf18f806c81a1895dcafa83c25a3e8', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6986cd0ceaf32d6cae61a7fef5657fe9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c480a3112cde688db935738e7c82f1c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bbf18f806c81a1895dcafa83c25a3e8', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/usersUpdateChange/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/usersUpdateChange/components/3e91a2db704d48babcf11446da73ccbd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin')) == null) {
    varLogIn = String(' -- ');
  } else {
    varLogIn = String(((new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin')))).toDateString()).slice(0, 3));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/3776554893c756adb103d0479e46239a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(((new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin')))).toDateString()).slice(4, 10));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/5aadebace99eb39254aefe3e07769285/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin')) == null) {
    varLogIn = String(' -- --');
  } else {
    varLogIn = String(subsequenceFromEndLast(((new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin')))).toDateString()), 3));
  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/74ff0b26cf084385576dccaf2f92a201/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var varLogIn, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin')) == null) {
      varLogIn = String(' -- --');
    } else {
      ___arguments.context.pageData['dateFound'] = ((new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin')))).toDateString());
      varLogIn = String(0 + Math.round((((new Date()).valueOf()) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin'))) / 86400000)) + String(' days ago.');
    }
    if (0 + Math.round((((new Date()).valueOf()) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin'))) / 86400000) == 0) {
      varLogIn = String('Today.');
    }
    if (0 + Math.round((((new Date()).valueOf()) - (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'lastLogin'))) / 86400000) == 1) {
      varLogIn = String('Yesterday.');
    }
    ___arguments.context.appData['userRole.noOffDays'] = varLogIn;

  } catch (error) {
    console.log(error);

  }

  return varLogIn

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/76963d1dd08b7a5f2ceba26dc53bfeee/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('76963d1dd08b7a5f2ceba26dc53bfeee'))['opacity'] = 1;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/usersUpdateChange/components/90728d16ce54f8f91bf148fb06e4fd29/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'nameFirst')),' ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'surName'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('userTopMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/usersUpdateChange/components/d318d88811a6c81c3218b18b5c5747d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'userTagFromUserConnections'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, userSelections, item, options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0134b7f029a235a834e8374ee4e1d2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef391f0eed789cce036daa6328b70f85', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c632236c135e0bac77de1dceedd10531', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c632236c135e0bac77de1dceedd10531', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ca9c78ab175ffe868c60d42d9f4df44', false);
    ___arguments.context.pageData['userRoleNote'] = '';
    ___arguments.context.pageData['userLevel'] = (getObjectProperty(___arguments.context.appData, 'selectedBusiness.userLevel'));
    options = (await Backendless.Data.of('userRoles').find(Backendless.DataQueryBuilder.create().setWhereClause((['businessType = ',(getObjectProperty(___arguments.context.appData, 'tradingStyleGroup')),'and ','userLevel < ','',(getObjectProperty(___arguments.context.pageData, 'userLevel')) == 8 ? 9 : (getObjectProperty(___arguments.context.pageData, 'userLevel'))].join(''))).setSortBy('userLevel').setPageSize(100)));
    userSelections = (await Promise.all(options.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'userLevel')) == 8 && (getObjectProperty(___arguments.context.appData, 'TotalNoOwners')) == 1 ? (getObjectProperty(item, 'roleName')) : (getObjectProperty(item, 'roleName')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
    ___arguments.context.pageData['userSelection'] = userSelections;
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('6d657a0f5ae2407de8b205d9bd9c9b25', userSelections);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/usersUpdateChange/components/6d657a0f5ae2407de8b205d9bd9c9b25/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.pageData['selectedRole'] = (await Backendless.Data.of('userRoles').findById(___arguments.value, ));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0134b7f029a235a834e8374ee4e1d2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ca9c78ab175ffe868c60d42d9f4df44', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c632236c135e0bac77de1dceedd10531', true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/usersUpdateChange/components/8575ce19694830552bf60358d2292f26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'selectedUserDetails.roleName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/70e5731ff5bbe008b4b25f08d8af3946/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var error, userSelections, item, options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'selectedUserDetails.roleDescription'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/9ffeafda5bb6feeabcbde95478972f25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedRole.roleName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/39d42214cc681b23f0f8866878fb33cd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'selectedRole.roleDescription'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/usersUpdateChange/components/ef391f0eed789cce036daa6328b70f85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c632236c135e0bac77de1dceedd10531', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef391f0eed789cce036daa6328b70f85', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/usersUpdateChange/components/4ca9c78ab175ffe868c60d42d9f4df44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, emailBody, emailSubject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    console.log('selectedUserDetails[appData] = ');
    console.log(getObjectProperty(___arguments.context.appData, 'selectedUserDetails'));
    ___arguments.context.pageData['welcomeTextWritten'] = (['<!doctype html> <html> <head> 	<title>HTML Editor - Full Version</title> </head> <body> <h1><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">Change of role for a user.</span></h1>  <p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">Hi ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'nameFirst')),',</span></p>  <p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">Your role within - ',(getObjectProperty(___arguments.context.appData, 'businessName')),' has changed.</span></p>  <p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">You have been moved to - ',String(subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'selectedRole.userRoleString')), (((getObjectProperty(___arguments.context.pageData, 'selectedRole.userRoleString')).indexOf('*') + 1 + 1) - 1))),'.</span></p>  <p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">If you have any concerns about your new role or why you have&nbsp;received this email please reply&nbsp;to ',(getObjectProperty(___arguments.context.appData, 'userEmail')),'</span></p>  <p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">Your role has changed, but your login details are the same.</span></p>',getValueLength((getObjectProperty(___arguments.context.pageData, 'userRoleNote'))) > 1 ? ['<p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.userTagFromUserConnections')),' has added a note:</span></p>  <p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">',(getObjectProperty(___arguments.context.pageData, 'userRoleNote')),'</span></p>'].join('') : null,'<p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">Regards,</span></p>  <p><span style="font-family:lucida sans unicode,lucida grande,sans-serif;">',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.softwareProductName')),' admin team.</span></p>  <p>&nbsp;</p>  <p>&nbsp;</p> </body> </html>'].join(''));
    emailSubject = [(getObjectProperty(___arguments.context.appData, 'selectedUserDetails.userTagFromUserConnections')),', your user role has been changed by ',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.userTagFromUserConnections')),' at "',(getObjectProperty(___arguments.context.appData, 'businessName')),'", to  ',String(subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'selectedRole.userRoleString')), (((getObjectProperty(___arguments.context.pageData, 'selectedRole.userRoleString')).indexOf('*') + 1 + 1) - 1))),'.'].join('');
    emailBody = (getObjectProperty(___arguments.context.pageData, 'welcomeTextWritten'));
    await Backendless.Messaging.sendEmail(emailSubject, new Backendless.Bodyparts({ htmlmessage: emailBody }), ensureArray([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedUserDetails')), 'initialEmail'))]), undefined);
    await Backendless.Data.of('userConnections').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.appData, 'selectedUserDetails.objectId')),[`userSpecificRoles`]: (getObjectProperty(___arguments.context.pageData, 'selectedRole.userRoleString')) }) );
    await Backendless.Data.of('userConnections').setRelation((getObjectProperty(___arguments.context.appData, 'selectedUserDetails.objectId')), 'userRoleAccessID2', [(getObjectProperty(___arguments.context.pageData, 'selectedRole.objectId'))]);
    if ((getObjectProperty(___arguments.context.appData, 'selectedUserDetails.userRole')) == 'Founder') {
      await Backendless.Data.of('businessDetails').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessObjectId')),[`founderControl`]: 0 }) );
    }

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
      ___arguments.context.pageData['statusMessageText'] = 'User already exists.';
    }

  } finally {
    (function () { window.history.back(); })();

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/viewData/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  onEnter(___arguments) {
      ___arguments.context.pageData['tableOptions'] = ({ 'title': 'My Table','whereClause': 'objectId != null','realTime': true,'searching': true,'sorting': true,'paging': true,'allowAdd': true,'allowEdit': true,'allowDelete': true });

  },
  /* handler:onEnter *//* content */
}));

define('./pages/xx1ingredientsTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inviteNewUser1', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'));
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 500) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0478c02f65289a5530ee8078f883b56b', undefined);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd73805893c65138a3f8df2823982b28', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0478c02f65289a5530ee8078f883b56b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd73805893c65138a3f8df2823982b28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfff7e78a97ea2951048dfe821284cd9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32a118f8ebcddd18d93beb6835d889a8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('430ee41e6cd8aecac527a97130633b71', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e06d14b3147899708fb36daeed76eec', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00cb2e22ced3d7751d5ada939c8b12ee', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca27986d085ab9829bd166e6779dd0a8', false);
    ___arguments.context.pageData['publicHolsFound'] = 0;
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('i10') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('518cbb1abaeec733dd8cda0ad08c81cf', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('i30') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', true);
    }
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('i40') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/518cbb1abaeec733dd8cda0ad08c81cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca27986d085ab9829bd166e6779dd0a8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb6926832144ca9edf05fd1abae71687', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/2f43a9389fe7613db21b7c4523c3bc34/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ingredientsUpdateMenu', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/07a61fc5e197615c7845b49bb7711926/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/f8adc219258b21dd2f2ec6537b470b09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/634f8fba3489534e709485f54ef51b28/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var newDate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    newDate = (new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('43539abda31876b774cbc596bed6ab12'))['minDate'] = newDate;

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/970897b5964b14a9a124fcb3402f069d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(Math.round(((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) + 1);
  if (Math.round(((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) + 1 < 14) {
    ___arguments.context.pageData['timeLine'] = ([Math.round(((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) + 1,' day',Math.round(((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) > 1 ? 's.' : '.'].join(''));
  } else {
    ___arguments.context.pageData['timeLine'] = ([Math.round((((getObjectProperty(___arguments.context.pageData, 'toDate')) - (getObjectProperty(___arguments.context.pageData, 'fromDate'))) / 86000000) / 7),' Wks.',''].join(''));
  }

  return (getObjectProperty(___arguments.context.pageData, 'timeLine'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/049d86de1bd9f26dc3017adf1e1b8097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var harvestRange2, harvestRange1, x, fullList, item, varHarvestRange, matchVar1, iLoop1, elementPerDay, finishedList, indexDay, iLoop2, searchPublicEvents, error, textOutput, varEventTo, varMenuTo, varMenuFrom, varEventFrom, varEventDays, varMenuDays;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function findHarvestRange() {
  if ((getObjectProperty(___arguments.context.pageData, 'indexCalcFrom')) <= (getObjectProperty(___arguments.context.pageData, 'indexCalcTo'))) {
    harvestRange1 = (getObjectProperty((fullList[(x - 1)]), 'HarString')).slice(((getObjectProperty(___arguments.context.pageData, 'indexCalcFrom')) - 1), getObjectProperty(___arguments.context.pageData, 'indexCalcTo'));
  } else {
    harvestRange2 = (getObjectProperty((fullList[(x - 1)]), 'HarString')).slice(0, getObjectProperty(___arguments.context.pageData, 'indexCalcTo'));
    harvestRange1 = (getObjectProperty((fullList[(x - 1)]), 'HarString')).slice(((getObjectProperty(___arguments.context.pageData, 'indexCalcFrom')) - 1), 365);
    harvestRange1 = String(harvestRange1) + String(harvestRange2);
  }
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function oldDecJanLogic() {
  while (!(iLoop2 >= getValueLength((getObjectProperty(___arguments.context.pageData, 'harvestRange2'))))) {
    iLoop2 = (typeof iLoop2 == 'number' ? iLoop2 : 0) + 1;
    if ((getObjectProperty(___arguments.context.pageData, 'harvestRange2')).charAt((iLoop2 - 1)) == '1') {
      matchVar1 = (typeof matchVar1 == 'number' ? matchVar1 : 0) + 1;
    }
    if (iLoop2 % (getObjectProperty(___arguments.context.pageData, 'skip')) == 0 && (getObjectProperty(___arguments.context.pageData, 'harvestRange2')).charAt((iLoop2 - 1)) == '1') {
      varHarvestRange = String(varHarvestRange) + String('l');
    } else if (iLoop2 % (getObjectProperty(___arguments.context.pageData, 'skip')) == 0 && (getObjectProperty(___arguments.context.pageData, 'harvestRange2')).charAt((iLoop2 - 1)) == '0') {
      varHarvestRange = String(varHarvestRange) + String('.');
    }
  }
}

/**
 * Describe this function...
 */
async function sportingEvents() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b146c2d1979e3642fe8dc6848c79bee6'))['opacity'] = 0.5;
  ___arguments.context.pageData['majorSportsFound'] = 0;
  ___arguments.context.pageData['majorSportsFound'] = (await Backendless.Data.of('events').find(Backendless.DataQueryBuilder.create().setWhereClause((['dateFrom after \'',((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate')))).toISOString()),'\' && dateFrom before \'',((new Date((getObjectProperty(___arguments.context.pageData, 'toDate')))).toISOString()),'\' && contentCatCode LIKE 500','','',''].join(''))).setPageSize(10)));
  ___arguments.context.pageData['noSportsFound'] = ((getObjectProperty(___arguments.context.pageData, 'majorSportsFound')).length);
  if ((getObjectProperty(___arguments.context.pageData, 'majorSportsFound')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b146c2d1979e3642fe8dc6848c79bee6'))['opacity'] = 1;
  }
  console.log('MMMMMMMMMMMMMMMMMMMMMM');
  console.log(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'majorSportsFound'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cfff7e78a97ea2951048dfe821284cd9', (getObjectProperty(___arguments.context.pageData, 'majorSportsFound')));
}

/**
 * Describe this function...
 */
async function displayPublicHols() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba9ccf94d3e3ad6da9b25d5efd0b0595'))['opacity'] = 0.5;
  searchPublicEvents = ['dateFrom after \'',((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate')))).toISOString()),'\' && dateFrom before \'',((new Date((getObjectProperty(___arguments.context.pageData, 'toDate')))).toISOString()),'\' && location LIKE \'',(getObjectProperty(___arguments.context.appData, 'ukNation')),'\''].join('');
  ___arguments.context.pageData['publicHolsFound'] = (await Backendless.Data.of('events').find(Backendless.DataQueryBuilder.create().setWhereClause(searchPublicEvents).setPageSize(10)));
  if ((getObjectProperty(___arguments.context.pageData, 'publicHolsFound')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ba9ccf94d3e3ad6da9b25d5efd0b0595'))['opacity'] = 1;
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('430ee41e6cd8aecac527a97130633b71', (getObjectProperty(___arguments.context.pageData, 'publicHolsFound')));
}

/**
 * Describe this function...
 */
async function staffHolidayDisplayFunction() {
  try {
    ___arguments.context.pageData['whereClause'] = (['','(','dateFrom after \'',((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate')))).toISOString()),'\' && dateFrom before \'',((new Date((getObjectProperty(___arguments.context.pageData, 'toDate')))).toISOString()),'\' or dateTo after \'',((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate')))).toISOString()),'\' && DateTo before \'',((new Date((getObjectProperty(___arguments.context.pageData, 'toDate')))).toISOString()),'\') && contentCatCode LIKE 200',''].join(''));
    ___arguments.context.pageData['havingClause'] = (String('businessLinkId LIKE ') + String(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')));
    ___arguments.context.pageData['returnedStaff'] = (await Backendless.Data.of('events').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'whereClause'))).setHavingClause((['businessLinkId LIKE \'',(getObjectProperty(___arguments.context.appData, 'selectedBusiness.businessLinkId')),'\''].join(''))).setPageSize(10)));
    ___arguments.context.pageData['totalStaffHols'] = ((getObjectProperty(___arguments.context.pageData, 'returnedStaff')).length);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32a118f8ebcddd18d93beb6835d889a8', (getObjectProperty(___arguments.context.pageData, 'returnedStaff')));

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function buildSportsEventText() {
  try {
    (function (message) { alert(message) })('\'buildingSportsEventText;\' running!');
    varMenuFrom = (getObjectProperty(___arguments.context.pageData, 'menuFrom'));
    varMenuTo = (getObjectProperty(___arguments.context.pageData, 'menuTo'));
    ___arguments.context.pageData['eventFrom'] = (getObjectProperty(___arguments.context.pageData, 'dateFrom'));
    ___arguments.context.pageData['eventTo'] = (getObjectProperty(___arguments.context.pageData, 'dateTo'));
    varEventFrom = (getObjectProperty(___arguments.context.pageData, 'eventFrom'));
    varEventTo = (getObjectProperty(___arguments.context.pageData, 'eventTo'));
    varMenuDays = Math.round(((getObjectProperty(___arguments.context.pageData, 'menuTo')) - (getObjectProperty(___arguments.context.pageData, 'menuFrom'))) / 86000000);
    varEventDays = Math.round(((getObjectProperty(___arguments.context.pageData, 'eventTo')) - (getObjectProperty(___arguments.context.pageData, 'eventFrom'))) / 86000000);
    if (varEventFrom >= varMenuFrom && varEventTo <= varMenuTo) {
      textOutput = ['Event runs from - ',((new Date(varEventFrom)).toLocaleDateString()),' for ',varEventDays,' days of menu.'].join('');
      console.log(textOutput);
    }
    if (varEventFrom > varMenuFrom && varEventFrom <= varMenuTo && varEventTo > varMenuTo) {
      textOutput = ['Event runs from -',((new Date(varEventFrom)).toLocaleDateString()),'to end of menu.',''].join('');
      console.log(textOutput);
    }
    if (varEventFrom < varMenuFrom && varEventTo > varMenuFrom && varEventTo <= varMenuTo) {
      textOutput = ['Event runs from start of menu ','to ',((new Date(varEventTo)).toLocaleDateString()),''].join('');
      console.log(textOutput);
    }

  } catch (error) {
    console.log(error);

  }
}


  ___arguments.context.pageData['menuNamesCount'] = ((generateUUID().long()).toUpperCase());
  ___arguments.context.pageData['menuId'] = (getObjectProperty((await Backendless.Data.of('menuNames').save( ({ [`toFromDates`]: [[(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getDate()) <= 9 ? String('0') + String(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getDate()) : (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getMonth() + 1) <= 9 ? String('0') + String(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getMonth() + 1) : (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))))).getMonth() + 1),''].join(''),' to ',[(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getDate()) < 10 ? String('0') + String(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getDate()) : (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getMonth() + 1) < 10 ? String('0') + String(new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getMonth() + 1) : (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))))).getMonth() + 1),''].join('')].join(''),[`menuRanked`]: undefined,[`menuCannotBeDeleted`]: false,[`menuName`]: (getObjectProperty(___arguments.context.pageData, 'menuName')),[`menuNotes`]: (getObjectProperty(___arguments.context.pageData, 'menuNotes')),[`menuRequiredFrom`]: (getObjectProperty(___arguments.context.pageData, 'fromDate')),[`menuRequiredTo`]: (getObjectProperty(___arguments.context.pageData, 'toDate')),[`kitchenId`]: (getObjectProperty(___arguments.context.appData, 'selectedId')),[`userId`]: (getObjectProperty(___arguments.context.pageData, 'userId')),[`menuId`]: (getObjectProperty(___arguments.context.pageData, 'menuNamesCount')) }) )), 'objectId'));
  ___arguments.context.pageData['fromMonth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))).getMonth() + 1);
  ___arguments.context.pageData['fromDay'] = (new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))).getDate());
  ___arguments.context.pageData['toMonth'] = (new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))).getMonth() + 1);
  ___arguments.context.pageData['toDay'] = (new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))).getDate());
  indexDay = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  ___arguments.context.pageData['indexCalcFrom'] = (indexDay[((getObjectProperty(___arguments.context.pageData, 'fromMonth')) - 1)] + (getObjectProperty(___arguments.context.pageData, 'fromDay')));
  ___arguments.context.pageData['indexCalcTo'] = (indexDay[((getObjectProperty(___arguments.context.pageData, 'toMonth')) - 1)] + (getObjectProperty(___arguments.context.pageData, 'toDay')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00cb2e22ced3d7751d5ada939c8b12ee', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b5815facf7e2df7ff7af0c305b6380d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca27986d085ab9829bd166e6779dd0a8', false);
  fullList = [];
  addItemToList(fullList, (await Backendless.Data.of('ecoFoodCore1').find(Backendless.DataQueryBuilder.create().setWhereClause((String('group = \'Vegetable\''))).setSortBy('produceName').setPageSize(100))));
  finishedList = [];
  await displayPublicHols();
  await sportingEvents();
  await staffHolidayDisplayFunction();
  var x_end = fullList.length;
  var x_inc = 1;
  if (1 > x_end) {
    x_inc = -x_inc;
  }
  for (x = 1; x_inc >= 0 ? x <= x_end : x >= x_end; x += x_inc) {
    varHarvestRange = '';
    matchVar1 = 0;
    iLoop1 = 0;
    await findHarvestRange();
    if (getValueLength(harvestRange1) >= 60) {
      ___arguments.context.pageData['skip'] = (getValueLength(harvestRange1) / 60);
      elementPerDay = 1;
    }
    if (getValueLength(harvestRange1) < 60) {
      ___arguments.context.pageData['skip'] = 1;
      elementPerDay = 60 / getValueLength(harvestRange1);
    }
    var iLoop1_end = getValueLength(harvestRange1);
    var iLoop1_inc = Math.abs((getObjectProperty(___arguments.context.pageData, 'skip')));
    if (1 > iLoop1_end) {
      iLoop1_inc = -iLoop1_inc;
    }
    for (iLoop1 = 1; iLoop1_inc >= 0 ? iLoop1 <= iLoop1_end : iLoop1 >= iLoop1_end; iLoop1 += iLoop1_inc) {
      if (harvestRange1.charAt((iLoop1 - 1)) == '1') {
        varHarvestRange = String(varHarvestRange) + String('lllllllll'.slice(0, elementPerDay));
        matchVar1 = (typeof matchVar1 == 'number' ? matchVar1 : 0) + (getObjectProperty(___arguments.context.pageData, 'skip'));
      } else if (harvestRange1.charAt((iLoop1 - 1)) == '0') {
        varHarvestRange = String(varHarvestRange) + String('.........'.slice(0, elementPerDay));
      }
    }
    (fullList[(x - 1)])['percentage'] = (Math.round((100 / iLoop1) * matchVar1));
    (fullList[(x - 1)])['percentageRange'] = varHarvestRange;
  }
  ___arguments.context.pageData['filteredByPercentage'] = (await asyncListFilter(fullList, async (item) => {


   return ((getObjectProperty(item, 'percentage')) >= 0);
  }));
  ___arguments.context.pageData['sortByPercentage'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'filteredByPercentage')), -1, async (item) => {


   return (getObjectProperty(item, 'percentage'));
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0b5815facf7e2df7ff7af0c305b6380d', (getObjectProperty(___arguments.context.pageData, 'sortByPercentage')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/e37dc8461c0f082101f353c86381d346/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('adminUniversal', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/f118cfc5c504f29f6e5175b8a279b10a/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'percentage')),'% - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'produceName')),' [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'ecoCoreId')),']'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var varNewId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  varNewId = (await Backendless.Data.of('menuIngredients').save( ({ [`dateListed`]: (new Date()),[`coreListingId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'objectId')),[`humanString`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'produceName')),[`kitchenId`]: (getObjectProperty(___arguments.context.appData, 'selectedId')),[`menuId`]: (getObjectProperty(___arguments.context.pageData, 'menuNamesCount')) }) ));
  await Backendless.Data.of('menuIngredients').setRelation(varNewId, 'coreListingID', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bdcc5ad12a5ca91d24bb89395aa10dd8'), 'objectId'))]);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f118cfc5c504f29f6e5175b8a279b10a'))['opacity'] = 0.5;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/07964a4feb8102e6ecef0fec9a17d5f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([[(new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'fromDate'))).getMonth() + 1)].join(''),'[',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b452e76c50b4438f7f8e5e4205534e1d'), 'percentageRange')),']',[(new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'toDate'))).getMonth() + 1)].join('')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/64a132dfc8046b1884698d66008bc476/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74e1333737b9c3e3a08989260de47092'), 'name')),'','','','',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/2c73948acbc18c798e7a085b223852b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'publicHolsFound')).length)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/009d434595f1b34fbc659bce27e30403/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('430ee41e6cd8aecac527a97130633b71', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/5e47b8fa6f4f9b6ee4477a6df1df075c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var error, textOutput, varEventTo, varMenuTo, varMenuFrom, varEventFrom, varEventDays, varMenuDays;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'noSportsFound')) + String(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/febaf6583ea39174c70aba27b2463ece/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32a118f8ebcddd18d93beb6835d889a8', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/91e831f8ac2b0f58b7c875948553a0e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var textOutput, varEventFrom, varEventTo, varEventDays, varMenuFrom, varMenuTo, varMenuDays;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function declareVariables() {
  varMenuFrom = (getObjectProperty(___arguments.context.pageData, 'fromDate'));
  varMenuTo = (getObjectProperty(___arguments.context.pageData, 'toDate'));
  varEventFrom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4068b953c8affadcc8227b78b39fcd3f'), 'dateFrom'));
  varEventTo = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4068b953c8affadcc8227b78b39fcd3f'), 'dateTo'));
  varMenuDays = Math.round((varMenuTo - varMenuFrom) / 86000000);
  varEventDays = Math.round((varEventTo - varEventFrom) / 86000000) + 1;
  ___arguments.context.pageData[textOutput] = 'No Staff matches!';
}

/**
 * Describe this function...
 */
async function testForEventEndingAfterMenu() {
  if (varEventTo >= varMenuFrom && varEventTo >= varMenuTo) {
    textOutput = ['Last ',Math.round((varEventTo - varMenuTo) / 86000000),Math.round((varEventTo - varMenuTo) / 86000000) > 1 ? ' days of menu' : ' day of menu'].join('');
    console.log(textOutput);
  }
}

/**
 * Describe this function...
 */
async function testForEventStartingBeforeMenu() {
  console.log('Started \'testForEventStartingBeforeMenu\'');
  if (varEventFrom <= varMenuFrom && varEventFrom <= varMenuTo) {
    textOutput = ['First  ',Math.round((varMenuFrom - varEventFrom) / 86000000),Math.round((varMenuFrom - varEventFrom) / 86000000) > 1 ? ' days of menu' : ' day of menu'].join('');
    console.log(textOutput);
  }
}

/**
 * Describe this function...
 */
async function testForEventFallsWithinMenu() {
  textOutput = [((new Date(varEventFrom)).toLocaleDateString()),' for  ',varEventDays,varEventDays > 1 ? ' days of menu' : ' day of menu'].join('');
  console.log(textOutput);
}


  await declareVariables();
  await testForEventFallsWithinMenu();
  await testForEventStartingBeforeMenu();
  await testForEventEndingAfterMenu();

  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4068b953c8affadcc8227b78b39fcd3f'), 'userTag')),' [ ',textOutput,' ].',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/e29770456823e3bcb347da5e569d803c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'totalStaffHols')) + String(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfff7e78a97ea2951048dfe821284cd9', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/a12855c4a17893c64b884938f2e4044c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'description')),',',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'name')),'.'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/c3a926081458e7c2ee580548d22a9988/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'location'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/279818289ba83fbf247838b86e9c7edd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var textOutput, error, varEventTo, varMenuTo, varMenuFrom, varEventFrom, varEventDays, varMenuDays;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    varMenuFrom = (getObjectProperty(___arguments.context.pageData, 'fromDate'));
    varMenuTo = (getObjectProperty(___arguments.context.pageData, 'toDate'));
    varEventFrom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'dateFrom'));
    varEventTo = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d38c06af7b6222607dce6f8322c1758'), 'dateTo'));
    varMenuDays = Math.round(((getObjectProperty(___arguments.context.pageData, 'menuTo')) - (getObjectProperty(___arguments.context.pageData, 'menuFrom'))) / 86000000);
    varEventDays = Math.round((varEventTo - varEventFrom) / 86000000) + 1;
    if (varEventFrom >= varMenuFrom && varEventTo <= varMenuTo) {
      textOutput = ['Event runs from - ',((new Date(varEventFrom)).toLocaleDateString()),' for ',varEventDays,varEventDays > 1 ? ' days of menu.' : ' day of menu.'].join('');
      console.log(textOutput);
    }
    if (varEventFrom > varMenuFrom && varEventFrom <= varMenuTo && varEventTo > varMenuTo) {
      textOutput = ['Event runs from -',((new Date(varEventFrom)).toLocaleDateString()),'to end of menu.'].join('');
      console.log(textOutput);
    }
    if (varEventFrom < varMenuFrom && varEventTo > varMenuFrom && varEventTo <= varMenuTo) {
      textOutput = ['Event runs from start of menu ','to ',((new Date(varEventTo)).toLocaleDateString())].join('');
      console.log(textOutput);
    }

  } catch (error) {
    console.log(error);

  }

  return textOutput

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/e74feb4be01f21ae2ebc9edaf98116f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74e1333737b9c3e3a08989260de47092'), 'dateFrom')))).toDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xx1ingredientsTopMenu/components/bd73805893c65138a3f8df2823982b28/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
      console.log('selected menu ////////');
  console.log(___arguments.selectedRecord);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/xxdates/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      console.log('date Now function');
  console.log(new Date());
  console.log('/////////');
  console.log('date from timestamp');
  console.log(new Date(((new Date()).toDateString())));
  console.log('/////////');
  console.log('date from string');
  console.log(new Date('28/12/26'));
  console.log('/////////');
  console.log('get time');
  console.log(new Date((new Date())).getTime());
  console.log('/////////');
  console.log('get full year');
  console.log(new Date((new Date())).getFullYear());
  console.log('/////////');
  console.log('UTCDay');
  console.log(new Date((new Date())).getUTCDay());
  console.log('/////////');
  console.log('UTCMonth');
  console.log(new Date((new Date())).getUTCMonth());
  console.log('/////////');
  console.log('UTCFullYear');
  console.log(new Date((new Date())).getUTCFullYear());
  console.log('/////////');
  console.log(['','','','','',''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/xxproduceTopMenu/components/5fe7a372b6a476fec7e718ddc98f4092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('adminUniversal', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/xxproduceTopMenu/components/df0be15b025647f9a7043cbeb3f117cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inviteNewUser1', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xxproduceTopMenu/components/ed1e9fc7cc0a5631c6ed3acd0595c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xxproduceTopMenu/components/cd32153e722de5be166707ba7ca2eb4a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e37218c831d3efa878465b19ad481848', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0b5cc2426d7eda35e131f069cdbc639', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xxproduceTopMenu/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log('topProducer menu 1');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e37218c831d3efa878465b19ad481848', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca9860420ac800bc8d15fff7b632b178', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33328183b5a5e4de6ec19eadf145bf2b', false);
    console.log('topProducer menu 2');
    console.log('test logic for menu bttn to display');
    console.log('selectedBusiness.userSpecificRoles[appData] = ');
    console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString'));
    console.log('selectedBusiness[appData] = ');
    console.log(getObjectProperty(___arguments.context.appData, 'selectedBusiness'));
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('p10') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd32153e722de5be166707ba7ca2eb4a', true);
    }
    console.log('topProducer menu 3');
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('p20') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f43a9389fe7613db21b7c4523c3bc34', true);
    }
    console.log('topProducer menu 4');
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('p30') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07a61fc5e197615c7845b49bb7711926', true);
    }
    console.log('topProducer menu 5');
    if ((getObjectProperty(___arguments.context.appData, 'selectedBusiness.userRoleString')).indexOf('p40') + 1 > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33328183b5a5e4de6ec19eadf145bf2b', true);
    }
    console.log('topProducer menu EXIT');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/xxproduceTopMenu/components/b45ce4687c7205c828e878c86b26b894/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
      console.log(___arguments.selectedRecord);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/zzdrawers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    
  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/zzdrawers/components/121c5b8d4678def8efc8958d87686f11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f398ed0886283378ad28e798345d96f8', true);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f398ed0886283378ad28e798345d96f8', ___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/zztestVariableCommissionCalc/components/9928f6b89b48d9590ab8ea2d47f8820b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['t1'] = true;
  ___arguments.context.pageData['t2'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/zztestVariableCommissionCalc/components/5c95c7285a370d78f8381ec8bc6821c8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['t1'] = false;
  ___arguments.context.pageData['t2'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/zztestVariableCommissionCalc/components/3b4b21b810f8c58d34a95ee827fe94e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundUpDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.ceil(number * factor) / factor;
}


  ___arguments.context.pageData['variableCommissionMaxWeek'] = 26;
  ___arguments.context.pageData['variableCommission'] = 1.5;
  ___arguments.context.pageData['baseCommission'] = 1.5;
  ___arguments.context.pageData['weeksCommission'] = 26;
  if ((roundUpDecimals((((getObjectProperty(___arguments.context.pageData, 'dateFrom')) - (getObjectProperty(___arguments.context.pageData, 'dateListed'))) / 604800000),0)) > 26) {
    ___arguments.context.pageData['weeksCommission'] = 0;
    console.log('if statement - ');
  } else {
    ___arguments.context.pageData['weeksCommission'] = (26 - (roundUpDecimals((((getObjectProperty(___arguments.context.pageData, 'dateFrom')) - (getObjectProperty(___arguments.context.pageData, 'dateListed'))) / 604800000),0)));
    console.log('else if statement - ');
    console.log(getObjectProperty(___arguments.context.pageData, 'weeksCommission'));
  }
  ___arguments.context.pageData['calcVariableCommission'] = ((getObjectProperty(___arguments.context.pageData, 'variableCommission')) / (getObjectProperty(___arguments.context.pageData, 'variableCommissionMaxWeek')));
  console.log('calcVariableCommission - ');
  console.log(getObjectProperty(___arguments.context.pageData, 'calcVariableCommission'));
  console.log('totalVarCommision');
  console.log((getObjectProperty(___arguments.context.pageData, 'calcVariableCommission')) * (getObjectProperty(___arguments.context.pageData, 'weeksCommission')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/zztestVariableCommissionCalc/components/85f84d0845184be870e87918a984fdb8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log((new Date(___arguments.value)).toDateString());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/zztestVariableCommissionCalc/components/3c73c2184738218dcba8f27dd712b3ab/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/zztestVariableCommissionCalc/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dateNow'] = (new Date());
  console.log(getObjectProperty(___arguments.context.pageData, 'dateNow'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./components/reusable/r_dd155f0d44712ade9093a1e238bed1bc/logic/45386517d71534789fd825a82888de38/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['endDate'] = 0;
  ___arguments.context.pageData['startEntered'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50380788a2080298a6581fa8357bddd8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f9c77882c180bc8ef286a286c68c668', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0ae8697865e8cca8211721e850f24508'))['backgroundColor'] = 'grey';

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_dd155f0d44712ade9093a1e238bed1bc/logic/965f0a287718d0880ea850080a8bfe61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maxDate'] = ((getObjectProperty(___arguments.context.pageData, 'startDate')) + (getObjectProperty(___arguments.context.pageData, 'startDate')) + 86400000 * 365);
  ___arguments.context.pageData['requiredDays'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  ___arguments.context.pageData['minDateAllowed'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50380788a2080298a6581fa8357bddd8', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f9c77882c180bc8ef286a286c68c668', undefined);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_dd155f0d44712ade9093a1e238bed1bc/logic/3998735c789846d80618aab8b3185f52/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  ___arguments.context.pageData['noDaysFromEndDate'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  ___arguments.context.pageData['requiredDays'] = (roundDecimals((((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000),0));
  ___arguments.context.pageData['maxDateAllowed'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3b839c795d83e18fe28fbf837b8f728', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_dd155f0d44712ade9093a1e238bed1bc/logic/4db99d55193720b8092808d52b4c62e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  ___arguments.context.pageData['startEntered'] = true;
  ___arguments.context.pageData['endDate'] = (roundDecimals(((getObjectProperty(___arguments.context.pageData, 'startDate')) + 86400000 * ___arguments.value),0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3b839c795d83e18fe28fbf837b8f728', true);

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    var output;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'endCalOverride')) == true) {
    output = ' -';
    ___arguments.context.pageData['endCalOverride'] = false;
  } else {
    output = ((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'requiredDays')) < 0) {
    ___arguments.context.pageData['requiredDays'] = 0;
  }

  return output

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./components/reusable/r_dd155f0d44712ade9093a1e238bed1bc/logic/0ae8697865e8cca8211721e850f24508/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'description')).length > 5) {
      await Backendless.Data.of('events').save( ({ [`dateFromDDMMYY`]: String((new Date((getObjectProperty(___arguments.context.pageData, 'startDate')))).toLocaleDateString()),[`dateToDDMMYY`]: String((new Date((getObjectProperty(___arguments.context.pageData, 'endDate')))).toLocaleDateString()),[`businessLinkId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedBusiness')), 'businessLinkId')),[`contentCatCode`]: '100',[`contentCatHuman`]: 'business busy period',[`dateFrom`]: (getObjectProperty(___arguments.context.pageData, 'startDate')),[`dateTo`]: (getObjectProperty(___arguments.context.pageData, 'endDate')),[`description`]: (getObjectProperty(___arguments.context.pageData, 'description')),[`noDaysRequested`]: (getObjectProperty(___arguments.context.pageData, 'requiredDays')) }) );
      ___arguments.context.pageData['startDate'] = null;
      ___arguments.context.pageData['endDate'] = null;
      ___arguments.context.pageData['requiredDays'] = null;
      ___arguments.context.pageData['description'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50380788a2080298a6581fa8357bddd8', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f9c77882c180bc8ef286a286c68c668', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3b839c795d83e18fe28fbf837b8f728', undefined);
    } else {
      ___arguments.context.pageData['descriptionInstruction'] = '6+ characters please';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_dd155f0d44712ade9093a1e238bed1bc/logic/2e6462a34b93c2a6ac98066ffcf85108/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3b839c795d83e18fe28fbf837b8f728', false);
  ___arguments.context.pageData['descriptionInstruction'] = 'Description';
  ___arguments.context.pageData['description'] = '';

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_41e9b9d9ce3d9d511b0e90e847b9f246/logic/b1ad8c99b67c2c57c2cd49a3e93777b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3f5ac5bdceb33dd528f28624175c7d8e/logic/45386517d71534789fd825a82888de38/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['endDate'] = 0;
  ___arguments.context.pageData['startEntered'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50380788a2080298a6581fa8357bddd8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f9c77882c180bc8ef286a286c68c668', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0ae8697865e8cca8211721e850f24508'))['backgroundColor'] = 'grey';

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_3f5ac5bdceb33dd528f28624175c7d8e/logic/965f0a287718d0880ea850080a8bfe61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maxDate'] = ((getObjectProperty(___arguments.context.pageData, 'startDate')) + (getObjectProperty(___arguments.context.pageData, 'startDate')) + 86400000 * 365);
  ___arguments.context.pageData['requiredDays'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  ___arguments.context.pageData['minDateAllowed'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50380788a2080298a6581fa8357bddd8', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f9c77882c180bc8ef286a286c68c668', undefined);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3f5ac5bdceb33dd528f28624175c7d8e/logic/3998735c789846d80618aab8b3185f52/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  ___arguments.context.pageData['noDaysFromEndDate'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  ___arguments.context.pageData['requiredDays'] = (roundDecimals((((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000),0));
  console.log('requiredDays =');
  console.log(roundDecimals((((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000),0));
  ___arguments.context.pageData['maxDateAllowed'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0ae8697865e8cca8211721e850f24508'))['backgroundColor'] = '#4da54e';

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3f5ac5bdceb33dd528f28624175c7d8e/logic/4db99d55193720b8092808d52b4c62e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  ___arguments.context.pageData['startEntered'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0ae8697865e8cca8211721e850f24508'))['backgroundColor'] = '#4da54e';
  console.log('changed value = ');
  console.log(___arguments.value);
  ___arguments.context.pageData['endDate'] = (roundDecimals(((getObjectProperty(___arguments.context.pageData, 'startDate')) + 86400000 * ___arguments.value),0));

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    var output;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'endCalOverride')) == true) {
    output = ' -';
    ___arguments.context.pageData['endCalOverride'] = false;
  } else {
    output = ((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'requiredDays')) < 0) {
    ___arguments.context.pageData['requiredDays'] = 0;
  }

  return output

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./components/reusable/r_3f5ac5bdceb33dd528f28624175c7d8e/logic/0ae8697865e8cca8211721e850f24508/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('run code to save entered dates');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_dff965e4707eca8b54d9eea17e278639/logic/45386517d71534789fd825a82888de38/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['endDate'] = 0;
  ___arguments.context.pageData['startEntered'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50380788a2080298a6581fa8357bddd8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f9c77882c180bc8ef286a286c68c668', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb38379d7008b678b7c878ea6878ac88', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0ae8697865e8cca8211721e850f24508'))['backgroundColor'] = 'grey';

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_dff965e4707eca8b54d9eea17e278639/logic/965f0a287718d0880ea850080a8bfe61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maxDate'] = ((getObjectProperty(___arguments.context.pageData, 'startDate')) + (getObjectProperty(___arguments.context.pageData, 'startDate')) + 86400000 * 365);
  ___arguments.context.pageData['requiredDays'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  ___arguments.context.pageData['minDateAllowed'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50380788a2080298a6581fa8357bddd8', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f9c77882c180bc8ef286a286c68c668', undefined);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_dff965e4707eca8b54d9eea17e278639/logic/3998735c789846d80618aab8b3185f52/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  ___arguments.context.pageData['noDaysFromEndDate'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  ___arguments.context.pageData['requiredDays'] = (roundDecimals((((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000),0));
  ___arguments.context.pageData['maxDateAllowed'] = (((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb38379d7008b678b7c878ea6878ac88', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_dff965e4707eca8b54d9eea17e278639/logic/4db99d55193720b8092808d52b4c62e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  ___arguments.context.pageData['startEntered'] = true;
  ___arguments.context.pageData['endDate'] = (roundDecimals(((getObjectProperty(___arguments.context.pageData, 'startDate')) + 86400000 * ___arguments.value),0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb38379d7008b678b7c878ea6878ac88', true);

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    var output;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'endCalOverride')) == true) {
    output = ' -';
    ___arguments.context.pageData['endCalOverride'] = false;
  } else {
    output = ((getObjectProperty(___arguments.context.pageData, 'endDate')) - (getObjectProperty(___arguments.context.pageData, 'startDate'))) / 86400000;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'requiredDays')) < 0) {
    ___arguments.context.pageData['requiredDays'] = 0;
  }

  return output

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./components/reusable/r_dff965e4707eca8b54d9eea17e278639/logic/0ae8697865e8cca8211721e850f24508/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'busyPeriods')).length > 5) {
      ___arguments.context.pageData['parentObjectId'] = (getObjectProperty((await Backendless.Data.of('events').save( ({ [`dateFromDDMMYY`]: String((new Date((getObjectProperty(___arguments.context.pageData, 'startDate')))).toLocaleDateString()),[`dateToDDMMYY`]: String((new Date((getObjectProperty(___arguments.context.pageData, 'endDate')))).toLocaleDateString()),[`businessLinkId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedBusiness')), 'businessLinkId')),[`contentCatCode`]: '100',[`contentCatHuman`]: 'business busy period',[`dateFrom`]: (getObjectProperty(___arguments.context.pageData, 'startDate')),[`dateTo`]: (getObjectProperty(___arguments.context.pageData, 'endDate')),[`description`]: (getObjectProperty(___arguments.context.pageData, 'busyPeriods')),[`noDaysRequested`]: (getObjectProperty(___arguments.context.pageData, 'requiredDays')) }) )), 'objectId'));
      await Backendless.Data.of('events').addRelation((getObjectProperty(___arguments.context.pageData, 'parentObjectId')), 'userDetails', [(getObjectProperty(___arguments.context.appData, 'selectedUsersObjectId'))]);
      ___arguments.context.pageData['startDate'] = null;
      ___arguments.context.pageData['endDate'] = null;
      ___arguments.context.pageData['requiredDays'] = null;
      ___arguments.context.pageData['description'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50380788a2080298a6581fa8357bddd8', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4f9c77882c180bc8ef286a286c68c668', undefined);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb38379d7008b678b7c878ea6878ac88', undefined);
    } else {
      ___arguments.context.pageData['descriptionInstruction'] = '6+ characters please';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

